/* eslint-disable */
/* NOTE: THIS IS AN AUTOGENERATED FILE, DO NOT EDIT */
/* orthlyweb graphql/types documentation: https://docs.dandyserv.net/orthlyweb/local-development/graphql/index.html */
import * as Types from '@orthly/graphql-schema';

type Maybe<T> = Types.Maybe<T>;
type ToothNumber = Types.Scalars['ToothNumber']['output'];
export type LabsGqlCheckoutEstimatedDeliveryQueryVariables = Types.Exact<{
  items_v2_by_sku: Types.InputMaybe<Types.LabsGqlLabOrderItemV2InputBySku>;
  doctor_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  waxup: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlCheckoutEstimatedDeliveryQuery = { __typename?: 'Query', estimatedDeliveryDate: { __typename?: 'EstimatedDeliveryDateRes', standard_delivery_date: string, design_preview_eta: Maybe<string>, expected_delivery_days: Maybe<number> } };

export type LabsGqlModifyOrderSlaMutationVariables = Types.Exact<{
  command: Types.LabsGqlModifyOrderSlaCommand;
}>;


export type LabsGqlModifyOrderSlaMutation = { __typename?: 'Mutation', modifyOrderSla: { __typename?: 'lab_order', id: string } };

export type LabsGqlCartDeliveryOptionFragment = { __typename?: 'CartDeliveryOption', sla_modifier: Types.LabsGqlCartSlaModifier, delivery_date: string, info_text: Maybe<string>, design_preview_eta: Maybe<string> };

export type LabsGqlGetCartDeliveryOptionsQueryVariables = Types.Exact<{
  items_v2_by_sku: Types.InputMaybe<Types.LabsGqlLabOrderItemV2InputBySku>;
  doctor_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  waxup: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  enable_delivery_options: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlGetCartDeliveryOptionsQuery = { __typename?: 'Query', getCartDeliveryOptions: { __typename?: 'GetCartDeliveryOptionsRes', options: Array<(
      { __typename?: 'CartDeliveryOption' }
      & LabsGqlCartDeliveryOptionFragment
    )> } };

export type LabsGqlUpdateLabsNotificationPrefsMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  data: Types.LabsGqlSetPartnerNotificationPreferencesCommand;
}>;


export type LabsGqlUpdateLabsNotificationPrefsMutation = { __typename?: 'Mutation', setPartnerNotificationPreferences: { __typename?: 'PartnerNotificationPreferences', id: string, emails: Array<string>, phone_number: Maybe<string> } };

export type LabsGqlMarkFulfillmentShippedMutationVariables = Types.Exact<{
  data: Types.LabsGqlMarkFulfillmentShippedCommand;
}>;


export type LabsGqlMarkFulfillmentShippedMutation = { __typename?: 'Mutation', markShipped: { __typename?: 'lab_order', id: string } };

export type LabsGqlCreateFulfillmentMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateFulfillmentCommand;
}>;


export type LabsGqlCreateFulfillmentMutation = { __typename?: 'Mutation', createFulfillment: { __typename?: 'lab_order', id: string } };

export type LabsGqlMarkFulfillmentDeliveredMutationVariables = Types.Exact<{
  data: Types.LabsGqlMarkDeliveredCommand;
}>;


export type LabsGqlMarkFulfillmentDeliveredMutation = { __typename?: 'Mutation', markDelivered: { __typename?: 'lab_order', id: string } };

export type LabsGqlMarkNeedsRefabricationMutationVariables = Types.Exact<{
  data: Types.LabsGqlMarkNeedsRefabricationCommand;
}>;


export type LabsGqlMarkNeedsRefabricationMutation = { __typename?: 'Mutation', markNeedsRefabrication: { __typename?: 'lab_order', id: string } };

export type LabsGqlExternalUserCancelOrderMutationVariables = Types.Exact<{
  data: Types.LabsGqlExternalUserCancelOrderCommand;
}>;


export type LabsGqlExternalUserCancelOrderMutation = { __typename?: 'Mutation', externalUserCancelOrder: { __typename?: 'lab_order', id: string } };

export type LabsGqlPsrCancelOrderMutationVariables = Types.Exact<{
  data: Types.LabsGqlOpsCancelOrderCommand;
}>;


export type LabsGqlPsrCancelOrderMutation = { __typename?: 'Mutation', opsCancelOrder: { __typename?: 'lab_order', id: string, dentist_amount_due_cents: Maybe<number> } };

export type LabsGqlAttachDesignFilesMutationVariables = Types.Exact<{
  data: Types.LabsGqlAttachDesignFilesCommand;
}>;


export type LabsGqlAttachDesignFilesMutation = { __typename?: 'Mutation', attachDesignFiles: { __typename?: 'lab_order', id: string } };

export type LabsGqlPlaceLabOrderMutationVariables = Types.Exact<{
  data: Types.LabsGqlPlaceLabOrderCommand;
}>;


export type LabsGqlPlaceLabOrderMutation = { __typename?: 'Mutation', placeOrder: Array<(
    { __typename?: 'lab_order' }
    & LabsGqlPlacedOrderFragment
  )> };

export type LabsGqlReplaceRejectedScanMutationVariables = Types.Exact<{
  data: Types.LabsGqlReplaceRejectedScanCommand;
}>;


export type LabsGqlReplaceRejectedScanMutation = { __typename?: 'Mutation', replaceRejectedScan: (
    { __typename?: 'lab_order' }
    & LabsGqlPlacedOrderFragment
  ) };

export type LabsGqlPlacedOrderFragment = { __typename?: 'lab_order', id: string, due_date: string, practice_dates: { __typename?: 'OrderPracticeDates', estimated_delivery_date: string, promised_digital_design_preview_completion_date: Maybe<string> }, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string } };

export type LabsGqlReplaceThreeoxzMutationVariables = Types.Exact<{
  data: Types.LabsGqlReplaceThreeoxzCommand;
}>;


export type LabsGqlReplaceThreeoxzMutation = { __typename?: 'Mutation', replaceThreeoxz: { __typename?: 'lab_order', id: string } };

export type LabsGqlSetCbctScanUrlMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  cbct_url: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSetCbctScanUrlMutation = { __typename?: 'Mutation', setCbctScanUrl: { __typename?: 'lab_order', id: string } };

export type LabsGqlCreateDeliveryAddressMutationVariables = Types.Exact<{
  data: Types.LabsGqlPartnerDeliveryAddressInput;
}>;


export type LabsGqlCreateDeliveryAddressMutation = { __typename?: 'Mutation', createDeliveryAddress: { __typename?: 'PartnerDeliveryAddress', id: string } };

export type LabsGqlEditDeliveryAddressMutationVariables = Types.Exact<{
  address_id: Types.Scalars['String']['input'];
  data: Types.LabsGqlPartnerDeliveryAddressInput;
}>;


export type LabsGqlEditDeliveryAddressMutation = { __typename?: 'Mutation', editDeliveryAddress: { __typename?: 'PartnerDeliveryAddress', id: string } };

export type LabsGqlChangeDeliveryAddressMutationVariables = Types.Exact<{
  data: Types.LabsGqlChangeDeliveryAddressCommand;
}>;


export type LabsGqlChangeDeliveryAddressMutation = { __typename?: 'Mutation', changeDeliveryAddress: { __typename?: 'lab_order', id: string } };

export type LabsGqlSetDoctorPreferencesIdMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetDoctorPreferencesIdCommand;
}>;


export type LabsGqlSetDoctorPreferencesIdMutation = { __typename?: 'Mutation', setDoctorPreferencesId: { __typename?: 'lab_order', id: string } };

export type LabsGqlProcess3OxzFileMutationVariables = Types.Exact<{
  file_url: Types.Scalars['String']['input'];
  partnerId: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlProcess3OxzFileMutation = { __typename?: 'Mutation', process3oxzFile: { __typename?: 'scan_export_processed', file_url: Maybe<string>, overwrote_file: boolean, already_has_order_submitted: boolean } };

export type LabsGqlCreateDoctorPreferencesMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateDoctorPreferencesCommand;
}>;


export type LabsGqlCreateDoctorPreferencesMutation = { __typename?: 'Mutation', createDoctorPreferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlDeleteDoctorPreferencesMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteDoctorPreferencesCommand;
}>;


export type LabsGqlDeleteDoctorPreferencesMutation = { __typename?: 'Mutation', deleteDoctorPreferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlSendCheckoutImagesUploadLinkMutationVariables = Types.Exact<{
  data: Types.LabsGqlCheckoutImagesUploadLinkData;
}>;


export type LabsGqlSendCheckoutImagesUploadLinkMutation = { __typename?: 'Mutation', sendCheckoutImagesUploadLink: boolean };

export type LabsGqlSendScanbodySurgicalReportUploadLinkMutationVariables = Types.Exact<{
  data: Types.LabsGqlScanbodySurgicalReportUploadData;
}>;


export type LabsGqlSendScanbodySurgicalReportUploadLinkMutation = { __typename?: 'Mutation', sendScanbodySurgicalReportUploadLink: boolean };

export type LabsGqlSendMobileAppLinksMutationVariables = Types.Exact<{
  data: Types.LabsGqlSendMobileAppLinksData;
}>;


export type LabsGqlSendMobileAppLinksMutation = { __typename?: 'Mutation', sendMobileAppLinks: boolean };

export type LabsGqlSendRefabFilesUploadLinkMutationVariables = Types.Exact<{
  data: Types.LabsGqlRefabFilesUploadData;
}>;


export type LabsGqlSendRefabFilesUploadLinkMutation = { __typename?: 'Mutation', sendRefabFilesUploadLink: boolean };

export type LabsGqlSendAttachPhotosUploadLinkMutationVariables = Types.Exact<{
  data: Types.LabsGqlAttachPhotosUploadData;
}>;


export type LabsGqlSendAttachPhotosUploadLinkMutation = { __typename?: 'Mutation', sendAttachPhotosUploadLink: boolean };

export type LabsGqlSetDoctorPreferencesMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetDoctorPreferencesCommand;
}>;


export type LabsGqlSetDoctorPreferencesMutation = { __typename?: 'Mutation', setDoctorPreferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlSetSingleClinicalPreferenceMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetSingleClinicalPreferenceCommand;
}>;


export type LabsGqlSetSingleClinicalPreferenceMutation = { __typename?: 'Mutation', setSingleClinicalPreference: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlSetDoctorNotificationPrefsMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetDoctorNotificationPrefsCommand;
}>;


export type LabsGqlSetDoctorNotificationPrefsMutation = { __typename?: 'Mutation', setDoctorNotificationPrefs: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlCollectNotificationPreferencesMutationVariables = Types.Exact<{
  data: Types.LabsGqlCollectNotificationPreferencesCommand;
}>;


export type LabsGqlCollectNotificationPreferencesMutation = { __typename?: 'Mutation', collectNotificationPreferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlSetPreferredManufacturersMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetPreferredManufacturersCommand;
}>;


export type LabsGqlSetPreferredManufacturersMutation = { __typename?: 'Mutation', setPreferredManufacturers: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlUpsertManufacturerProfileMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpsertManufacturerProfileCommand;
}>;


export type LabsGqlUpsertManufacturerProfileMutation = { __typename?: 'Mutation', upsertManufacturerProfile: (
    { __typename?: 'ManufacturerProfile' }
    & LabsGqlManufacturerProfileFragment
  ) };

export type LabsGqlOverrideDentistAmountDueMutationVariables = Types.Exact<{
  data: Types.LabsGqlOverrideDentistAmountDueCommand;
}>;


export type LabsGqlOverrideDentistAmountDueMutation = { __typename?: 'Mutation', overrideDentistAmountDue: { __typename?: 'lab_order', id: string, dentist_amount_due_cents: Maybe<number> } };

export type LabsGqlDeleteUnusedScanFileMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteScanExportCommand;
}>;


export type LabsGqlDeleteUnusedScanFileMutation = { __typename?: 'Mutation', deleteScanExport: boolean };

export type LabsGqlSetPartnerScannersMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  scanner_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSetPartnerScannersMutation = { __typename?: 'Mutation', setPartnerScanners: { __typename?: 'ScannerResponse', success: boolean } };

export type LabsGqlToggleDeliveryAddressDeletedMutationVariables = Types.Exact<{
  addressId: Types.Scalars['String']['input'];
  isDeleted: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlToggleDeliveryAddressDeletedMutation = { __typename?: 'Mutation', toggleDeliveryAddressDeleted: { __typename?: 'PartnerDeliveryAddress', id: string, deleted_at: Maybe<string> } };

export type LabsGqlUpdatePartnerLabsNotificationPrefsMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  data: Types.LabsGqlSetPartnerNotificationPreferencesCommand;
}>;


export type LabsGqlUpdatePartnerLabsNotificationPrefsMutation = { __typename?: 'Mutation', setPartnerNotificationPreferences: { __typename?: 'PartnerNotificationPreferences', id: string, emails: Array<string>, phone_number: Maybe<string>, daily_digest_timing: Maybe<Types.LabsGqlPartnerLabsNotificationTiming>, unsubmitted_scan_alert_delay_mins: Maybe<number>, unsubmitted_scans_daily_sms: Maybe<Types.LabsGqlPartnerLabsNotificationTiming> } };

export type LabsGqlUpdateManufacturerLabsNotificationPrefsMutationVariables = Types.Exact<{
  manufacturer_id: Types.Scalars['String']['input'];
  data: Types.LabsGqlSetManufacturerNotificationPreferencesCommand;
}>;


export type LabsGqlUpdateManufacturerLabsNotificationPrefsMutation = { __typename?: 'Mutation', setManufacturerNotificationPreferences: { __typename?: 'ManufacturerNotificationPreferences', id: string, emails: Array<string>, phone_number: Maybe<string> } };

export type LabsGqlRemoveLabsFulfillmentShippingMutationVariables = Types.Exact<{
  data: Types.LabsGqlRemoveFulfillmentShippingCommand;
}>;


export type LabsGqlRemoveLabsFulfillmentShippingMutation = { __typename?: 'Mutation', removeFulfillmentShipping: { __typename?: 'lab_order', id: string, status: Types.LabsGqlLabOrderStatus, updated_at: string, ship_date: Maybe<string> } };

export type LabsGqlChangeLabOrderManufacturerMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  manufacturerId: Types.Scalars['String']['input'];
  reason: Types.Scalars['String']['input'];
  disable_sla_reset: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  disable_notification: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlChangeLabOrderManufacturerMutation = { __typename?: 'Mutation', changeLabOrderManufacturer: { __typename?: 'lab_order', id: string, manufacturer_id: string } };

export type LabsGqlLinkOrderToRefabricationMutationVariables = Types.Exact<{
  data: Types.LabsGqlLinkOrderToRefabricationCommand;
}>;


export type LabsGqlLinkOrderToRefabricationMutation = { __typename?: 'Mutation', linkOrderToRefabrication: { __typename?: 'lab_order', id: string, refabrication_order_id: Maybe<string> } };

export type LabsGqlSendInviteEmailMutationVariables = Types.Exact<{
  data: Types.LabsGqlSendInviteEmailData;
}>;


export type LabsGqlSendInviteEmailMutation = { __typename?: 'Mutation', sendInviteEmail: boolean };

export type LabsGqlSyncOrderPriceMutationVariables = Types.Exact<{
  orderIds: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSyncOrderPriceMutation = { __typename?: 'Mutation', syncOrderPrices: Array<{ __typename?: 'lab_order', id: string, dentist_amount_due_cents: Maybe<number> }> };

export type LabsGqlMarkEventReadMutationVariables = Types.Exact<{
  eventIds: Array<Types.Scalars['Int']['input']>;
}>;


export type LabsGqlMarkEventReadMutation = { __typename?: 'Mutation', markEventsRead: { __typename?: 'UserReadEvents', read_event_ids: Array<number>, id: string } };

export type LabsGqlMarkEventUnreadMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
}>;


export type LabsGqlMarkEventUnreadMutation = { __typename?: 'Mutation', markEventUnread: { __typename?: 'UserReadEvents', read_event_ids: Array<number>, id: string } };

export type LabsGqlRefreshScanImagesMutationVariables = Types.Exact<{
  processedScanId: Types.Scalars['String']['input'];
}>;


export type LabsGqlRefreshScanImagesMutation = { __typename?: 'Mutation', refreshImagesForProcessedScan: { __typename?: 'scan_export', id: string, image_urls: Maybe<Array<string>> } };

export type LabsGqlEditOrderNoteMutationVariables = Types.Exact<{
  newNote: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderId: Types.Scalars['String']['input'];
  category_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlEditOrderNoteMutation = { __typename?: 'Mutation', editDoctorNote: { __typename?: 'lab_order', id: string, doctor_notes: Maybe<string> } };

export type LabsGqlUpdateOrderClinicalSupportNotesMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrderClinicalSupportNotesCommand;
}>;


export type LabsGqlUpdateOrderClinicalSupportNotesMutation = { __typename?: 'Mutation', updateOrderClinicalSupportNotes: { __typename?: 'lab_order', id: string } };

export type LabsGqlSchedule3oxzConvertMutationVariables = Types.Exact<{
  scanId: Types.Scalars['String']['input'];
}>;


export type LabsGqlSchedule3oxzConvertMutation = { __typename?: 'Mutation', schedule3oxzToStlConversion: boolean };

export type LabsGqlOverrideManufacturerNonProdMutationVariables = Types.Exact<{
  data: Types.LabsGqlOverrideNonProdManufacturerCommand;
}>;


export type LabsGqlOverrideManufacturerNonProdMutation = { __typename?: 'Mutation', overrideNonProdManufacturer: { __typename?: 'lab_order', id: string, manufacturer_id: string } };

export type LabsGqlCreateOrderHoldMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateOrderHoldCommand;
}>;


export type LabsGqlCreateOrderHoldMutation = { __typename?: 'Mutation', createOrderHold: { __typename?: 'lab_order', id: string, status: Types.LabsGqlLabOrderStatus, hold_reason: Maybe<string>, hold_details: Maybe<{ __typename?: 'LabOrderHoldDetails', hold_category: string, hold_subcategory: Maybe<string>, hold_freetext: Maybe<string> }> } };

export type LabsGqlRemoveOrderHoldMutationVariables = Types.Exact<{
  data: Types.LabsGqlRemoveOrderHoldCommand;
}>;


export type LabsGqlRemoveOrderHoldMutation = { __typename?: 'Mutation', removeOrderHold: { __typename?: 'lab_order', id: string, status: Types.LabsGqlLabOrderStatus, hold_reason: Maybe<string> } };

export type LabsGqlUpdateOrderHoldMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrderHoldCommand;
}>;


export type LabsGqlUpdateOrderHoldMutation = { __typename?: 'Mutation', updateOrderHold: { __typename?: 'lab_order', id: string, hold_reason: Maybe<string>, show_hold_status_to_practice: Maybe<boolean>, hold_details: Maybe<{ __typename?: 'LabOrderHoldDetails', hold_category: string, hold_subcategory: Maybe<string>, hold_freetext: Maybe<string> }> } };

export type LabsGqlAskDoctorAboutHoldMutationVariables = Types.Exact<{
  data: Types.LabsGqlAskDoctorAboutHoldCommand;
}>;


export type LabsGqlAskDoctorAboutHoldMutation = { __typename?: 'Mutation', askDoctorAboutHold: { __typename?: 'lab_order', id: string } };

export type LabsGqlPracticeRespondToOrderHoldMutationVariables = Types.Exact<{
  data: Types.LabsGqlPracticeRespondToOrderHoldCommand;
}>;


export type LabsGqlPracticeRespondToOrderHoldMutation = { __typename?: 'Mutation', practiceRespondToOrderHold: { __typename?: 'lab_order', id: string } };

export type LabsGqlAddRetainerToAlignerCaseMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddRetainerToAlignerCaseCommand;
}>;


export type LabsGqlAddRetainerToAlignerCaseMutation = { __typename?: 'Mutation', addRetainerToAlignerCase: (
    { __typename?: 'lab_order' }
    & LabsGqlPlacedOrderFragment
  ) };

export type LabsGqlUpdateCurrentRetainerMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateCurrentRetainerCommand;
}>;


export type LabsGqlUpdateCurrentRetainerMutation = { __typename?: 'Mutation', updateCurrentRetainer: { __typename?: 'lab_order', id: string } };

export type LabsGqlOrderMetafieldChangeResultFragment = { __typename?: 'lab_order', id: string, items: Array<{ __typename?: 'LabOrderItem', id: string, preference_fields: Array<{ __typename?: 'ICustomFieldSubmission', display_name: string, field_id: string, value: string | boolean | number, price_cents: Maybe<number> }> }> };

export type LabsGqlAddOrderItemsV2MutationVariables = Types.Exact<{
  data: Types.LabsGqlAddOrderItemsV2Command;
}>;


export type LabsGqlAddOrderItemsV2Mutation = { __typename?: 'Mutation', addOrderItemsV2: { __typename?: 'lab_order', id: string } };

export type LabsGqlUpdateOrderItemsV2PracticeMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrderItemsV2PracticeCommand;
}>;


export type LabsGqlUpdateOrderItemsV2PracticeMutation = { __typename?: 'Mutation', updateOrderItemsV2Practice: { __typename?: 'lab_order', id: string } };

export type LabsGqlUpdatePartialDentureMetadataMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdatePartialDentureMetadataCommand;
}>;


export type LabsGqlUpdatePartialDentureMetadataMutation = { __typename?: 'Mutation', updatePartialDentureMetadata: { __typename?: 'lab_order', id: string } };

export type LabsGqlUpdateOrderItemPennyweightsV2MutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrderItemPennyweightsV2Command;
}>;


export type LabsGqlUpdateOrderItemPennyweightsV2Mutation = { __typename?: 'Mutation', updateOrderItemPennyweightsV2: { __typename?: 'lab_order', id: string } };

export type LabsGqlResolveOrderReviewFlagMutationVariables = Types.Exact<{
  data: Types.LabsGqlResolveOrderReviewFlagCommand;
}>;


export type LabsGqlResolveOrderReviewFlagMutation = { __typename?: 'Mutation', resolveOrderReviewFlag: { __typename?: 'lab_order', id: string } };

export type LabsGqlUnlinkRefabricationMutationVariables = Types.Exact<{
  originalOrderId: Types.Scalars['String']['input'];
  reason: Types.Scalars['String']['input'];
}>;


export type LabsGqlUnlinkRefabricationMutation = { __typename?: 'Mutation', undoLinkOrderToRefabrication: { __typename?: 'lab_order', id: string } };

export type LabsGqlEditRefabricationMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  refabricationNotes: Types.Scalars['String']['input'];
}>;


export type LabsGqlEditRefabricationMutation = { __typename?: 'Mutation', editRefabrication: { __typename?: 'lab_order', id: string } };

export type LabsGqlEditRefabricationReasonsMutationVariables = Types.Exact<{
  originalOrderId: Types.Scalars['String']['input'];
  reasons: Array<Types.LabsGqlOrderRefabReasonInput>;
}>;


export type LabsGqlEditRefabricationReasonsMutation = { __typename?: 'Mutation', editRefabricationReasons: { __typename?: 'lab_order', id: string } };

export type LabsGqlRefreshOrderShippingStatusMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type LabsGqlRefreshOrderShippingStatusMutation = { __typename?: 'Mutation', refreshShippingStatus: { __typename?: 'update_delivery_statuses_result', message: string } };

export type LabsGqlSaveLabSlipAlertsMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  saved_alerts: Array<Types.LabsGqlLabSlipAlertInput>;
}>;


export type LabsGqlSaveLabSlipAlertsMutation = { __typename?: 'Mutation', saveLabSlipAlerts: { __typename?: 'lab_order', id: string } };

export type LabsGqlAssignFulfillmentTaskMutationVariables = Types.Exact<{
  data: Types.LabsGqlAssignFulfillmentTaskCommand;
}>;


export type LabsGqlAssignFulfillmentTaskMutation = { __typename?: 'Mutation', assignFulfillmentTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlStartFulfillmentTaskMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  task_id: Types.Scalars['String']['input'];
  last_user_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlStartFulfillmentTaskMutation = { __typename?: 'Mutation', startFulfillmentTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlAttachQcPhotosMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  item_photos: Array<Types.LabsGqlItemPhotosInput>;
}>;


export type LabsGqlAttachQcPhotosMutation = { __typename?: 'Mutation', attachQcPhotos: { __typename?: 'lab_order', id: string } };

export type LabsGqlCreatePendingAlignerCaseMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePendingAlignerCaseCommand;
}>;


export type LabsGqlCreatePendingAlignerCaseMutation = { __typename?: 'Mutation', createPendingAlignerCase: { __typename?: 'PendingAlignerCaseDTO', id: string } };

export type LabsGqlOverridePendingAlignerPatientPriceMutationVariables = Types.Exact<{
  data: Types.LabsGqlOverridePendingAlignerPatientPrice;
}>;


export type LabsGqlOverridePendingAlignerPatientPriceMutation = { __typename?: 'Mutation', overridePendingAlignerPatientPrice: { __typename?: 'PendingAlignerCaseDTO', id: string } };

export type LabsGqlLabOrderQcStationPassMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  issues: Array<Types.LabsGqlQcIssueResultInputV2>;
  completed_checklist_item_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
  employee_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  integration_order_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabOrderQcStationPassMutation = { __typename?: 'Mutation', labOrderQcStationPass: { __typename?: 'lab_order', id: string } };

export type LabsGqlLabOrderQcStationFailMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  reason: Types.Scalars['String']['input'];
  issues: Array<Types.LabsGqlQcIssueResultInputV2>;
  completed_checklist_item_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlLabOrderQcStationFailMutation = { __typename?: 'Mutation', labOrderQcStationFail: { __typename?: 'lab_order', id: string } };

export type LabsGqlAddLabOrderPhotosMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddLabOrderPhotosCommand;
}>;


export type LabsGqlAddLabOrderPhotosMutation = { __typename?: 'Mutation', addLabOrderPhotos: { __typename?: 'lab_order', id: string } };

export type LabsGqlAddLabOrderPhotosWithNotesMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddLabOrderPhotosWithNotesCommand;
}>;


export type LabsGqlAddLabOrderPhotosWithNotesMutation = { __typename?: 'Mutation', addLabOrderPhotosWithNotes: { __typename?: 'lab_order', id: string } };

export type LabsGqlPlaceDenturesFulfillmentCoreMutationVariables = Types.Exact<{
  data: Types.LabsGqlPlaceDenturesFulfillmentCoreCommand;
}>;


export type LabsGqlPlaceDenturesFulfillmentCoreMutation = { __typename?: 'Mutation', placeDenturesFulfillmentCore: (
    { __typename?: 'lab_order' }
    & LabsGqlPlacedOrderFragment
  ) };

export type LabsGqlPlaceDenturesFulfillmentWaxRimMutationVariables = Types.Exact<{
  data: Types.LabsGqlPlaceDenturesFulfillmentWaxRimCommand;
}>;


export type LabsGqlPlaceDenturesFulfillmentWaxRimMutation = { __typename?: 'Mutation', placeDenturesFulfillmentWaxRim: (
    { __typename?: 'lab_order' }
    & LabsGqlPlacedOrderFragment
  ) };

export type LabsGqlContinueDenturesFulfillmentWaxRimMutationVariables = Types.Exact<{
  data: Types.LabsGqlContinueDenturesFulfillmentWaxRimCommand;
}>;


export type LabsGqlContinueDenturesFulfillmentWaxRimMutation = { __typename?: 'Mutation', continueDenturesFulfillmentWaxRim: (
    { __typename?: 'lab_order' }
    & LabsGqlPlacedOrderFragment
  ) };

export type LabsGqlPracticeScheduleTrainingRequestFragment = { __typename?: 'PracticeRequestScheduleTraining', training_uri: string, type: Types.LabsGqlPracticeRequestType };

export type LabsGqlPracticeMarketingMaterialsRequestFragment = { __typename?: 'PracticeRequestMarketingMaterials', address_id: string, doctor_id: string, type: Types.LabsGqlPracticeRequestType };

export type LabsGqlPracticeRequestFragment = { __typename?: 'PracticeRequestDTO', created_at: string, organization_id: string, metadata: (
    { __typename?: 'PracticeRequestMarketingMaterials' }
    & LabsGqlPracticeMarketingMaterialsRequestFragment
  ) | (
    { __typename?: 'PracticeRequestScheduleTraining' }
    & LabsGqlPracticeScheduleTrainingRequestFragment
  ) };

export type LabsGqlCreatePracticeRequestMarketingMaterialsMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePracticeRequestMarketingMaterialsCommand;
}>;


export type LabsGqlCreatePracticeRequestMarketingMaterialsMutation = { __typename?: 'Mutation', createPracticeRequestMarketingMaterials: (
    { __typename?: 'PracticeRequestDTO' }
    & LabsGqlPracticeRequestFragment
  ) };

export type LabsGqlCreatePracticeRequestScheduleTrainingMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePracticeRequestScheduleTrainingCommand;
}>;


export type LabsGqlCreatePracticeRequestScheduleTrainingMutation = { __typename?: 'Mutation', createPracticeRequestScheduleTraining: (
    { __typename?: 'PracticeRequestDTO' }
    & LabsGqlPracticeRequestFragment
  ) };

export type LabsGqlUpdateDesignStaffStatusMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateDesignStaffStatusCommand;
}>;


export type LabsGqlUpdateDesignStaffStatusMutation = { __typename?: 'Mutation', updateDesignStaffStatus: { __typename?: 'DesignStaffDTO', status: Types.LabsGqlDesignStaffStatus } };

export type LabsGqlPreemptDesignTaskTimeoutMutationVariables = Types.Exact<{
  data: Types.LabsGqlPreemptDesignTaskTimeoutCommand;
}>;


export type LabsGqlPreemptDesignTaskTimeoutMutation = { __typename?: 'Mutation', preemptDesignTaskTimeout: { __typename?: 'DesignStaffDTO', id: string } };

export type LabsGqlNonDoctorPracticeStaffFragment = { __typename?: 'NonDoctorPracticeStaffDTO', id: string, name: string, role: Maybe<string>, kustomer_customer_id: Maybe<string> };

export type LabsGqlCreateNonDoctorPracticeStaffMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateNonDoctorPracticeStaffCommand;
}>;


export type LabsGqlCreateNonDoctorPracticeStaffMutation = { __typename?: 'Mutation', createNonDoctorPracticeStaff: (
    { __typename?: 'NonDoctorPracticeStaffDTO' }
    & LabsGqlNonDoctorPracticeStaffFragment
  ) };

export type LabsGqlDeleteNonDoctorPracticeStaffMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteNonDoctorPracticeStaffCommand;
}>;


export type LabsGqlDeleteNonDoctorPracticeStaffMutation = { __typename?: 'Mutation', deleteNonDoctorPracticeStaff: (
    { __typename?: 'NonDoctorPracticeStaffDTO' }
    & LabsGqlNonDoctorPracticeStaffFragment
  ) };

export type LabsGqlSetNonDoctorPracticeStaffMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetNonDoctorPracticeStaffCommand;
}>;


export type LabsGqlSetNonDoctorPracticeStaffMutation = { __typename?: 'Mutation', setNonDoctorPracticeStaff: (
    { __typename?: 'NonDoctorPracticeStaffDTO' }
    & LabsGqlNonDoctorPracticeStaffFragment
  ) };

export type LabsGqlSetDoctorProfilePhotoMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetDoctorProfilePhotoCommand;
}>;


export type LabsGqlSetDoctorProfilePhotoMutation = { __typename?: 'Mutation', setDoctorProfilePhoto: { __typename?: 'DoctorPreferences', id: string, profile_photo: (
      { __typename?: 'DoctorProfilePhotoDTO' }
      & LabsGqlDoctorProfilePhotoFragment
    ) } };

export type LabsGqlSubmitQcFlagMutationVariables = Types.Exact<{
  data: Types.LabsGqlSubmitQcFlagCommand;
}>;


export type LabsGqlSubmitQcFlagMutation = { __typename?: 'Mutation', submitQcFlag: { __typename?: 'lab_order', id: string } };

export type LabsGqlUpdatePracticeSupportMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdatePracticeSupportCommand;
}>;


export type LabsGqlUpdatePracticeSupportMutation = { __typename?: 'Mutation', updatePracticeSupport: { __typename?: 'PracticeSupportDTO', id: string } };

export type LabsGqlCreatePracticeSupportMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePracticeSupportCommand;
}>;


export type LabsGqlCreatePracticeSupportMutation = { __typename?: 'Mutation', createPracticeSupport: { __typename?: 'PracticeSupportDTO', id: string } };

export type LabsGqlMobileUploadLoadedMutationVariables = Types.Exact<{
  case_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlMobileUploadLoadedMutation = { __typename?: 'Mutation', mobileUploadLoaded: boolean };

export type LabsGqlCreateThreeshapeDmeMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateThreeshapeDmeCommand;
}>;


export type LabsGqlCreateThreeshapeDmeMutation = { __typename?: 'Mutation', createThreeshapeDme: { __typename?: 'ThreeshapeDmeDTO', id: string } };

export type LabsGqlArchiveThreeshapeDmeMutationVariables = Types.Exact<{
  data: Types.LabsGqlArchiveThreeshapeDmeCommand;
}>;


export type LabsGqlArchiveThreeshapeDmeMutation = { __typename?: 'Mutation', archiveThreeshapeDme: { __typename?: 'ThreeshapeDmeDTO', id: string } };

export type LabsGqlUnarchiveThreeshapeDmeMutationVariables = Types.Exact<{
  data: Types.LabsGqlUnarchiveThreeshapeDmeCommand;
}>;


export type LabsGqlUnarchiveThreeshapeDmeMutation = { __typename?: 'Mutation', unarchiveThreeshapeDme: { __typename?: 'ThreeshapeDmeDTO', id: string } };

export type LabsGqlUpdateThreeshapeDmeFilePathMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateThreeshapeDmeFilePathCommand;
}>;


export type LabsGqlUpdateThreeshapeDmeFilePathMutation = { __typename?: 'Mutation', updateThreeshapeDmeFilePath: { __typename?: 'ThreeshapeDmeDTO', id: string } };

export type LabsGqlCreateAbutmentPartMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateAbutmentPartCommand;
}>;


export type LabsGqlCreateAbutmentPartMutation = { __typename?: 'Mutation', createAbutmentPart: { __typename?: 'AbutmentPartDTO', id: string } };

export type LabsGqlArchiveAbutmentPartMutationVariables = Types.Exact<{
  data: Types.LabsGqlArchiveAbutmentPartCommand;
}>;


export type LabsGqlArchiveAbutmentPartMutation = { __typename?: 'Mutation', archiveAbutmentPart: { __typename?: 'AbutmentPartDTO', id: string } };

export type LabsGqlUnarchiveAbutmentPartMutationVariables = Types.Exact<{
  data: Types.LabsGqlUnarchiveAbutmentPartCommand;
}>;


export type LabsGqlUnarchiveAbutmentPartMutation = { __typename?: 'Mutation', unarchiveAbutmentPart: { __typename?: 'AbutmentPartDTO', id: string } };

export type LabsGqlUpdateAbutmentPartMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateAbutmentPartCommand;
}>;


export type LabsGqlUpdateAbutmentPartMutation = { __typename?: 'Mutation', updateAbutmentPart: (
    { __typename?: 'AbutmentPartDTO' }
    & LabsGqlAbutmentPartFragment
  ) };

export type LabsGqlAddAbutmentPartToImplantScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddAbutmentPartToImplantScanbodyCommand;
}>;


export type LabsGqlAddAbutmentPartToImplantScanbodyMutation = { __typename?: 'Mutation', addAbutmentPartToImplantScanbody: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlUpdateAbutmentPartToImplantScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateAbutmentPartToImplantScanbodyCommand;
}>;


export type LabsGqlUpdateAbutmentPartToImplantScanbodyMutation = { __typename?: 'Mutation', updateAbutmentPartToImplantScanbody: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlRemoveAbutmentPartToImplantScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlRemoveAbutmentPartToImplantScanbodyCommand;
}>;


export type LabsGqlRemoveAbutmentPartToImplantScanbodyMutation = { __typename?: 'Mutation', removeAbutmentPartToImplantScanbody: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlCreateCompletedScanningCaseMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateCompletedScanningCaseCommand;
}>;


export type LabsGqlCreateCompletedScanningCaseMutation = { __typename?: 'Mutation', createCompletedScanningCase: { __typename?: 'CompletedScanningCaseDTO', id: string } };

export type LabsGqlCreateDesignQaEvaluationMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateDesignQaEvaluationCommand;
}>;


export type LabsGqlCreateDesignQaEvaluationMutation = { __typename?: 'Mutation', createDesignQaEvaluation: { __typename?: 'DesignQaEvaluationDTO', id: string } };

export type LabsGqlSubmitDesignQaEvaluationMutationVariables = Types.Exact<{
  data: Types.LabsGqlSubmitDesignQaEvaluationCommand;
}>;


export type LabsGqlSubmitDesignQaEvaluationMutation = { __typename?: 'Mutation', submitDesignQaEvaluation: (
    { __typename?: 'DesignQaEvaluationDTO' }
    & LabsGqlDesignQaEvaluationDtoFragment
  ) };

export type LabsGqlCancelAndResubmitMutationVariables = Types.Exact<{
  data: Types.LabsGqlCancelAndResubmitCommand;
}>;


export type LabsGqlCancelAndResubmitMutation = { __typename?: 'Mutation', cancelAndResubmit: { __typename?: 'lab_order', id: string, replaced_by_ids: Maybe<Array<string>> } };

export type LabsGqlOrderReturnForTryInFeedbackFragment = { __typename?: 'IOrderReturn', status: Types.LabsGqlOrderReturnStatus, label_url: string };

export type LabsGqlCreateReturnForTryInMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateReturnForTryInCommand;
}>;


export type LabsGqlCreateReturnForTryInMutation = { __typename?: 'Mutation', createReturnForTryIn: (
    { __typename?: 'IOrderReturn' }
    & LabsGqlOrderReturnForTryInFeedbackFragment
  ) };

export type LabsGqlPlaceLabOrderFromTryInMutationVariables = Types.Exact<{
  data: Types.LabsGqlPlaceLabOrderFromTryInCommand;
}>;


export type LabsGqlPlaceLabOrderFromTryInMutation = { __typename?: 'Mutation', placeLabOrderFromTryIn: { __typename?: 'lab_order', id: string } };

export type LabsGqlListDisplayRuleOptsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListDisplayRuleOptsQuery = { __typename?: 'Query', listDisplayRuleOptions: { __typename?: 'DisplayRuleOptions', material_types: Array<string>, unit_types: Array<string> } };

export type LabsGqlCustomFieldFragment = { __typename?: 'ICustomField', id: string, name: string, element: Types.LabsGqlCustomFieldElement, type: Types.LabsGqlCustomFieldType, helper_text: Maybe<string>, optional: Maybe<boolean>, has_preference: boolean, updated_at: string, created_at: string, label: Maybe<string>, preference_label: Maybe<string>, archived: boolean, sort_order: number, default_value: Maybe<string | boolean | number>, order_form_inline_values: Maybe<Array<string>>, options: Maybe<Array<{ __typename?: 'ICustomFieldOption', value: string, label: Maybe<string>, color: Maybe<string>, internal_display_label: Maybe<string>, image_url: Maybe<string>, non_standard: Maybe<boolean> }>>, display_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )>, pricing_rules: Array<(
    { __typename?: 'CustomFieldPricingRule' }
    & LabsGqlFieldPricingRuleFragment
  )>, suggested_values: Maybe<Array<(
    { __typename?: 'ICustomFieldSuggestion' }
    & LabsGqlCustomFieldSuggestionFragment
  )>> };

export type LabsGqlFieldPricingRuleFragment = { __typename?: 'CustomFieldPricingRule', id: string, default_price_cents: Maybe<number>, field_value: string | boolean | number, partner_prices: Array<{ __typename?: 'PartnerPriceOverride', partner_id: string, price_cents: number }> };

export type LabsGqlDisplayRuleFragment = { __typename?: 'CustomFieldDisplayRule', id: string, name: string, applicable_values: Array<string>, display_if_passes: boolean, property: Types.LabsGqlDisplayRuleOrderProperty };

export type LabsGqlCustomFieldSuggestionFragment = { __typename?: 'ICustomFieldSuggestion', id: string, name: string, recommended_option: string, item_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )> };

export type LabsGqlCancelDesignQaEvaluationsMutationVariables = Types.Exact<{
  evaluation_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlCancelDesignQaEvaluationsMutation = { __typename?: 'Mutation', cancelDesignQaEvaluations: boolean };

export type LabsGqlRequestScanReviewMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  reasons: Array<Types.Scalars['String']['input']>;
  notes: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlRequestScanReviewMutation = { __typename?: 'Mutation', requestScanReview: { __typename?: 'lab_order', id: string } };

export type LabsGqlSubmitScanReviewMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  rejection: Types.InputMaybe<Types.LabsGqlOrderScanReviewRejectionInput>;
  approval_notes: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSubmitScanReviewMutation = { __typename?: 'Mutation', submitOrderScanReview: { __typename?: 'lab_order', id: string } };

export type LabsGqlResolveRejectedScanMutationVariables = Types.Exact<{
  data: Types.LabsGqlResolveOrderScanRejectionCommand;
}>;


export type LabsGqlResolveRejectedScanMutation = { __typename?: 'Mutation', resolveOrderScanRejection: { __typename?: 'lab_order', id: string } };

export type LabsGqlPracticeRespondToRejectedScanMutationVariables = Types.Exact<{
  data: Types.LabsGqlPracticeRespondToRejectedScanCommand;
}>;


export type LabsGqlPracticeRespondToRejectedScanMutation = { __typename?: 'Mutation', practiceRespondToRejectedScan: { __typename?: 'lab_order', id: string } };

export type LabsGqlConfigureDesignerTypeMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  internal_design_required: Types.Scalars['Boolean']['input'];
  internal_design_prep_required: Types.Scalars['Boolean']['input'];
  separate_model_design_step: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  automate_review_required: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlConfigureDesignerTypeMutation = { __typename?: 'Mutation', configureOrderDesignerType: { __typename?: 'lab_order', id: string } };

export type LabsGqlCompleteInternalDesignTaskMutationVariables = Types.Exact<{
  data: Types.LabsGqlCompleteInternalDesignTaskCommand;
}>;


export type LabsGqlCompleteInternalDesignTaskMutation = { __typename?: 'Mutation', completeInternalDesignTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlCompleteModelDesignTaskMutationVariables = Types.Exact<{
  data: Types.LabsGqlCompleteModelDesignTaskCommand;
}>;


export type LabsGqlCompleteModelDesignTaskMutation = { __typename?: 'Mutation', completeModelDesignTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlCompleteDesignPrepTaskMutationVariables = Types.Exact<{
  data: Types.LabsGqlCompleteDesignPrepTaskCommand;
}>;


export type LabsGqlCompleteDesignPrepTaskMutation = { __typename?: 'Mutation', completeDesignPrepTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlConfigureDesignReviewMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  design_review_required: Types.Scalars['Boolean']['input'];
  external_design_review_blocking: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlConfigureDesignReviewMutation = { __typename?: 'Mutation', configureOrderDesignReview: { __typename?: 'lab_order', id: string } };

export type LabsGqlConfigureDesignReview2MutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  required: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlConfigureDesignReview2Mutation = { __typename?: 'Mutation', configureDesignReview2Command: { __typename?: 'lab_order', id: string } };

export type LabsGqlCompleteDesignReviewTaskMutationVariables = Types.Exact<{
  data: Types.LabsGqlCompleteDesignReviewTaskCommand;
}>;


export type LabsGqlCompleteDesignReviewTaskMutation = { __typename?: 'Mutation', completeDesignReviewTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlCompleteExternalDesignVerificationTaskMutationVariables = Types.Exact<{
  data: Types.LabsGqlCompleteExternalDesignVerificationTaskCommand;
}>;


export type LabsGqlCompleteExternalDesignVerificationTaskMutation = { __typename?: 'Mutation', completeExternalDesignVerificationTask: { __typename?: 'lab_order', id: string } };

export type LabsGqlUpsertDesignStaffMutationVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
  task_type: Types.LabsGqlDesignStaffTaskType;
  capabilities: Types.LabsGqlDesignStaffCapabilityInput;
}>;


export type LabsGqlUpsertDesignStaffMutation = { __typename?: 'Mutation', upsertDesignStaff: (
    { __typename?: 'DesignStaffDTO' }
    & LabsGqlDesignStaffDtoFragment
  ) };

export type LabsGqlCreateDesignStaffTeamMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type LabsGqlCreateDesignStaffTeamMutation = { __typename?: 'Mutation', createDesignStaffTeam: (
    { __typename?: 'DesignStaffTeamDTO' }
    & LabsGqlDesignStaffTeamDtoFragment
  ) };

export type LabsGqlPatchDesignStaffRosterInfoMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateDesignStaffRosterInfoCommand;
}>;


export type LabsGqlPatchDesignStaffRosterInfoMutation = { __typename?: 'Mutation', updateDesignStaffRosterInfo: (
    { __typename?: 'DesignStaffDTO' }
    & LabsGqlDesignStaffDtoFragment
  ) };

export type LabsGqlBulkUpdateDesignStaffRosterMutationVariables = Types.Exact<{
  uploadPath: Types.Scalars['String']['input'];
}>;


export type LabsGqlBulkUpdateDesignStaffRosterMutation = { __typename?: 'Mutation', bulkUpdateDesignStaffRoster: { __typename?: 'BulkUpdateResult', success: boolean } };

export type LabsGqlOffboardDesignStaffMutationVariables = Types.Exact<{
  data: Types.LabsGqlOffboardDesignStaffCommand;
}>;


export type LabsGqlOffboardDesignStaffMutation = { __typename?: 'Mutation', offboardDesignStaff: { __typename?: 'DesignStaffDTO', id: string, status: Types.LabsGqlDesignStaffStatus } };

export type LabsGqlReOnboardDesignStaffMutationVariables = Types.Exact<{
  data: Types.LabsGqlReOnboardDesignStaffCommand;
}>;


export type LabsGqlReOnboardDesignStaffMutation = { __typename?: 'Mutation', reOnboardDesignStaff: { __typename?: 'DesignStaffDTO', id: string, status: Types.LabsGqlDesignStaffStatus } };

export type LabsGqlCreateAndDeleteFocusAreasMutationVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
  focus_areas: Array<Types.LabsGqlDesignStaffFocusAreaInput>;
}>;


export type LabsGqlCreateAndDeleteFocusAreasMutation = { __typename?: 'Mutation', createAndDeleteFocusAreas: Array<(
    { __typename?: 'DesignStaffFocusAreaDTO' }
    & LabsGqlDesignStaffFocusAreaDtoFragment
  )> };

export type LabsGqlCreateManualLabOrderIntegrationAttemptMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlCreateManualLabOrderIntegrationAttemptMutation = { __typename?: 'Mutation', createManualLabOrderIntegrationAttempt: Maybe<Array<{ __typename?: 'CreateLabOrderIntegrationAttemptResponse', orderId: string, success: boolean, errorMessage: Maybe<string> }>> };

export type LabsGqlLabBulkOverrideOrderUnitPriceResultFragment = { __typename?: 'LabBulkOverrideOrderUnitPriceResult', errors: Array<string> };

export type LabsGqlLabLedgerEntryReviewedToggledEventMutationVariables = Types.Exact<{
  data: Types.LabsGqlToggleLabLedgerEntryReviewedCommand;
}>;


export type LabsGqlLabLedgerEntryReviewedToggledEventMutation = { __typename?: 'Mutation', toggleLabLedgerEntryReviewed: { __typename?: 'LabPriceLedgerDTO', id: string } };

export type LabsGqlCreateLabCaseLedgerEntryMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateLabCaseLedgerEntryCommand;
}>;


export type LabsGqlCreateLabCaseLedgerEntryMutation = { __typename?: 'Mutation', createLabCaseLedgerEntry: { __typename?: 'LabCaseLedgerDTO', id: string } };

export type LabsGqlToggleLabCaseLedgerEntryReviewedMutationVariables = Types.Exact<{
  data: Types.LabsGqlToggleLabCaseLedgerEntryReviewedCommand;
}>;


export type LabsGqlToggleLabCaseLedgerEntryReviewedMutation = { __typename?: 'Mutation', toggleLabCaseLedgerEntryReviewed: { __typename?: 'LabCaseLedgerDTO', id: string } };

export type LabsGqlOverrideLabCaseUnitPriceMutationVariables = Types.Exact<{
  data: Types.LabsGqlOverrideLabCaseUnitPriceCommand;
}>;


export type LabsGqlOverrideLabCaseUnitPriceMutation = { __typename?: 'Mutation', overrideLabCaseUnitPrice: { __typename?: 'LabCaseLedgerDTO', id: string } };

export type LabsGqlBulkOverrideLabUnitPricesMutationVariables = Types.Exact<{
  overrides: Types.LabsGqlLabBulkOverrideOrderUnitPriceArgs;
}>;


export type LabsGqlBulkOverrideLabUnitPricesMutation = { __typename?: 'Mutation', bulkOverrideLabUnitPrices: (
    { __typename?: 'LabBulkOverrideOrderUnitPriceResult' }
    & LabsGqlLabBulkOverrideOrderUnitPriceResultFragment
  ) };

export type LabsGqlCreateLabCaseCompletionMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateLabCaseCompletionCommand;
}>;


export type LabsGqlCreateLabCaseCompletionMutation = { __typename?: 'Mutation', createLabCaseCompletion: { __typename?: 'LabCaseCompletionDTO', id: string } };

export type LabsGqlCreateLabPriceMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateLabPriceCommand;
}>;


export type LabsGqlCreateLabPriceMutation = { __typename?: 'Mutation', createLabPrice: (
    { __typename?: 'LabPriceDTO' }
    & LabsGqlLabPriceFragment
  ) };

export type LabsGqlUpdateLabPriceMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateLabPriceCommand;
}>;


export type LabsGqlUpdateLabPriceMutation = { __typename?: 'Mutation', updateLabPrice: (
    { __typename?: 'LabPriceDTO' }
    & LabsGqlLabPriceFragment
  ) };

export type LabsGqlConfigureLabPriceLabPricesMutationVariables = Types.Exact<{
  data: Types.LabsGqlConfigureLabPriceLabPricesCommand;
}>;


export type LabsGqlConfigureLabPriceLabPricesMutation = { __typename?: 'Mutation', configureLabPriceLabPrices: { __typename?: 'LabPriceDTO', id: string, name: string, lab_configs: Array<(
      { __typename?: 'LabPriceConfigDTO' }
      & LabsGqlLabPriceConfigFragment
    )> } };

export type LabsGqlConfigureLabPricePartnerPricesMutationVariables = Types.Exact<{
  data: Types.LabsGqlConfigureLabPricePartnerPricesCommand;
}>;


export type LabsGqlConfigureLabPricePartnerPricesMutation = { __typename?: 'Mutation', configureLabPricePartnerPrices: { __typename?: 'LabPriceDTO', id: string, name: string, partner_configs: Array<(
      { __typename?: 'LabPricePartnerConfigDTO' }
      & LabsGqlLabPricePartnerConfigFragment
    )> } };

export type LabsGqlToggleLabPriceDeletionMutationVariables = Types.Exact<{
  data: Types.LabsGqlToggleLabPriceDeletionCommand;
}>;


export type LabsGqlToggleLabPriceDeletionMutation = { __typename?: 'Mutation', toggleLabPriceDeletion: (
    { __typename?: 'LabPriceDTO' }
    & LabsGqlLabPriceFragment
  ) };

export type LabsGqlQueueZeroOutModelsBulkPricingJobMutationVariables = Types.Exact<{
  orderIds: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlQueueZeroOutModelsBulkPricingJobMutation = { __typename?: 'Mutation', queueZeroOutModelsBulkPricingJob: Maybe<(
    { __typename?: 'OrderPriceAdjustmentBulkJobStatus' }
    & LabsGqlOrderPriceAdjustmentBulkJobStatusFragment
  )> };

export type LabsGqlListZeroOutModelsBulkPricingJobsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListZeroOutModelsBulkPricingJobsQuery = { __typename?: 'Query', listZeroOutModelsBulkPricingJobs: Array<(
    { __typename?: 'OrderPriceAdjustmentBulkJobStatus' }
    & LabsGqlOrderPriceAdjustmentBulkJobStatusFragment
  )> };

export type LabsGqlBulkPriceAdjustmentOrderResultFragment = { __typename?: 'BulkPriceAdjustmentOrderResult', order_id: string, message: Maybe<string> };

export type LabsGqlOrderPriceAdjustmentBulkJobStatusFragment = { __typename?: 'OrderPriceAdjustmentBulkJobStatus', id: string, status: string, created_at: string, started_at: Maybe<string>, completed_at: Maybe<string>, order_ids: Array<string>, orders_missing_pricing: Array<(
    { __typename?: 'BulkPriceAdjustmentOrderResult' }
    & LabsGqlBulkPriceAdjustmentOrderResultFragment
  )>, errors: Array<(
    { __typename?: 'BulkPriceAdjustmentOrderResult' }
    & LabsGqlBulkPriceAdjustmentOrderResultFragment
  )>, successes: Array<(
    { __typename?: 'BulkPriceAdjustmentOrderResult' }
    & LabsGqlBulkPriceAdjustmentOrderResultFragment
  )> };

export type LabsGqlSetSalesforcePriceMappingMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetSalesforcePriceMappingCommand;
}>;


export type LabsGqlSetSalesforcePriceMappingMutation = { __typename?: 'Mutation', setSalesforcePriceMapping: (
    { __typename?: 'LabPriceDTO' }
    & LabsGqlLabPriceFragment
  ) };

export type LabsGqlBulkUpsertLabPriceLabPricesMutationVariables = Types.Exact<{
  data: Types.LabsGqlBulkUpsertLabPriceLabPrices;
}>;


export type LabsGqlBulkUpsertLabPriceLabPricesMutation = { __typename?: 'Mutation', bulkUpsertLabPriceLabPrices: boolean };

export type LabsGqlBulkUpsertOrganizationPricesMutationVariables = Types.Exact<{
  data: Types.LabsGqlBulkUpsertOrganizationPricesCommand;
}>;


export type LabsGqlBulkUpsertOrganizationPricesMutation = { __typename?: 'Mutation', bulkUpsertOrganizationPrices: boolean };

export type LabsGqlCreateOrganizationPriceConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateOrganizationPriceConfigCommand;
}>;


export type LabsGqlCreateOrganizationPriceConfigMutation = { __typename?: 'Mutation', createOrganizationPriceConfig: (
    { __typename?: 'OrganizationPriceConfigDTO' }
    & LabsGqlOrganizationPriceConfigFragment
  ) };

export type LabsGqlUpdateOrganizationPriceConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrganizationPriceConfigCommand;
}>;


export type LabsGqlUpdateOrganizationPriceConfigMutation = { __typename?: 'Mutation', updateOrganizationPriceConfig: (
    { __typename?: 'OrganizationPriceConfigDTO' }
    & LabsGqlOrganizationPriceConfigFragment
  ) };

export type LabsGqlDeleteOrganizationPriceConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteOrganizationPriceConfigCommand;
}>;


export type LabsGqlDeleteOrganizationPriceConfigMutation = { __typename?: 'Mutation', deleteOrganizationPriceConfig: (
    { __typename?: 'OrganizationPriceConfigDTO' }
    & LabsGqlOrganizationPriceConfigFragment
  ) };

export type LabsGqlOrganizationPriceConfigFragment = { __typename?: 'OrganizationPriceConfigDTO', id: string, organization_id: string, organization_type: Types.LabsGqlOrganizationTypeForPricing, price_id: string, price_cents: number };

export type LabsGqlBulkSendToFloorMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlBulkSendToFloorMutation = { __typename?: 'Mutation', sendOrdersToFloorBulk: Array<{ __typename?: 'lab_order', id: string }> };

export type LabsGqlBulkCreateFabricationMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlBulkCreateFabricationMutation = { __typename?: 'Mutation', createFabricationBulk: Array<{ __typename?: 'CreateFabricationResult', id: string }> };

export type LabsGqlBulkRecordDesignDownloadedMutationVariables = Types.Exact<{
  files: Array<Types.LabsGqlDownloadedFileInfo>;
}>;


export type LabsGqlBulkRecordDesignDownloadedMutation = { __typename?: 'Mutation', recordDesignDownloadedManufacturerBulk: { __typename?: 'ManufacturerBulkMutationResult', success_ids: Array<string>, error_ids: Array<string> } };

export type LabsGqlBulkReturnReceivedMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlBulkReturnReceivedMutation = { __typename?: 'Mutation', markReturnReceivedBulk: { __typename?: 'ManufacturerBulkMutationResult', success_ids: Array<string>, error_ids: Array<string> } };

export type LabsGqlRerunDesignConversionMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  revision_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  force_temporal_workflow: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlRerunDesignConversionMutation = { __typename?: 'Mutation', rerunDesignConversion: boolean };

export type LabsGqlBulkCreateDesignOrdersMutationVariables = Types.Exact<{
  lab_order_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlBulkCreateDesignOrdersMutation = { __typename?: 'Mutation', bulkCreateDesignOrders: boolean };

export type LabsGqlSubmitPrepInBrowserMutationVariables = Types.Exact<{
  payload: Types.LabsGqlPrepInBrowserPayload;
}>;


export type LabsGqlSubmitPrepInBrowserMutation = { __typename?: 'Mutation', submitPrepInBrowser: boolean };

export type LabsGqlGenerateEmptyDesignFileMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGenerateEmptyDesignFileMutation = { __typename?: 'Mutation', generateEmptyDesignFile: string };

export type LabsGqlBulkUpdateOrderPricesMutationVariables = Types.Exact<{
  updates: Array<Types.LabsGqlUpdateOrderPriceEntryCommand>;
}>;


export type LabsGqlBulkUpdateOrderPricesMutation = { __typename?: 'Mutation', bulkUpdateOrderPrices: Array<(
    { __typename?: 'OrderPriceDTO' }
    & LabsGqlOrderPriceDtoFragment
  )> };

export type LabsGqlCreateOrderPriceBackfillWorkflowMutationVariables = Types.Exact<{
  args: Types.LabsGqlCreateOrderPriceBackfillWorkflowArgs;
}>;


export type LabsGqlCreateOrderPriceBackfillWorkflowMutation = { __typename?: 'Mutation', createOrderPriceBackfillWorkflow: { __typename?: 'CreateOrderPriceBackfillWorkflowResult', workflowId: string } };

export type LabsGqlCreateTicketMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateTicketCommand;
}>;


export type LabsGqlCreateTicketMutation = { __typename?: 'Mutation', createTicket: { __typename?: 'TicketDTO', id: string } };

export type LabsGqlAppendTicketActionMutationVariables = Types.Exact<{
  data: Types.LabsGqlAppendTicketActionCommand;
}>;


export type LabsGqlAppendTicketActionMutation = { __typename?: 'Mutation', appendTicketAction: { __typename?: 'TicketDTO', id: string } };

export type LabsGqlEditTicketActionNoteMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditTicketActionNoteCommand;
}>;


export type LabsGqlEditTicketActionNoteMutation = { __typename?: 'Mutation', editTicketActionNote: { __typename?: 'TicketDTO', id: string } };

export type LabsGqlClaimTicketActionMutationVariables = Types.Exact<{
  data: Types.LabsGqlClaimTicketActionCommand;
}>;


export type LabsGqlClaimTicketActionMutation = { __typename?: 'Mutation', claimTicketAction: { __typename?: 'TicketDTO', id: string } };

export type LabsGqlReleaseTicketActionMutationVariables = Types.Exact<{
  data: Types.LabsGqlReleaseTicketActionCommand;
}>;


export type LabsGqlReleaseTicketActionMutation = { __typename?: 'Mutation', releaseTicketAction: { __typename?: 'TicketDTO', id: string } };

export type LabsGqlCloseTicketActionMutationVariables = Types.Exact<{
  data: Types.LabsGqlCloseTicketActionCommand;
}>;


export type LabsGqlCloseTicketActionMutation = { __typename?: 'Mutation', closeTicketAction: { __typename?: 'TicketDTO', id: string } };

export type LabsGqlCreateActionTypeMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateActionTypeCommand;
}>;


export type LabsGqlCreateActionTypeMutation = { __typename?: 'Mutation', createActionType: { __typename?: 'ActionTypeDTO', id: string } };

export type LabsGqlUpdateActionTypeMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateActionTypeCommand;
}>;


export type LabsGqlUpdateActionTypeMutation = { __typename?: 'Mutation', updateActionType: { __typename?: 'ActionTypeDTO', id: string } };

export type LabsGqlCreateActionCategoryMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateActionCategoryCommand;
}>;


export type LabsGqlCreateActionCategoryMutation = { __typename?: 'Mutation', createActionCategory: { __typename?: 'ActionCategoryDTO', id: string } };

export type LabsGqlUpdateActionCategoryMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateActionCategoryCommand;
}>;


export type LabsGqlUpdateActionCategoryMutation = { __typename?: 'Mutation', updateActionCategory: { __typename?: 'ActionCategoryDTO', id: string } };

export type LabsGqlCreateActionCapabilityMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateActionCapabilityCommand;
}>;


export type LabsGqlCreateActionCapabilityMutation = { __typename?: 'Mutation', createActionCapability: { __typename?: 'ActionCapabilityDTO', id: string } };

export type LabsGqlUpdateActionCapabilityMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateActionCapabilityCommand;
}>;


export type LabsGqlUpdateActionCapabilityMutation = { __typename?: 'Mutation', updateActionCapability: { __typename?: 'ActionCapabilityDTO', id: string } };

export type LabsGqlEditBillingContactEmailMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  contact_emails: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlEditBillingContactEmailMutation = { __typename?: 'Mutation', editBillingContacts: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlUpdatePrimaryBillingContactUserIdMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  primary_billing_contact_user_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlUpdatePrimaryBillingContactUserIdMutation = { __typename?: 'Mutation', updatePrimaryBillingContactUserId: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlUpdatePrimaryBillingContactUserMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  primary_billing_contact_user_id: Types.Scalars['String']['input'];
  primary_billing_contact_user_type: Types.LabsGqlBillingContactUserType;
}>;


export type LabsGqlUpdatePrimaryBillingContactUserMutation = { __typename?: 'Mutation', updatePrimaryBillingContactUser: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlEditAccountManagementContactsMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  account_management_contact_emails: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlEditAccountManagementContactsMutation = { __typename?: 'Mutation', editAccountManagementContacts: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlBulkUpdatePartnerBillingBooleanMutationVariables = Types.Exact<{
  partner_ids: Array<Types.Scalars['String']['input']>;
  property: Types.LabsGqlPartnerBillingBoolean;
  value: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlBulkUpdatePartnerBillingBooleanMutation = { __typename?: 'Mutation', bulkUpdatePartnerBillingConfigFlag: Array<(
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  )> };

export type LabsGqlSetUsagePaymentSplitPercentMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  splits: Array<Types.LabsGqlPaymentSplitConfigEntryPercentIn>;
}>;


export type LabsGqlSetUsagePaymentSplitPercentMutation = { __typename?: 'Mutation', setUsagePaymentSplitConfigPercent: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlSetUsagePaymentSplitDoctorsMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  splits: Array<Types.LabsGqlPaymentSplitConfigEntryDoctorIn>;
}>;


export type LabsGqlSetUsagePaymentSplitDoctorsMutation = { __typename?: 'Mutation', setUsagePaymentSplitConfigDoctor: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlSetUsagePaymentSplitLocationMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  splits: Array<Types.LabsGqlPaymentSplitConfigEntryLocationIn>;
}>;


export type LabsGqlSetUsagePaymentSplitLocationMutation = { __typename?: 'Mutation', setUsagePaymentSplitConfigLocation: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlRemoveUsagePaymentSplitConfigMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlRemoveUsagePaymentSplitConfigMutation = { __typename?: 'Mutation', removeUsagePaymentSplitConfig: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlUpdateStripeLinkingMutationVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  stripe_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlUpdateStripeLinkingMutation = { __typename?: 'Mutation', updateStripeLinking: (
    { __typename?: 'IPartnerBilling' }
    & LabsGqlPartnerBillingFragment
  ) };

export type LabsGqlCreatePartnerMutationVariables = Types.Exact<{
  data: Types.LabsGqlPartnerRegistrationFields;
}>;


export type LabsGqlCreatePartnerMutation = { __typename?: 'Mutation', createPartner: boolean };

export type LabsGqlCreateParentOrgMutationVariables = Types.Exact<{
  data: Types.LabsGqlParentOrgRegistrationFields;
}>;


export type LabsGqlCreateParentOrgMutation = { __typename?: 'Mutation', createParentOrg: boolean };

export type LabsGqlConvertPracticeToParentMutationVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlConvertPracticeToParentMutation = { __typename?: 'Mutation', convertPracticeToParent: boolean };

export type LabsGqlOptPracticeInToCreditCardSurchargeMutationVariables = Types.Exact<{
  data: Types.LabsGqlOptPracticeInToCreditCardSurchargeCommand;
}>;


export type LabsGqlOptPracticeInToCreditCardSurchargeMutation = { __typename?: 'Mutation', optPracticeInToCreditCardSurcharge: { __typename?: 'PracticeBillingRecurringItemsDTO', id: string, practice_id: string, type: string, start_date: Maybe<string>, end_date: Maybe<string>, deleted_at: Maybe<string> } };

export type LabsGqlOptPracticeOutOfCreditCardSurchargeMutationVariables = Types.Exact<{
  data: Types.LabsGqlOptPracticeOutOfCreditCardSurchargeCommand;
}>;


export type LabsGqlOptPracticeOutOfCreditCardSurchargeMutation = { __typename?: 'Mutation', optPracticeOutOfCreditCardSurcharge: { __typename?: 'PracticeBillingRecurringItemsDTO', id: string, practice_id: string, deleted_at: Maybe<string> } };

export type LabsGqlDeleteRegisteredInvoiceItemMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteRegisteredInvoiceItemCommand;
}>;


export type LabsGqlDeleteRegisteredInvoiceItemMutation = { __typename?: 'Mutation', deleteRegisteredInvoiceItem: { __typename?: 'PracticeBillingRecurringItemsDTO', id: string, deleted_at: Maybe<string> } };

export type LabsGqlUpdateRegisteredInvoiceItemMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateRegisteredInvoiceItemCommand;
}>;


export type LabsGqlUpdateRegisteredInvoiceItemMutation = { __typename?: 'Mutation', updateRegisteredInvoiceItem: { __typename?: 'PracticeBillingRecurringItemsDTO', id: string, updated_at: string } };

export type LabsGqlBulkRegisterInvoiceItemsMutationVariables = Types.Exact<{
  data: Types.LabsGqlBulkRegisterInvoiceItemCommand;
}>;


export type LabsGqlBulkRegisterInvoiceItemsMutation = { __typename?: 'Mutation', bulkRegisterInvoiceItems: { __typename?: 'BulkRegisterInvoiceItemResult', results: Array<{ __typename?: 'PracticeBillingRecurringItemsDTO', id: string, type: string }> } };

export type LabsGqlCreateLabMetalCostMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateLabMetalCostCommand;
}>;


export type LabsGqlCreateLabMetalCostMutation = { __typename?: 'Mutation', createLabMetalCost: (
    { __typename?: 'LabMetalCostDTO' }
    & LabsGqlMetalCostFragment
  ) };

export type LabsGqlUpsertMetalCostsBulkMutationVariables = Types.Exact<{
  metal_costs: Array<Types.LabsGqlLabMetalCostUpsertInput>;
}>;


export type LabsGqlUpsertMetalCostsBulkMutation = { __typename?: 'Mutation', upsertMetalCostsBulk: Array<(
    { __typename?: 'LabMetalCostDTO' }
    & LabsGqlMetalCostFragment
  )> };

export type LabsGqlMetalCostFragment = { __typename?: 'LabMetalCostDTO', id: string, metal_id: string, price_cents: Maybe<number> };

export type LabsGqlCreateMetalMaterialMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateMetalMaterialCommand;
}>;


export type LabsGqlCreateMetalMaterialMutation = { __typename?: 'Mutation', createMetalMaterial: (
    { __typename?: 'MetalMaterialDTO' }
    & LabsGqlMetalMaterialFragment
  ) };

export type LabsGqlDeleteMetalMaterialMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteMetalMaterialCommand;
}>;


export type LabsGqlDeleteMetalMaterialMutation = { __typename?: 'Mutation', deleteMetalMaterial: (
    { __typename?: 'MetalMaterialDTO' }
    & LabsGqlMetalMaterialFragment
  ) };

export type LabsGqlMetalMaterialFragment = { __typename?: 'MetalMaterialDTO', id: string, name: string };

export type LabsGqlMigratePreferencesToStaffMutationVariables = Types.Exact<{
  args: Types.LabsGqlMigratePreferencesToStaffArgs;
}>;


export type LabsGqlMigratePreferencesToStaffMutation = { __typename?: 'Mutation', migratePreferencesToStaff: (
    { __typename?: 'MigratedStaffResult' }
    & LabsGqlMigratedStaffResultFragment
  ) };

export type LabsGqlCreatePriceMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePriceCommand;
}>;


export type LabsGqlCreatePriceMutation = { __typename?: 'Mutation', createPrice: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlUpsertPartnerPriceConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpsertPartnerPriceConfigCommand;
}>;


export type LabsGqlUpsertPartnerPriceConfigMutation = { __typename?: 'Mutation', upsertPartnerPriceConfig: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlAddPriceApplicationRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddPriceApplicationRuleCommand;
}>;


export type LabsGqlAddPriceApplicationRuleMutation = { __typename?: 'Mutation', addPriceApplicationRule: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlRemovePriceApplicationRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlRemovePriceApplicationRuleCommand;
}>;


export type LabsGqlRemovePriceApplicationRuleMutation = { __typename?: 'Mutation', removePriceApplicationRule: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlBulkUpsertPartnerPricesMutationVariables = Types.Exact<{
  upserts: Array<Types.LabsGqlBulkUploadPartnerPriceUpsert>;
}>;


export type LabsGqlBulkUpsertPartnerPricesMutation = { __typename?: 'Mutation', bulkUpsertPrices: { __typename?: 'BulkPriceUpsertRes', errors: Array<string> } };

export type LabsGqlCreatePricePresetMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePricePresetCommand;
}>;


export type LabsGqlCreatePricePresetMutation = { __typename?: 'Mutation', createPricePreset: { __typename?: 'IPricePreset', id: string, code: string } };

export type LabsGqlUpdatePricePresetMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdatePricePresetCommand;
}>;


export type LabsGqlUpdatePricePresetMutation = { __typename?: 'Mutation', updatePricePreset: { __typename?: 'IPricePreset', id: string, code: string } };

export type LabsGqlDeletePricePresetMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeletePricePresetCommand;
}>;


export type LabsGqlDeletePricePresetMutation = { __typename?: 'Mutation', deletePricePreset: { __typename?: 'IPricePreset', id: string, code: string, deleted_at: Maybe<string> } };

export type LabsGqlApplyPricePresetMutationVariables = Types.Exact<{
  data: Types.LabsGqlApplyPricePresetCommand;
}>;


export type LabsGqlApplyPricePresetMutation = { __typename?: 'Mutation', applyPricePreset: { __typename?: 'IPricePreset', id: string, code: string } };

export type LabsGqlDeletePartnerPriceConfigMutationVariables = Types.Exact<{
  priceId: Types.Scalars['String']['input'];
  partnerId: Types.Scalars['String']['input'];
}>;


export type LabsGqlDeletePartnerPriceConfigMutation = { __typename?: 'Mutation', deletePartnerPriceConfig: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlDeletePriceMutationVariables = Types.Exact<{
  priceId: Types.Scalars['String']['input'];
}>;


export type LabsGqlDeletePriceMutation = { __typename?: 'Mutation', deletePrice: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlChangePriceNameMutationVariables = Types.Exact<{
  priceId: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type LabsGqlChangePriceNameMutation = { __typename?: 'Mutation', changePriceName: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlSetPriceSalesforceMappingMutationVariables = Types.Exact<{
  price_id: Types.Scalars['String']['input'];
  salesforce_price_mapping: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSetPriceSalesforceMappingMutation = { __typename?: 'Mutation', setPriceSalesforceMapping: (
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  ) };

export type LabsGqlSyncPricePresetsToSalesforceMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlSyncPricePresetsToSalesforceMutation = { __typename?: 'Mutation', syncPricePresetsToSalesforce: boolean };

export type LabsGqlListPricePresetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListPricePresetsQuery = { __typename?: 'Query', active_price_presets: Array<(
    { __typename?: 'IPricePreset' }
    & LabsGqlPricePresetFragment
  )> };

export type LabsGqlListLabPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListLabPricesQuery = { __typename?: 'Query', listPrices: Array<(
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  )> };

export type LabsGqlListSalesforcePriceMappingOptsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListSalesforcePriceMappingOptsQuery = { __typename?: 'Query', listSalesforcePriceNameMappings: Array<string> };

export type LabsGqlListPartnerPricesQueryVariables = Types.Exact<{
  partnerId: Types.Scalars['String']['input'];
}>;


export type LabsGqlListPartnerPricesQuery = { __typename?: 'Query', partnerPrices: Array<(
    { __typename?: 'IPrice' }
    & LabsGqlPriceFragment
  )> };

export type LabsGqlPriceFragment = { __typename?: 'IPrice', id: string, created_at: string, updated_at: string, name: string, salesforce_price_mapping: Maybe<string>, application_rules: Array<(
    { __typename?: 'PriceApplicationRule' }
    & LabsGqlPriceRuleFragment
  )>, partner_prices: Array<(
    { __typename?: 'PartnerPriceOverride' }
    & LabsGqlPartnerPriceFragment
  )> };

export type LabsGqlPartnerPriceFragment = { __typename?: 'PartnerPriceOverride', partner_id: string, price_cents: number };

export type LabsGqlPriceRuleFragment = { __typename?: 'PriceApplicationRule', material_type: Maybe<string>, unit_type: string };

export type LabsGqlPricePresetFragment = { __typename?: 'IPricePreset', id: string, code: string, price_defaults: Array<(
    { __typename?: 'DefaultPrice' }
    & LabsGqlDefaultPriceFragment
  )> };

export type LabsGqlDefaultPriceFragment = { __typename?: 'DefaultPrice', price_id: string, amount_cents: number };

export type LabsGqlBulkCreateUsersMutationVariables = Types.Exact<{
  command: Types.LabsGqlBulkCreateUsersCommand;
}>;


export type LabsGqlBulkCreateUsersMutation = { __typename?: 'Mutation', bulkCreateUsers: { __typename?: 'BulkCreateUserResult', bulk_results: Array<(
      { __typename?: 'CreateUserResult' }
      & LabsGqlCreateUserResultFragment
    )> } };

export type LabsGqlCreateUserResultFragment = { __typename?: 'CreateUserResult', message: Maybe<string>, success: boolean };

export type LabsGqlSendResetPasswordEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type LabsGqlSendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: boolean };

export type LabsGqlCreateOrganizationMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateOrganizationCommand;
}>;


export type LabsGqlCreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateOrganizationSettingsMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrganizationSettingsCommand;
}>;


export type LabsGqlUpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganizationSettings: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlSalesforceUserSyncMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlSalesforceUserSyncMutation = { __typename?: 'Mutation', salesforceUserSync: boolean };

export type LabsGqlCancelOrderReturnMutationVariables = Types.Exact<{
  reason: Types.Scalars['String']['input'];
  returnId: Types.Scalars['String']['input'];
}>;


export type LabsGqlCancelOrderReturnMutation = { __typename?: 'Mutation', cancelOrderReturn: (
    { __typename?: 'IOrderReturn' }
    & LabsGqlOrderReturnFragment
  ) };

export type LabsGqlCreateReturnForRefabMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateReturnForRefabricationCommand;
}>;


export type LabsGqlCreateReturnForRefabMutation = { __typename?: 'Mutation', createReturnForRefabrication: (
    { __typename?: 'IOrderReturn' }
    & LabsGqlOrderReturnFragment
  ) };

export type LabsGqlConfirmReturnReceivedMutationVariables = Types.Exact<{
  returnId: Types.Scalars['String']['input'];
}>;


export type LabsGqlConfirmReturnReceivedMutation = { __typename?: 'Mutation', confirmOrderReturnReceived: (
    { __typename?: 'IOrderReturn' }
    & LabsGqlOrderReturnFragment
  ) };

export type LabsGqlBiasRulesForDoctorQueryVariables = Types.Exact<{
  doctor_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlBiasRulesForDoctorQuery = { __typename?: 'Query', biasRulesForDoctor: Array<(
    { __typename?: 'BiasRule' }
    & LabsGqlBiasRuleFragment
  )> };

export type LabsGqlBiasRuleFragment = { __typename?: 'BiasRule', id: string, name: string, disabled: boolean, condition_json: string, veto: boolean, score: Maybe<number> };

export type LabsGqlCreateBiasRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateBiasRuleCommand;
}>;


export type LabsGqlCreateBiasRuleMutation = { __typename?: 'Mutation', createBiasRule: (
    { __typename?: 'BiasRule' }
    & LabsGqlBiasRuleFragment
  ) };

export type LabsGqlUpdateBiasRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateBiasRuleCommand;
}>;


export type LabsGqlUpdateBiasRuleMutation = { __typename?: 'Mutation', updateBiasRule: (
    { __typename?: 'BiasRule' }
    & LabsGqlBiasRuleFragment
  ) };

export type LabsGqlDisableBiasRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlDisableBiasRuleCommand;
}>;


export type LabsGqlDisableBiasRuleMutation = { __typename?: 'Mutation', disableBiasRule: (
    { __typename?: 'BiasRule' }
    & LabsGqlBiasRuleFragment
  ) };

export type LabsGqlEnableBiasRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlEnableBiasRuleCommand;
}>;


export type LabsGqlEnableBiasRuleMutation = { __typename?: 'Mutation', enableBiasRule: (
    { __typename?: 'BiasRule' }
    & LabsGqlBiasRuleFragment
  ) };

export type LabsGqlCapacityRuleFragment = { __typename?: 'CapacityRule', id: string, name: string, manufacturer_id: string, unit_limit: Maybe<number>, limit_range: Types.LabsGqlRoutingMetricsRange, disabled: boolean, order_limit: Maybe<number>, item_condition_json: string, order_condition_json: string, priority: number, supports_design: boolean, supports_manufacturing: boolean, active_sla_days: Array<Types.LabsGqlDayOfWeek> };

export type LabsGqlCapacityRulesForManufacturerQueryVariables = Types.Exact<{
  manufacturer_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlCapacityRulesForManufacturerQuery = { __typename?: 'Query', capacityRulesForManufacturer: Array<(
    { __typename?: 'CapacityRule' }
    & LabsGqlCapacityRuleFragment
  )> };

export type LabsGqlCreateCapacityRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateCapacityRuleCommand;
}>;


export type LabsGqlCreateCapacityRuleMutation = { __typename?: 'Mutation', createCapacityRule: (
    { __typename?: 'CapacityRule' }
    & LabsGqlCapacityRuleFragment
  ) };

export type LabsGqlUpdateCapacityRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateCapacityRuleCommand;
}>;


export type LabsGqlUpdateCapacityRuleMutation = { __typename?: 'Mutation', updateCapacityRule: (
    { __typename?: 'CapacityRule' }
    & LabsGqlCapacityRuleFragment
  ) };

export type LabsGqlDisableCapacityRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlDisableCapacityRuleCommand;
}>;


export type LabsGqlDisableCapacityRuleMutation = { __typename?: 'Mutation', disableCapacityRule: (
    { __typename?: 'CapacityRule' }
    & LabsGqlCapacityRuleFragment
  ) };

export type LabsGqlEnableCapacityRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlEnableCapacityRuleCommand;
}>;


export type LabsGqlEnableCapacityRuleMutation = { __typename?: 'Mutation', enableCapacityRule: (
    { __typename?: 'CapacityRule' }
    & LabsGqlCapacityRuleFragment
  ) };

export type LabsGqlDesignRuleFragment = { __typename?: 'DesignRule', id: string, name: string, item_condition_json: string, order_condition_json: string, unit_limit: Maybe<number>, order_limit: Maybe<number>, limit_range: Types.LabsGqlRoutingMetricsRange, disabled: boolean };

export type LabsGqlDesignRulesForManufacturerQueryVariables = Types.Exact<{
  manufacturer_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlDesignRulesForManufacturerQuery = { __typename?: 'Query', designRulesForManufacturer: Array<(
    { __typename?: 'DesignRule' }
    & LabsGqlDesignRuleFragment
  )> };

export type LabsGqlCreateDesignRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateDesignRuleCommand;
}>;


export type LabsGqlCreateDesignRuleMutation = { __typename?: 'Mutation', createDesignRule: (
    { __typename?: 'DesignRule' }
    & LabsGqlDesignRuleFragment
  ) };

export type LabsGqlUpdateDesignRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateDesignRuleCommand;
}>;


export type LabsGqlUpdateDesignRuleMutation = { __typename?: 'Mutation', updateDesignRule: (
    { __typename?: 'DesignRule' }
    & LabsGqlDesignRuleFragment
  ) };

export type LabsGqlDisableDesignRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlDisableDesignRuleCommand;
}>;


export type LabsGqlDisableDesignRuleMutation = { __typename?: 'Mutation', disableDesignRule: (
    { __typename?: 'DesignRule' }
    & LabsGqlDesignRuleFragment
  ) };

export type LabsGqlEnableDesignRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlEnableDesignRuleCommand;
}>;


export type LabsGqlEnableDesignRuleMutation = { __typename?: 'Mutation', enableDesignRule: (
    { __typename?: 'DesignRule' }
    & LabsGqlDesignRuleFragment
  ) };

export type LabsGqlLabOrderItemFragment = { __typename?: 'LabOrderItem', id: string, sku: Types.LabsGqlOrderItemSkuType };

export type LabsGqlCapacityRuleLoadResultFragment = { __typename?: 'CapacityRuleLoadResult', ruleId: string, name: string, unitCount: number, orderCount: number };

export type LabsGqlGetCapacityRuleLoadsQueryVariables = Types.Exact<{
  ruleIds: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlGetCapacityRuleLoadsQuery = { __typename?: 'Query', getCapacityRuleLoads: Array<(
    { __typename?: 'CapacityRuleLoadResult' }
    & LabsGqlCapacityRuleLoadResultFragment
  )> };

export type LabsGqlRoutingDecisionEventFragment = { __typename?: 'RoutingDecisionEvent', message: string, data: string };

export type LabsGqlDebugRoutingDecisionQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  jitConfigType: Types.Scalars['String']['input'];
}>;


export type LabsGqlDebugRoutingDecisionQuery = { __typename?: 'Query', debugRoutingDecision: Array<(
    { __typename?: 'RoutingDecisionEvent' }
    & LabsGqlRoutingDecisionEventFragment
  )> };

export type LabsGqlGetRoutingRulesForOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  manufacturerId: Types.InputMaybe<Types.Scalars['String']['input']>;
  internalDesign: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlGetRoutingRulesForOrderQuery = { __typename?: 'Query', getRoutingRulesForOrder: { __typename?: 'RoutingRulesForOrderResult', designRules: Array<(
      { __typename?: 'DesignRule' }
      & LabsGqlDesignRuleFragment
    )>, labFilterRules: Array<(
      { __typename?: 'BiasRule' }
      & LabsGqlBiasRuleFragment
    )>, capacityRules: Array<(
      { __typename?: 'CapacityRule' }
      & LabsGqlCapacityRuleFragment
    )>, targetDistributionRules: Array<(
      { __typename?: 'RoutingTargetDistributionRule' }
      & LabsGqlTargetDistributionRuleFragment
    )> } };

export type LabsGqlTargetDistributionItemFragment = { __typename?: 'RoutingTargetDistributionItem', manufacturer_id: string, weight: number };

export type LabsGqlTargetDistributionRuleFragment = { __typename?: 'RoutingTargetDistributionRule', id: string, name: string, disabled: boolean, condition_json: string, priority: number, routing_target_distribution_items: Array<(
    { __typename?: 'RoutingTargetDistributionItem' }
    & LabsGqlTargetDistributionItemFragment
  )> };

export type LabsGqlTargetDistributionRulesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlTargetDistributionRulesQuery = { __typename?: 'Query', routingTargetDistributionRules: Array<(
    { __typename?: 'RoutingTargetDistributionRule' }
    & LabsGqlTargetDistributionRuleFragment
  )> };

export type LabsGqlCreateTargetDistributionRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateRoutingTargetDistributionRuleCommand;
}>;


export type LabsGqlCreateTargetDistributionRuleMutation = { __typename?: 'Mutation', createRoutingTargetDistribution: (
    { __typename?: 'RoutingTargetDistributionRule' }
    & LabsGqlTargetDistributionRuleFragment
  ) };

export type LabsGqlUpdateTargetDistributionRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateRoutingTargetDistributionRuleCommand;
}>;


export type LabsGqlUpdateTargetDistributionRuleMutation = { __typename?: 'Mutation', updateRoutingTargetDistributionRule: (
    { __typename?: 'RoutingTargetDistributionRule' }
    & LabsGqlTargetDistributionRuleFragment
  ) };

export type LabsGqlDisableTargetDistributionRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlDisableRoutingTargetDistributionRuleCommand;
}>;


export type LabsGqlDisableTargetDistributionRuleMutation = { __typename?: 'Mutation', disableRoutingTargetDistributionRule: (
    { __typename?: 'RoutingTargetDistributionRule' }
    & LabsGqlTargetDistributionRuleFragment
  ) };

export type LabsGqlEnableTargetDistributionRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlEnableRoutingTargetDistributionRuleCommand;
}>;


export type LabsGqlEnableTargetDistributionRuleMutation = { __typename?: 'Mutation', enableRoutingTargetDistributionRule: (
    { __typename?: 'RoutingTargetDistributionRule' }
    & LabsGqlTargetDistributionRuleFragment
  ) };

export type LabsGqlBulkRerouteOrdersMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['String']['input']>;
  disable_sla_reset: Types.Scalars['Boolean']['input'];
  disable_notification: Types.Scalars['Boolean']['input'];
  reason: Types.Scalars['String']['input'];
}>;


export type LabsGqlBulkRerouteOrdersMutation = { __typename?: 'Mutation', rerouteOrders: Array<{ __typename?: 'RerouteLabOrderResult', order_id: string, previous_manufacturer_id: string, new_manufacturer_id: Maybe<string>, manufacturer_last_updated_date: string, manufacturer_assignment_changed: boolean }> };

export type LabsGqlAttachScanStlsMutationVariables = Types.Exact<{
  data: Types.LabsGqlAttachScanExportStlsCommand;
}>;


export type LabsGqlAttachScanStlsMutation = { __typename?: 'Mutation', attachScanStlFiles: (
    { __typename?: 'scan_export' }
    & LabsGqlScanFileForOrderFragment
  ) };

export type LabsGqlAttachAlignerPreppedScansMutationVariables = Types.Exact<{
  data: Types.LabsGqlAttachAlignerPreppedScansCommand;
}>;


export type LabsGqlAttachAlignerPreppedScansMutation = { __typename?: 'Mutation', attachAlignerPreppedScans: boolean };

export type LabsGqlBulkCreateScanbodyRequestsMutationVariables = Types.Exact<{
  args: Types.LabsGqlBulkCreateScanbodyRequestCommand;
}>;


export type LabsGqlBulkCreateScanbodyRequestsMutation = { __typename?: 'Mutation', bulkCreateScanbodyRequests: Array<(
    { __typename?: 'ScanbodyRequestDTO' }
    & LabsGqlScanbodyRequestResultFragment
  )> };

export type LabsGqlLinkScanbodyRequestFulfillmentMutationVariables = Types.Exact<{
  data: Types.LabsGqlLinkScanbodyRequestFulfillmentCommand;
}>;


export type LabsGqlLinkScanbodyRequestFulfillmentMutation = { __typename?: 'Mutation', linkScanbodyRequestFulfillment: { __typename?: 'ScanbodyRequestDTO', id: string } };

export type LabsGqlCreateScanbodyRequestMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateScanbodyRequestCommand;
}>;


export type LabsGqlCreateScanbodyRequestMutation = { __typename?: 'Mutation', createScanbodyRequest: { __typename?: 'ScanbodyRequestDTO', id: string } };

export type LabsGqlDeleteScanbodyRequestMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteScanbodyRequestCommand;
}>;


export type LabsGqlDeleteScanbodyRequestMutation = { __typename?: 'Mutation', deleteScanbodyRequest: { __typename?: 'ScanbodyRequestDTO', id: string } };

export type LabsGqlUpdateScanbodyRequestMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateScanbodyRequestCommand;
}>;


export type LabsGqlUpdateScanbodyRequestMutation = { __typename?: 'Mutation', updateScanbodyRequest: { __typename?: 'ScanbodyRequestDTO', id: string } };

export type LabsGqlScanbodyRequestResultFragment = { __typename?: 'ScanbodyRequestDTO', appointment_date: string, connection: string, system: string, manufacturer: string };

export type LabsGqlCreateRebuildAggregateWorkflowMutationVariables = Types.Exact<{
  args: Types.LabsGqlCreateRebuildAggregateWorkflowArgs;
}>;


export type LabsGqlCreateRebuildAggregateWorkflowMutation = { __typename?: 'Mutation', createRebuildAggregateWorkflow: { __typename?: 'CreateRebuildAggregateWorkflowResult', workflowId: string } };

export type LabsGqlApplySplitDeltasMutationVariables = Types.Exact<{
  data: Types.LabsGqlLabOrderUpdateSplitsInput;
}>;


export type LabsGqlApplySplitDeltasMutation = { __typename?: 'Mutation', updateLabOrderSplits: { __typename?: 'LabOrderUpdateSplitsResult', success: boolean } };

export type LabsGqlCreateTagMutationVariables = Types.Exact<{
  entity_type: Types.LabsGqlTaggableEntityType;
  name: Types.Scalars['String']['input'];
  description: Types.InputMaybe<Types.Scalars['String']['input']>;
  color: Types.InputMaybe<Types.Scalars['String']['input']>;
  entity_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlCreateTagMutation = { __typename?: 'Mutation', createTag: (
    { __typename?: 'Tag' }
    & LabsGqlTagFragment
  ) };

export type LabsGqlEditTagMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  description: Types.InputMaybe<Types.Scalars['String']['input']>;
  color: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlEditTagMutation = { __typename?: 'Mutation', editTag: (
    { __typename?: 'Tag' }
    & LabsGqlTagFragment
  ) };

export type LabsGqlDeleteTagMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlDeleteTagMutation = { __typename?: 'Mutation', deleteTag: (
    { __typename?: 'Tag' }
    & LabsGqlTagFragment
  ) };

export type LabsGqlTaggedEntityDtoFragment = { __typename?: 'TaggedEntityDTO', id: string, tag_ids: Array<string>, entity_type: Types.LabsGqlTaggableEntityType };

export type LabsGqlTagEntityMutationVariables = Types.Exact<{
  tag_id: Types.Scalars['String']['input'];
  entity_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlTagEntityMutation = { __typename?: 'Mutation', addEntityTag: (
    { __typename?: 'TaggedEntityDTO' }
    & LabsGqlTaggedEntityDtoFragment
  ) };

export type LabsGqlUntagEntityMutationVariables = Types.Exact<{
  tag_id: Types.Scalars['String']['input'];
  entity_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlUntagEntityMutation = { __typename?: 'Mutation', removeEntityTag: (
    { __typename?: 'TaggedEntityDTO' }
    & LabsGqlTaggedEntityDtoFragment
  ) };

export type LabsGqlSendOrderToAutomateMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlSendOrderToAutomateMutation = { __typename?: 'Mutation', sendOrderToAutomate: boolean };

export type LabsGqlAcceptAutomateDesignRevisionMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlAcceptAutomateDesignRevisionMutation = { __typename?: 'Mutation', acceptAutomateDesignRevision: boolean };

export type LabsGqlCancelOrderAutomateTaskMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlCancelOrderAutomateTaskMutation = { __typename?: 'Mutation', cancelOrderAutomateTask: boolean };

export type LabsGqlLogThreeshapePluginOperationMutationVariables = Types.Exact<{
  operation: Types.LabsGqlThreeshapePluginOperationInput;
}>;


export type LabsGqlLogThreeshapePluginOperationMutation = { __typename?: 'Mutation', logThreeshapePluginOperation: boolean };

export type LabsGqlCreateTicketSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateTicketSavedSearchCommand;
}>;


export type LabsGqlCreateTicketSavedSearchMutation = { __typename?: 'Mutation', createTicketSavedSearch: { __typename?: 'TicketingSavedSearch', id: string } };

export type LabsGqlDeleteTicketSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteTicketSavedSearchCommand;
}>;


export type LabsGqlDeleteTicketSavedSearchMutation = { __typename?: 'Mutation', deleteTicketSavedSearch: { __typename?: 'TicketingSavedSearch', id: string } };

export type LabsGqlEditTicketSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditTicketSavedSearchCommand;
}>;


export type LabsGqlEditTicketSavedSearchMutation = { __typename?: 'Mutation', editTicketSavedSearch: { __typename?: 'TicketingSavedSearch', id: string } };

export type LabsGqlFavoriteTicketSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlFavoriteTicketSavedSearchCommand;
}>;


export type LabsGqlFavoriteTicketSavedSearchMutation = { __typename?: 'Mutation', favoriteTicketSavedSearch: { __typename?: 'TicketingSavedSearch', id: string } };

export type LabsGqlUnfavoriteTicketSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlUnfavoriteTicketSavedSearchCommand;
}>;


export type LabsGqlUnfavoriteTicketSavedSearchMutation = { __typename?: 'Mutation', unfavoriteTicketSavedSearch: { __typename?: 'TicketingSavedSearch', id: string } };

export type LabsGqlListManufacturerIntegrationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListManufacturerIntegrationsQuery = { __typename?: 'Query', manufacturer_integrations: Array<(
    { __typename?: 'ManufacturerIntegration' }
    & LabsGqlManufacturerIntegrationFragment
  )> };

export type LabsGqlGetQcTechnicianQueryVariables = Types.Exact<{
  employee_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetQcTechnicianQuery = { __typename?: 'Query', getQcTechnician: Maybe<{ __typename?: 'QcTechnician', id: string, name: string }> };

export type LabsGqlManufacturerIntegrationFragment = { __typename?: 'ManufacturerIntegration', id: string, created_at: string, updated_at: string, order_io_capability: Types.LabsGqlIntegrationOrderIoCapability, can_generate_order_entry_qr_code: boolean, can_complete_tasks: Array<Types.LabsGqlTaskType> };

export type LabsGqlAbutmentPartFragment = { __typename?: 'AbutmentPartDTO', id: string, created_at: string, updated_at: string, sku: string, manufacturer: string, material: Types.LabsGqlAbutmentPartMaterial, engagement: Types.LabsGqlAbutmentPartEngagement, diameter_mm: Maybe<number>, gingival_height_mm: Maybe<number>, top_cap_height_mm: Maybe<number>, three_shape_material: string, three_shape_category: string, three_shape_manufacturer: string, three_shape_manufacturing_process: string, three_shape_kit: string, three_shape_system: string, is_archived: boolean, analog_sku: Maybe<string>, screw_sku: Maybe<string> };

export type LabsGqlAbutmentPartToImplantAndScanbodyFragment = { __typename?: 'AbutmentPartToImplantAndScanbodyDTO', abutment_part_id: string, implant_to_scanbody_id: string, priority: number, abutment_part: (
    { __typename?: 'AbutmentPartDTO' }
    & LabsGqlAbutmentPartFragment
  ) };

export type LabsGqlListAbutmentPartsQueryVariables = Types.Exact<{
  withArchived: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlListAbutmentPartsQuery = { __typename?: 'Query', listAbutmentParts: Array<(
    { __typename?: 'AbutmentPartDTO' }
    & LabsGqlAbutmentPartFragment
  )> };

export type LabsGqlGetAbutmentPartQueryVariables = Types.Exact<{
  part_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetAbutmentPartQuery = { __typename?: 'Query', getAbutmentPart: Maybe<(
    { __typename?: 'AbutmentPartDTO' }
    & LabsGqlAbutmentPartFragment
  )> };

export type LabsGqlListAbutmentPartByImplantAndScanbodyQueryVariables = Types.Exact<{
  implantToScanbodyId: Types.Scalars['String']['input'];
}>;


export type LabsGqlListAbutmentPartByImplantAndScanbodyQuery = { __typename?: 'Query', listAbutmentPartByImplantAndScanbody: Array<(
    { __typename?: 'AbutmentPartToImplantAndScanbodyDTO' }
    & LabsGqlAbutmentPartToImplantAndScanbodyFragment
  )> };

export type LabsGqlAlignerCaseFragment = { __typename?: 'AlignerCaseDTO', id: string, created_at: string, updated_at: string, photo_zip_path: Maybe<string>, aligner_arch: Types.LabsGqlAlignerArch, aligner_treatment_area: Types.LabsGqlAlignerTreatmentArea, aligner_notes: Maybe<string>, movement_restricted_teeth: Array<ToothNumber>, attachment_restricted_teeth: Array<ToothNumber>, extraction_teeth: Array<ToothNumber>, is_refinement: boolean, dandy_plan: Maybe<Types.LabsGqlAlignerPlan>, design_software: Maybe<Types.LabsGqlAlignerDesignSoftware>, photos: (
    { __typename?: 'PendingAlignerCasePhotoMap' }
    & LabsGqlAlignerCasePhotosFragment
  ), concerns: Maybe<(
    { __typename?: 'PendingAlignerCaseConcerns' }
    & LabsGqlPendingAlignerCaseConcernsFragment
  )>, estimate: (
    { __typename?: 'PendingAlignerCaseEstimate' }
    & LabsGqlPendingAlignerCaseEstimateFragment
  ), bite_concerns: Maybe<(
    { __typename?: 'PendingAlignerCaseBiteConcerns' }
    & LabsGqlPendingAlignerCaseBiteConcernsFragment
  )>, crowding_resolution: Maybe<(
    { __typename?: 'PendingAlignerCaseCrowdingResolution' }
    & LabsGqlPendingAlignerCaseCrowdingResolutionFragment
  )>, interproximal_space_sizes: Array<(
    { __typename?: 'PendingAlignerCaseInterproximalSpaceSize' }
    & LabsGqlPendingAlignerCaseInterproximalSpaceSizeFragment
  )>, retainers: { __typename?: 'RetainersCollection', current: Maybe<(
      { __typename?: 'RetainerDTO' }
      & LabsGqlAlignerRetainerFragment
    )>, historical: Array<(
      { __typename?: 'RetainerDTO' }
      & LabsGqlAlignerRetainerFragment
    )> } };

export type LabsGqlPendingAlignerCaseForScanExportQueryVariables = Types.Exact<{
  scan_export_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlPendingAlignerCaseForScanExportQuery = { __typename?: 'Query', pendingAlignerCaseForScanExport: Maybe<(
    { __typename?: 'PendingAlignerCaseDTO' }
    & LabsGqlPendingAlignerCaseFragment
  )> };

export type LabsGqlAlignerPhotoUploadedQueryVariables = Types.Exact<{
  scan_export_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlAlignerPhotoUploadedQuery = { __typename?: 'Query', alignerPhotoUploaded: boolean };

export type LabsGqlUploadedAlignerPhotoTypesQueryVariables = Types.Exact<{
  scan_export_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlUploadedAlignerPhotoTypesQuery = { __typename?: 'Query', uploadedAlignerPhotoTypes: Array<Types.LabsGqlAlignerCasePhotoType> };

export type LabsGqlUploadedAlignerPhotoGcsPathsQueryVariables = Types.Exact<{
  scan_export_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlUploadedAlignerPhotoGcsPathsQuery = { __typename?: 'Query', uploadedAlignerPhotoGCSPaths: Array<string> };

export type LabsGqlSetTreatmentPlanRequestUrlMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  url: Types.Scalars['String']['input'];
}>;


export type LabsGqlSetTreatmentPlanRequestUrlMutation = { __typename?: 'Mutation', setTreatmentPlanRequestUrl: { __typename?: 'lab_order', id: string } };

export type LabsGqlRejectTreatmentPlanMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  feedback: Types.Scalars['String']['input'];
}>;


export type LabsGqlRejectTreatmentPlanMutation = { __typename?: 'Mutation', rejectTreatmentPlan: { __typename?: 'lab_order', id: string } };

export type LabsGqlFinalizeTreatmentPlanRequestMutationVariables = Types.Exact<{
  data: Types.LabsGqlFinalizeTreatmentPlanRequestCommand;
}>;


export type LabsGqlFinalizeTreatmentPlanRequestMutation = { __typename?: 'Mutation', finalizeTreatmentPlanRequest: { __typename?: 'lab_order', id: string } };

export type LabsGqlAttachTreatmentPlanRequestMutationVariables = Types.Exact<{
  data: Types.LabsGqlAttachTreatmentPlanRequestCommand;
}>;


export type LabsGqlAttachTreatmentPlanRequestMutation = { __typename?: 'Mutation', attachTreatmentPlanRequest: { __typename?: 'lab_order', id: string } };

export type LabsGqlApproveAlignerFabricationMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  from_date: Types.Scalars['DateTime']['input'];
  dandy_plan: Types.InputMaybe<Types.LabsGqlAlignerPlan>;
}>;


export type LabsGqlApproveAlignerFabricationMutation = { __typename?: 'Mutation', approveAlignerFabrication: { __typename?: 'lab_order', id: string } };

export type LabsGqlAttachExternalAlignerFulfillmentMutationVariables = Types.Exact<{
  data: Types.LabsGqlAttachExternalAlignerFulfillmentCommand;
}>;


export type LabsGqlAttachExternalAlignerFulfillmentMutation = { __typename?: 'Mutation', attachExternalAlignerFulfillment: { __typename?: 'lab_order', id: string } };

export type LabsGqlEditAlignerCaseMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditAlignerCaseCommand;
}>;


export type LabsGqlEditAlignerCaseMutation = { __typename?: 'Mutation', editAlignerCase: { __typename?: 'lab_order', id: string } };

export type LabsGqlChangeDesignSoftwareMutationVariables = Types.Exact<{
  data: Types.LabsGqlChangeDesignSoftwareCommand;
}>;


export type LabsGqlChangeDesignSoftwareMutation = { __typename?: 'Mutation', changeDesignSoftware: { __typename?: 'lab_order', id: string } };

export type LabsGqlPendingAlignerCaseFragment = { __typename?: 'PendingAlignerCaseDTO', id: string, overridden_patient_price_in_cents: Maybe<number>, aligner_notes: Maybe<string>, photos: (
    { __typename?: 'PendingAlignerCasePhotoMap' }
    & LabsGqlAlignerCasePhotosFragment
  ), estimate: Maybe<(
    { __typename?: 'PendingAlignerCaseEstimate' }
    & LabsGqlPendingAlignerCaseEstimateFragment
  )>, concerns: Maybe<{ __typename?: 'PendingAlignerCaseConcerns', primary_concern: string, primary_concern_severity: Types.LabsGqlAlignerConcernSeverity, additional_concerns: Array<string>, additional_concerns_notes: Maybe<string>, concerns_metadata: Maybe<Array<{ __typename?: 'PendingAlignerCaseConcernMetadata', concern: string, metadata: string }>> }>, rejection: Maybe<{ __typename?: 'PendingAlignerCaseRejection', reason: Types.LabsGqlPendingAlignerCaseRejectionReason, notes: Maybe<string> }> };

export type LabsGqlAlignerCasePhotosFragment = { __typename?: 'PendingAlignerCasePhotoMap', LeftBite: Maybe<string>, FrontBite: Maybe<string>, RightBite: Maybe<string>, MandibularOcclusion: Maybe<string>, MaxillaryOcclusion: Maybe<string>, PanoramicXray: Maybe<string>, FrontPortraitSmile: Maybe<string>, FrontPortraitNoSmile: Maybe<string>, SideView: Maybe<string> };

export type LabsGqlPendingAlignerCaseConcernsFragment = { __typename?: 'PendingAlignerCaseConcerns', primary_concern: string, primary_concern_severity: Types.LabsGqlAlignerConcernSeverity, additional_concerns: Array<string>, additional_concerns_notes: Maybe<string>, concerns_metadata: Maybe<Array<{ __typename?: 'PendingAlignerCaseConcernMetadata', concern: string, metadata: string }>> };

export type LabsGqlPendingAlignerCaseEstimateFragment = { __typename?: 'PendingAlignerCaseEstimate', dandy_plan: Types.LabsGqlAlignerPlan, needsIpr: boolean, needsAttachments: boolean, overridden_patient_price_in_cents: Maybe<number>, doctor_proposed_step_limit: Maybe<number> };

export type LabsGqlPendingAlignerCaseBiteConcernsFragment = { __typename?: 'PendingAlignerCaseBiteConcerns', improve_overjet: Types.LabsGqlBiteConcernOptions, improve_overbite: Types.LabsGqlBiteConcernOptions, improve_midline: Types.LabsGqlBiteConcernOptions };

export type LabsGqlPendingAlignerCaseCrowdingResolutionFragment = { __typename?: 'PendingAlignerCaseCrowdingResolution', expansion: Types.LabsGqlCrowdingResolutionOption, proclination: Types.LabsGqlCrowdingResolutionOption, ipr: Types.LabsGqlCrowdingResolutionOption };

export type LabsGqlPendingAlignerCaseInterproximalSpaceSizeFragment = { __typename?: 'PendingAlignerCaseInterproximalSpaceSize', size: number, space: { __typename?: 'PendingAlignerCaseInterproximalSpaceShape', tooth1: number, tooth2: number } };

export type LabsGqlExternalAlignerFulfillmentFragment = { __typename: 'ExternalAlignerFulfillment', id: string, created_at: string, expected_arrival_date: Maybe<string> };

export type LabsGqlAlignerRetainerFragment = { __typename?: 'RetainerDTO', arch: Types.LabsGqlOrderItemArch, quantity: number, priceInCents: number, hasRestorations: boolean, isFixedLingual: boolean };

export type LabsGqlPatientPortalLabOrderQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type LabsGqlPatientPortalLabOrderQuery = { __typename?: 'Query', patient_portal_lab_order: { __typename?: 'PatientPortalLabOrder', id: string, patient_first_name: string, patient_last_name: string, doctor_name: string } };

export type LabsGqlPatientPortalLinkMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  version_id: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type LabsGqlPatientPortalLinkMutation = { __typename?: 'Mutation', patient_portal_link: string };

export type LabsGqlSoftSmileVisionLinkMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  version_id: Types.InputMaybe<Types.Scalars['Float']['input']>;
  link_type: Types.InputMaybe<Types.LabsGqlVisionLinkType>;
}>;


export type LabsGqlSoftSmileVisionLinkMutation = { __typename?: 'Mutation', generate_softsmile_vision_link: string };

export type LabsGqlSoftSmileAssociatePlanWithCaseMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['Float']['input'];
  pathPrefix: Types.Scalars['String']['input'];
}>;


export type LabsGqlSoftSmileAssociatePlanWithCaseMutation = { __typename?: 'Mutation', dev_associate_treatment_plan_with_case: boolean };

export type LabsGqlSoftSmileWebviewerLinkMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  versionId: Types.InputMaybe<Types.Scalars['Float']['input']>;
  accessToken: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSoftSmileWebviewerLinkMutation = { __typename?: 'Mutation', generateSoftsmileWebviewerLink: string };

export type LabsGqlListOrderAutomationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListOrderAutomationsQuery = { __typename?: 'Query', listOrderAutomations: Array<(
    { __typename?: 'OrderAutomation' }
    & LabsGqlOrderAutomationListElementFragment
  )> };

export type LabsGqlOrderAutomationListElementFragment = { __typename?: 'OrderAutomation', id: string, name: string, description: string, created_at: string, updated_at: string, triggered_by: Array<Types.LabsGqlAutomationTriggerEventNamesEnum>, created_by_user_id: string, folder: Maybe<string>, archived: boolean, filter: (
    { __typename?: 'FilterSubmission' }
    & LabsGqlOrderFilterFragment
  ), actions: Array<{ __typename?: 'AutomationActionConfig', action_id: string, fields: Array<(
      { __typename?: 'AutomationFieldSubmission' }
      & LabsGqlAutomationFieldSubmissionFragment
    )> }> };

export type LabsGqlListAutomationActionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListAutomationActionsQuery = { __typename?: 'Query', actions: Array<(
    { __typename?: 'AutomationActionDefinition' }
    & LabsGqlAutomationActionFragment
  )> };

export type LabsGqlAutomationActionFragment = { __typename?: 'AutomationActionDefinition', id: string, name: string, description: Maybe<string>, test_available: boolean, fields: Array<(
    { __typename?: 'AutomationFieldBoolean' }
    & LabsGqlAutomationField_AutomationFieldBoolean_Fragment
  ) | (
    { __typename?: 'AutomationFieldCopy' }
    & LabsGqlAutomationField_AutomationFieldCopy_Fragment
  ) | (
    { __typename?: 'AutomationFieldDate' }
    & LabsGqlAutomationField_AutomationFieldDate_Fragment
  ) | (
    { __typename?: 'AutomationFieldMultiSelect' }
    & LabsGqlAutomationField_AutomationFieldMultiSelect_Fragment
  ) | (
    { __typename?: 'AutomationFieldNumber' }
    & LabsGqlAutomationField_AutomationFieldNumber_Fragment
  ) | (
    { __typename?: 'AutomationFieldSelect' }
    & LabsGqlAutomationField_AutomationFieldSelect_Fragment
  ) | (
    { __typename?: 'AutomationFieldText' }
    & LabsGqlAutomationField_AutomationFieldText_Fragment
  )> };

export type LabsGqlIAutomationField_AutomationFieldBoolean_Fragment = { __typename?: 'AutomationFieldBoolean', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationField_AutomationFieldCopy_Fragment = { __typename?: 'AutomationFieldCopy', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationField_AutomationFieldDate_Fragment = { __typename?: 'AutomationFieldDate', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationField_AutomationFieldMultiSelect_Fragment = { __typename?: 'AutomationFieldMultiSelect', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationField_AutomationFieldNumber_Fragment = { __typename?: 'AutomationFieldNumber', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationField_AutomationFieldSelect_Fragment = { __typename?: 'AutomationFieldSelect', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationField_AutomationFieldText_Fragment = { __typename?: 'AutomationFieldText', id: string, default_value: Maybe<string | boolean | number | string[]>, helper_text: Maybe<string>, label: string, optional: Maybe<boolean>, type: Types.LabsGqlAutomationFieldType };

export type LabsGqlIAutomationFieldFragment = LabsGqlIAutomationField_AutomationFieldBoolean_Fragment | LabsGqlIAutomationField_AutomationFieldCopy_Fragment | LabsGqlIAutomationField_AutomationFieldDate_Fragment | LabsGqlIAutomationField_AutomationFieldMultiSelect_Fragment | LabsGqlIAutomationField_AutomationFieldNumber_Fragment | LabsGqlIAutomationField_AutomationFieldSelect_Fragment | LabsGqlIAutomationField_AutomationFieldText_Fragment;

export type LabsGqlAutomationField_AutomationFieldBoolean_Fragment = (
  { __typename: 'AutomationFieldBoolean' }
  & LabsGqlIAutomationField_AutomationFieldBoolean_Fragment
);

export type LabsGqlAutomationField_AutomationFieldCopy_Fragment = (
  { __typename: 'AutomationFieldCopy', display_text: string }
  & LabsGqlIAutomationField_AutomationFieldCopy_Fragment
);

export type LabsGqlAutomationField_AutomationFieldDate_Fragment = (
  { __typename: 'AutomationFieldDate', minDate: Maybe<string>, maxDate: Maybe<string> }
  & LabsGqlIAutomationField_AutomationFieldDate_Fragment
);

export type LabsGqlAutomationField_AutomationFieldMultiSelect_Fragment = (
  { __typename: 'AutomationFieldMultiSelect', minSelections: Maybe<number>, maxSelections: Maybe<number>, options: Array<{ __typename?: 'AutomationFieldOption', label: Maybe<string>, value: string, displayIfMatches: Maybe<Array<{ __typename?: 'AutomationFieldOptionConditional', field: string, values: Array<string> }>> }> }
  & LabsGqlIAutomationField_AutomationFieldMultiSelect_Fragment
);

export type LabsGqlAutomationField_AutomationFieldNumber_Fragment = (
  { __typename: 'AutomationFieldNumber', min: Maybe<number>, max: Maybe<number> }
  & LabsGqlIAutomationField_AutomationFieldNumber_Fragment
);

export type LabsGqlAutomationField_AutomationFieldSelect_Fragment = (
  { __typename: 'AutomationFieldSelect', options: Array<{ __typename?: 'AutomationFieldOption', label: Maybe<string>, value: string, displayIfMatches: Maybe<Array<{ __typename?: 'AutomationFieldOptionConditional', field: string, values: Array<string> }>> }> }
  & LabsGqlIAutomationField_AutomationFieldSelect_Fragment
);

export type LabsGqlAutomationField_AutomationFieldText_Fragment = (
  { __typename: 'AutomationFieldText', minimum_characters: Maybe<number>, multiline: Maybe<boolean> }
  & LabsGqlIAutomationField_AutomationFieldText_Fragment
);

export type LabsGqlAutomationFieldFragment = LabsGqlAutomationField_AutomationFieldBoolean_Fragment | LabsGqlAutomationField_AutomationFieldCopy_Fragment | LabsGqlAutomationField_AutomationFieldDate_Fragment | LabsGqlAutomationField_AutomationFieldMultiSelect_Fragment | LabsGqlAutomationField_AutomationFieldNumber_Fragment | LabsGqlAutomationField_AutomationFieldSelect_Fragment | LabsGqlAutomationField_AutomationFieldText_Fragment;

export type LabsGqlListOrderFiltersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListOrderFiltersQuery = { __typename?: 'Query', rules: Array<(
    { __typename?: 'FilterDefinition' }
    & LabsGqlOrderFilterRuleFragment
  )> };

export type LabsGqlListOrderFilterOptionsQueryVariables = Types.Exact<{
  filterId: Types.Scalars['String']['input'];
  partnerId: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlListOrderFilterOptionsQuery = { __typename?: 'Query', loadOrderFilterOptions: Array<(
    { __typename?: 'ICustomFieldOption' }
    & LabsGqlFilterRuleOptionFragment
  )> };

export type LabsGqlListPalateOrderFiltersQueryVariables = Types.Exact<{
  partnerId: Types.Scalars['String']['input'];
}>;


export type LabsGqlListPalateOrderFiltersQuery = { __typename?: 'Query', rules: Array<(
    { __typename?: 'FilterDefinition' }
    & LabsGqlOrderFilterRuleFragment
  )> };

export type LabsGqlCreateOrderAutomationMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateOrderAutomationCommand;
}>;


export type LabsGqlCreateOrderAutomationMutation = { __typename?: 'Mutation', saveAutomation: (
    { __typename?: 'OrderAutomation' }
    & LabsGqlOrderAutomationFragment
  ) };

export type LabsGqlUpdateOrderAutomationMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrderAutomationCommand;
}>;


export type LabsGqlUpdateOrderAutomationMutation = { __typename?: 'Mutation', saveAutomation: (
    { __typename?: 'OrderAutomation' }
    & LabsGqlOrderAutomationFragment
  ) };

export type LabsGqlArchiveOrderAutomationMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  archived: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlArchiveOrderAutomationMutation = { __typename?: 'Mutation', archiveOrderAutomation: (
    { __typename?: 'OrderAutomation' }
    & LabsGqlOrderAutomationListElementFragment
  ) };

export type LabsGqlSetOrderAutomationFolderMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  folder: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlSetOrderAutomationFolderMutation = { __typename?: 'Mutation', setOrderAutomationFolder: (
    { __typename?: 'OrderAutomation' }
    & LabsGqlOrderAutomationListElementFragment
  ) };

export type LabsGqlDeleteOrderAutomationMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlDeleteOrderAutomationMutation = { __typename?: 'Mutation', deleteOrderAutomation: (
    { __typename?: 'OrderAutomation' }
    & LabsGqlOrderAutomationListElementFragment
  ) };

export type LabsGqlTestOrderAutomationMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  config: Types.LabsGqlAutomationActionConfigInput;
}>;


export type LabsGqlTestOrderAutomationMutation = { __typename?: 'Mutation', testOrderAutomation: (
    { __typename?: 'TestOrderAutomationResult' }
    & LabsGqlTestOrderAutomationResultFragment
  ) };

export type LabsGqlTestOrderAutomationResultFragment = { __typename?: 'TestOrderAutomationResult', success: boolean, summary: string };

export type LabsGqlFilterRuleOptionFragment = { __typename?: 'ICustomFieldOption', value: string, label: Maybe<string>, color: Maybe<string>, image_url: Maybe<string>, non_standard: Maybe<boolean> };

export type LabsGqlOrderFilterRuleFragment = { __typename?: 'FilterDefinition', id: string, name: string, comparison_value_type: Types.LabsGqlFilterComparisonValueType, comparison_value_nullable: boolean, list_entity_name: Maybe<string>, excluded_comparators: Maybe<Array<Types.LabsGqlFilterComparator>>, hasOptions: boolean };

export type LabsGqlOrderFilterValueFragment = { __typename?: 'FilterCriteriaSubmission', filter_id: string, comparator: Types.LabsGqlFilterComparator, comparison_value: Maybe<string | boolean | number | string[]>, list_combinator: Maybe<Types.LabsGqlFilterListCombinator> };

export type LabsGqlOrderFilterFragment = { __typename?: 'FilterSubmission', combinator: Types.LabsGqlFilterCombinator, criteria: Array<(
    { __typename?: 'FilterCriteriaSubmission' }
    & LabsGqlOrderFilterValueFragment
  )> };

export type LabsGqlAutomationFieldSubmissionFragment = { __typename?: 'AutomationFieldSubmission', field_id: string, value: string | boolean | number | string[] };

export type LabsGqlAutomationActionConfigFragment = { __typename?: 'AutomationActionConfig', action_id: string, action: Maybe<(
    { __typename?: 'AutomationActionDefinition' }
    & LabsGqlAutomationActionFragment
  )>, fields: Array<(
    { __typename?: 'AutomationFieldSubmission' }
    & LabsGqlAutomationFieldSubmissionFragment
  )> };

export type LabsGqlOrderAutomationFragment = { __typename?: 'OrderAutomation', id: string, name: string, description: string, created_at: string, updated_at: string, triggered_by: Array<Types.LabsGqlAutomationTriggerEventNamesEnum>, created_by_user_id: string, folder: Maybe<string>, archived: boolean, actions: Array<(
    { __typename?: 'AutomationActionConfig' }
    & LabsGqlAutomationActionConfigFragment
  )>, filter: (
    { __typename?: 'FilterSubmission' }
    & LabsGqlOrderFilterFragment
  ) };

export type LabsGqlGetAllBillingCreditCategoriesQueryVariables = Types.Exact<{
  include_archived: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlGetAllBillingCreditCategoriesQuery = { __typename?: 'Query', getAllBillingCreditCategories: Array<(
    { __typename?: 'BillingCreditCategory' }
    & LabsGqlBillingCreditCategoryFragment
  )> };

export type LabsGqlBillingCreditCategoryFragment = { __typename?: 'BillingCreditCategory', id: string, updated_at: string, created_at: string, name: string, archived: boolean };

export type LabsGqlRenameBillingCreditCategoryMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type LabsGqlRenameBillingCreditCategoryMutation = { __typename?: 'Mutation', updateBillingCreditCategory: (
    { __typename?: 'BillingCreditCategory' }
    & LabsGqlBillingCreditCategoryFragment
  ) };

export type LabsGqlToggleBillingCreditCategoryArchivedMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  archived: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlToggleBillingCreditCategoryArchivedMutation = { __typename?: 'Mutation', updateBillingCreditCategory: (
    { __typename?: 'BillingCreditCategory' }
    & LabsGqlBillingCreditCategoryFragment
  ) };

export type LabsGqlCreateBillingCreditCategoryMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type LabsGqlCreateBillingCreditCategoryMutation = { __typename?: 'Mutation', createBillingCreditCategory: (
    { __typename?: 'BillingCreditCategory' }
    & LabsGqlBillingCreditCategoryFragment
  ) };

export type LabsGqlCaseReadinessFragment = { __typename?: 'CaseReadinessDTO', id: string, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, items: Array<(
    { __typename?: 'CartAlignerItem' }
    & LabsGqlCartItemV2Dto_CartAlignerItem_Fragment
  ) | (
    { __typename?: 'CartBridgeItem' }
    & LabsGqlCartItemV2Dto_CartBridgeItem_Fragment
  ) | (
    { __typename?: 'CartCrownItem' }
    & LabsGqlCartItemV2Dto_CartCrownItem_Fragment
  ) | (
    { __typename?: 'CartDentureItem' }
    & LabsGqlCartItemV2Dto_CartDentureItem_Fragment
  ) | (
    { __typename?: 'CartImplantBridgeItem' }
    & LabsGqlCartItemV2Dto_CartImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'CartImplantItem' }
    & LabsGqlCartItemV2Dto_CartImplantItem_Fragment
  ) | (
    { __typename?: 'CartInlayItem' }
    & LabsGqlCartItemV2Dto_CartInlayItem_Fragment
  ) | (
    { __typename?: 'CartModelItem' }
    & LabsGqlCartItemV2Dto_CartModelItem_Fragment
  ) | (
    { __typename?: 'CartOtherItem' }
    & LabsGqlCartItemV2Dto_CartOtherItem_Fragment
  ) | (
    { __typename?: 'CartPartialDentureItem' }
    & LabsGqlCartItemV2Dto_CartPartialDentureItem_Fragment
  ) | (
    { __typename?: 'CartRemovableItem' }
    & LabsGqlCartItemV2Dto_CartRemovableItem_Fragment
  ) | (
    { __typename?: 'CartSleepApneaItem' }
    & LabsGqlCartItemV2Dto_CartSleepApneaItem_Fragment
  ) | (
    { __typename?: 'CartSurgicalGuideItem' }
    & LabsGqlCartItemV2Dto_CartSurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'CartTMJItem' }
    & LabsGqlCartItemV2Dto_CartTmjItem_Fragment
  ) | (
    { __typename?: 'CartUnknownItem' }
    & LabsGqlCartItemV2Dto_CartUnknownItem_Fragment
  ) | (
    { __typename?: 'CartVeneerItem' }
    & LabsGqlCartItemV2Dto_CartVeneerItem_Fragment
  ) | (
    { __typename?: 'CartWaxupItem' }
    & LabsGqlCartItemV2Dto_CartWaxupItem_Fragment
  ) | (
    { __typename?: 'CartWellnessScanItem' }
    & LabsGqlCartItemV2Dto_CartWellnessScanItem_Fragment
  )>, scanbody_requests: Array<{ __typename?: 'ScanbodyRequestDTO', manufacturer: string, system: string, connection: string, shipment: Maybe<{ __typename?: 'IShipment', id: string, tracking_number: string, carrier: Types.LabsGqlShippingCarriersEnum, status: Types.LabsGqlShipmentStatus, eta: string }>, scanbody: Maybe<{ __typename?: 'ScanbodyDTO', name: string, manufacturer: string }> }> };

export type LabsGqlGetCaseReadinessCasesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetCaseReadinessCasesQuery = { __typename?: 'Query', getCaseReadinessCases: Array<(
    { __typename?: 'CaseReadinessDTO' }
    & LabsGqlCaseReadinessFragment
  )> };

export type LabsGqlListCategoriesQueryVariables = Types.Exact<{
  kind: Types.LabsGqlCategoryKind;
}>;


export type LabsGqlListCategoriesQuery = { __typename?: 'Query', listCategories: Array<(
    { __typename?: 'CategoryDTO' }
    & LabsGqlCategoryFragment
  )> };

export type LabsGqlCreateCategoryMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateCategoryCommand;
}>;


export type LabsGqlCreateCategoryMutation = { __typename?: 'Mutation', createCategory: (
    { __typename?: 'CategoryDTO' }
    & LabsGqlCategoryFragment
  ) };

export type LabsGqlUpdateCategoryMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateCategoryCommand;
}>;


export type LabsGqlUpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: (
    { __typename?: 'CategoryDTO' }
    & LabsGqlCategoryFragment
  ) };

export type LabsGqlToggleArchiveCategoryMutationVariables = Types.Exact<{
  data: Types.LabsGqlToggleArchiveCategoryCommand;
}>;


export type LabsGqlToggleArchiveCategoryMutation = { __typename?: 'Mutation', toggleArchiveCategory: (
    { __typename?: 'CategoryDTO' }
    & LabsGqlCategoryFragment
  ) };

export type LabsGqlSubcategoryFragment = { __typename?: 'SubcategoryDTO', id: string, parent_id: string, archived: boolean, label: string, requires_further_info: boolean };

export type LabsGqlCategoryFragment = { __typename?: 'CategoryDTO', id: string, created_at: string, updated_at: string, kind: Types.LabsGqlCategoryKind, archived: boolean, label: string, requires_further_info: boolean, visible_to_internal: boolean, visible_to_lab: boolean, visible_to_practice: boolean, subcategories: Maybe<Array<(
    { __typename?: 'SubcategoryDTO' }
    & LabsGqlSubcategoryFragment
  )>> };

export type LabsGqlCreateChatMessageMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateChatMessageCommand;
}>;


export type LabsGqlCreateChatMessageMutation = { __typename?: 'Mutation', createChatMessage: (
    { __typename?: 'ChatMessageDTO' }
    & LabsGqlChatMessageDtoFragment
  ) };

export type LabsGqlSetChatMessageVisibilityMutationVariables = Types.Exact<{
  data: Types.LabsGqlSetChatMessageVisibilityCommand;
}>;


export type LabsGqlSetChatMessageVisibilityMutation = { __typename?: 'Mutation', setChatMessageVisibility: (
    { __typename?: 'ChatMessageDTO' }
    & LabsGqlChatMessageDtoFragment
  ) };

export type LabsGqlDeleteChatMessageMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteChatMessageCommand;
}>;


export type LabsGqlDeleteChatMessageMutation = { __typename?: 'Mutation', deleteChatMessage: (
    { __typename?: 'ChatMessageDTO' }
    & LabsGqlChatMessageDtoFragment
  ) };

export type LabsGqlFindLastChatForEntityQueryVariables = Types.Exact<{
  entity_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlFindLastChatForEntityQuery = { __typename?: 'Query', findLastChatForEntity: Maybe<(
    { __typename?: 'ChatMessageDTO' }
    & LabsGqlChatMessageDtoFragment
  )> };

export type LabsGqlListChatMessagesQueryVariables = Types.Exact<{
  entity_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlListChatMessagesQuery = { __typename?: 'Query', listChatMessages: Array<(
    { __typename?: 'ChatMessageDTO' }
    & LabsGqlChatMessageDtoFragment
  )> };

export type LabsGqlChatMessageDtoFragment = { __typename?: 'ChatMessageDTO', id: string, text: string, visible_to_org_ids: Array<string>, visible_to_roles: Array<Types.LabsGqlStaffRoleWithAny>, created_by_staff_id: string, entity_id: string, entity_type: Types.LabsGqlChatEntityTypes, created_at: string, deleted_at: Maybe<string>, seen_by_org_ids: Array<string>, seen_by_staff_ids: Array<string>, attachments: Array<{ __typename?: 'TimelineAttachment', url: string, description: Maybe<string> }>, sender: { __typename?: 'StaffMemberWithRelations', organization_type: Types.LabsGqlOrganizationType, organization_id: string, id: string, user: { __typename?: 'UserDTO', id: string, first_name: string, last_name: string } } };

export type LabsGqlPracticeChatOrderFragment = { __typename?: 'LabOrderWithEvents', id: string, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, items_v2: Array<{ __typename?: 'AlignerItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'BridgeItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'CrownItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'DentureItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'ImplantBridgeItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'ImplantItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'InlayItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'ModelItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'OtherItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'PartialDentureItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'RemovableItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'SleepApneaItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'SurgicalGuideItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'TMJItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'UnknownItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'VeneerItem', id: string, sku: Types.LabsGqlOrderItemSkuType } | { __typename?: 'WaxupItem', id: string, sku: Types.LabsGqlOrderItemSkuType }> };

export type LabsGqlZendeskLsrTicketDetailsFragment = { __typename: 'ZendeskLSRTicketDetails', id: string, created_at: string, zendesk_ticket_id: string, zendesk_ticket_url: string, interaction_notes: string };

export type LabsGqlZendeskLsrTicketForScanQueryVariables = Types.Exact<{
  scan_export_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlZendeskLsrTicketForScanQuery = { __typename?: 'Query', zendeskLSRTicketForScan: Maybe<(
    { __typename?: 'ZendeskLSRTicketDetails' }
    & LabsGqlZendeskLsrTicketDetailsFragment
  )> };

export type LabsGqlGetCrmPracticeQueryVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetCrmPracticeQuery = { __typename?: 'Query', getCRMPractice: (
    { __typename?: 'CRMPractice' }
    & LabsGqlCrmPracticeFragment
  ) };

export type LabsGqlCrmPracticeFragment = { __typename?: 'CRMPractice', id: string, salesforce_account_id: Maybe<string>, has_completed_training: boolean, nullable_loyalty_details: Maybe<{ __typename?: 'PracticeLoyaltyDetails', has_opted_into_loyalty: boolean, loyalty_points_balance: number }> };

export type LabsGqlDesignQaEvaluationDtoFragment = { __typename?: 'DesignQaEvaluationDTO', id: string, created_at: string, order_id: string, design_file_path: string, design_type: Types.LabsGqlOrderDesignType, assigned_user_id: Maybe<string>, status: Types.LabsGqlDesignQaEvaluationStatus, updated_at: string, is_calibration: boolean, review_result_entries: Maybe<Array<(
    { __typename?: 'DesignReviewGuidedQcResultEntry' }
    & LabsGqlDesignReviewGuidedQcResultEntryFragment
  )>> };

export type LabsGqlDesignQaEvaluationDtoWithOrderDesignFragment = (
  { __typename?: 'DesignQaEvaluationDTO', order: Maybe<{ __typename?: 'LabOrderWithEvents', doctor_name: string, items_v2: Array<(
      { __typename?: 'AlignerItem' }
      & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
    ) | (
      { __typename?: 'BridgeItem' }
      & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
    ) | (
      { __typename?: 'CrownItem' }
      & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
    ) | (
      { __typename?: 'DentureItem' }
      & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
    ) | (
      { __typename?: 'ImplantBridgeItem' }
      & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
    ) | (
      { __typename?: 'ImplantItem' }
      & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
    ) | (
      { __typename?: 'InlayItem' }
      & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
    ) | (
      { __typename?: 'ModelItem' }
      & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
    ) | (
      { __typename?: 'OtherItem' }
      & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
    ) | (
      { __typename?: 'PartialDentureItem' }
      & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
    ) | (
      { __typename?: 'RemovableItem' }
      & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
    ) | (
      { __typename?: 'SleepApneaItem' }
      & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
    ) | (
      { __typename?: 'SurgicalGuideItem' }
      & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
    ) | (
      { __typename?: 'TMJItem' }
      & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
    ) | (
      { __typename?: 'UnknownItem' }
      & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
    ) | (
      { __typename?: 'VeneerItem' }
      & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
    ) | (
      { __typename?: 'WaxupItem' }
      & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
    )>, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string } }> }
  & LabsGqlDesignQaEvaluationDtoFragment
);

export type LabsGqlGetMyPendingDesignQaEvaluationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetMyPendingDesignQaEvaluationsQuery = { __typename?: 'Query', getMyPendingDesignQaEvaluations: Array<(
    { __typename?: 'DesignQaEvaluationDTO' }
    & LabsGqlDesignQaEvaluationDtoWithOrderDesignFragment
  )> };

export type LabsGqlDesignEvaluationByIdOrderFragmentFragment = { __typename?: 'LabOrderWithEvents', id: string, manufacturer_id: string, items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>, patient: (
    { __typename?: 'PatientDTO' }
    & LabsGqlPatientFragment
  ), scan_export: (
    { __typename?: 'scan_export' }
    & LabsGqlScanFileForOrderFragment
  ) };

export type LabsGqlGetDesignQaEvaluationByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDesignQaEvaluationByIdQuery = { __typename?: 'Query', getDesignQaEvaluationById: (
    { __typename?: 'DesignQaEvaluationDTO', order: Maybe<(
      { __typename?: 'LabOrderWithEvents' }
      & LabsGqlDesignEvaluationByIdOrderFragmentFragment
    )> }
    & LabsGqlDesignQaEvaluationDtoFragment
  ) };

export type LabsGqlDesignQaEvaluationResultsOrderFragmentFragment = (
  { __typename?: 'LabOrderWithEvents', order_number: string, doctor_notes: Maybe<string>, doctor_name: string, partner_id: string, clinical_support_notes: Maybe<{ __typename?: 'ClinicalSupportNotes', notes: Maybe<string> }>, fulfillment_workflow: (
    { __typename?: 'OrderFulfillmentWorkflow' }
    & LabsGqlOrderFulfillmentWorkflowFragment
  ) }
  & LabsGqlDesignEvaluationByIdOrderFragmentFragment
);

export type LabsGqlGetDesignQaEvaluationByIdForResultsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDesignQaEvaluationByIdForResultsQuery = { __typename?: 'Query', getDesignQaEvaluationById: (
    { __typename?: 'DesignQaEvaluationDTO', order: Maybe<(
      { __typename?: 'LabOrderWithEvents' }
      & LabsGqlDesignQaEvaluationResultsOrderFragmentFragment
    )> }
    & LabsGqlDesignQaEvaluationDtoFragment
  ) };

export type LabsGqlGetDesignQaEvaluationsByOrderIdQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDesignQaEvaluationsByOrderIdQuery = { __typename?: 'Query', getDesignQaEvaluationsByOrderId: Array<(
    { __typename?: 'DesignQaEvaluationDTO' }
    & LabsGqlDesignQaEvaluationDtoWithOrderDesignFragment
  )> };

export type LabsGqlDesignStaffAllTaskCapabilitiesDtoFragment = { __typename?: 'DesignStaffAllTaskCapabilitiesDTO', InternalDesign: { __typename?: 'InternalDesignCapabilitiesDTO', anterior_crown_and_bridge: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, posterior_crown_and_bridge: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, implant: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, model: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, waxup: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, dentures: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, pfm: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, pfz: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, refabrication: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, emax: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, red_carpet: Maybe<Types.LabsGqlOrderDesignCapabilityLevel> }, DesignReview: { __typename?: 'DesignReviewCapabilitiesDTO', anterior_crown_and_bridge: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, posterior_crown_and_bridge: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, implant: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, model: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, waxup: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, dentures: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, pfm: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, pfz: Maybe<Types.LabsGqlOrderDesignCapabilityLevel> }, DesignPrep: { __typename?: 'DesignPrepCapabilitiesDTO', posterior_crown_and_bridge: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, anterior_crown_and_bridge: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, implant: Maybe<Types.LabsGqlOrderDesignCapabilityLevel> } };

export type LabsGqlDesignStaffTeamDtoFragment = { __typename?: 'DesignStaffTeamDTO', id: string, name: string };

export type LabsGqlShiftScheduleStartEndFragment = { __typename?: 'ShiftScheduleStartEnd', start: Maybe<string>, end: Maybe<string> };

export type LabsGqlDesignStaffDtoFragment = { __typename?: 'DesignStaffDTO', id: string, created_at: string, updated_at: string, assignable_task_types: Array<Types.LabsGqlDesignStaffTaskType>, status: Types.LabsGqlDesignStaffStatus, country: Maybe<Types.LabsGqlDesignStaffEligibleCountry>, employment_type: Maybe<Types.LabsGqlDesignStaffEmploymentType>, ordered_main_capabilities: Maybe<Array<Types.LabsGqlOrderDesignCapabilityType>>, design_staff_role: Maybe<Types.LabsGqlDesignStaffRole>, design_staff_region: Maybe<Types.LabsGqlDesignStaffRegion>, design_staff_qc_percentage_required: number, task_capabilities: (
    { __typename?: 'DesignStaffAllTaskCapabilitiesDTO' }
    & LabsGqlDesignStaffAllTaskCapabilitiesDtoFragment
  ), design_staff_team: Maybe<(
    { __typename?: 'DesignStaffTeamDTO' }
    & LabsGqlDesignStaffTeamDtoFragment
  )>, schedule: { __typename?: 'ShiftSchedule', timezone: Maybe<string>, mon: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ), tue: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ), wed: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ), thu: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ), fri: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ), sat: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ), sun: (
      { __typename?: 'ShiftScheduleStartEnd' }
      & LabsGqlShiftScheduleStartEndFragment
    ) } };

export type LabsGqlGetDesignStaffQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDesignStaffQuery = { __typename?: 'Query', getDesignStaff: Maybe<(
    { __typename?: 'DesignStaffDTO' }
    & LabsGqlDesignStaffDtoFragment
  )> };

export type LabsGqlGetDesignStaffTeamsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetDesignStaffTeamsQuery = { __typename?: 'Query', getDesignStaffTeams: Maybe<Array<(
    { __typename?: 'DesignStaffTeamDTO' }
    & LabsGqlDesignStaffTeamDtoFragment
  )>> };

export type LabsGqlDesignStaffFocusAreaDtoFragment = { __typename?: 'DesignStaffFocusAreaDTO', id: string, capability: Types.LabsGqlOrderDesignCapabilityType, task_type: Types.LabsGqlDesignTaskType, level: Types.LabsGqlOrderDesignCapabilityLevel };

export type LabsGqlGetDesignStaffFocusAreasByDesignerIdQueryVariables = Types.Exact<{
  designer_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDesignStaffFocusAreasByDesignerIdQuery = { __typename?: 'Query', getDesignStaffFocusAreasByDesigner: Maybe<Array<(
    { __typename?: 'DesignStaffFocusAreaDTO' }
    & LabsGqlDesignStaffFocusAreaDtoFragment
  )>> };

export type LabsGqlListMatchingDesignersForOrderQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlListMatchingDesignersForOrderQuery = { __typename?: 'Query', listMatchingDesignersForOrder: Array<{ __typename?: 'ListMatchingDesignersResult', id: string }> };

export type LabsGqlAssignmentCandidateOrderFragment = { __typename?: 'AssignmentCandidateOrder', id: string, productLine: Types.LabsGqlProductLine, taskType: Types.LabsGqlDesignStaffTaskType, priority: number };

export type LabsGqlDesignStaffDetailedStatusAssignmentFragment = { __typename?: 'DesignStaffDetailedStatusAssignment', order_id: string, task_id: string, assigned_at: string, auto_assignment_expiration: Maybe<string>, priority: number, product_line: Maybe<Types.LabsGqlProductLine>, task_type: Types.LabsGqlDesignStaffTaskType };

export type LabsGqlDesignStaffDetailedStatusFragment = { __typename?: 'DesignStaffDetailedStatus', status: Maybe<Types.LabsGqlDesignStaffStatus>, assignable_task_types: Array<Types.LabsGqlDesignStaffTaskType>, auto_assignments: Array<(
    { __typename?: 'DesignStaffDetailedStatusAssignment' }
    & LabsGqlDesignStaffDetailedStatusAssignmentFragment
  )>, manual_assignments: Array<(
    { __typename?: 'DesignStaffDetailedStatusAssignment' }
    & LabsGqlDesignStaffDetailedStatusAssignmentFragment
  )>, task_capabilities: Maybe<(
    { __typename?: 'DesignStaffAllTaskCapabilitiesDTO' }
    & LabsGqlDesignStaffAllTaskCapabilitiesDtoFragment
  )>, focus_areas: Array<(
    { __typename?: 'DesignStaffFocusAreaDTO' }
    & LabsGqlDesignStaffFocusAreaDtoFragment
  )> };

export type LabsGqlDesignStaffDetailedStatusQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlDesignStaffDetailedStatusQuery = { __typename?: 'Query', designStaffDetailedStatus: (
    { __typename?: 'DesignStaffDetailedStatus' }
    & LabsGqlDesignStaffDetailedStatusFragment
  ) };

export type LabsGqlDesignStaffDebugQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlDesignStaffDebugQuery = { __typename?: 'Query', designStaffDetailedStatus: (
    { __typename?: 'DesignStaffDetailedStatus', candidate_orders: Array<(
      { __typename?: 'AssignmentCandidateOrder' }
      & LabsGqlAssignmentCandidateOrderFragment
    )> }
    & LabsGqlDesignStaffDetailedStatusFragment
  ) };

export type LabsGqlDesignStaffStatusBulkQueryVariables = Types.Exact<{
  user_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlDesignStaffStatusBulkQuery = { __typename?: 'Query', designStaffStatusBulk: Array<{ __typename?: 'DesignStaffStatusEntry', id: string, status: Types.LabsGqlDesignStaffStatus }> };

export type LabsGqlTaskAssignmentTimelineQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlTaskAssignmentTimelineQuery = { __typename?: 'Query', taskAssignmentTimeline: Array<{ __typename?: 'TaskAssignmentTimelineEntry', task_id: string, task_type: Types.LabsGqlDesignStaffTaskType, event_id: number, event_name: string, assigned_at: string, assigned_by: string, assignee_name: Maybe<string>, auto_assigned: boolean, auto_assignment_expiration: Maybe<string>, assignment_reason: Maybe<string>, created_at: string }> };

export type LabsGqlDesignStaffWithUserFragment = { __typename?: 'DesignStaffWithUser', first_name: string, last_name: string, email: string, designStaff: { __typename?: 'DesignStaffDTO', id: string, assignable_task_types: Array<Types.LabsGqlDesignStaffTaskType>, status: Types.LabsGqlDesignStaffStatus } };

export type LabsGqlListFilteredDesignersQueryVariables = Types.Exact<{
  data: Types.LabsGqlDesignerFilters;
}>;


export type LabsGqlListFilteredDesignersQuery = { __typename?: 'Query', listFilteredDesigners: { __typename?: 'ListDesignersResult', hasNextPage: boolean, designers: Array<(
      { __typename?: 'DesignStaffWithUser' }
      & LabsGqlDesignStaffWithUserFragment
    )> } };

export type LabsGqlDebugDesignerAutoAssignmentQueryVariables = Types.Exact<{
  designerId: Types.Scalars['String']['input'];
  orderId: Types.Scalars['String']['input'];
}>;


export type LabsGqlDebugDesignerAutoAssignmentQuery = { __typename?: 'Query', debugInfo: { __typename?: 'AutoAssignerDebuggerInfo', numTasksAssigned: number, maxTasksAssigned: number, availableForActiveTask: boolean, matchesActiveTaskCapabilities: boolean, taskTypeCapabilityMatch: Array<{ __typename?: 'TaskTypeCapabilityMatch', taskType: Types.LabsGqlWorkflowTaskType, matches: boolean, details: Array<{ __typename?: 'CapabilityMatch', type: Types.LabsGqlOrderDesignCapabilityType, level: Types.LabsGqlOrderDesignCapabilityLevel, designerLevel: Maybe<Types.LabsGqlOrderDesignCapabilityLevel>, passes: boolean }> }>, focusAreas: Maybe<Array<{ __typename?: 'CapabilityMatch', type: Types.LabsGqlOrderDesignCapabilityType, level: Types.LabsGqlOrderDesignCapabilityLevel, passes: boolean }>> } };

export type LabsGqlDesignAutoAssignableOrderFragment = { __typename?: 'lab_order', id: string, order_number: string, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, fulfillment_workflow: { __typename?: 'OrderFulfillmentWorkflow', active_task: Maybe<{ __typename?: 'DesignReviewWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'DrReviewHoldWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'ExternalDesignWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'InternalDesignWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'ResolveHoldWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'ResolveScanRejectionWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'ReviewOrderWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'ScanReviewWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'WaxupReviewWorkflowTask', type: Types.LabsGqlWorkflowTaskType } | { __typename?: 'WorkflowTaskGeneric', type: Types.LabsGqlWorkflowTaskType }> } };

export type LabsGqlActiveInternalDesignTaskFragment = { __typename?: 'ActiveInternalDesignTaskSummary', matchStaleTime: string, designStaffMatchingLogic: Types.LabsGqlDesignStaffMatchingLogic, labOrderId: string, taskType: Types.LabsGqlDesignTaskType, requirements: Array<(
    { __typename?: 'OrderDesignCapabilityDTO' }
    & LabsGqlOrderDesignCapabilityFragment
  )> };

export type LabsGqlGetActiveInternalDesignTasksQueryVariables = Types.Exact<{
  orderIds: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetActiveInternalDesignTasksQuery = { __typename?: 'Query', getActiveInternalDesignTasks: Array<(
    { __typename?: 'ActiveInternalDesignTaskSummary' }
    & LabsGqlActiveInternalDesignTaskFragment
  )> };

export type LabsGqlGetActiveInternalDesignTaskQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetActiveInternalDesignTaskQuery = { __typename?: 'Query', getActiveInternalDesignTask: Maybe<(
    { __typename?: 'ActiveInternalDesignTaskSummary' }
    & LabsGqlActiveInternalDesignTaskFragment
  )> };

export type LabsGqlListDesignReviewFieldsQueryVariables = Types.Exact<{
  type: Types.InputMaybe<Types.LabsGqlDesignReviewFieldType>;
}>;


export type LabsGqlListDesignReviewFieldsQuery = { __typename?: 'Query', listDesignReviewFields: Array<(
    { __typename?: 'DesignReviewFieldDTO' }
    & LabsGqlDesignReviewFieldFragment
  )> };

export type LabsGqlCreateDesignReviewFieldMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateDesignReviewFieldCommand;
}>;


export type LabsGqlCreateDesignReviewFieldMutation = { __typename?: 'Mutation', createDesignReviewField: (
    { __typename?: 'DesignReviewFieldDTO' }
    & LabsGqlDesignReviewFieldFragment
  ) };

export type LabsGqlUpdateDesignReviewFieldMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateDesignReviewFieldCommand;
}>;


export type LabsGqlUpdateDesignReviewFieldMutation = { __typename?: 'Mutation', updateDesignReviewField: (
    { __typename?: 'DesignReviewFieldDTO' }
    & LabsGqlDesignReviewFieldFragment
  ) };

export type LabsGqlDesignReviewFieldFragment = { __typename?: 'DesignReviewFieldDTO', id: string, updated_at: string, created_at: string, archived: boolean, types: Array<Types.LabsGqlDesignReviewFieldType>, name: string, category: string, required: boolean, applicable_order_types: Array<Types.LabsGqlDesignReviewFieldFilterType>, field: { __typename?: 'DesignReviewFormField', type: Types.LabsGqlCustomFieldType, default_value: Maybe<string | boolean | number>, options: Maybe<Array<{ __typename?: 'ICustomFieldOption', value: string, label: Maybe<string>, color: Maybe<string>, internal_display_label: Maybe<string>, image_url: Maybe<string>, non_standard: Maybe<boolean> }>> } };

export type LabsGqlDoctorRequestFragment = { __typename?: 'DoctorRequestDTO', id: string, order_id: string, question_text: string, photo_attachment_urls: Array<string>, initiating_flow: Types.LabsGqlDoctorRequestInitiatingFlow, status: Types.LabsGqlDoctorRequestStatus, options: Array<{ __typename?: 'DoctorRequestOptionDTO', id: string, label: string, type: Types.LabsGqlDoctorRequestOptionType, config: Maybe<{ __typename: 'ModifyOrderConfig', mode: Types.LabsGqlDoctorRequestOptionModifyOrderMode, items_v2: Array<(
        { __typename?: 'AlignerItem' }
        & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
      ) | (
        { __typename?: 'BridgeItem' }
        & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
      ) | (
        { __typename?: 'CrownItem' }
        & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
      ) | (
        { __typename?: 'DentureItem' }
        & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
      ) | (
        { __typename?: 'ImplantBridgeItem' }
        & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
      ) | (
        { __typename?: 'ImplantItem' }
        & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
      ) | (
        { __typename?: 'InlayItem' }
        & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
      ) | (
        { __typename?: 'ModelItem' }
        & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
      ) | (
        { __typename?: 'OtherItem' }
        & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
      ) | (
        { __typename?: 'PartialDentureItem' }
        & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
      ) | (
        { __typename?: 'RemovableItem' }
        & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
      ) | (
        { __typename?: 'SleepApneaItem' }
        & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
      ) | (
        { __typename?: 'SurgicalGuideItem' }
        & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
      ) | (
        { __typename?: 'TMJItem' }
        & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
      ) | (
        { __typename?: 'UnknownItem' }
        & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
      ) | (
        { __typename?: 'VeneerItem' }
        & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
      ) | (
        { __typename?: 'WaxupItem' }
        & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
      )> }> }>, doctor_request_response: Maybe<{ __typename?: 'DoctorRequestResponseDTO', selected_doctor_request_option_id: string, freeform_notes: string }> };

export type LabsGqlGetDoctorRequestQueryVariables = Types.Exact<{
  doctorRequestId: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDoctorRequestQuery = { __typename?: 'Query', getDoctorRequest: Maybe<(
    { __typename?: 'DoctorRequestDTO' }
    & LabsGqlDoctorRequestFragment
  )> };

export type LabsGqlGetIsPracticeByodQueryVariables = Types.Exact<{
  practiceId: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetIsPracticeByodQuery = { __typename?: 'Query', getIsPracticeByod: boolean };

export type LabsGqlGetPracticeTrainingDateQueryVariables = Types.Exact<{
  practiceId: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetPracticeTrainingDateQuery = { __typename?: 'Query', getPracticeTrainingDate: Maybe<string> };

export type LabsGqlGetPracticeEquipmentDataQueryVariables = Types.Exact<{
  practiceId: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetPracticeEquipmentDataQuery = { __typename?: 'Query', getPracticeEquipmentData: Maybe<(
    { __typename?: 'EquipmentTrackerSnapshot' }
    & LabsGqlEquipmentTrackerSnapshotFragment
  )> };

export type LabsGqlEquipmentTrackerSnapshotFragment = { __typename?: 'EquipmentTrackerSnapshot', account_id: string, opportunity_id: Maybe<string>, byod_c: Maybe<boolean>, carrier_code: Maybe<string>, contact_id_coalesce: Maybe<string>, created_at: string, account_owner_email: Maybe<string>, account_owner_name: Maybe<string>, owner_id: Maybe<string>, scanner_shipment_address_override_c: Maybe<string>, shipment_status: Maybe<string>, shipping_city: Maybe<string>, shipping_state: Maybe<string>, shipping_street: Maybe<string>, shipping_postal_code: Maybe<string>, stage_c: Maybe<string>, stage_d: Maybe<string>, synthetic_training_date_c: Maybe<string>, tracking_number_c: Maybe<string>, tracking_number_d: Maybe<string> };

export type LabsGqlListMyDesignTasksQueryVariables = Types.Exact<{
  sort: Types.LabsGqlWorkflowTaskSortParam;
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
}>;


export type LabsGqlListMyDesignTasksQuery = { __typename?: 'Query', tasks: Array<(
    { __typename?: 'DesignReviewWorkflowTask' }
    & LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'DrReviewHoldWorkflowTask' }
    & LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ExternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'InternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveHoldWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveScanRejectionWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
  ) | (
    { __typename?: 'ReviewOrderWorkflowTask' }
    & LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment
  ) | (
    { __typename?: 'ScanReviewWorkflowTask' }
    & LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WaxupReviewWorkflowTask' }
    & LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WorkflowTaskGeneric' }
    & LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment
  )> };

export type LabsGqlGetFeatureFlagValueByOrganizationIdQueryVariables = Types.Exact<{
  params: Types.LabsGqlGetFeatureFlagValueByOrganizationIdRequest;
}>;


export type LabsGqlGetFeatureFlagValueByOrganizationIdQuery = { __typename?: 'Query', getFeatureFlagValueByOrganizationId: { __typename?: 'GetFeatureFlagValueByOrganizationIdResponse', value: string } };

export type LabsGqlFetchDoctorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlFetchDoctorsQuery = { __typename?: 'Query', fetchDoctors: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorWithChatTokenFragment
  )> };

export type LabsGqlFetchPracticeStaffQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlFetchPracticeStaffQuery = { __typename?: 'Query', fetchPracticeStaff: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorWithChatTokenFragment
  )> };

export type LabsGqlFetchAllPracticeEmployeesQueryVariables = Types.Exact<{
  practice_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlFetchAllPracticeEmployeesQuery = { __typename?: 'Query', fetchAllPracticeEmployees: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  )> };

export type LabsGqlDoctorWithChatTokenFragment = (
  { __typename?: 'DoctorPreferences', kustomer_chat_token: Maybe<string> }
  & LabsGqlDoctorPreferencesFragment
);

export type LabsGqlGetScannersByPracticeQueryVariables = Types.Exact<{
  practiceId: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetScannersByPracticeQuery = { __typename?: 'Query', getScannersByPractice: Array<(
    { __typename?: 'ScannerEntity' }
    & LabsGqlScannerDtoFragment
  )> };

export type LabsGqlScannerDtoFragment = { __typename?: 'ScannerEntity', id: string, assigned_practice_id: Maybe<string> };

export type LabsGqlAllScannersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlAllScannersQuery = { __typename?: 'Query', getAllScanners: { __typename?: 'AllScannersResponse', scanners: Array<{ __typename?: 'ScannerWithPartners', id: string, partner_ids: Array<string> }> } };

export type LabsGqlAllScannersWithSearchQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
}>;


export type LabsGqlAllScannersWithSearchQuery = { __typename?: 'Query', getAllScannersWithSearch: { __typename?: 'AllScannersResponse', scanners: Array<{ __typename?: 'ScannerWithPartners', id: string, partner_ids: Array<string> }> } };

export type LabsGqlPartnerSessionForScannerQueryVariables = Types.Exact<{
  staff_member_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlPartnerSessionForScannerQuery = { __typename?: 'Query', partnerSessionForScanner: (
    { __typename?: 'ScannerPartnerSession' }
    & LabsGqlScannerPartnerSessionFragment
  ) };

export type LabsGqlScannerPartnerSessionFragment = { __typename?: 'ScannerPartnerSession', partner_name: string, partner_id: string, native_id_token: string, user: (
    { __typename?: 'ScannerPartnerSessionUser' }
    & LabsGqlScannerPartnerSessionUserFragment
  ) };

export type LabsGqlScannerPartnerSessionUserFragment = { __typename?: 'ScannerPartnerSessionUser', id: string, created_at: string, updated_at: string, first_name: string, last_name: string, email: string, birth_date: Maybe<string>, phone_number: string, zip_code: Maybe<string>, legacy_firebase_id: string, superuser: boolean, practitioner_id: Maybe<string> };

export type LabsGqlGetLabCaseLedgerDataQueryVariables = Types.Exact<{
  date_range: Types.InputMaybe<Types.LabsGqlLabPriceLedgerDateRangeInput>;
}>;


export type LabsGqlGetLabCaseLedgerDataQuery = { __typename?: 'Query', getLabCaseLedgerData: Array<(
    { __typename?: 'LabPriceLedgerResult' }
    & LabsGqlLabPriceLedgerResultFragment
  )> };

export type LabsGqlGetLabCaseLedgerSummaryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLabCaseLedgerSummaryQuery = { __typename?: 'Query', getLabCaseLedgerSummary: Array<(
    { __typename?: 'LabPriceLedgerSummaryResult' }
    & LabsGqlLabPriceLedgerSummaryResultFragment
  )> };

export type LabsGqlLabPortalSidebarCountsQueryVariables = Types.Exact<{
  pages: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalSidebarCountsQuery = { __typename?: 'Query', counts: (
    { __typename?: 'LabPortalSidebarCounts' }
    & LabsGqlLabPortalSidebarCountsFragment
  ) };

export type LabsGqlLabPortalSidebarCountsFragment = { __typename?: 'LabPortalSidebarCounts', New_V2: Maybe<number>, Intake: Maybe<number>, Nested_Intake: Maybe<number>, Design_V2: Maybe<number>, Updates_V2: Maybe<number>, Expedite_V2: Maybe<number>, RecentAndFabrication_V2: Maybe<number>, OnHold_V2: Maybe<number>, Returns_V2: Maybe<number> };

export type LabsGqlLabPortalOverviewQueryVariables = Types.Exact<{
  pages: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalOverviewQuery = { __typename?: 'Query', labPortalOverview: (
    { __typename?: 'LabPortalOverviewViewModel' }
    & LabsGqlLabPortalOverviewViewModelFragment
  ) };

export type LabsGqlLabPortalOverviewViewModelFragment = { __typename?: 'LabPortalOverviewViewModel', manufacturerName: string, requestDate: string, ordersNewOrders: number, ordersIntakeOrders: number, ordersInFabrication: number, ordersNeedsManualEntry: Maybe<number>, ordersOnHold: number, designInDesign: Maybe<number>, designRevise: Maybe<number>, designSendToFloor: Maybe<number>, designWaitForDandy: Maybe<number>, shippingToday: number, shippingLate: number, shippingWeekToDate: number, returns: Maybe<number>, updatesPullFromFloor: number, updatesOther: number };

export type LabsGqlLabPortalNewOrderItemFragment = { __typename?: 'LabPortalNewOrderItem', unitType: string, material: string };

export type LabsGqlLabPortalNewOrderListItemFragment = { __typename?: 'LabPortalNewOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, inListDate: Maybe<string>, shipDate: string, modelType: string, designFilePath: Maybe<string>, partnerOrderNumber: Maybe<string>, scanExportSanitizedUrl: Maybe<string>, items: Array<(
    { __typename?: 'LabPortalNewOrderItem' }
    & LabsGqlLabPortalNewOrderItemFragment
  )>, itemsV2: Maybe<Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>> };

export type LabsGqlLabPortalNestedIntakeOrderListItemFragment = { __typename?: 'LabPortalNestedIntakeOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, inListDate: Maybe<string>, shipDate: string, modelType: string, designFilePath: Maybe<string>, partnerOrderNumber: Maybe<string>, scanExportSanitizedUrl: Maybe<string>, nestingBatchId: Maybe<string>, items: Array<(
    { __typename?: 'LabPortalNewOrderItem' }
    & LabsGqlLabPortalNewOrderItemFragment
  )>, itemsV2: Maybe<Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>> };

export type LabsGqlLabPortalNestingInProgressOrderListItemFragment = { __typename?: 'LabPortalNestingInProgressOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, inListDate: Maybe<string>, shipDate: string, modelType: string, designFilePath: Maybe<string>, partnerOrderNumber: Maybe<string>, scanExportSanitizedUrl: Maybe<string>, manufacturingOrderId: string, stackCodeLabel: Maybe<string>, items: Array<(
    { __typename?: 'LabPortalNewOrderItem' }
    & LabsGqlLabPortalNewOrderItemFragment
  )>, itemsV2: Maybe<Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>> };

export type LabsGqlLabPortalNewOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalNewOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalNewOrdersWithoutDesignByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalNewOrdersWithoutDesignByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalNewOrdersWithDesignByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalNewOrdersWithDesignByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalNewOrdersWithReturnByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalNewOrdersWithReturnByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalNewNeedsManualEntryOrderListItemFragment = { __typename?: 'LabPortalNewNeedsManualEntryOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, errorReason: Maybe<string>, inListDate: Maybe<string>, shipDate: string, modelType: string, items: Array<(
    { __typename?: 'LabPortalNewOrderItem' }
    & LabsGqlLabPortalNewOrderItemFragment
  )> };

export type LabsGqlLabPortalNewNeedsManualEntryOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalNewNeedsManualEntryOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewNeedsManualEntryOrderListItem' }
    & LabsGqlLabPortalNewNeedsManualEntryOrderListItemFragment
  )> };

export type LabsGqlLabPortalNewOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalNewOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalNewOrderListCounts' }
    & LabsGqlLabPortalNewOrderListCountsFragment
  ) };

export type LabsGqlLabPortalNewOrderListCountsFragment = { __typename?: 'LabPortalNewOrderListCounts', newWithoutDesign: Maybe<number>, newWithoutPrint: Maybe<number>, newWithDesign: Maybe<number>, newWithReturn: Maybe<number>, newManualEntryNeeded: Maybe<number> };

export type LabsGqlLabPortalIntakeOrdersWithoutDesignByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalIntakeOrdersWithoutDesignByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalIntakeOrdersWithDesignByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalIntakeOrdersWithDesignByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalIntakeOrdersWithReturnByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalIntakeOrdersWithReturnByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNewOrderListItem' }
    & LabsGqlLabPortalNewOrderListItemFragment
  )> };

export type LabsGqlLabPortalNestedIntakeOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalNestedIntakeOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNestedIntakeOrderListItem' }
    & LabsGqlLabPortalNestedIntakeOrderListItemFragment
  )> };

export type LabsGqlLabPortalAutoNestingInProgressOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalAutoNestingInProgressOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalNestingInProgressOrderListItem' }
    & LabsGqlLabPortalNestingInProgressOrderListItemFragment
  )> };

export type LabsGqlLabPortalIntakeOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalIntakeOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalIntakeOrderListCounts' }
    & LabsGqlLabPortalIntakeOrderListCountsFragment
  ) };

export type LabsGqlLabPortalIntakeOrderListCountsFragment = { __typename?: 'LabPortalIntakeOrderListCounts', intakeWithoutDesign: Maybe<number>, intakeWithDesign: Maybe<number>, intakeWithReturn: Maybe<number>, nestedIntake: Maybe<number>, nestingIntake: Maybe<number>, newManualEntryNeeded: Maybe<number> };

export type LabsGqlLabPortalUpdateItemFragment = { __typename?: 'LabPortalUpdateInfo', updateType: string, updateDate: string };

export type LabsGqlLabPortalPullFromFloorUpdateListItemFragment = { __typename?: 'LabPortalPullFromFloorUpdateListItem', orderId: string, orderNumber: string, patientName: string, orderProductLine: string, status: string, modelType: string, shipDate: string, minUpdateDate: string, maxUpdateDate: string, items: Array<(
    { __typename?: 'LabPortalNewOrderItem' }
    & LabsGqlLabPortalNewOrderItemFragment
  )>, updates: Array<(
    { __typename?: 'LabPortalUpdateInfo' }
    & LabsGqlLabPortalUpdateItemFragment
  )> };

export type LabsGqlLabPortalOrderUpdateListItemFragment = { __typename?: 'LabPortalOrderUpdateListItem', orderId: string, orderNumber: string, patientName: string, orderProductLine: string, status: string, modelType: string, shipDate: string, minUpdateDate: string, maxUpdateDate: string, items: Array<(
    { __typename?: 'LabPortalNewOrderItem' }
    & LabsGqlLabPortalNewOrderItemFragment
  )>, updates: Array<(
    { __typename?: 'LabPortalUpdateInfo' }
    & LabsGqlLabPortalUpdateItemFragment
  )> };

export type LabsGqlLabPortalPullFromFloorUpdatesByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalPullFromFloorUpdatesByListViewQuery = { __typename?: 'Query', updates: Array<(
    { __typename?: 'LabPortalPullFromFloorUpdateListItem' }
    & LabsGqlLabPortalPullFromFloorUpdateListItemFragment
  )> };

export type LabsGqlLabPortalOrderUpdatesByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalOrderUpdatesByListViewQuery = { __typename?: 'Query', updates: Array<(
    { __typename?: 'LabPortalOrderUpdateListItem' }
    & LabsGqlLabPortalOrderUpdateListItemFragment
  )> };

export type LabsGqlLabPortalUpdatesOrderListCountsFragment = { __typename?: 'LabPortalUpdatesOrderListCounts', pullFromFloor: Maybe<number>, orderUpdates: Maybe<number> };

export type LabsGqlLabPortalUpdatesOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalUpdatesOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalUpdatesOrderListCounts' }
    & LabsGqlLabPortalUpdatesOrderListCountsFragment
  ) };

export type LabsGqlAcknowledgeLabUpdatesForOrderMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  max_update_date: Types.Scalars['DateTime']['input'];
}>;


export type LabsGqlAcknowledgeLabUpdatesForOrderMutation = { __typename?: 'Mutation', acknowledgeLabUpdatesForOrder: boolean };

export type LabsGqlLabPortalOnHoldOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalOnHoldOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalOnHoldOrderListItem' }
    & LabsGqlLabPortalOnHoldOrderListItemFragment
  )> };

export type LabsGqlLabPortalOnHoldOrderListItemFragment = { __typename?: 'LabPortalOnHoldOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalOnHoldOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalOnHoldOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalOnHoldOrderListCountsNullable' }
    & LabsGqlLabPortalOnHoldOrderListCountsNullableFragment
  ) };

export type LabsGqlLabPortalOnHoldOrderListCountsNullableFragment = { __typename?: 'LabPortalOnHoldOrderListCountsNullable', onHold: Maybe<number> };

export type LabsGqlLabPortalReturnsPendingOrderListItemFragment = { __typename?: 'LabPortalReturnsPendingOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalReturnsPendingOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalReturnsPendingOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalReturnsPendingOrderListItem' }
    & LabsGqlLabPortalReturnsPendingOrderListItemFragment
  )> };

export type LabsGqlLabPortalReturnsOrderListCountsFragment = { __typename?: 'LabPortalReturnsOrderListCounts', returnsPending: Maybe<number> };

export type LabsGqlLabPortalReturnsOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalReturnsOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalReturnsOrderListCounts' }
    & LabsGqlLabPortalReturnsOrderListCountsFragment
  ) };

export type LabsGqlLabPortalShipTodayOrderListItemFragment = { __typename?: 'LabPortalShipTodayOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalShipTodayOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalShipTodayOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalShipTodayOrderListItem' }
    & LabsGqlLabPortalShipTodayOrderListItemFragment
  )> };

export type LabsGqlLabPortalShipTodayLateOrderListItemFragment = { __typename?: 'LabPortalShipTodayLateOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalShipTodayLateOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalShipTodayLateOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalShipTodayLateOrderListItem' }
    & LabsGqlLabPortalShipTodayLateOrderListItemFragment
  )> };

export type LabsGqlLabPortalShipTodayOvernightOrderListItemFragment = { __typename?: 'LabPortalShipTodayOvernightOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalShipTodayOvernightOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalShipTodayOvernightOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalShipTodayOvernightOrderListItem' }
    & LabsGqlLabPortalShipTodayOvernightOrderListItemFragment
  )> };

export type LabsGqlLabPortalShipTodayOrderListCountsFragment = { __typename?: 'LabPortalShipTodayOrderListCounts', shipToday: Maybe<number>, shipLate: Maybe<number>, shipOvernightToday: Maybe<number> };

export type LabsGqlLabPortalShipTodayOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalShipTodayOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalShipTodayOrderListCounts' }
    & LabsGqlLabPortalShipTodayOrderListCountsFragment
  ) };

export type LabsGqlLabPortalDesignOrderListItemFragment = { __typename?: 'LabPortalDesignOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string, designFilePath: Maybe<string>, partnerOrderNumber: Maybe<string>, scanExportSanitizedUrl: Maybe<string>, itemsV2: Maybe<Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>> };

export type LabsGqlLabPortalDesignOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalDesignOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalDesignOrderListItem' }
    & LabsGqlLabPortalDesignOrderListItemFragment
  )> };

export type LabsGqlLabPortalDesignWaitForDandyOrderListItemFragment = { __typename?: 'LabPortalDesignWaitForDandyOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalDesignWaitForDandyOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalDesignWaitForDandyOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalDesignWaitForDandyOrderListItem' }
    & LabsGqlLabPortalDesignWaitForDandyOrderListItemFragment
  )> };

export type LabsGqlLabPortalDesignReviseOrderListItemFragment = { __typename?: 'LabPortalDesignReviseOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string, designFilePath: Maybe<string>, partnerOrderNumber: Maybe<string>, scanExportSanitizedUrl: Maybe<string>, itemsV2: Maybe<Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>> };

export type LabsGqlLabPortalDesignReviseOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalDesignReviseOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalDesignReviseOrderListItem' }
    & LabsGqlLabPortalDesignReviseOrderListItemFragment
  )> };

export type LabsGqlLabPortalDesignSendToFloorOrderListItemFragment = { __typename?: 'LabPortalDesignSendToFloorOrderListItem', id: string, listFlags: Array<string>, patientName: string, orderNumber: string, orderProductLine: string, shipDate: string };

export type LabsGqlLabPortalDesignSendToFloorOrdersByListViewQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  labPortalSort: Types.InputMaybe<Types.LabsGqlLabPortalListOrdersSort>;
}>;


export type LabsGqlLabPortalDesignSendToFloorOrdersByListViewQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabPortalDesignSendToFloorOrderListItem' }
    & LabsGqlLabPortalDesignSendToFloorOrderListItemFragment
  )> };

export type LabsGqlLabPortalDesignOrderListCountsFragment = { __typename?: 'LabPortalDesignOrderListCounts', design: Maybe<number>, designWaitForDandy: Maybe<number>, designRevise: Maybe<number>, designSendToFloor: Maybe<number> };

export type LabsGqlLabPortalDesignOrderCountsQueryVariables = Types.Exact<{
  criteria: Array<Types.LabsGqlFilterCriteriaSubmissionInput>;
  sort: Types.LabsGqlListOrdersSort;
  columns: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabPortalDesignOrderCountsQuery = { __typename?: 'Query', orders: (
    { __typename?: 'LabPortalDesignOrderListCounts' }
    & LabsGqlLabPortalDesignOrderListCountsFragment
  ) };

export type LabsGqlLabPriceLedgerPriceOverrideDtoFragment = { __typename?: 'LabPriceLedgerPriceOverrideDTO', original_price_cents: number, original_total_price_cents: number, reason: Types.LabsGqlLabPriceLedgerOverrideReason, description: Maybe<string> };

export type LabsGqlLabPriceLedgerPriceDtoFragment = { __typename?: 'LabPriceLedgerPriceDTO', price_id: string, price_cents: number, price_name: string, lab_unit_count: number, total_price_cents: number, item_id: Maybe<string>, units: Maybe<Array<{ __typename?: 'LabPriceLedgerUnitInfoDTO', unit_type: string, material: Maybe<string>, unn: Maybe<number>, arch: Maybe<Types.LabsGqlOrderItemArch> }>>, price_override: Maybe<(
    { __typename?: 'LabPriceLedgerPriceOverrideDTO' }
    & LabsGqlLabPriceLedgerPriceOverrideDtoFragment
  )> };

export type LabsGqlLabPriceLedgerResultFragment = { __typename?: 'LabPriceLedgerResult', id: string, order_id: string, order_number: string, created_at: string, fulfillment_number: number, fabrication_start_date: Maybe<string>, ship_date: string, patient_first_name: string, patient_last_name: string, reviewed: boolean, lab_prices: Array<(
    { __typename?: 'LabPriceLedgerPriceDTO' }
    & LabsGqlLabPriceLedgerPriceDtoFragment
  )> };

export type LabsGqlLabPriceLedgerSummaryResultFragment = { __typename?: 'LabPriceLedgerSummaryResult', month: string, orders_count: number };

export type LabsGqlLabPriceRule_LabPriceAdditionalPonticsInRemovableRuleDto_Fragment = { __typename?: 'LabPriceAdditionalPonticsInRemovableRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceAlignerKittingRuleDto_Fragment = { __typename?: 'LabPriceAlignerKittingRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceAlignerRushFeeRuleDto_Fragment = { __typename?: 'LabPriceAlignerRushFeeRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceAlignerUnitRuleDto_Fragment = { __typename?: 'LabPriceAlignerUnitRuleDTO', type: Types.LabsGqlLabPriceRuleType, aligner_retainers_only: boolean };

export type LabsGqlLabPriceRule_LabPriceDentureAddOnCuSilGasketDto_Fragment = { __typename?: 'LabPriceDentureAddOnCuSilGasketDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceDentureAddOnMetalFrameworkDto_Fragment = { __typename?: 'LabPriceDentureAddOnMetalFrameworkDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceDentureAddOnMetalMeshDto_Fragment = { __typename?: 'LabPriceDentureAddOnMetalMeshDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceDentureAddOnSoftlinerDto_Fragment = { __typename?: 'LabPriceDentureAddOnSoftlinerDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceDentureArchRuleDto_Fragment = { __typename?: 'LabPriceDentureArchRuleDTO', type: Types.LabsGqlLabPriceRuleType, arch_type: Types.LabsGqlDenturesSingleFulfillmentArchType, fabrication_method: Types.LabsGqlDenturesFabricationMethod, teeth_quality: Types.LabsGqlDenturesTeethQuality };

export type LabsGqlLabPriceRule_LabPriceDentureTryInRuleDto_Fragment = { __typename?: 'LabPriceDentureTryInRuleDTO', type: Types.LabsGqlLabPriceRuleType, denture_arch: Types.LabsGqlDenturesArchType };

export type LabsGqlLabPriceRule_LabPriceDentureWaxRimRuleDto_Fragment = { __typename?: 'LabPriceDentureWaxRimRuleDTO', type: Types.LabsGqlLabPriceRuleType, denture_arch: Types.LabsGqlDenturesArchType };

export type LabsGqlLabPriceRule_LabPriceExternalDesignRuleDto_Fragment = { __typename?: 'LabPriceExternalDesignRuleDTO', type: Types.LabsGqlLabPriceRuleType, unit_type: string };

export type LabsGqlLabPriceRule_LabPriceFirstPonticInRemovableRuleDto_Fragment = { __typename?: 'LabPriceFirstPonticInRemovableRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceImplantAbutmentRuleDto_Fragment = { __typename?: 'LabPriceImplantAbutmentRuleDTO', type: Types.LabsGqlLabPriceRuleType, abutment_type: Types.LabsGqlLabPriceAbutmentType, authentic: boolean, manufacturer: Maybe<string>, generic_manufacturer: Maybe<Types.LabsGqlOrderItemLinkGenericManufacturer> };

export type LabsGqlLabPriceRule_LabPriceImplantDigitalAnalogRuleDto_Fragment = { __typename?: 'LabPriceImplantDigitalAnalogRuleDTO', type: Types.LabsGqlLabPriceRuleType, authentic: boolean, generic_manufacturer: Maybe<Types.LabsGqlOrderItemLinkGenericManufacturer>, manufacturer: Maybe<string> };

export type LabsGqlLabPriceRule_LabPriceImplantModelRuleDto_Fragment = { __typename?: 'LabPriceImplantModelRuleDTO', type: Types.LabsGqlLabPriceRuleType, model_type: Types.LabsGqlOrderItemModelType };

export type LabsGqlLabPriceRule_LabPriceImplantRuleDto_Fragment = { __typename?: 'LabPriceImplantRuleDTO', type: Types.LabsGqlLabPriceRuleType, abutment_type: Types.LabsGqlLabPriceAbutmentType, authentic: boolean, generic_manufacturer: Maybe<Types.LabsGqlOrderItemLinkGenericManufacturer> };

export type LabsGqlLabPriceRule_LabPriceModelRuleDto_Fragment = { __typename?: 'LabPriceModelRuleDTO', type: Types.LabsGqlLabPriceRuleType, model_type: Types.LabsGqlOrderItemModelType };

export type LabsGqlLabPriceRule_LabPriceNightguardColorCustomizationRuleDto_Fragment = { __typename?: 'LabPriceNightguardColorCustomizationRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceOrderRuleDto_Fragment = { __typename?: 'LabPriceOrderRuleDTO', type: Types.LabsGqlLabPriceRuleType, designer_type: Maybe<Types.LabsGqlLabPriceRuleOrderDesignerType> };

export type LabsGqlLabPriceRule_LabPriceOtherAddOnRuleDto_Fragment = { __typename?: 'LabPriceOtherAddOnRuleDTO', type: Types.LabsGqlLabPriceRuleType, unit_type: string };

export type LabsGqlLabPriceRule_LabPricePackagingRuleDto_Fragment = { __typename?: 'LabPricePackagingRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPricePartialDentureArchRuleDto_Fragment = { __typename?: 'LabPricePartialDentureArchRuleDTO', type: Types.LabsGqlLabPriceRuleType, coverage_type: Types.LabsGqlOrderItemPartialDentureCoverageType, material: string, partial_unit_type: Types.LabsGqlLabPricePartialDentureArchUnitType, tooth_count_range: { __typename?: 'LabPricePartialDentureToothCountRange', min: Maybe<number>, max: Maybe<number> } };

export type LabsGqlLabPriceRule_LabPricePartialDentureClaspRuleDto_Fragment = { __typename?: 'LabPricePartialDentureClaspRuleDTO', type: Types.LabsGqlLabPriceRuleType, clasp_type: Types.LabsGqlOrderItemPartialDentureClaspType };

export type LabsGqlLabPriceRule_LabPricePartialDentureWaxRimRuleDto_Fragment = { __typename?: 'LabPricePartialDentureWaxRimRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPricePracticePartialDentureFinalRuleDto_Fragment = { __typename?: 'LabPricePracticePartialDentureFinalRuleDTO', type: Types.LabsGqlLabPriceRuleType, material: string, practice_partial_clasp_type: Maybe<Types.LabsGqlLabPricePartialDenturePracticeClaspType>, optional_coverage_type: Maybe<Types.LabsGqlOrderItemPartialDentureCoverageType>, optional_tooth_count_range: Maybe<{ __typename?: 'LabPricePartialDentureToothCountRange', min: Maybe<number>, max: Maybe<number> }> };

export type LabsGqlLabPriceRule_LabPricePracticePartialDentureRuleDto_Fragment = { __typename?: 'LabPricePracticePartialDentureRuleDTO', type: Types.LabsGqlLabPriceRuleType, material: string, practice_partial_clasp_type: Maybe<Types.LabsGqlLabPricePartialDenturePracticeClaspType>, practice_partial_unit_type: Types.LabsGqlLabPricePartialDenturePracticeUnitType, optional_coverage_type: Maybe<Types.LabsGqlOrderItemPartialDentureCoverageType>, optional_tooth_count_range: Maybe<{ __typename?: 'LabPricePartialDentureToothCountRange', min: Maybe<number>, max: Maybe<number> }> };

export type LabsGqlLabPriceRule_LabPricePracticePartialDentureTryInRuleDto_Fragment = { __typename?: 'LabPricePracticePartialDentureTryInRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPricePracticePartialDentureWaxRimRuleDto_Fragment = { __typename?: 'LabPricePracticePartialDentureWaxRimRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPricePracticeUnitRuleDto_Fragment = { __typename?: 'LabPricePracticeUnitRuleDTO', type: Types.LabsGqlLabPriceRuleType, unit_material: Maybe<string>, unit_type: string };

export type LabsGqlLabPriceRule_LabPricePreciousMetalRuleDto_Fragment = { __typename?: 'LabPricePreciousMetalRuleDTO', type: Types.LabsGqlLabPriceRuleType, material: string };

export type LabsGqlLabPriceRule_LabPriceRemovableClaspRuleDto_Fragment = { __typename?: 'LabPriceRemovableClaspRuleDTO', type: Types.LabsGqlLabPriceRuleType, removable_clasp_type: Types.LabsGqlOrderItemRemovableClaspType };

export type LabsGqlLabPriceRule_LabPriceRemovableRuleDto_Fragment = { __typename?: 'LabPriceRemovableRuleDTO', type: Types.LabsGqlLabPriceRuleType, unit_type: string, material: string, arch: Types.LabsGqlOrderItemArch };

export type LabsGqlLabPriceRule_LabPriceSleepApneaRuleDto_Fragment = { __typename?: 'LabPriceSleepApneaRuleDTO', type: Types.LabsGqlLabPriceRuleType, sleep_apnea_type: Types.LabsGqlOrderItemSleepApneaType, discluding_ramp: boolean };

export type LabsGqlLabPriceRule_LabPriceSurgicalGuideRuleDto_Fragment = { __typename?: 'LabPriceSurgicalGuideRuleDTO', type: Types.LabsGqlLabPriceRuleType, guide_type: Types.LabsGqlLabPriceSurgicalGuideType, ownership: Types.LabsGqlLabPriceSurgicalGuideOwnership };

export type LabsGqlLabPriceRule_LabPriceSurgicalGuideSleeveRuleDto_Fragment = { __typename?: 'LabPriceSurgicalGuideSleeveRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceTmjRuleDto_Fragment = { __typename?: 'LabPriceTMJRuleDTO', type: Types.LabsGqlLabPriceRuleType, tmj_type: Types.LabsGqlOrderItemTmjType, includes_wiring: Maybe<boolean> };

export type LabsGqlLabPriceRule_LabPriceUnitRuleDto_Fragment = { __typename?: 'LabPriceUnitRuleDTO', type: Types.LabsGqlLabPriceRuleType, unit_type: string, material: string, tooth_position_class: Maybe<Types.LabsGqlLabPriceToothPositionClass> };

export type LabsGqlLabPriceRule_LabPriceUnknownRuleDto_Fragment = { __typename?: 'LabPriceUnknownRuleDTO', type: Types.LabsGqlLabPriceRuleType };

export type LabsGqlLabPriceRule_LabPriceWaxupRuleDto_Fragment = { __typename?: 'LabPriceWaxupRuleDTO', type: Types.LabsGqlLabPriceRuleType, unit_type: string };

export type LabsGqlLabPriceRuleFragment = LabsGqlLabPriceRule_LabPriceAdditionalPonticsInRemovableRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceAlignerKittingRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceAlignerRushFeeRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceAlignerUnitRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureAddOnCuSilGasketDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureAddOnMetalFrameworkDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureAddOnMetalMeshDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureAddOnSoftlinerDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureArchRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureTryInRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceDentureWaxRimRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceExternalDesignRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceFirstPonticInRemovableRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceImplantAbutmentRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceImplantDigitalAnalogRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceImplantModelRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceImplantRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceModelRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceNightguardColorCustomizationRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceOrderRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceOtherAddOnRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePackagingRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePartialDentureArchRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePartialDentureClaspRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePartialDentureWaxRimRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePracticePartialDentureFinalRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePracticePartialDentureRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePracticePartialDentureTryInRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePracticePartialDentureWaxRimRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePracticeUnitRuleDto_Fragment | LabsGqlLabPriceRule_LabPricePreciousMetalRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceRemovableClaspRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceRemovableRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceSleepApneaRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceSurgicalGuideRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceSurgicalGuideSleeveRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceTmjRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceUnitRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceUnknownRuleDto_Fragment | LabsGqlLabPriceRule_LabPriceWaxupRuleDto_Fragment;

export type LabsGqlLabPriceConfigFragment = { __typename?: 'LabPriceConfigDTO', lab_id: Maybe<string>, price_cents: number };

export type LabsGqlLabPricePartnerConfigFragment = { __typename?: 'LabPricePartnerConfigDTO', partner_id: Maybe<string>, price_cents: number };

export type LabsGqlLabPriceFragment = { __typename?: 'LabPriceDTO', id: string, name: string, created_at: string, updated_at: string, deleted_at: Maybe<string>, rule: (
    { __typename?: 'LabPriceAdditionalPonticsInRemovableRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAdditionalPonticsInRemovableRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceAlignerKittingRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAlignerKittingRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceAlignerRushFeeRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAlignerRushFeeRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceAlignerUnitRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAlignerUnitRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnCuSilGasketDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnCuSilGasketDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnMetalFrameworkDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnMetalFrameworkDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnMetalMeshDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnMetalMeshDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnSoftlinerDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnSoftlinerDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureArchRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureArchRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureTryInRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureTryInRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureWaxRimRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureWaxRimRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceExternalDesignRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceExternalDesignRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceFirstPonticInRemovableRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceFirstPonticInRemovableRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantAbutmentRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantAbutmentRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantDigitalAnalogRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantDigitalAnalogRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantModelRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantModelRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceModelRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceModelRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceNightguardColorCustomizationRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceNightguardColorCustomizationRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceOrderRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceOrderRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceOtherAddOnRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceOtherAddOnRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePackagingRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePackagingRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePartialDentureArchRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePartialDentureArchRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePartialDentureClaspRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePartialDentureClaspRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePartialDentureWaxRimRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePartialDentureWaxRimRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureFinalRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureFinalRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureTryInRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureTryInRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureWaxRimRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureWaxRimRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticeUnitRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticeUnitRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePreciousMetalRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePreciousMetalRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceRemovableClaspRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceRemovableClaspRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceRemovableRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceRemovableRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceSleepApneaRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceSleepApneaRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceSurgicalGuideRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceSurgicalGuideRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceSurgicalGuideSleeveRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceSurgicalGuideSleeveRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceTMJRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceTmjRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceUnitRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceUnitRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceUnknownRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceUnknownRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceWaxupRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceWaxupRuleDto_Fragment
  ), lab_configs: Array<(
    { __typename?: 'LabPriceConfigDTO' }
    & LabsGqlLabPriceConfigFragment
  )>, partner_configs: Array<(
    { __typename?: 'LabPricePartnerConfigDTO' }
    & LabsGqlLabPricePartnerConfigFragment
  )>, configs: Array<(
    { __typename?: 'LabPriceConfigDTO' }
    & LabsGqlLabPriceConfigFragment
  )> };

export type LabsGqlGetLabPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLabPricesQuery = { __typename?: 'Query', getLabPrices: Array<(
    { __typename?: 'LabPriceDTO' }
    & LabsGqlLabPriceFragment
  )> };

export type LabsGqlLabPriceDefinitionResultFragment = { __typename?: 'LabPriceDefinitionResult', id: string, created_at: string, updated_at: string, deleted_at: Maybe<string>, name: string, labs_configured: number, partners_configured: number, salesforce_price_mapping: Maybe<string>, enabled_for_labs: Maybe<boolean>, enabled_for_practices: Maybe<boolean>, default_practice_price_cents: Maybe<number>, rule: (
    { __typename?: 'LabPriceAdditionalPonticsInRemovableRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAdditionalPonticsInRemovableRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceAlignerKittingRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAlignerKittingRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceAlignerRushFeeRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAlignerRushFeeRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceAlignerUnitRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceAlignerUnitRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnCuSilGasketDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnCuSilGasketDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnMetalFrameworkDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnMetalFrameworkDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnMetalMeshDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnMetalMeshDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureAddOnSoftlinerDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureAddOnSoftlinerDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureArchRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureArchRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureTryInRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureTryInRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceDentureWaxRimRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceDentureWaxRimRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceExternalDesignRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceExternalDesignRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceFirstPonticInRemovableRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceFirstPonticInRemovableRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantAbutmentRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantAbutmentRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantDigitalAnalogRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantDigitalAnalogRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantModelRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantModelRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceImplantRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceImplantRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceModelRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceModelRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceNightguardColorCustomizationRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceNightguardColorCustomizationRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceOrderRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceOrderRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceOtherAddOnRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceOtherAddOnRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePackagingRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePackagingRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePartialDentureArchRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePartialDentureArchRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePartialDentureClaspRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePartialDentureClaspRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePartialDentureWaxRimRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePartialDentureWaxRimRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureFinalRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureFinalRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureTryInRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureTryInRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticePartialDentureWaxRimRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticePartialDentureWaxRimRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePracticeUnitRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePracticeUnitRuleDto_Fragment
  ) | (
    { __typename?: 'LabPricePreciousMetalRuleDTO' }
    & LabsGqlLabPriceRule_LabPricePreciousMetalRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceRemovableClaspRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceRemovableClaspRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceRemovableRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceRemovableRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceSleepApneaRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceSleepApneaRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceSurgicalGuideRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceSurgicalGuideRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceSurgicalGuideSleeveRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceSurgicalGuideSleeveRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceTMJRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceTmjRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceUnitRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceUnitRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceUnknownRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceUnknownRuleDto_Fragment
  ) | (
    { __typename?: 'LabPriceWaxupRuleDTO' }
    & LabsGqlLabPriceRule_LabPriceWaxupRuleDto_Fragment
  ) };

export type LabsGqlGetLabPriceDefinitionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLabPriceDefinitionsQuery = { __typename?: 'Query', getLabPriceDefinitions: Array<(
    { __typename?: 'LabPriceDefinitionResult' }
    & LabsGqlLabPriceDefinitionResultFragment
  )> };

export type LabsGqlLabPriceLabPricesResultFragment = { __typename?: 'LabPriceLabPricesResult', id: string, name: string, lab_configs: Array<(
    { __typename?: 'LabPriceConfigDTO' }
    & LabsGqlLabPriceConfigFragment
  )> };

export type LabsGqlGetLabPriceLabPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLabPriceLabPricesQuery = { __typename?: 'Query', getLabPriceLabPrices: Array<(
    { __typename?: 'LabPriceLabPricesResult' }
    & LabsGqlLabPriceLabPricesResultFragment
  )> };

export type LabsGqlLabPricePartnerPricesResultFragment = { __typename?: 'LabPricePartnerPricesResult', id: string, name: string, partners_configured: number };

export type LabsGqlGetLabPricePartnerPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLabPricePartnerPricesQuery = { __typename?: 'Query', getLabPricePartnerPrices: Array<(
    { __typename?: 'LabPricePartnerPricesResult' }
    & LabsGqlLabPricePartnerPricesResultFragment
  )> };

export type LabsGqlOrganizationPriceConfigDtoFragment = { __typename?: 'OrganizationPriceConfigDTO', id: string, organization_id: string, price_cents: number, price_id: string };

export type LabsGqlGetOrganizationPriceConfigsQueryVariables = Types.Exact<{
  price_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  organization_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  organization_type: Types.InputMaybe<Types.LabsGqlOrganizationTypeForPricing>;
}>;


export type LabsGqlGetOrganizationPriceConfigsQuery = { __typename?: 'Query', getOrganizationPriceConfigs: Array<(
    { __typename?: 'OrganizationPriceConfigDTO' }
    & LabsGqlOrganizationPriceConfigDtoFragment
  )> };

export type LabsGqlListSalesforcePriceNameMappingsForLabPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListSalesforcePriceNameMappingsForLabPricesQuery = { __typename?: 'Query', listSalesforcePriceNameMappingsForLabPrices: Array<string> };

export type LabsGqlSingleMailingAddressQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlSingleMailingAddressQuery = { __typename?: 'Query', singleAddress: (
    { __typename?: 'PartnerDeliveryAddress' }
    & LabsGqlDoctorDeliveryAddressFragment
  ) };

export type LabsGqlLabDeliveryAddressesQueryVariables = Types.Exact<{
  partner_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabDeliveryAddressesQuery = { __typename?: 'Query', addresses: Array<(
    { __typename?: 'PartnerDeliveryAddress' }
    & LabsGqlDoctorDeliveryAddressFragment
  )> };

export type LabsGqlCanDeleteDeliveryAddressQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlCanDeleteDeliveryAddressQuery = { __typename?: 'Query', canDeleteDeliveryAddress: boolean };

export type LabsGqlDoctorDeliveryAddressFragment = { __typename: 'PartnerDeliveryAddress', id: string, partner_id: string, street_one: string, street_two: Maybe<string>, city: string, state: string, postal_code: string, country: string, deleted_at: Maybe<string>, can_delete: boolean, latitude: Maybe<number>, longitude: Maybe<number> };

export type LabsGqlValidateDeliveryAddressQueryVariables = Types.Exact<{
  data: Types.LabsGqlDeliveryAddressInput;
}>;


export type LabsGqlValidateDeliveryAddressQuery = { __typename?: 'Query', validateDeliveryAddress: (
    { __typename?: 'DeliveryAddressValidationError' }
    & LabsGqlDeliveryAddressValidationResult_DeliveryAddressValidationError_Fragment
  ) | (
    { __typename?: 'DeliveryAddressValidationSuccess' }
    & LabsGqlDeliveryAddressValidationResult_DeliveryAddressValidationSuccess_Fragment
  ) };

export type LabsGqlDeliveryAddressValidationResult_DeliveryAddressValidationError_Fragment = { __typename: 'DeliveryAddressValidationError', error: string };

export type LabsGqlDeliveryAddressValidationResult_DeliveryAddressValidationSuccess_Fragment = { __typename: 'DeliveryAddressValidationSuccess', validated_address: (
    { __typename?: 'DeliveryAddress' }
    & LabsGqlDeliveryAddressFragment
  ) };

export type LabsGqlDeliveryAddressValidationResultFragment = LabsGqlDeliveryAddressValidationResult_DeliveryAddressValidationError_Fragment | LabsGqlDeliveryAddressValidationResult_DeliveryAddressValidationSuccess_Fragment;

export type LabsGqlDeliveryAddressFragment = { __typename?: 'DeliveryAddress', street_one: string, street_two: Maybe<string>, city: string, state: string, postal_code: string, country: string };

export type LabsGqlLabOrderForListViewFragment = { __typename?: 'LabOrderWithEvents', id: string, created_at: string, updated_at: string, created_from_return_id: Maybe<string>, can_edit: Maybe<boolean>, can_leave_notes: Maybe<boolean>, can_refabricate: Maybe<boolean>, can_submit_feedback: Maybe<boolean>, can_submit_tryin_feedback: Maybe<boolean>, can_cancel: Maybe<boolean>, can_attach_scans: Maybe<boolean>, can_attach_images_or_files: Maybe<boolean>, partner_order_id: string, lab_customer_id: string, mailing_address_id: string, status: Types.LabsGqlLabOrderStatus, ship_status: Maybe<string>, scan_export_id: string, replaced_scan_export_ids: Array<string>, doctor_notes: Maybe<string>, doctor_preferences_id: string, manufacturer_id: string, partner_id: string, product_line: Maybe<Types.LabsGqlProductLine>, dentist_amount_due_cents: Maybe<number>, cancel_date: Maybe<string>, ship_date: Maybe<string>, ship_servicelevel: Maybe<string>, shipped_by_lab: Maybe<boolean>, shipping_label_url: Maybe<string>, shipping_method: Types.LabsGqlPortalShipShippingSpeed, tracking_number: Maybe<string>, carrier: Maybe<string>, shipped_to_dandy: boolean, delivery_date: Maybe<string>, needs_refabrication_date: Maybe<string>, refabrication_notes: Maybe<string>, notes_for_refabrication: Maybe<string>, refabrication_order_id: Maybe<string>, hold_in_review: boolean, hold_reason: Maybe<string>, show_hold_status_to_practice: Maybe<boolean>, sent_to_floor_date: Maybe<string>, fabrication_start_date: Maybe<string>, partner_order_number: Maybe<number>, doctor_name: string, split_order_count: Maybe<number>, original_order_id: Maybe<string>, previous_fulfillment_order_id: Maybe<string>, next_fulfillment_order_ids: Maybe<Array<string>>, review_flag_reasons: Maybe<Array<string>>, patient_order_count: number, design_file_path: Maybe<string>, order_number: string, qc_error: Maybe<Types.LabsGqlQcErrorType>, design_due_date: string, cbct_url: Maybe<string>, latest_design_file_validation_errors: Array<Types.LabsGqlDesignFileValidationError>, replaced_by_ids: Maybe<Array<string>>, cancelled_order_id: Maybe<string>, waxup_status: Maybe<Types.LabsGqlLabOrderWaxupReviewStatus>, patient: (
    { __typename?: 'PatientDTO' }
    & LabsGqlPatientFragment
  ), scan_export: (
    { __typename?: 'scan_export' }
    & LabsGqlScanFileForOrderFragment
  ), replaced_scan_exports: Array<(
    { __typename?: 'scan_export' }
    & LabsGqlScanFileForOrderFragment
  )>, fulfillment: (
    { __typename?: 'LabOrderFulfillmentDTO' }
    & LabsGqlLabOrderFulfillmentFragment
  ), refab_reasons: Maybe<Array<{ __typename?: 'OrderRefabReasonDTO', refab_reason_id: Maybe<string>, name: string, label: string, category: Maybe<string>, internal_only: boolean, fault: Maybe<string>, fault_override: Maybe<Types.LabsGqlRefabFault> }>>, hold_details: Maybe<{ __typename?: 'LabOrderHoldDetails', hold_category: string, hold_subcategory: Maybe<string>, hold_freetext: Maybe<string>, hold_created_at: Maybe<string> }>, hold_history: Array<{ __typename?: 'LabOrderHoldDetailsHistoryElement', hold_category: string, hold_subcategory: Maybe<string>, delay_days: Maybe<number>, hold_shown_to_practice: Maybe<boolean>, hold_created_at: Maybe<string>, hold_removed_at: Maybe<string> }>, doctor_photos: Array<(
    { __typename?: 'LabOrderDoctorPhoto' }
    & LabsGqlLabOrderDoctorPhotoFragment
  )>, line_items: Array<(
    { __typename?: 'LabOrderItem' }
    & LabsGqlLineItemFragment
  )>, items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), practice_dates: (
    { __typename?: 'OrderPracticeDates' }
    & LabsGqlPracticeDatesFragment
  ), lab_slip_alerts: Array<(
    { __typename?: 'LabSlipAlert' }
    & LabsGqlLabSlipAlertFragment
  )>, workflow_state: (
    { __typename?: 'WorkflowState' }
    & LabsGqlWorkflowStateFragment
  ), fulfillment_workflow: (
    { __typename?: 'OrderFulfillmentWorkflow' }
    & LabsGqlOrderFulfillmentWorkflowFragment
  ), manufacturer_history: (
    { __typename?: 'ManufacturerOrderHistory' }
    & LabsGqlManufacturerOrderHistoryFragment
  ), photos: Array<{ __typename?: 'LabOrderSinglePhotoDTO', type: Types.LabsGqlLabOrderPhotoType, fullPath: string }>, integration_order: Maybe<{ __typename?: 'IntegrationOrder', id: string, pan: Maybe<string>, lab_charge_price_cents: Maybe<number>, manufacturer_case_number: Maybe<number>, manufacturer_order_id: Maybe<string> }>, integration_order_entry_job: Maybe<{ __typename?: 'OrderEntryJobDTO', id: string, updated_at: string, status: Types.LabsGqlOrderEntryJobStatus, last_queued_at: Maybe<string>, failures: Array<(
      { __typename?: 'OrderEntryJobFailure' }
      & LabsGqlOrderEntryJobFailureFragment
    )> }>, dentures_fulfillment: Maybe<(
    { __typename?: 'DenturesFulfillmentDTO' }
    & LabsGqlDenturesFulfillmentFragment
  )>, partials_fulfillment: Maybe<(
    { __typename?: 'PartialsFulfillmentDTO' }
    & LabsGqlPartialsFulfillmentFragment
  )>, review_submission: Maybe<{ __typename?: 'IReviewSubmission', doctor_is_happy: Maybe<boolean>, rating: Types.LabsGqlReviewRating, items: Array<{ __typename?: 'ReviewSubmissionSectionItem', star_rating: Maybe<number> }> }>, clinical_support_notes: Maybe<{ __typename?: 'ClinicalSupportNotes', notes: Maybe<string>, last_edited_by_staff_id: Maybe<string> }>, try_in_feedback: Maybe<{ __typename?: 'TryInFeedbackDTO', id: string }> };

export type LabsGqlLabOrderFragment = (
  { __typename?: 'LabOrderWithEvents', aligner_case: Maybe<(
    { __typename?: 'AlignerCaseDTO' }
    & LabsGqlAlignerCaseFragment
  )> }
  & LabsGqlLabOrderForListViewFragment
);

export type LabsGqlSingleLabOrderFragment = (
  { __typename?: 'LabOrderWithEvents', cancelled_orders: Maybe<Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )>>, replaced_by_orders: Maybe<Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )>>, split_orders: Maybe<Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )>> }
  & LabsGqlLabOrderFragment
);

export type LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment = (
  { __typename: 'AlignerItem' }
  & LabsGqlAlignerItemFragment
  & LabsGqlOrderItemBase_AlignerItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment = (
  { __typename: 'BridgeItem' }
  & LabsGqlBridgeItemFragment
  & LabsGqlOrderItemBase_BridgeItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_CrownItem_Fragment = (
  { __typename: 'CrownItem' }
  & LabsGqlCrownItemFragment
  & LabsGqlOrderItemBase_CrownItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_DentureItem_Fragment = (
  { __typename: 'DentureItem' }
  & LabsGqlDentureItemFragment
  & LabsGqlOrderItemBase_DentureItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment = (
  { __typename: 'ImplantBridgeItem' }
  & LabsGqlImplantBridgeItemFragment
  & LabsGqlOrderItemBase_ImplantBridgeItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment = (
  { __typename: 'ImplantItem' }
  & LabsGqlImplantItemFragment
  & LabsGqlOrderItemBase_ImplantItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_InlayItem_Fragment = (
  { __typename: 'InlayItem' }
  & LabsGqlInlayItemFragment
  & LabsGqlOrderItemBase_InlayItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_ModelItem_Fragment = (
  { __typename: 'ModelItem' }
  & LabsGqlModelItemFragment
  & LabsGqlOrderItemBase_ModelItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_OtherItem_Fragment = (
  { __typename: 'OtherItem' }
  & LabsGqlOtherItemFragment
  & LabsGqlOrderItemBase_OtherItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment = (
  { __typename: 'PartialDentureItem' }
  & LabsGqlPartialDentureItemFragment
  & LabsGqlOrderItemBase_PartialDentureItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment = (
  { __typename: 'RemovableItem' }
  & LabsGqlRemovableItemFragment
  & LabsGqlOrderItemBase_RemovableItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment = (
  { __typename: 'SleepApneaItem' }
  & LabsGqlSleepApneaItemFragment
  & LabsGqlOrderItemBase_SleepApneaItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment = (
  { __typename: 'SurgicalGuideItem' }
  & LabsGqlSurgicalGuideItemFragment
  & LabsGqlOrderItemBase_SurgicalGuideItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_TmjItem_Fragment = (
  { __typename: 'TMJItem' }
  & LabsGqlTmjItemFragment
  & LabsGqlOrderItemBase_TmjItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment = (
  { __typename: 'UnknownItem' }
  & LabsGqlOrderItemBase_UnknownItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment = (
  { __typename: 'VeneerItem' }
  & LabsGqlVeneerItemFragment
  & LabsGqlOrderItemBase_VeneerItem_Fragment
);

export type LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment = (
  { __typename: 'WaxupItem' }
  & LabsGqlWaxupItemFragment
  & LabsGqlOrderItemBase_WaxupItem_Fragment
);

export type LabsGqlLabOrderItemV2DtoFragment = LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment | LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment | LabsGqlLabOrderItemV2Dto_CrownItem_Fragment | LabsGqlLabOrderItemV2Dto_DentureItem_Fragment | LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment | LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment | LabsGqlLabOrderItemV2Dto_InlayItem_Fragment | LabsGqlLabOrderItemV2Dto_ModelItem_Fragment | LabsGqlLabOrderItemV2Dto_OtherItem_Fragment | LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment | LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment | LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment | LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment | LabsGqlLabOrderItemV2Dto_TmjItem_Fragment | LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment | LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment | LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment;

export type LabsGqlOrderDesignCapabilityFragment = { __typename?: 'OrderDesignCapabilityDTO', name: string, description: string, type: Types.LabsGqlOrderDesignCapabilityType, level: Types.LabsGqlOrderDesignCapabilityLevel };

export type LabsGqlOrderItemShadeFragment = { __typename?: 'LabOrderItemShade', name: string, value: string };

export type LabsGqlOrderItemAttachmentFragment = { __typename?: 'LabOrderAttachment', filepath: string };

export type LabsGqlOrderItemBase_AlignerItem_Fragment = { __typename?: 'AlignerItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_BridgeItem_Fragment = { __typename?: 'BridgeItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_CrownItem_Fragment = { __typename?: 'CrownItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_DentureItem_Fragment = { __typename?: 'DentureItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_ImplantBridgeItem_Fragment = { __typename?: 'ImplantBridgeItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_ImplantItem_Fragment = { __typename?: 'ImplantItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_InlayItem_Fragment = { __typename?: 'InlayItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_ModelItem_Fragment = { __typename?: 'ModelItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_OtherItem_Fragment = { __typename?: 'OtherItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_PartialDentureItem_Fragment = { __typename?: 'PartialDentureItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_RemovableItem_Fragment = { __typename?: 'RemovableItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_SleepApneaItem_Fragment = { __typename?: 'SleepApneaItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_SurgicalGuideItem_Fragment = { __typename?: 'SurgicalGuideItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_TmjItem_Fragment = { __typename?: 'TMJItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_UnknownItem_Fragment = { __typename?: 'UnknownItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_VeneerItem_Fragment = { __typename?: 'VeneerItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBase_WaxupItem_Fragment = { __typename?: 'WaxupItem', id: string, sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: { __typename?: 'OrderItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlOrderItemAttachmentFragment
  )> };

export type LabsGqlOrderItemBaseFragment = LabsGqlOrderItemBase_AlignerItem_Fragment | LabsGqlOrderItemBase_BridgeItem_Fragment | LabsGqlOrderItemBase_CrownItem_Fragment | LabsGqlOrderItemBase_DentureItem_Fragment | LabsGqlOrderItemBase_ImplantBridgeItem_Fragment | LabsGqlOrderItemBase_ImplantItem_Fragment | LabsGqlOrderItemBase_InlayItem_Fragment | LabsGqlOrderItemBase_ModelItem_Fragment | LabsGqlOrderItemBase_OtherItem_Fragment | LabsGqlOrderItemBase_PartialDentureItem_Fragment | LabsGqlOrderItemBase_RemovableItem_Fragment | LabsGqlOrderItemBase_SleepApneaItem_Fragment | LabsGqlOrderItemBase_SurgicalGuideItem_Fragment | LabsGqlOrderItemBase_TmjItem_Fragment | LabsGqlOrderItemBase_UnknownItem_Fragment | LabsGqlOrderItemBase_VeneerItem_Fragment | LabsGqlOrderItemBase_WaxupItem_Fragment;

export type LabsGqlCrownItemFragment = (
  { __typename?: 'CrownItem', unit: (
    { __typename?: 'OrderItemSingleToothUnit' }
    & LabsGqlOrderItemSingleToothUnitFragment
  ) }
  & LabsGqlOrderItemBase_CrownItem_Fragment
);

export type LabsGqlBridgeItemFragment = (
  { __typename?: 'BridgeItem', units: Array<(
    { __typename?: 'OrderItemSingleToothUnit' }
    & LabsGqlOrderItemSingleToothUnitFragment
  )> }
  & LabsGqlOrderItemBase_BridgeItem_Fragment
);

export type LabsGqlOtherItemFragment = (
  { __typename?: 'OtherItem', unit: (
    { __typename?: 'OrderItemUnitMetadata' }
    & LabsGqlOrderItemUnitMetadataFragment
  ) }
  & LabsGqlOrderItemBase_OtherItem_Fragment
);

export type LabsGqlModelItemFragment = (
  { __typename?: 'ModelItem', unit_type: string, model_type: Types.LabsGqlOrderItemModelType, selected_teeth: Maybe<Array<ToothNumber>> }
  & LabsGqlOrderItemBase_ModelItem_Fragment
);

export type LabsGqlWaxupItemFragment = (
  { __typename?: 'WaxupItem', unit_type: string, selected_teeth: Maybe<Array<ToothNumber>> }
  & LabsGqlOrderItemBase_WaxupItem_Fragment
);

export type LabsGqlInlayItemFragment = (
  { __typename?: 'InlayItem', unit: (
    { __typename?: 'OrderItemSingleToothUnit' }
    & LabsGqlOrderItemSingleToothUnitFragment
  ) }
  & LabsGqlOrderItemBase_InlayItem_Fragment
);

export type LabsGqlVeneerItemFragment = (
  { __typename?: 'VeneerItem', unit: (
    { __typename?: 'OrderItemSingleToothUnit' }
    & LabsGqlOrderItemSingleToothUnitFragment
  ) }
  & LabsGqlOrderItemBase_VeneerItem_Fragment
);

export type LabsGqlRemovableItemFragment = (
  { __typename?: 'RemovableItem', unit: (
    { __typename?: 'OrderItemArchUnit' }
    & LabsGqlOrderItemArchUnitFragment
  ) }
  & LabsGqlOrderItemBase_RemovableItem_Fragment
);

export type LabsGqlImplantItemFragment = (
  { __typename?: 'ImplantItem', unit: (
    { __typename?: 'ImplantToothGroup' }
    & LabsGqlImplantToothGroupFragment
  ) }
  & LabsGqlOrderItemBase_ImplantItem_Fragment
);

export type LabsGqlImplantBridgeItemFragment = (
  { __typename?: 'ImplantBridgeItem', implants: Array<(
    { __typename?: 'ImplantToothGroup' }
    & LabsGqlImplantToothGroupFragment
  )>, restoratives: Array<(
    { __typename?: 'OrderItemSingleToothUnit' }
    & LabsGqlOrderItemSingleToothUnitFragment
  )> }
  & LabsGqlOrderItemBase_ImplantBridgeItem_Fragment
);

export type LabsGqlOrderItemUnitMetadataFragment = { __typename?: 'OrderItemUnitMetadata', unit_type: string, material: string };

export type LabsGqlImplantToothGroupFragment = { __typename?: 'ImplantToothGroup', unn: ToothNumber, abutment: (
    { __typename?: 'OrderItemUnitMetadata' }
    & LabsGqlOrderItemUnitMetadataFragment
  ), crown: (
    { __typename?: 'OrderItemUnitMetadata' }
    & LabsGqlOrderItemUnitMetadataFragment
  ), implant_metadata: { __typename?: 'OrderItemImplantMetadata', manufacturer: string, system: string, connection_size: string, relationship: Types.LabsGqlOrderItemLinkRelationship, scanbody_id: Maybe<string>, authentic: Maybe<boolean>, generic_manufacturer: Maybe<Types.LabsGqlOrderItemLinkGenericManufacturer>, part_id: Maybe<string>, non_preferred_part_reason: Maybe<string>, abutment_part_manufacturer: Maybe<string> } };

export type LabsGqlDentureItemFragment = (
  { __typename?: 'DentureItem', denture_type: Types.LabsGqlDentureType, denture_production_type: Maybe<Types.LabsGqlDenturesProductionType>, denture_fabrication_method: Maybe<Types.LabsGqlDenturesFabricationMethod>, unit: (
    { __typename?: 'OrderItemArchUnit' }
    & LabsGqlOrderItemArchUnitFragment
  ), denture_production_metadata: Maybe<{ __typename?: 'OrderItemDentureProductionMetadata', quantity: Maybe<number>, smile_style: Maybe<Types.LabsGqlSmileStyleChoice>, festooning_level: Maybe<Types.LabsGqlDenturesFestooningLevel>, handle_diastema: Maybe<Types.LabsGqlDenturesHandleDiastemaOption>, correct_occlusal_scheme: Maybe<boolean>, add_post_dam: Maybe<boolean>, add_stippling: Maybe<boolean>, add_metal_framework: Maybe<boolean>, add_metal_mesh: Maybe<boolean>, add_softliner: Maybe<boolean>, cusil_gaskets_teeth: Maybe<Array<ToothNumber>>, try_in_design: Maybe<Types.LabsGqlDenturesTryInDesignType>, bite_adjustment: Maybe<{ __typename?: 'OrderItemDentureBiteAdjustment', adjustment_type: Types.LabsGqlDenturesBiteAdjustmentType, adjustment_distance_mm: Maybe<number> }>, midline_correction: Maybe<{ __typename?: 'OrderItemDentureMidlineCorrection', correction_type: Types.LabsGqlDenturesMidlineCorrectionType, correction_distance_mm: Maybe<number> }>, implant_support: Maybe<{ __typename?: 'OrderItemDentureImplantSupport', is_implant_supported: boolean, collar_heights_mm: Maybe<string>, is_horseshoe: Maybe<boolean> }>, copy_metadata: Maybe<{ __typename?: 'OrderItemDentureCopyMetadata', is_exact_copy: boolean, copy_change_notes: Maybe<string> }> }> }
  & LabsGqlOrderItemBase_DentureItem_Fragment
);

export type LabsGqlAlignerItemFragment = (
  { __typename?: 'AlignerItem', unit: (
    { __typename?: 'OrderItemArchUnit' }
    & LabsGqlOrderItemArchUnitFragment
  ), aligner_treatment_metadata: Maybe<{ __typename?: 'OrderItemAlignerTreatmentMetadata', treatment_area: Maybe<Types.LabsGqlAlignerTreatmentArea>, aligner_plan: Maybe<Types.LabsGqlAlignerPlan>, movement_restricted_teeth: Maybe<Array<ToothNumber>>, attachment_restricted_teeth: Maybe<Array<ToothNumber>>, extraction_teeth: Maybe<Array<ToothNumber>>, proposed_step_limit: Maybe<number>, trays_count: Maybe<number>, bite_concerns: Maybe<{ __typename?: 'OrderItemAlignerBiteConcerns', improve_overjet: Maybe<Types.LabsGqlBiteConcernOptions>, improve_overbite: Maybe<Types.LabsGqlBiteConcernOptions>, improve_midline: Maybe<Types.LabsGqlBiteConcernOptions> }>, crowding_resolution: Maybe<{ __typename?: 'OrderItemAlignerCrowdingResolution', expansion: Maybe<Types.LabsGqlCrowdingResolutionOption>, proclination: Maybe<Types.LabsGqlCrowdingResolutionOption>, ipr: Maybe<Types.LabsGqlCrowdingResolutionOption> }>, interproximal_space_sizes: Maybe<Array<{ __typename?: 'InterproximalSpaceSize', size: number, space: { __typename?: 'InterproximalSpace', tooth1: number, tooth2: number } }>> }> }
  & LabsGqlOrderItemBase_AlignerItem_Fragment
);

export type LabsGqlSleepApneaItemFragment = (
  { __typename?: 'SleepApneaItem', sleep_apnea_type: Types.LabsGqlOrderItemSleepApneaType, manufacturing_metadata: { __typename?: 'OrderItemSleepApneaManufacturingMetadata', should_cover_last_molar_distal: boolean, should_include_anterior_discluding_ramp: boolean, should_have_posterior_support_pads: Maybe<boolean> } }
  & LabsGqlOrderItemBase_SleepApneaItem_Fragment
);

export type LabsGqlSurgicalGuideItemFragment = (
  { __typename?: 'SurgicalGuideItem', surgical_guide_type: Types.LabsGqlOrderItemSurgicalGuideType, unit: (
    { __typename?: 'OrderItemSurgicalGuideUnit' }
    & LabsGqlOrderItemSurgicalGuideUnitFragment
  ), treatment_plan_metadata: { __typename?: 'OrderItemSurgicalGuidanceTreatmentPlanMetadata', patient_cbct_appointment_date: Maybe<string>, treatment_plan_review_type: Types.LabsGqlOrderItemSurgicalGuideTreatmentPlanReviewType, planned_procedures: Array<Types.LabsGqlOrderItemSurgicalGuidePlannedProcedureType>, final_restorative_type: Types.LabsGqlOrderItemSurgicalGuideFinalRestorativeType } }
  & LabsGqlOrderItemBase_SurgicalGuideItem_Fragment
);

export type LabsGqlTmjItemFragment = (
  { __typename?: 'TMJItem', tmj_type: Types.LabsGqlOrderItemTmjType, unit: (
    { __typename?: 'OrderItemArchUnit' }
    & LabsGqlOrderItemArchUnitFragment
  ), manufacturing_metadata: { __typename?: 'OrderItemTMJManufacturingMetadata', appliance_material: Maybe<Types.LabsGqlOrderItemTmjApplianceMaterial>, arch_separation_distance_mm: Maybe<number>, teeth_height_coverage: Maybe<Types.LabsGqlOrderItemTmjTeethHeightCoverage>, splint_material_thickness_mm: Maybe<number>, color: Maybe<Types.LabsGqlOrderItemTmjColor>, lingual_wire: Maybe<boolean>, teeth_coverage: Maybe<Types.LabsGqlOrderItemTmjTeethCoverage> } }
  & LabsGqlOrderItemBase_TmjItem_Fragment
);

export type LabsGqlPartialDentureItemFragment = (
  { __typename?: 'PartialDentureItem', partial_production_type: Maybe<Types.LabsGqlOrderItemPartialDentureProductionType>, coverage_type: Maybe<Types.LabsGqlOrderItemPartialDentureCoverageType>, unit: (
    { __typename?: 'OrderItemMultiToothUnit' }
    & LabsGqlOrderItemMultiToothUnitFragment
  ), partial_production_metadata: Maybe<{ __typename?: 'OrderItemPartialDentureProductionMetadata', is_replacement: Maybe<boolean>, digital_extractions: Maybe<Array<ToothNumber>>, clasp_generic_type: Maybe<Types.LabsGqlOrderItemPartialDentureGenericClaspType>, clasp_color: Maybe<Types.LabsGqlOrderItemPartialDentureClaspColor>, clasp_locations: Maybe<Array<ToothNumber>>, clasp_shade: Maybe<string>, clasp_notes: Maybe<string> }>, clasps: Maybe<Array<{ __typename?: 'OrderItemPartialDentureClasp', type: Types.LabsGqlOrderItemPartialDentureClaspType, count: number }>> }
  & LabsGqlOrderItemBase_PartialDentureItem_Fragment
);

export type LabsGqlOrderItemArchUnitFragment = { __typename?: 'OrderItemArchUnit', material: string, unit_type: string, arch: Types.LabsGqlOrderItemArch };

export type LabsGqlOrderItemSingleToothUnitFragment = { __typename?: 'OrderItemSingleToothUnit', material: string, unit_type: string, unn: ToothNumber, precious_metal_pennyweight: Maybe<number> };

export type LabsGqlOrderItemMultiToothUnitFragment = { __typename?: 'OrderItemMultiToothUnit', material: string, unit_type: string, unns: Array<ToothNumber> };

export type LabsGqlOrderItemSurgicalGuideUnitFragment = { __typename?: 'OrderItemSurgicalGuideUnit', unit_type: string, unns: Array<ToothNumber>, implant_metadata: { __typename?: 'OrderItemSurgicalGuideImplantMetadata', manufacturer: string, system: string, drill_kit: string, desired_size: Maybe<string> } };

export type LabsGqlOrderEntryJobFailureFragment = { __typename?: 'OrderEntryJobFailure', created_at: string, reasons: Array<(
    { __typename?: 'OrderEntryJobFailureReason' }
    & LabsGqlOrderEntryJobFailureReasonFragment
  )> };

export type LabsGqlOrderEntryJobFailureReasonFragment = { __typename?: 'OrderEntryJobFailureReason', reason: string, human_readable: boolean };

export type LabsGqlLabSlipAlertFragment = { __typename?: 'LabSlipAlert', text: string, type: Types.LabsGqlLabSlipAlertType, visibility: Maybe<Array<Types.LabsGqlDoctorAlertLocation>> };

export type LabsGqlManufacturerOrderHistoryFragment = { __typename?: 'ManufacturerOrderHistory', lab_slip_printed_at: Maybe<string>, design_downloaded_at: Maybe<string> };

export type LabsGqlDeliveryDelayFragment = { __typename?: 'OrderDeliveryDelay', days: number, status: Types.LabsGqlOrderDelayStatus, reason: Maybe<string> };

export type LabsGqlDesignEventLogEventAggregateFragment = { __typename?: 'DesignEventLogEventAggregate', name: string, count: number, cumulative_duration: number };

export type LabsGqlDesignEventLogMetadataFragment = { __typename?: 'DesignEventLogMetadata', number_sessions: number, cumulative_session_time: number, cumulative_gap_between_sessions: number, prepare_step_duration: number, segmentation_step_duration: number, interfaces_step_duration: number, directions_step_duration: number, anatomy_pre_design_step_duration: number, frame_design_step_duration: number, abutments_post_and_core_step_duration: number, anatomy_design_step_duration: number, idle_duration: number };

export type LabsGqlDesignEventLogFragment = { __typename?: 'DesignEventLog', metadata: (
    { __typename?: 'DesignEventLogMetadata' }
    & LabsGqlDesignEventLogMetadataFragment
  ), event_aggregates: Array<(
    { __typename?: 'DesignEventLogEventAggregate' }
    & LabsGqlDesignEventLogEventAggregateFragment
  )> };

export type LabsGqlDesignCaseFileModelElementFragment = { __typename?: 'DesignCaseFileModelElement', model_element_id: string, color_id: string, process_status_id: string, manufacturer_id: number, cache_material_name: string, model_volume: Maybe<number>, model_height: Maybe<number>, items_description: string, is_active: boolean, is_virtual: boolean, model_file_name: string, insertion_axis: Maybe<Array<number>> };

export type LabsGqlDesignCaseFileToothElementFragment = { __typename?: 'DesignCaseFileToothElement', tooth_element_id: string, model_element_id: string, tool_element_type_id: string, tooth_number: number, abutment_kit_id: Maybe<string>, is_anatomical: boolean, is_post_and_core: boolean, tooth_type_class: Maybe<string> };

export type LabsGqlDesignCaseFileFragment = { __typename?: 'DesignCaseFile', model_elements: Array<(
    { __typename?: 'DesignCaseFileModelElement' }
    & LabsGqlDesignCaseFileModelElementFragment
  )>, tooth_elements: Array<(
    { __typename?: 'DesignCaseFileToothElement' }
    & LabsGqlDesignCaseFileToothElementFragment
  )> };

export type LabsGqlOrderFulfillmentWorkflowFragment = { __typename?: 'OrderFulfillmentWorkflow', active_task: Maybe<(
    { __typename?: 'DesignReviewWorkflowTask' }
    & LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'DrReviewHoldWorkflowTask' }
    & LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ExternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'InternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveHoldWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveScanRejectionWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
  ) | (
    { __typename?: 'ReviewOrderWorkflowTask' }
    & LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment
  ) | (
    { __typename?: 'ScanReviewWorkflowTask' }
    & LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WaxupReviewWorkflowTask' }
    & LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WorkflowTaskGeneric' }
    & LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment
  )>, configuration: (
    { __typename?: 'OrderFulfillmentWorkflowConfigDTO' }
    & LabsGqlOrderFulfillmentWorkflowConfigFragment
  ), closed_tasks: Array<(
    { __typename?: 'DesignReviewWorkflowTask' }
    & LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'DrReviewHoldWorkflowTask' }
    & LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ExternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'InternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveHoldWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveScanRejectionWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
  ) | (
    { __typename?: 'ReviewOrderWorkflowTask' }
    & LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment
  ) | (
    { __typename?: 'ScanReviewWorkflowTask' }
    & LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WaxupReviewWorkflowTask' }
    & LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WorkflowTaskGeneric' }
    & LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment
  )> };

export type LabsGqlWaxupReviewHistoryFragment = { __typename?: 'OrderWaxupReviewHistory', approval: Maybe<(
    { __typename?: 'OrderWaxupReviewSubmission' }
    & LabsGqlWaxupReviewSubmissionFragment
  )>, rejections: Array<(
    { __typename?: 'OrderWaxupReviewRejection' }
    & LabsGqlWaxupReviewRejectionFragment
  )> };

export type LabsGqlWaxupReviewRejectionFragment = { __typename?: 'OrderWaxupReviewRejection', notes: string, review_event_id: number, created_at: string, design_file_path: Maybe<string>, annotations: Array<{ __typename?: 'OrderWaxupReviewRejectionAnnotation', image_url: string, comment: string }>, presets: Maybe<Array<{ __typename?: 'DesignViewPreset', preset_status: Types.LabsGqlGuidedWaxupPresetStatus, preset_type: Types.LabsGqlGuidedWaxupPresetType, notes: string, annotated_image_urls: Array<string> }>> };

export type LabsGqlWaxupReviewSubmissionFragment = { __typename?: 'OrderWaxupReviewSubmission', review_event_id: number, created_at: string, design_file_path: Maybe<string> };

export type LabsGqlOrderFulfillmentWorkflowConfigFragment = { __typename?: 'OrderFulfillmentWorkflowConfigDTO', design_review2_required: boolean, design_review_required: boolean, internal_design_required: boolean, separate_model_design_step: boolean, enable_threeshape_automate: boolean, enable_threeshape_automate_review: boolean, internal_design_prep_required: boolean, external_design_review_blocking: Maybe<boolean>, waxup_required: boolean, skip_finishing_design: boolean, injection_mold_required: boolean, needed_review_steps: Array<{ __typename?: 'ReviewStep', id: string, name: string }> };

export type LabsGqlOrderSlaFragment = { __typename?: 'OrderSLA', start_date: string, version: Maybe<number>, current_stage: Maybe<string>, design_days: Maybe<number>, review_days: number, fabrication_days: number, shipping_days: number, buffer_days: Maybe<number>, design_due_date: Maybe<string>, due_date_buffered: Maybe<string>, ready_for_fabrication_date: Maybe<string>, manufacturer_committed_ship_by_date: string, manufacturer_committed_due_date: string, internal_committed_ship_by_date: string, internal_committed_due_date: string, ship_by_date: string, due_date: string, original_deadline: Maybe<string>, rush_request: Maybe<(
    { __typename?: 'RushRequest' }
    & LabsGqlRushRequestFragment
  )>, manufacturer_delay_request: Maybe<(
    { __typename?: 'ManufacturerDelayRequest' }
    & LabsGqlManufacturerDelayRequestFragment
  )>, stages: Maybe<{ __typename?: 'KeyedSlaStages', ProcessingStart: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), ReadyForDesign: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), Design: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), WaxupReview: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), ReadyForFabrication: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), Fabrication: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), ShipToDandy: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), ShipToPractice: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ), Buffer: (
      { __typename?: 'SlaStage' }
      & LabsGqlMinimalSlaStageFragment
    ) }> };

export type LabsGqlMinimalSlaStageFragment = { __typename?: 'SlaStage', eta: Maybe<string>, original_deadline: Maybe<string> };

export type LabsGqlSlaStageDataFragment = { __typename?: 'SlaStageData', responsible_party: Maybe<Types.LabsGqlSlaResponsibleParty>, sla_days: number, start_event_id: Maybe<number>, start_date: Maybe<string>, end_event_id: Maybe<number>, end_date: Maybe<string> };

export type LabsGqlSlaStageRevisionFragment = { __typename?: 'SlaStageRevision', event_id: number, caused_by_party: Maybe<Types.LabsGqlSlaResponsibleParty>, previous: (
    { __typename?: 'SlaStageData' }
    & LabsGqlSlaStageDataFragment
  ) };

export type LabsGqlSlaStageInterruptionFragment = { __typename?: 'SlaStageInterruption', caused_by_party: Types.LabsGqlSlaResponsibleParty, start_event_id: number, start_date: string, end_event_id: Maybe<number>, end_date: Maybe<string>, expected_interruption_days: Maybe<number>, effective_interruption_days: Maybe<number> };

export type LabsGqlSlaStageDelayFragment = { __typename?: 'SlaStageDelay', lab: number, internal: number, practice: number };

export type LabsGqlSlaStageFragment = { __typename?: 'SlaStage', responsible_party: Maybe<Types.LabsGqlSlaResponsibleParty>, sla_days: number, start_event_id: Maybe<number>, start_date: Maybe<string>, end_event_id: Maybe<number>, end_date: Maybe<string>, was_complete_at_recommitment: Maybe<boolean>, eta: Maybe<string>, original_deadline: Maybe<string>, revisions: Array<(
    { __typename?: 'SlaStageRevision' }
    & LabsGqlSlaStageRevisionFragment
  )>, interruptions: Array<(
    { __typename?: 'SlaStageInterruption' }
    & LabsGqlSlaStageInterruptionFragment
  )>, delay_days: (
    { __typename?: 'SlaStageDelay' }
    & LabsGqlSlaStageDelayFragment
  ) };

export type LabsGqlDetailedOrderSlaFragment = (
  { __typename?: 'OrderSLA', waxup_review_due_date: Maybe<string>, manufacturer_sla_cutoff_time: Maybe<string>, manufacturer_sla_cutoff_timezone: Maybe<string>, manufacturer_shipping_time: Maybe<string>, stages: Maybe<{ __typename?: 'KeyedSlaStages', ProcessingStart: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), ReadyForDesign: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), Design: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), WaxupReview: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), ReadyForFabrication: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), Fabrication: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), ShipToDandy: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), ShipToPractice: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ), Buffer: (
      { __typename?: 'SlaStage' }
      & LabsGqlSlaStageFragment
    ) }> }
  & LabsGqlOrderSlaFragment
);

export type LabsGqlRushRequestFragment = { __typename?: 'RushRequest', status: Types.LabsGqlRushRequestStatus, design_days: Maybe<number>, fabrication_days: Maybe<number>, shipping_days: number, ship_by_date: string, due_date: string };

export type LabsGqlManufacturerDelayRequestFragment = { __typename?: 'ManufacturerDelayRequest', status: Types.LabsGqlManufacturerDelayRequestStatus, delay_days: number, shipping_days: number, updated_at: Maybe<string>, reason: (
    { __typename?: 'OrderSlaModificationReasonDTO' }
    & LabsGqlOrderSlaModificationReasonDtoFragment
  ) };

export type LabsGqlOrderSlaModificationReasonDtoFragment = { __typename?: 'OrderSlaModificationReasonDTO', category_id: string, subcategory_id: Maybe<string>, further_info: Maybe<string> };

export type LabsGqlWorkflowStateFragment = { __typename?: 'WorkflowState', state: Types.LabsGqlWorkflowStateEnum, responsible_party: Maybe<Types.LabsGqlResponsiblePartyEnum> };

export type LabsGqlManufacturerFabricationStateFragment = { __typename?: 'LabOrderManufacturerFabricationState', name: string, active: boolean, date_completed: Maybe<string> };

export type LabsGqlLineItemFragment = { __typename?: 'LabOrderItem', id: string, sku: Types.LabsGqlOrderItemSkuType, link_type: Maybe<Types.LabsGqlOrderItemLinkType>, material: Maybe<string>, item_notes: Maybe<string>, original_item_id: Maybe<string>, link_metadata: Maybe<(
    { __typename?: 'LabOrderItemLinkMetadata' }
    & LabsGqlOrderItemLinkMetadataFragment
  )>, partial_denture_metadata: Maybe<(
    { __typename?: 'LabOrderItemPartialDentureMetadata' }
    & LabsGqlOrderItemPartialDentureMetadataFragment
  )>, removable_metadata: Maybe<(
    { __typename?: 'LabOrderItemRemovableMetadata' }
    & LabsGqlOrderItemRemovableMetadataFragment
  )>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, teeth: Array<(
    { __typename?: 'LabOrderItemTooth' }
    & LabsGqlLineToothItemFragment
  )>, shades: Maybe<Array<{ __typename?: 'LabOrderItemShade', name: string, value: string }>> };

export type LabsGqlOrderItemLinkMetadataFragment = { __typename?: 'LabOrderItemLinkMetadata', manufacturer: Maybe<string>, system: Maybe<string>, connection: Maybe<string>, relationship: Maybe<Types.LabsGqlOrderItemLinkRelationship>, authentic: Maybe<boolean>, generic_manufacturer: Maybe<Types.LabsGqlOrderItemLinkGenericManufacturer>, part_id: Maybe<string>, non_preferred_part_reason: Maybe<string>, abutment_part_manufacturer: Maybe<string>, implant_scanbody_usages: Maybe<Array<(
    { __typename?: 'ImplantToothScanbodyUsage' }
    & LabsGqlImplantScanbodyUsagesFragment
  )>> };

export type LabsGqlOrderItemPartialDentureMetadataFragment = { __typename?: 'LabOrderItemPartialDentureMetadata', coverage_type: Maybe<Types.LabsGqlOrderItemPartialDentureCoverageType>, clasp_type: Maybe<Types.LabsGqlOrderItemPartialDentureClaspType>, clasps: Maybe<Array<{ __typename?: 'OrderItemPartialDentureClasp', type: Types.LabsGqlOrderItemPartialDentureClaspType, count: number }>> };

export type LabsGqlOrderItemRemovableMetadataFragment = { __typename?: 'LabOrderItemRemovableMetadata', clasps: Maybe<Array<{ __typename?: 'OrderItemRemovableClasp', type: Types.LabsGqlOrderItemRemovableClaspType, count: number }>> };

export type LabsGqlImplantScanbodyUsagesFragment = { __typename?: 'ImplantToothScanbodyUsage', unn: number, scanbody_id: Maybe<string>, scanbody: Maybe<(
    { __typename?: 'ScanbodyDTO' }
    & LabsGqlScanbodyFragment
  )> };

export type LabsGqlOrderFieldSubmissionFragment = { __typename: 'ICustomFieldSubmission', field_id: string, display_name: string, price_cents: Maybe<number>, value: string | boolean | number };

export type LabsGqlLineToothItemFragment = { __typename?: 'LabOrderItemTooth', unit_type: string, unn: string, material: Maybe<string>, amount_due_cents: Maybe<number>, precious_metal_pennyweight: Maybe<number> };

export type LabsGqlLabOrderDoctorPhotoFragment = { __typename?: 'LabOrderDoctorPhoto', url: string, deleted_at: Maybe<string> };

export type LabsGqlQualityControlItemFragment = { __typename?: 'QualityControlItemResult', id: string, title: string, description: string, attachments: Maybe<Array<string>>, complete: boolean, ignore: boolean };

export type LabsGqlScanFileForOrderFragment = { __typename?: 'scan_export', id: string, stl_url: Maybe<string>, sanitized_url: Maybe<string>, threeshape_order_id: string, threeshape_patient_id: string, patient_first_name: string, patient_last_name: string, patient_birthday: Maybe<string>, file_url: Maybe<string>, created_at: string, image_urls: Maybe<Array<string>>, lower_margin_suggestion_path: Maybe<string>, upper_margin_suggestion_path: Maybe<string>, has_shade_match_images: boolean, scan_source: Types.LabsGqlScanExportSource, scan_source_version: Maybe<string>, scanned_at: Maybe<string>, elements: Array<(
    { __typename?: 'ScanExportElement' }
    & LabsGqlScanExportItemForOrderFragment
  )>, oxz_margin_info: Maybe<(
    { __typename?: 'OXZMarginInformation' }
    & LabsGqlOxzMarginInformationFragment
  )> };

export type LabsGqlOxzMarginInformationFragment = { __typename?: 'OXZMarginInformation', doctorMargins: Maybe<Array<{ __typename?: 'BasicMarginInfo', unn: number, scan_id: string, coords: Maybe<Array<number>> }>>, prepMarks: Maybe<Array<{ __typename?: 'PrepMark', unn: number, details: string, sectioned: Maybe<boolean>, text: string, dcmName: string, origin: { __typename?: 'SimpleVector3', x: number, y: number, z: number } }>> };

export type LabsGqlScanExportItemForOrderFragment = { __typename?: 'ScanExportElement', Color: Maybe<string>, LinkTypeClass: string, Material: Maybe<string>, TypeIDs: Array<{ __typename?: 'ScanExportElementTypeID', UNN: string, unit_type: string }> };

export type LabsGqlDesignReduceOpposingGuideFragment = { __typename?: 'DesignReduceOpposingGuide', image_paths: Array<string>, notes: Maybe<string> };

export type LabsGqlLabOrderScanFragment = { __typename?: 'LabOrderScanDTO', export_id: string, replaced_export_ids: Array<string> };

export type LabsGqlLabOrderShipmentFragment = { __typename?: 'LabOrderShipmentDTO', carrier: Maybe<string>, carrier_account_number: Maybe<string>, created_via: Maybe<Types.LabsGqlShipmentCreatedViaEnumType>, tracking_number: Maybe<string>, ship_date: Maybe<string>, eta: Maybe<string>, original_eta: Maybe<string>, label_url: Maybe<string>, tracking_status: Maybe<string>, tracking_substatus: Maybe<Types.LabsGqlShipmentSubStatus>, tracking_status_updated_at: Maybe<string>, delivery_date: Maybe<string>, service_level: Maybe<string>, shipped_by_lab: Maybe<boolean>, package_accepted_date: Maybe<string>, latest_delivery_attempt_date: Maybe<string> };

export type LabsGqlLabOrderSingleFulfillmentFragment = { __typename?: 'LabOrderSingleFulfillmentDTO', status: Types.LabsGqlLabOrderFulfillmentStatus, updated_at: string, created_at: string, start_date: Maybe<string>, sent_to_floor_at: Maybe<string>, estimated_ship_date: Maybe<string>, shipping_method_override: Maybe<Types.LabsGqlPortalShipShippingSpeed>, scan: (
    { __typename?: 'LabOrderScanDTO' }
    & LabsGqlLabOrderScanFragment
  ), manufacturer_history: (
    { __typename?: 'ManufacturerOrderHistory' }
    & LabsGqlManufacturerOrderHistoryFragment
  ), shipment: Maybe<(
    { __typename?: 'LabOrderShipmentDTO' }
    & LabsGqlLabOrderShipmentFragment
  )>, inbound_shipment: Maybe<(
    { __typename?: 'LabOrderShipmentDTO' }
    & LabsGqlLabOrderShipmentFragment
  )>, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ) };

export type LabsGqlLabOrderFulfillmentFragment = { __typename?: 'LabOrderFulfillmentDTO', current: (
    { __typename?: 'LabOrderSingleFulfillmentDTO' }
    & LabsGqlLabOrderSingleFulfillmentFragment
  ), history: Array<(
    { __typename?: 'LabOrderSingleFulfillmentDTO' }
    & LabsGqlLabOrderSingleFulfillmentFragment
  )> };

export type LabsGqlDenturesFulfillmentSinglePhotoFragment = { __typename?: 'DenturesFulfillmentSinglePhotoDTO', path: string };

export type LabsGqlDenturesFulfillmentFixupIssueFragment = { __typename?: 'DenturesFulfillmentFixupIssueDTO', type: Types.LabsGqlDenturesFulfillmentFixupIssueType, details: string, photos: Array<(
    { __typename?: 'DenturesFulfillmentSinglePhotoDTO' }
    & LabsGqlDenturesFulfillmentSinglePhotoFragment
  )> };

export type LabsGqlDenturesFulfillmentFixupFragment = { __typename: 'DenturesFulfillmentFixupDTO', type: Types.LabsGqlDenturesSingleFulfillmentType, is_complete: boolean, is_try_in: boolean, upper_arch: Maybe<(
    { __typename?: 'DenturesFulfillmentFixupArch' }
    & LabsGqlDenturesFulfillmentFixupArchFragment
  )>, lower_arch: Maybe<(
    { __typename?: 'DenturesFulfillmentFixupArch' }
    & LabsGqlDenturesFulfillmentFixupArchFragment
  )>, fixup_issues_metadata: Maybe<(
    { __typename?: 'DenturesFulfillmentFixupAestheticIssuesMetadata' }
    & LabsGqlDenturesFulfillmentFixupIssuesMetadata_DenturesFulfillmentFixupAestheticIssuesMetadata_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentFixupStructuralIssuesMetadata' }
    & LabsGqlDenturesFulfillmentFixupIssuesMetadata_DenturesFulfillmentFixupStructuralIssuesMetadata_Fragment
  )> };

export type LabsGqlDenturesFulfillmentTryInFollowupFragment = { __typename: 'DenturesFulfillmentTryInFollowupDTO', type: Types.LabsGqlDenturesSingleFulfillmentType, is_try_in: boolean, upper_arch: Maybe<(
    { __typename?: 'DenturesFulfillmentFollowupArch' }
    & LabsGqlDenturesFulfillmentFollowupArchFragment
  )>, lower_arch: Maybe<(
    { __typename?: 'DenturesFulfillmentFollowupArch' }
    & LabsGqlDenturesFulfillmentFollowupArchFragment
  )>, followup_issues_metadata: Maybe<(
    { __typename?: 'DenturesFulfillmentFollowupAestheticIssuesMetadata' }
    & LabsGqlDenturesFulfillmentFollowupIssuesMetadata_DenturesFulfillmentFollowupAestheticIssuesMetadata_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentFollowupStructuralIssuesMetadata' }
    & LabsGqlDenturesFulfillmentFollowupIssuesMetadata_DenturesFulfillmentFollowupStructuralIssuesMetadata_Fragment
  )> };

export type LabsGqlDenturesFulfillmentFixupArchFragment = { __typename?: 'DenturesFulfillmentFixupArch', fixup_reasons: Array<Types.LabsGqlDenturesFixupReason>, fixup_issues: Array<(
    { __typename?: 'DenturesFulfillmentFixupIssueDTO' }
    & LabsGqlDenturesFulfillmentFixupIssueFragment
  )> };

export type LabsGqlDenturesFulfillmentFollowupArchFragment = { __typename?: 'DenturesFulfillmentFollowupArch', followup_reasons: Array<Types.LabsGqlDenturesFixupReason>, followup_issues: Array<(
    { __typename?: 'DenturesFulfillmentFixupIssueDTO' }
    & LabsGqlDenturesFulfillmentFixupIssueFragment
  )> };

export type LabsGqlDenturesFulfillmentWaxRimFragment = { __typename: 'DenturesFulfillmentWaxRimDTO', type: Types.LabsGqlDenturesSingleFulfillmentType, arch: Types.LabsGqlDenturesArchType, notes: string, implant_support: Maybe<(
    { __typename?: 'DenturesFulfillmentImplantSupportDTO' }
    & LabsGqlDenturesFulfillmentImplantSupportFragment
  )> };

export type LabsGqlDenturesFulfillmentCoreArchFragment = { __typename?: 'DenturesFulfillmentCoreArchDTO', type: Types.LabsGqlDenturesSingleFulfillmentArchType, fabrication_method: Array<Types.LabsGqlDenturesFabricationMethod>, teeth_quality: Array<Types.LabsGqlDenturesTeethQuality>, is_exact_copy: Maybe<boolean>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )> };

export type LabsGqlDenturesFulfillmentImplantSupportFragment = { __typename?: 'DenturesFulfillmentImplantSupportDTO', collar_heights_mm: string, horseshoe: Maybe<boolean> };

export type LabsGqlDenturesFulfillmentBiteAdjustmentFragment = { __typename?: 'DenturesFulfillmentBiteAdjustmentDTO', adjustment: Types.LabsGqlDenturesBiteAdjustmentType, adjustment_distance: Maybe<number> };

export type LabsGqlDenturesFulfillmentMidlineCorrectionFragment = { __typename?: 'DenturesFulfillmentMidlineCorrectionDTO', type: Types.LabsGqlDenturesMidlineCorrectionType, distance: Maybe<number> };

export type LabsGqlDenturesFulfillmentCoreFragment = { __typename: 'DenturesFulfillmentCoreDTO', type: Types.LabsGqlDenturesSingleFulfillmentType, is_try_in: boolean, smile_style: Types.LabsGqlSmileStyleChoice, festooning_level: Maybe<Types.LabsGqlDenturesFestooningLevel>, correct_occlusal_scheme: Maybe<boolean>, add_post_dam: Maybe<boolean>, add_stippling: Maybe<boolean>, handle_diastema: Maybe<Types.LabsGqlDenturesHandleDiastemaOption>, copy_change_notes: Maybe<string>, notes: string, number_of_spares: Maybe<number>, upper_arch: Maybe<(
    { __typename?: 'DenturesFulfillmentCoreArchDTO' }
    & LabsGqlDenturesFulfillmentCoreArchFragment
  )>, lower_arch: Maybe<(
    { __typename?: 'DenturesFulfillmentCoreArchDTO' }
    & LabsGqlDenturesFulfillmentCoreArchFragment
  )>, photos: Array<(
    { __typename?: 'DenturesFulfillmentSinglePhotoDTO' }
    & LabsGqlDenturesFulfillmentSinglePhotoFragment
  )>, bite_adjustment: Maybe<(
    { __typename?: 'DenturesFulfillmentBiteAdjustmentDTO' }
    & LabsGqlDenturesFulfillmentBiteAdjustmentFragment
  )>, midline_correction: Maybe<(
    { __typename?: 'DenturesFulfillmentMidlineCorrectionDTO' }
    & LabsGqlDenturesFulfillmentMidlineCorrectionFragment
  )>, implant_support: Maybe<(
    { __typename?: 'DenturesFulfillmentImplantSupportDTO' }
    & LabsGqlDenturesFulfillmentImplantSupportFragment
  )> };

export type LabsGqlDenturesSingleFulfillment_DenturesFulfillmentCoreDto_Fragment = (
  { __typename?: 'DenturesFulfillmentCoreDTO' }
  & LabsGqlDenturesFulfillmentCoreFragment
);

export type LabsGqlDenturesSingleFulfillment_DenturesFulfillmentFixupDto_Fragment = (
  { __typename?: 'DenturesFulfillmentFixupDTO' }
  & LabsGqlDenturesFulfillmentFixupFragment
);

export type LabsGqlDenturesSingleFulfillment_DenturesFulfillmentTryInFollowupDto_Fragment = (
  { __typename?: 'DenturesFulfillmentTryInFollowupDTO' }
  & LabsGqlDenturesFulfillmentTryInFollowupFragment
);

export type LabsGqlDenturesSingleFulfillment_DenturesFulfillmentWaxRimDto_Fragment = (
  { __typename?: 'DenturesFulfillmentWaxRimDTO' }
  & LabsGqlDenturesFulfillmentWaxRimFragment
);

export type LabsGqlDenturesSingleFulfillmentFragment = LabsGqlDenturesSingleFulfillment_DenturesFulfillmentCoreDto_Fragment | LabsGqlDenturesSingleFulfillment_DenturesFulfillmentFixupDto_Fragment | LabsGqlDenturesSingleFulfillment_DenturesFulfillmentTryInFollowupDto_Fragment | LabsGqlDenturesSingleFulfillment_DenturesFulfillmentWaxRimDto_Fragment;

export type LabsGqlDenturesFulfillmentFollowupIssuesMetadata_DenturesFulfillmentFollowupAestheticIssuesMetadata_Fragment = { __typename?: 'DenturesFulfillmentFollowupAestheticIssuesMetadata', followup_reason: Types.LabsGqlDenturesFixupReason };

export type LabsGqlDenturesFulfillmentFollowupIssuesMetadata_DenturesFulfillmentFollowupStructuralIssuesMetadata_Fragment = { __typename?: 'DenturesFulfillmentFollowupStructuralIssuesMetadata', followup_reason: Types.LabsGqlDenturesFixupReason, scan_export_id: Maybe<string> };

export type LabsGqlDenturesFulfillmentFollowupIssuesMetadataFragment = LabsGqlDenturesFulfillmentFollowupIssuesMetadata_DenturesFulfillmentFollowupAestheticIssuesMetadata_Fragment | LabsGqlDenturesFulfillmentFollowupIssuesMetadata_DenturesFulfillmentFollowupStructuralIssuesMetadata_Fragment;

export type LabsGqlDenturesFulfillmentFixupIssuesMetadata_DenturesFulfillmentFixupAestheticIssuesMetadata_Fragment = { __typename?: 'DenturesFulfillmentFixupAestheticIssuesMetadata', fixup_reason: Types.LabsGqlDenturesFixupReason };

export type LabsGqlDenturesFulfillmentFixupIssuesMetadata_DenturesFulfillmentFixupStructuralIssuesMetadata_Fragment = { __typename?: 'DenturesFulfillmentFixupStructuralIssuesMetadata', fixup_reason: Types.LabsGqlDenturesFixupReason, scan_export_id: Maybe<string> };

export type LabsGqlDenturesFulfillmentFixupIssuesMetadataFragment = LabsGqlDenturesFulfillmentFixupIssuesMetadata_DenturesFulfillmentFixupAestheticIssuesMetadata_Fragment | LabsGqlDenturesFulfillmentFixupIssuesMetadata_DenturesFulfillmentFixupStructuralIssuesMetadata_Fragment;

export type LabsGqlDenturesFulfillmentFragment = { __typename?: 'DenturesFulfillmentDTO', current: (
    { __typename?: 'DenturesFulfillmentCoreDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentCoreDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentFixupDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentFixupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentTryInFollowupDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentTryInFollowupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentWaxRimDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentWaxRimDto_Fragment
  ), history: Array<(
    { __typename?: 'DenturesFulfillmentCoreDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentCoreDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentFixupDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentFixupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentTryInFollowupDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentTryInFollowupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentWaxRimDTO' }
    & LabsGqlDenturesSingleFulfillment_DenturesFulfillmentWaxRimDto_Fragment
  )> };

export type LabsGqlPartialsFulfillmentReturnFragment = { __typename?: 'PartialsFulfillmentReturnDTO', created_at: string, shipment_id: string, in_transit_at: Maybe<string>, received_at: Maybe<string>, shipment: (
    { __typename?: 'IShipment' }
    & LabsGqlShipmentFragment
  ) };

export type LabsGqlPartialsWaxRimFeedbackFragment = { __typename?: 'PartialsWaxRimFeedbackDTO', notes: string };

export type LabsGqlPartialsFulfillmentWaxRimFragment = { __typename?: 'PartialsFulfillmentWaxRimDTO', type: Types.LabsGqlPartialsSingleFulfillmentType, feedback: Maybe<(
    { __typename?: 'PartialsWaxRimFeedbackDTO' }
    & LabsGqlPartialsWaxRimFeedbackFragment
  )>, return: Maybe<(
    { __typename?: 'PartialsFulfillmentReturnDTO' }
    & LabsGqlPartialsFulfillmentReturnFragment
  )> };

export type LabsGqlPartialsTryInFeedbackIssueFragment = { __typename?: 'PartialsTryInFeedbackIssueDTO', type: Types.LabsGqlPartialsTryInFeedbackIssueType, details: string };

export type LabsGqlPartialsTryInFeedbackFragment = { __typename?: 'PartialsTryInFeedbackDTO', type: Types.LabsGqlPartialsTryInFeedbackType, issues: Array<(
    { __typename?: 'PartialsTryInFeedbackIssueDTO' }
    & LabsGqlPartialsTryInFeedbackIssueFragment
  )> };

export type LabsGqlPartialsFulfillmentTryInFragment = { __typename?: 'PartialsFulfillmentTryInDTO', type: Types.LabsGqlPartialsSingleFulfillmentType, feedback: Maybe<(
    { __typename?: 'PartialsTryInFeedbackDTO' }
    & LabsGqlPartialsTryInFeedbackFragment
  )>, return: Maybe<(
    { __typename?: 'PartialsFulfillmentReturnDTO' }
    & LabsGqlPartialsFulfillmentReturnFragment
  )> };

export type LabsGqlPartialsFulfillmentFinishFragment = { __typename?: 'PartialsFulfillmentFinishDTO', type: Types.LabsGqlPartialsSingleFulfillmentType };

export type LabsGqlPartialsSingleFulfillment_PartialsFulfillmentFinishDto_Fragment = (
  { __typename?: 'PartialsFulfillmentFinishDTO' }
  & LabsGqlPartialsFulfillmentFinishFragment
);

export type LabsGqlPartialsSingleFulfillment_PartialsFulfillmentTryInDto_Fragment = (
  { __typename?: 'PartialsFulfillmentTryInDTO' }
  & LabsGqlPartialsFulfillmentTryInFragment
);

export type LabsGqlPartialsSingleFulfillment_PartialsFulfillmentWaxRimDto_Fragment = (
  { __typename?: 'PartialsFulfillmentWaxRimDTO' }
  & LabsGqlPartialsFulfillmentWaxRimFragment
);

export type LabsGqlPartialsSingleFulfillmentFragment = LabsGqlPartialsSingleFulfillment_PartialsFulfillmentFinishDto_Fragment | LabsGqlPartialsSingleFulfillment_PartialsFulfillmentTryInDto_Fragment | LabsGqlPartialsSingleFulfillment_PartialsFulfillmentWaxRimDto_Fragment;

export type LabsGqlPartialsFulfillmentFragment = { __typename?: 'PartialsFulfillmentDTO', upcoming: Maybe<(
    { __typename?: 'PartialsFulfillmentFinishDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentFinishDto_Fragment
  ) | (
    { __typename?: 'PartialsFulfillmentTryInDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentTryInDto_Fragment
  ) | (
    { __typename?: 'PartialsFulfillmentWaxRimDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentWaxRimDto_Fragment
  )>, current: (
    { __typename?: 'PartialsFulfillmentFinishDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentFinishDto_Fragment
  ) | (
    { __typename?: 'PartialsFulfillmentTryInDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentTryInDto_Fragment
  ) | (
    { __typename?: 'PartialsFulfillmentWaxRimDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentWaxRimDto_Fragment
  ), history: Array<(
    { __typename?: 'PartialsFulfillmentFinishDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentFinishDto_Fragment
  ) | (
    { __typename?: 'PartialsFulfillmentTryInDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentTryInDto_Fragment
  ) | (
    { __typename?: 'PartialsFulfillmentWaxRimDTO' }
    & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentWaxRimDto_Fragment
  )> };

export type LabsGqlLabOrderForLabSlipFragment = { __typename?: 'LabOrderForLabSlip', id: string, order_number: string, delivery_address_alias: Maybe<string>, doctor_name: string, doctor_notes: Maybe<string>, notes_for_refabrication: Maybe<string>, clinical_support_notes: Maybe<string>, needs_refabrication_date: Maybe<string>, created_at: string, is_multi_refab: boolean, original_order_id: Maybe<string>, labtrac_id: Maybe<string>, batch_ids: Maybe<Array<string>>, manufacturer_sla: { __typename?: 'OrderSlaForLabSlip', manufacturer_committed_ship_by_date: string, manufacturer_committed_due_date: string, ready_for_fabrication_date: Maybe<string>, ship_by_date: string, rush_request: Maybe<{ __typename?: 'RushRequest', status: Types.LabsGqlRushRequestStatus }> }, patient: { __typename?: 'PatientForLabSlip', first_name: string, last_name: string, birthday: string, gender: string }, items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>, lab_slip_alerts: Array<(
    { __typename?: 'LabSlipAlert' }
    & LabsGqlLabSlipAlertFragment
  )>, try_in_feedback_details: Maybe<Array<{ __typename?: 'TryInFeedbackDetailForLabSlip', arch: Types.LabsGqlOrderItemArch, category: string, details: string }>>, design_revision: Maybe<{ __typename?: 'DesignOrderDesignRevisionDTO', case_file_model_elements: Array<{ __typename?: 'DesignRevisionCaseFileModelElement', model_element_id: string, model_height: Maybe<number> }>, case_file_tooth_elements: Array<{ __typename?: 'DesignCaseFileToothElement', tooth_number: number, tooth_type_class: Maybe<string>, model_element_id: string }> }>, stackAndPanCodes: Maybe<{ __typename?: 'StackAndPanCodesDTO', stackCode: string, panCodes: Array<{ __typename?: 'PanCodeDTO', code: string, prefix: Maybe<string>, suffix: Maybe<string> }> }> };

export type LabsGqlSingleLabOrderQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlSingleLabOrderQuery = { __typename?: 'Query', lab_order: (
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlSingleLabOrderFragment
  ) };

export type LabsGqlGetOrderIdFromOrderNumberQueryVariables = Types.Exact<{
  order_number: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderIdFromOrderNumberQuery = { __typename?: 'Query', id: Maybe<string> };

export type LabsGqlLabOrdersByIdForLabSlipsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabOrdersByIdForLabSlipsQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabOrderForLabSlip' }
    & LabsGqlLabOrderForLabSlipFragment
  )> };

export type LabsGqlSingleLabOrderFromTestsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlSingleLabOrderFromTestsQuery = { __typename?: 'Query', lab_order: { __typename?: 'LabOrderWithEvents', id: string, status: Types.LabsGqlLabOrderStatus, photos: Array<{ __typename?: 'LabOrderSinglePhotoDTO', type: Types.LabsGqlLabOrderPhotoType, fullPath: string }> } };

export type LabsGqlDesignFileDmeFragment = { __typename?: 'DesignFileDme', dme_name: string, dme_version: number, latest_version: number, provides_materials: Array<string>, provides_smile_styles: Array<string> };

export type LabsGqlDesignFileDmeListResultFragment = { __typename?: 'DesignFileDmeListResult', number_unmatched_entries: number, found_dmes: Array<(
    { __typename?: 'DesignFileDme' }
    & LabsGqlDesignFileDmeFragment
  )> };

export type LabsGqlGetDesignFileDmeListQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDesignFileDmeListQuery = { __typename?: 'Query', getDesignFileDmeList: (
    { __typename?: 'DesignFileDmeListResult' }
    & LabsGqlDesignFileDmeListResultFragment
  ) };

export type LabsGqlLabOrderCountByStatusPracticeQueryVariables = Types.Exact<{
  doctor_preferences_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  partner_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlLabOrderCountByStatusPracticeQuery = { __typename?: 'Query', labOrderCountByStatus: (
    { __typename?: 'LabOrderStatusCount' }
    & LabsGqlLabOrderCountByStatusPracticeFragment
  ) };

export type LabsGqlLabOrderCountByStatusPracticeFragment = { __typename?: 'LabOrderStatusCount', New: number, NeedsReview: number, WaxupReview: number, Shipped: number, Cancelled: number, Delivered: number, Fabrication: number, OnHold: number, UnshippedReturns: number, InTransitReturns: number, UnsubmittedScans: number, All: number, NeedsOrderFeedback: number };

export type LabsGqlRecomputeOrderMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlRecomputeOrderMutation = { __typename?: 'Mutation', recomputeOrder: { __typename?: 'lab_order', id: string } };

export type LabsGqlUserReadEventsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlUserReadEventsQuery = { __typename?: 'Query', getUserReadEvents: (
    { __typename?: 'UserReadEvents' }
    & LabsGqlReadEventsFragment
  ) };

export type LabsGqlReadEventsFragment = { __typename?: 'UserReadEvents', read_event_ids: Array<number>, id: string };

export type LabsGqlTimelineItemsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['String']['input'];
  entityType: Types.Scalars['String']['input'];
  forceProjection?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlTimelineItemsQuery = { __typename?: 'Query', timelineItems: Array<(
    { __typename?: 'OrderTimelineItem' }
    & LabsGqlOrderTimelineItemFragment
  ) | (
    { __typename?: 'PracticeTimelineItem' }
    & LabsGqlPracticeTimelineItemFragment
  )> };

export type LabsGqlTimelineV2ItemsQueryVariables = Types.Exact<{
  entityId: Types.Scalars['String']['input'];
}>;


export type LabsGqlTimelineV2ItemsQuery = { __typename?: 'Query', timelineV2Items: Array<{ __typename?: 'OrderTimelineV2Item', order_id: string, date: string, name: Types.LabsGqlOrderTimelineV2EventEnum, variant: Types.LabsGqlOrderTimelineV2EventVariantEnum, icon: Types.LabsGqlOrderTimelineV2EventIconEnum, title: string, details: Maybe<string>, showAvatar: Maybe<boolean>, linked_order_id: Maybe<string>, linked_order_text: Maybe<string>, actor: { __typename?: 'OrderTimelineV2Actor', initial: Maybe<string>, isInternal: boolean }, attachments: Maybe<Array<{ __typename?: 'OrderTimelineV2Attachment', source: string, name: string, downloadUrl: Maybe<string> }>> }> };

export type LabsGqlTimelineItemActorFragment = { __typename?: 'TimelineItemActor', actor: string, actor_id: Maybe<string>, user_email: Maybe<string>, user_display_text: Maybe<string> };

export type LabsGqlITimelineItem_OrderTimelineItem_Fragment = { __typename?: 'OrderTimelineItem', date: string, title: string, subtitle: Array<string>, title_link: Maybe<{ __typename?: 'TimelineItemLink', href: string, text: string }>, actor: (
    { __typename?: 'TimelineItemActor' }
    & LabsGqlTimelineItemActorFragment
  ), attachments: Array<{ __typename?: 'TimelineAttachment', url: string, description: Maybe<string> }> };

export type LabsGqlITimelineItem_PracticeTimelineItem_Fragment = { __typename?: 'PracticeTimelineItem', date: string, title: string, subtitle: Array<string>, title_link: Maybe<{ __typename?: 'TimelineItemLink', href: string, text: string }>, actor: (
    { __typename?: 'TimelineItemActor' }
    & LabsGqlTimelineItemActorFragment
  ), attachments: Array<{ __typename?: 'TimelineAttachment', url: string, description: Maybe<string> }> };

export type LabsGqlITimelineItemFragment = LabsGqlITimelineItem_OrderTimelineItem_Fragment | LabsGqlITimelineItem_PracticeTimelineItem_Fragment;

export type LabsGqlOrderTimelineItemFragment = (
  { __typename: 'OrderTimelineItem', orderEvent: Types.LabsGqlOrderTimelineEventNameEnum }
  & LabsGqlITimelineItem_OrderTimelineItem_Fragment
);

export type LabsGqlPracticeTimelineItemFragment = (
  { __typename: 'PracticeTimelineItem', practiceEvent: Types.LabsGqlPracticeTimelineEventNameEnum }
  & LabsGqlITimelineItem_PracticeTimelineItem_Fragment
);

export type LabsGqlLastMatchingOrderByUnitTypeQueryVariables = Types.Exact<{
  unit_type: Types.Scalars['String']['input'];
  doctor_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlLastMatchingOrderByUnitTypeQuery = { __typename?: 'Query', lastMatchingOrderByUnitType: Maybe<(
    { __typename?: 'lab_order' }
    & LabsGqlLastMatchingOrderFragment
  )> };

export type LabsGqlLastMatchingOrderFragment = { __typename?: 'lab_order', created_at: string, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )> };

export type LabsGqlFlagOrderForReviewMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  reason: Types.Scalars['String']['input'];
}>;


export type LabsGqlFlagOrderForReviewMutation = { __typename?: 'Mutation', flagOrderForReview: { __typename?: 'lab_order', id: string } };

export type LabsGqlRecordPrintableLabSlipViewedMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  manufacturer_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlRecordPrintableLabSlipViewedMutation = { __typename?: 'Mutation', printableLabSlipViewed: { __typename?: 'lab_order', id: string } };

export type LabsGqlRecordPackingSheetViewedMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlRecordPackingSheetViewedMutation = { __typename?: 'Mutation', recordPackingSheetViewed: { __typename?: 'lab_order', id: string } };

export type LabsGqlRecordDesignDownloadMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  filePath: Types.Scalars['String']['input'];
}>;


export type LabsGqlRecordDesignDownloadMutation = { __typename?: 'Mutation', recordDesignDownload: { __typename?: 'lab_order', id: string } };

export type LabsGqlRefabReasonsForOrderItemsQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlRefabReasonsForOrderItemsQuery = { __typename?: 'Query', refabReasonsForOrderItems: Array<(
    { __typename?: 'LabOrderRefabReasonOption' }
    & LabsGqlRefabReasonOptionFragment
  )> };

export type LabsGqlReasonCodesForOrderItemQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  item_id: Types.Scalars['String']['input'];
  form_display: Types.LabsGqlFormDisplay;
}>;


export type LabsGqlReasonCodesForOrderItemQuery = { __typename?: 'Query', reasonCodesForOrderItem: Array<(
    { __typename?: 'LabOrderReasonCodeOption' }
    & LabsGqlReasonCodeOptionFragment
  )> };

export type LabsGqlRefabReasonOptionFragment = { __typename?: 'LabOrderRefabReasonOption', id: string, name: string, category: Maybe<string>, requires_return: boolean, internal_only: boolean, label: string, default_fault: Maybe<Types.LabsGqlRefabFault> };

export type LabsGqlReasonCodeOptionFragment = { __typename?: 'LabOrderReasonCodeOption', id: string, title: string, group: Maybe<Types.LabsGqlReasonCodeGroup>, category: Maybe<string>, requires_return: boolean, additional_info_request: Array<string>, internal_only: boolean, form_display: Maybe<Types.LabsGqlFormDisplay>, default_fault: Maybe<Types.LabsGqlReasonCodeFault>, label: string };

export type LabsGqlOrdersMatchingAutomationFilterCountQueryVariables = Types.Exact<{
  automationFilter: Types.LabsGqlFilterSubmissionInput;
  minAgeDays: Types.Scalars['Int']['input'];
}>;


export type LabsGqlOrdersMatchingAutomationFilterCountQuery = { __typename?: 'Query', ordersMatchingAutomationFilterCount: Maybe<number> };

export type LabsGqlPracticeOrdersCountQueryVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlPracticeOrdersCountQuery = { __typename?: 'Query', practiceOrdersCount: number };

export type LabsGqlOrderEntriesByListViewQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrdersFilter>;
  criteria: Types.InputMaybe<Array<Types.LabsGqlFilterCriteriaSubmissionInput>>;
  search: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort: Types.InputMaybe<Types.LabsGqlListOrdersSort>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
  combinator: Types.InputMaybe<Types.LabsGqlFilterCombinator>;
}>;


export type LabsGqlOrderEntriesByListViewQuery = { __typename?: 'Query', orderEntriesByListView: Array<(
    { __typename?: 'ListViewEntry' }
    & LabsGqlListViewEntryFragment
  )> };

export type LabsGqlOrdersByListViewQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrdersFilter>;
  criteria: Types.InputMaybe<Array<Types.LabsGqlFilterCriteriaSubmissionInput>>;
  search: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort: Types.InputMaybe<Types.LabsGqlListOrdersSort>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
  combinator: Types.InputMaybe<Types.LabsGqlFilterCombinator>;
}>;


export type LabsGqlOrdersByListViewQuery = { __typename?: 'Query', ordersByListView: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderForListViewFragment
  )> };

export type LabsGqlPracticeInboxActiveOrdersQueryVariables = Types.Exact<{
  doctor_preferences_id: Types.Scalars['String']['input'];
  timezone_offset_minutes: Types.Scalars['Int']['input'];
}>;


export type LabsGqlPracticeInboxActiveOrdersQuery = { __typename?: 'Query', practiceInboxActiveOrders: { __typename?: 'InboxActiveOrders', priority: Array<(
      { __typename?: 'LabOrderWithEvents', order_tracker_entries: Array<{ __typename?: 'OrderTrackerStepDefinition', active: boolean, alert: Maybe<boolean>, subtitle: Maybe<string>, subtitleAttachment: Maybe<string>, title: string }> }
      & LabsGqlSingleLabOrderFragment
    )>, orders: Array<(
      { __typename?: 'LabOrderWithEvents', order_tracker_entries: Array<{ __typename?: 'OrderTrackerStepDefinition', active: boolean, alert: Maybe<boolean>, subtitle: Maybe<string>, subtitleAttachment: Maybe<string>, title: string }> }
      & LabsGqlSingleLabOrderFragment
    )> } };

export type LabsGqlLabOrderForRefabLinkFragment = { __typename?: 'LabOrderWithEvents', id: string, created_at: string, status: Types.LabsGqlLabOrderStatus, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string } };

export type LabsGqlOrdersForRefabLinkQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrdersFilter>;
  criteria: Types.InputMaybe<Array<Types.LabsGqlFilterCriteriaSubmissionInput>>;
  search: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort: Types.InputMaybe<Types.LabsGqlListOrdersSort>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
  combinator: Types.InputMaybe<Types.LabsGqlFilterCombinator>;
}>;


export type LabsGqlOrdersForRefabLinkQuery = { __typename?: 'Query', ordersByListView: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderForRefabLinkFragment
  )> };

export type LabsGqlListViewEntryFragment = { __typename?: 'ListViewEntry', id: string, updated_at: string };

export type LabsGqlQualityControlItemsForOrderQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlQualityControlItemsForOrderQuery = { __typename?: 'Query', getQCItemsForOrder: Array<(
    { __typename?: 'QualityControlItemResult' }
    & LabsGqlQualityControlItemFragment
  )> };

export type LabsGqlQualityControlIssuesForOrderQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlQualityControlIssuesForOrderQuery = { __typename?: 'Query', getQCIssuesForOrder: Array<(
    { __typename?: 'QcIssue' }
    & LabsGqlQcIssueFragment
  )> };

export type LabsGqlCompleteQualityControlItemMutationVariables = Types.Exact<{
  data: Types.LabsGqlCompleteQualityControlItemCommand;
}>;


export type LabsGqlCompleteQualityControlItemMutation = { __typename?: 'Mutation', completeQualityControlItem: { __typename?: 'lab_order', id: string } };

export type LabsGqlChangeShippingMethodMutationVariables = Types.Exact<{
  data: Types.LabsGqlChangeShippingMethodCommand;
}>;


export type LabsGqlChangeShippingMethodMutation = { __typename?: 'Mutation', changeShippingMethod: { __typename?: 'lab_order', id: string } };

export type LabsGqlIgnoreQualityControlItemMutationVariables = Types.Exact<{
  data: Types.LabsGqlIgnoreQualityControlItemCommand;
}>;


export type LabsGqlIgnoreQualityControlItemMutation = { __typename?: 'Mutation', ignoreQualityControlItem: { __typename?: 'lab_order', id: string } };

export type LabsGqlAddManualQualityControlItemMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddManualQualityControlItemCommand;
}>;


export type LabsGqlAddManualQualityControlItemMutation = { __typename?: 'Mutation', addManualQualityControlItem: { __typename?: 'lab_order', id: string } };

export type LabsGqlOrdersByIdsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlOrdersByIdsQuery = { __typename?: 'Query', ordersByIds: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )> };

export type LabsGqlOrdersByScanIdQueryVariables = Types.Exact<{
  scan_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlOrdersByScanIdQuery = { __typename?: 'Query', ordersByScanId: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )> };

export type LabsGqlRefabOrdersByOrderIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlRefabOrdersByOrderIdQuery = { __typename?: 'Query', refabOrdersByOrderId: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )> };

export type LabsGqlOrderRefabRatesQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlOrderRefabRatesQuery = { __typename?: 'Query', labOrderRefabRates: (
    { __typename?: 'LabOrderRefabRates' }
    & LabsGqlLabOrderRefabRatesFragment
  ) };

export type LabsGqlGetSkusForPartnerQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetSkusForPartnerQuery = { __typename?: 'Query', getSkusForPartner: { __typename?: 'SkusForPartner', skus: Array<Types.LabsGqlOrderItemSkuType> } };

export type LabsGqlGetRefabRateBySkuForPartnerQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetRefabRateBySkuForPartnerQuery = { __typename?: 'Query', getRefabRateBySkuForPartner: { __typename?: 'RefabRateBySkuForPartner', skus: Array<(
      { __typename?: 'RefabRateBySku' }
      & LabsGqlRefabRateBySkuFragment
    )> } };

export type LabsGqlLabOrderRefabRatesFragment = { __typename?: 'LabOrderRefabRates', doctor: number, partner: number };

export type LabsGqlRefabRateBySkuFragment = { __typename?: 'RefabRateBySku', name: string, total: number, refab: number };

export type LabsGqlGetQcWarningsForOrderQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetQcWarningsForOrderQuery = { __typename?: 'Query', getQcWarningsForOrder: Array<{ __typename?: 'QCWarningResult', title: string, details: Array<string> }> };

export type LabsGqlGetNextPartnerOrderNumberQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetNextPartnerOrderNumberQuery = { __typename?: 'Query', getNextPartnerOrderNumber: number };

export type LabsGqlPracticeOrderIdsByStatusQueryVariables = Types.Exact<{
  filter: Types.LabsGqlPracticeListViewFilterInput;
}>;


export type LabsGqlPracticeOrderIdsByStatusQuery = { __typename?: 'Query', practiceOrderIdsByStatus: Array<{ __typename?: 'OnlyId', id: string }> };

export type LabsGqlGetLabAssignmentsByOrderIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetLabAssignmentsByOrderIdQuery = { __typename?: 'Query', getLabAssignmentsByOrderId: Array<{ __typename?: 'LabCaseAssignmentsByOrderIdResult', id: string, manufacturer_id: string, assigned_at: Maybe<string>, accepted_at: Maybe<string>, shipped_at: Maybe<string>, delivered_at: Maybe<string> }> };

export type LabsGqlGetCanceledLabOrdersQueryVariables = Types.Exact<{
  date_range: Types.InputMaybe<Types.LabsGqlLabCaseDateRangeInput>;
}>;


export type LabsGqlGetCanceledLabOrdersQuery = { __typename?: 'Query', getCanceledLabOrders: Array<{ __typename?: 'CanceledLabOrderResult', id: string, canceled_at: Maybe<string>, fulfillment_number: Maybe<number>, order_id: string, order_number: string, patient_id: string, patient_first_name: string, patient_last_name: string, percentage_completed: Maybe<number> }> };

export type LabsGqlGetOrderTrackingHoldTitleQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderTrackingHoldTitleQuery = { __typename?: 'Query', holdTitle: Maybe<string> };

export type LabsGqlGetOrderTrackingHoldMessageQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderTrackingHoldMessageQuery = { __typename?: 'Query', holdMessage: Maybe<string> };

export type LabsGqlLabOrderForTryInFeedbackFragment = { __typename?: 'LabOrderWithEvents', id: string, order_number: string, status: Types.LabsGqlLabOrderStatus, can_submit_tryin_feedback: Maybe<boolean>, refabrication_order_id: Maybe<string>, replaced_by_ids: Maybe<Array<string>>, patient: (
    { __typename?: 'PatientDTO' }
    & LabsGqlPatientFragment
  ), items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>, try_in_feedback: Maybe<{ __typename?: 'TryInFeedbackDTO', id: string }> };

export type LabsGqlGetLabOrderForTryInFeedbackQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetLabOrderForTryInFeedbackQuery = { __typename?: 'Query', lab_order: (
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderForTryInFeedbackFragment
  ) };

export type LabsGqlOrderInboxItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlOrderInboxItemsQuery = { __typename?: 'Query', orderInboxItems: Array<(
    { __typename?: 'OrderInboxItem' }
    & LabsGqlOrderInboxItemFragment
  )> };

export type LabsGqlOrderInboxItemFragment = { __typename?: 'OrderInboxItem', content: string, title: string, date: string, user_role: Maybe<string>, event_id: number, event_name: Types.LabsGqlEventNames, order: (
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  ) };

export type LabsGqlSlimOrderInboxItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlSlimOrderInboxItemsQuery = { __typename?: 'Query', slimOrderInboxItems: Array<(
    { __typename?: 'SlimOrderInboxItem' }
    & LabsGqlSlimOrderInboxItemFragment
  )> };

export type LabsGqlSlimOrderInboxItemFragment = { __typename?: 'SlimOrderInboxItem', content: string, title: string, date: string, order_id: string, user_role: Maybe<string>, event_id: number, event_name: Types.LabsGqlEventNames };

export type LabsGqlManufacturerUpdatesScreenCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlManufacturerUpdatesScreenCountQuery = { __typename?: 'Query', manufacturerUpdatesScreenCount: number };

export type LabsGqlLabtracIdForOrderQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlLabtracIdForOrderQuery = { __typename?: 'Query', labtracIdForOrder: Maybe<string> };

export type LabsGqlListManufacturerNotificationPrefsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListManufacturerNotificationPrefsQuery = { __typename?: 'Query', listManufacturerPreferences: Array<(
    { __typename?: 'ManufacturerNotificationPreferences' }
    & LabsGqlManufacturerNotificationPreferencesFragment
  )> };

export type LabsGqlGetManufacturerPreferencesPreferencesQueryVariables = Types.Exact<{
  manufacturer_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetManufacturerPreferencesPreferencesQuery = { __typename?: 'Query', getManufacturerPreferencesPreferences: Maybe<(
    { __typename?: 'ManufacturerNotificationPreferences' }
    & LabsGqlManufacturerNotificationPreferencesFragment
  )> };

export type LabsGqlManufacturerNotificationPreferencesFragment = { __typename?: 'ManufacturerNotificationPreferences', id: string, manufacturer_id: string, emails: Array<string>, phone_number: Maybe<string>, time_zone: Maybe<string>, new_order_notifications: Array<Types.LabsGqlManufacturerNotificationType> };

export type LabsGqlCreateLabsManufacturerMutationVariables = Types.Exact<{
  fields: Types.LabsGqlCreateManufacturerCommand;
}>;


export type LabsGqlCreateLabsManufacturerMutation = { __typename?: 'Mutation', createLabsManufacturer: { __typename?: 'ManufacturerCreatedRes', id: string } };

export type LabsGqlGetNonDoctorStaffByPartnerIdQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  include_deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlGetNonDoctorStaffByPartnerIdQuery = { __typename?: 'Query', getNonDoctorStaffByPartnerId: Array<(
    { __typename?: 'NonDoctorPracticeStaffDTO' }
    & LabsGqlNonDoctorPracticeStaffFragment
  )> };

export type LabsGqlGetNonDoctorStaffByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetNonDoctorStaffByIdQuery = { __typename?: 'Query', getNonDoctorStaffById: (
    { __typename?: 'NonDoctorPracticeStaffDTO' }
    & LabsGqlNonDoctorPracticeStaffFragment
  ) };

export type LabsGqlNotificationGroupFragment = { __typename?: 'NotificationGroupDTO', communication_email: Maybe<boolean>, communication_sms: Maybe<boolean>, marketing_email: Maybe<boolean>, marketing_sms: Maybe<boolean>, order_tracking_email: Maybe<boolean>, order_tracking_sms: Maybe<boolean>, review_required_email: Maybe<boolean>, review_required_sms: Maybe<boolean>, status_change_email: Maybe<boolean>, status_change_sms: Maybe<boolean> };

export type LabsGqlNotificationOrderItemFragment = { __typename?: 'LabOrderWithEvents', id: string, created_at: string, hold_reason: Maybe<string>, show_hold_status_to_practice: Maybe<boolean>, doctor_preferences_id: string, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, hold_details: Maybe<{ __typename?: 'LabOrderHoldDetails', hold_category: string, hold_subcategory: Maybe<string>, hold_freetext: Maybe<string> }>, fulfillment_workflow: { __typename?: 'OrderFulfillmentWorkflow', active_task: Maybe<(
      { __typename?: 'DesignReviewWorkflowTask' }
      & LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'DrReviewHoldWorkflowTask' }
      & LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment
    ) | (
      { __typename?: 'ExternalDesignWorkflowTask' }
      & LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment
    ) | (
      { __typename?: 'InternalDesignWorkflowTask' }
      & LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment
    ) | (
      { __typename?: 'ResolveHoldWorkflowTask' }
      & LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment
    ) | (
      { __typename?: 'ResolveScanRejectionWorkflowTask' }
      & LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
    ) | (
      { __typename?: 'ReviewOrderWorkflowTask' }
      & LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment
    ) | (
      { __typename?: 'ScanReviewWorkflowTask' }
      & LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'WaxupReviewWorkflowTask' }
      & LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'WorkflowTaskGeneric' }
      & LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment
    )> }, partials_fulfillment: Maybe<{ __typename?: 'PartialsFulfillmentDTO', current: (
      { __typename?: 'PartialsFulfillmentFinishDTO' }
      & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentFinishDto_Fragment
    ) | (
      { __typename?: 'PartialsFulfillmentTryInDTO' }
      & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentTryInDto_Fragment
    ) | (
      { __typename?: 'PartialsFulfillmentWaxRimDTO' }
      & LabsGqlPartialsSingleFulfillment_PartialsFulfillmentWaxRimDto_Fragment
    ) }>, active_scan_review_work_order: Maybe<{ __typename?: 'ScanReviewWorkOrderDTO', status: Types.LabsGqlScanReviewWorkOrderStatus }> };

export type LabsGqlNotificationItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlNotificationItemsQuery = { __typename?: 'Query', orderInboxItems: Array<{ __typename?: 'OrderInboxItem', event_id: number, event_name: Types.LabsGqlEventNames, title: string, content: string, date: string, order: { __typename?: 'LabOrderWithEvents', id: string, doctor_name: string, doctor_preferences_id: string, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string } } }>, overdueInvoices: Array<{ __typename?: 'InvoiceDTO', id: string, created_at: string, period_start: string, amount_remaining: number }>, waxupReviews: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlNotificationOrderItemFragment
  )>, scanFiles: Array<{ __typename?: 'scan_export', id: string, created_at: string, patient_first_name: string, patient_last_name: string, restorations: Array<{ __typename?: 'ScanExportElement', Color: Maybe<string> }> }>, actionableHoldOrders: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlNotificationOrderItemFragment
  )> };

export type LabsGqlCreateOrderEntryJobMutationVariables = Types.Exact<{
  lab_order_id: Types.Scalars['ID']['input'];
}>;


export type LabsGqlCreateOrderEntryJobMutation = { __typename?: 'Mutation', createOrderEntryJob: { __typename?: 'OrderEntryJobDTO', id: string } };

export type LabsGqlCreateOrderEntryJobBulkMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['ID']['input']>;
}>;


export type LabsGqlCreateOrderEntryJobBulkMutation = { __typename?: 'Mutation', createOrderEntryJobBulk: { __typename?: 'OrderEntryJobBulkMutationResult', success_ids: Array<string>, error_ids: Array<string> } };

export type LabsGqlQueueOrderEntryJobBulkMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['ID']['input']>;
}>;


export type LabsGqlQueueOrderEntryJobBulkMutation = { __typename?: 'Mutation', queueOrderEntryJobBulk: { __typename?: 'OrderEntryJobBulkMutationResult', success_ids: Array<string>, error_ids: Array<string> } };

export type LabsGqlSkipOrderEntryJobBulkMutationVariables = Types.Exact<{
  order_ids: Array<Types.Scalars['ID']['input']>;
}>;


export type LabsGqlSkipOrderEntryJobBulkMutation = { __typename?: 'Mutation', skipOrderEntryJobBulk: { __typename?: 'OrderEntryJobBulkMutationResult', success_ids: Array<string>, error_ids: Array<string> } };

export type LabsGqlLineItemPreviewFragment = { __typename?: 'LabOrderItem', id: string, sku: Types.LabsGqlOrderItemSkuType, link_type: Maybe<Types.LabsGqlOrderItemLinkType>, material: Maybe<string>, teeth: Array<{ __typename?: 'LabOrderItemTooth', unit_type: string, unn: string }> };

export type LabsGqlWorkflowTaskPreview_DesignReviewWorkflowTask_Fragment = { __typename: 'DesignReviewWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_DrReviewHoldWorkflowTask_Fragment = { __typename: 'DrReviewHoldWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_ExternalDesignWorkflowTask_Fragment = { __typename: 'ExternalDesignWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_InternalDesignWorkflowTask_Fragment = { __typename: 'InternalDesignWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_ResolveHoldWorkflowTask_Fragment = { __typename: 'ResolveHoldWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_ResolveScanRejectionWorkflowTask_Fragment = { __typename: 'ResolveScanRejectionWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_ReviewOrderWorkflowTask_Fragment = { __typename: 'ReviewOrderWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_ScanReviewWorkflowTask_Fragment = { __typename: 'ScanReviewWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_WaxupReviewWorkflowTask_Fragment = { __typename: 'WaxupReviewWorkflowTask', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreview_WorkflowTaskGeneric_Fragment = { __typename: 'WorkflowTaskGeneric', type: Types.LabsGqlWorkflowTaskType, created_at: string };

export type LabsGqlWorkflowTaskPreviewFragment = LabsGqlWorkflowTaskPreview_DesignReviewWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_DrReviewHoldWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_ExternalDesignWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_InternalDesignWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_ResolveHoldWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_ResolveScanRejectionWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_ReviewOrderWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_ScanReviewWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_WaxupReviewWorkflowTask_Fragment | LabsGqlWorkflowTaskPreview_WorkflowTaskGeneric_Fragment;

export type LabsGqlFulfillmentWorkflowPreviewFragment = { __typename?: 'OrderFulfillmentWorkflow', active_task: Maybe<(
    { __typename?: 'DesignReviewWorkflowTask' }
    & LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'DrReviewHoldWorkflowTask' }
    & LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ExternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'InternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveHoldWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveScanRejectionWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
  ) | (
    { __typename?: 'ReviewOrderWorkflowTask' }
    & LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment
  ) | (
    { __typename?: 'ScanReviewWorkflowTask' }
    & LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WaxupReviewWorkflowTask' }
    & LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WorkflowTaskGeneric' }
    & LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment
  )>, configuration: (
    { __typename?: 'OrderFulfillmentWorkflowConfigDTO' }
    & LabsGqlOrderFulfillmentWorkflowConfigFragment
  ), closed_tasks: Array<(
    { __typename?: 'DesignReviewWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_DesignReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'DrReviewHoldWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_DrReviewHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ExternalDesignWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_ExternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'InternalDesignWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_InternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveHoldWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_ResolveHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveScanRejectionWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_ResolveScanRejectionWorkflowTask_Fragment
  ) | (
    { __typename?: 'ReviewOrderWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_ReviewOrderWorkflowTask_Fragment
  ) | (
    { __typename?: 'ScanReviewWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_ScanReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WaxupReviewWorkflowTask' }
    & LabsGqlWorkflowTaskPreview_WaxupReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WorkflowTaskGeneric' }
    & LabsGqlWorkflowTaskPreview_WorkflowTaskGeneric_Fragment
  )> };

export type LabsGqlSingleFulfillmentPreviewFragment = { __typename?: 'LabOrderSingleFulfillmentDTO', created_at: string, status: Types.LabsGqlLabOrderFulfillmentStatus, start_date: Maybe<string>, sent_to_floor_at: Maybe<string>, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), shipment: Maybe<{ __typename?: 'LabOrderShipmentDTO', ship_date: Maybe<string>, delivery_date: Maybe<string>, tracking_status: Maybe<string>, tracking_substatus: Maybe<Types.LabsGqlShipmentSubStatus>, package_accepted_date: Maybe<string>, tracking_status_updated_at: Maybe<string>, eta: Maybe<string> }> };

export type LabsGqlOrderFulfillmentPreviewFragment = { __typename?: 'LabOrderFulfillmentDTO', current: (
    { __typename?: 'LabOrderSingleFulfillmentDTO' }
    & LabsGqlSingleFulfillmentPreviewFragment
  ) };

export type LabsGqlPracticeDatesFragment = { __typename?: 'OrderPracticeDates', estimated_delivery_date: string, promised_delivery_date: string, is_delivery_delayed: boolean, digital_design_preview_estimated_completion_date: Maybe<string>, promised_digital_design_preview_completion_date: Maybe<string>, is_digital_design_preview_delayed: boolean };

export type LabsGqlOrderPreviewFragment = { __typename?: 'LabOrderWithEvents', id: string, original_order_id: Maybe<string>, created_from_return_id: Maybe<string>, replaced_by_ids: Maybe<Array<string>>, created_at: string, updated_at: string, cancel_date: Maybe<string>, doctor_preferences_id: string, doctor_name: string, order_number: string, status: Types.LabsGqlLabOrderStatus, can_edit: Maybe<boolean>, can_refabricate: Maybe<boolean>, can_submit_feedback: Maybe<boolean>, can_submit_tryin_feedback: Maybe<boolean>, ship_date: Maybe<string>, ship_status: Maybe<string>, shipped_to_dandy: boolean, fabrication_start_date: Maybe<string>, delivery_date: Maybe<string>, hold_reason: Maybe<string>, hold_in_review: boolean, waxup_status: Maybe<Types.LabsGqlLabOrderWaxupReviewStatus>, replaced_by_orders: Maybe<Array<{ __typename?: 'LabOrderWithEvents', id: string, order_number: string }>>, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, aligner_case: Maybe<{ __typename?: 'AlignerCaseDTO', created_at: string }>, practice_dates: (
    { __typename?: 'OrderPracticeDates' }
    & LabsGqlPracticeDatesFragment
  ), hold_details: Maybe<{ __typename?: 'LabOrderHoldDetails', hold_category: string, hold_subcategory: Maybe<string>, hold_freetext: Maybe<string> }>, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), workflow_state: (
    { __typename?: 'WorkflowState' }
    & LabsGqlWorkflowStateFragment
  ), fulfillment: (
    { __typename?: 'LabOrderFulfillmentDTO' }
    & LabsGqlOrderFulfillmentPreviewFragment
  ), fulfillment_workflow: (
    { __typename?: 'OrderFulfillmentWorkflow' }
    & LabsGqlFulfillmentWorkflowPreviewFragment
  ), items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>, review_submission: Maybe<{ __typename?: 'IReviewSubmission', doctor_is_happy: Maybe<boolean>, rating: Types.LabsGqlReviewRating, items: Array<{ __typename?: 'ReviewSubmissionSectionItem', star_rating: Maybe<number> }> }>, dentures_fulfillment: Maybe<(
    { __typename?: 'DenturesFulfillmentDTO' }
    & LabsGqlDenturesFulfillmentPreviewFragment
  )>, partials_fulfillment: Maybe<(
    { __typename?: 'PartialsFulfillmentDTO' }
    & LabsGqlPartialsFulfillmentFragment
  )>, order_tracker_entries: Array<{ __typename?: 'OrderTrackerStepDefinition', active: boolean, alert: Maybe<boolean>, subtitle: Maybe<string>, subtitleAttachment: Maybe<string>, title: string }> };

export type LabsGqlOrderPracticePreviewsByIdsQueryVariables = Types.Exact<{
  ids: Array<Types.Scalars['String']['input']>;
  timezone_offset_minutes: Types.Scalars['Int']['input'];
}>;


export type LabsGqlOrderPracticePreviewsByIdsQuery = { __typename?: 'Query', orders: Array<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlOrderPreviewFragment
  )> };

export type LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentCoreDto_Fragment = { __typename?: 'DenturesFulfillmentCoreDTO', type: Types.LabsGqlDenturesSingleFulfillmentType };

export type LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentFixupDto_Fragment = { __typename?: 'DenturesFulfillmentFixupDTO', type: Types.LabsGqlDenturesSingleFulfillmentType };

export type LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentTryInFollowupDto_Fragment = { __typename?: 'DenturesFulfillmentTryInFollowupDTO', type: Types.LabsGqlDenturesSingleFulfillmentType };

export type LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentWaxRimDto_Fragment = { __typename?: 'DenturesFulfillmentWaxRimDTO', type: Types.LabsGqlDenturesSingleFulfillmentType };

export type LabsGqlDenturesSingleFulfillmentPreviewFragment = LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentCoreDto_Fragment | LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentFixupDto_Fragment | LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentTryInFollowupDto_Fragment | LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentWaxRimDto_Fragment;

export type LabsGqlDenturesFulfillmentPreviewFragment = { __typename?: 'DenturesFulfillmentDTO', current: (
    { __typename?: 'DenturesFulfillmentCoreDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentCoreDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentFixupDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentFixupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentTryInFollowupDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentTryInFollowupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentWaxRimDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentWaxRimDto_Fragment
  ), history: Array<(
    { __typename?: 'DenturesFulfillmentCoreDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentCoreDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentFixupDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentFixupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentTryInFollowupDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentTryInFollowupDto_Fragment
  ) | (
    { __typename?: 'DenturesFulfillmentWaxRimDTO' }
    & LabsGqlDenturesSingleFulfillmentPreview_DenturesFulfillmentWaxRimDto_Fragment
  )> };

export type LabsGqlOrderTrackerPreviewFragment = { __typename?: 'LabOrderWithEvents', created_at: string, status: Types.LabsGqlLabOrderStatus, delivery_date: Maybe<string>, ship_date: Maybe<string>, ship_status: Maybe<string>, original_order_id: Maybe<string>, practice_dates: (
    { __typename?: 'OrderPracticeDates' }
    & LabsGqlPracticeDatesFragment
  ), manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), fulfillment: { __typename?: 'LabOrderFulfillmentDTO', current: { __typename?: 'LabOrderSingleFulfillmentDTO', shipment: Maybe<{ __typename?: 'LabOrderShipmentDTO', tracking_status: Maybe<string>, tracking_substatus: Maybe<Types.LabsGqlShipmentSubStatus>, package_accepted_date: Maybe<string> }> } }, fulfillment_workflow: { __typename?: 'OrderFulfillmentWorkflow', active_task: Maybe<(
      { __typename?: 'DesignReviewWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_DesignReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'DrReviewHoldWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_DrReviewHoldWorkflowTask_Fragment
    ) | (
      { __typename?: 'ExternalDesignWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ExternalDesignWorkflowTask_Fragment
    ) | (
      { __typename?: 'InternalDesignWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_InternalDesignWorkflowTask_Fragment
    ) | (
      { __typename?: 'ResolveHoldWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ResolveHoldWorkflowTask_Fragment
    ) | (
      { __typename?: 'ResolveScanRejectionWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ResolveScanRejectionWorkflowTask_Fragment
    ) | (
      { __typename?: 'ReviewOrderWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ReviewOrderWorkflowTask_Fragment
    ) | (
      { __typename?: 'ScanReviewWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ScanReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'WaxupReviewWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_WaxupReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'WorkflowTaskGeneric' }
      & LabsGqlWorkflowTaskPreview_WorkflowTaskGeneric_Fragment
    )>, closed_tasks: Array<(
      { __typename?: 'DesignReviewWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_DesignReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'DrReviewHoldWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_DrReviewHoldWorkflowTask_Fragment
    ) | (
      { __typename?: 'ExternalDesignWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ExternalDesignWorkflowTask_Fragment
    ) | (
      { __typename?: 'InternalDesignWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_InternalDesignWorkflowTask_Fragment
    ) | (
      { __typename?: 'ResolveHoldWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ResolveHoldWorkflowTask_Fragment
    ) | (
      { __typename?: 'ResolveScanRejectionWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ResolveScanRejectionWorkflowTask_Fragment
    ) | (
      { __typename?: 'ReviewOrderWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ReviewOrderWorkflowTask_Fragment
    ) | (
      { __typename?: 'ScanReviewWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_ScanReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'WaxupReviewWorkflowTask' }
      & LabsGqlWorkflowTaskPreview_WaxupReviewWorkflowTask_Fragment
    ) | (
      { __typename?: 'WorkflowTaskGeneric' }
      & LabsGqlWorkflowTaskPreview_WorkflowTaskGeneric_Fragment
    )> }, aligner_case: Maybe<{ __typename?: 'AlignerCaseDTO', created_at: string }>, workflow_state: { __typename?: 'WorkflowState', state: Types.LabsGqlWorkflowStateEnum } };

export type LabsGqlOrderFlagsPreviewFragment = { __typename?: 'LabOrderWithEvents', status: Types.LabsGqlLabOrderStatus, split_order_count: Maybe<number>, original_order_id: Maybe<string>, partner_order_number: Maybe<number>, fabrication_start_date: Maybe<string>, dentist_amount_due_cents: Maybe<number>, review_flag_reasons: Maybe<Array<string>>, integration_order: Maybe<{ __typename?: 'IntegrationOrder', pan: Maybe<string> }>, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), dentures_fulfillment: Maybe<(
    { __typename?: 'DenturesFulfillmentDTO' }
    & LabsGqlDenturesFulfillmentPreviewFragment
  )>, manufacturer_history: { __typename?: 'ManufacturerOrderHistory', lab_slip_printed_at: Maybe<string> } };

export type LabsGqlOrderLabDownloadPreviewFragment = { __typename?: 'LabOrderWithEvents', id: string, partner_order_number: Maybe<number>, design_file_path: Maybe<string>, patient: { __typename?: 'PatientDTO', first_name: string, last_name: string }, scan_export: { __typename?: 'scan_export', sanitized_url: Maybe<string> } };

export type LabsGqlOrderIntegrationPreviewFragment = { __typename?: 'LabOrderWithEvents', id: string, integration_order: Maybe<{ __typename?: 'IntegrationOrder', id: string, pan: Maybe<string>, lab_charge_price_cents: Maybe<number>, manufacturer_case_number: Maybe<number>, manufacturer_order_id: Maybe<string> }>, integration_order_entry_job: Maybe<{ __typename?: 'OrderEntryJobDTO', id: string, updated_at: string, status: Types.LabsGqlOrderEntryJobStatus, last_queued_at: Maybe<string>, failures: Array<(
      { __typename?: 'OrderEntryJobFailure' }
      & LabsGqlOrderEntryJobFailureFragment
    )> }> };

export type LabsGqlOrderLabDelayPreviewFragment = { __typename?: 'LabOrderWithEvents', id: string, status: Types.LabsGqlLabOrderStatus, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), practice_dates: (
    { __typename?: 'OrderPracticeDates' }
    & LabsGqlPracticeDatesFragment
  ) };

export type LabsGqlOrderLabSlipPreviewFragment = (
  { __typename?: 'LabOrderWithEvents', id: string, created_at: string, updated_at: string, product_line: Maybe<Types.LabsGqlProductLine>, mailing_address_id: string, doctor_name: string, order_number: string, partner_order_number: Maybe<number>, original_order_id: Maybe<string>, partner_id: string, lab_customer_id: string, manufacturer_id: string, needs_refabrication_date: Maybe<string>, notes_for_refabrication: Maybe<string>, doctor_notes: Maybe<string>, patient: (
    { __typename?: 'PatientDTO' }
    & LabsGqlPatientFragment
  ), lab_slip_alerts: Array<(
    { __typename?: 'LabSlipAlert' }
    & LabsGqlLabSlipAlertFragment
  )>, manufacturer_sla: (
    { __typename?: 'OrderSLA' }
    & LabsGqlOrderSlaFragment
  ), items_v2: Array<(
    { __typename?: 'AlignerItem' }
    & LabsGqlLabOrderItemV2Dto_AlignerItem_Fragment
  ) | (
    { __typename?: 'BridgeItem' }
    & LabsGqlLabOrderItemV2Dto_BridgeItem_Fragment
  ) | (
    { __typename?: 'CrownItem' }
    & LabsGqlLabOrderItemV2Dto_CrownItem_Fragment
  ) | (
    { __typename?: 'DentureItem' }
    & LabsGqlLabOrderItemV2Dto_DentureItem_Fragment
  ) | (
    { __typename?: 'ImplantBridgeItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'ImplantItem' }
    & LabsGqlLabOrderItemV2Dto_ImplantItem_Fragment
  ) | (
    { __typename?: 'InlayItem' }
    & LabsGqlLabOrderItemV2Dto_InlayItem_Fragment
  ) | (
    { __typename?: 'ModelItem' }
    & LabsGqlLabOrderItemV2Dto_ModelItem_Fragment
  ) | (
    { __typename?: 'OtherItem' }
    & LabsGqlLabOrderItemV2Dto_OtherItem_Fragment
  ) | (
    { __typename?: 'PartialDentureItem' }
    & LabsGqlLabOrderItemV2Dto_PartialDentureItem_Fragment
  ) | (
    { __typename?: 'RemovableItem' }
    & LabsGqlLabOrderItemV2Dto_RemovableItem_Fragment
  ) | (
    { __typename?: 'SleepApneaItem' }
    & LabsGqlLabOrderItemV2Dto_SleepApneaItem_Fragment
  ) | (
    { __typename?: 'SurgicalGuideItem' }
    & LabsGqlLabOrderItemV2Dto_SurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'TMJItem' }
    & LabsGqlLabOrderItemV2Dto_TmjItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & LabsGqlLabOrderItemV2Dto_UnknownItem_Fragment
  ) | (
    { __typename?: 'VeneerItem' }
    & LabsGqlLabOrderItemV2Dto_VeneerItem_Fragment
  ) | (
    { __typename?: 'WaxupItem' }
    & LabsGqlLabOrderItemV2Dto_WaxupItem_Fragment
  )>, dentures_fulfillment: Maybe<(
    { __typename?: 'DenturesFulfillmentDTO' }
    & LabsGqlDenturesFulfillmentFragment
  )>, partials_fulfillment: Maybe<(
    { __typename?: 'PartialsFulfillmentDTO' }
    & LabsGqlPartialsFulfillmentFragment
  )> }
  & LabsGqlOrderIntegrationPreviewFragment
);

export type LabsGqlGetOrderPricesByOrderIdQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderPricesByOrderIdQuery = { __typename?: 'Query', prices: Array<(
    { __typename?: 'OrderPriceDTO' }
    & LabsGqlOrderPriceDtoFragment
  )> };

export type LabsGqlOrderPriceDtoFragment = { __typename?: 'OrderPriceDTO', id: string, order_id: string, item_id: string, price_id: string, unit_count: number, price_name: string, price_cents: number, total_price_cents: number, override_total_price_cents: Maybe<number>, override_total_price_cents_reason: Maybe<string>, units: Array<(
    { __typename?: 'OrderPriceUnitInfoDTO' }
    & LabsGqlOrderPriceUnitInfoDtoFragment
  )> };

export type LabsGqlOrderPriceUnitInfoDtoFragment = { __typename?: 'OrderPriceUnitInfoDTO', unit_type: string, material: Maybe<string>, unn: Maybe<number>, unns: Maybe<Array<number>>, arch: Maybe<Types.LabsGqlOrderItemArch>, precious_metal_pennyweight: Maybe<number> };

export type LabsGqlOrderProcedureFragment = { __typename?: 'OrderProcedureResult', description: string, bookedOn: string, bookedOff: string, technicianID: string, status: string, redo: boolean };

export type LabsGqlGetOrderProceduresV2QueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  manufacturer_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetOrderProceduresV2Query = { __typename?: 'Query', getOrderProceduresV2: { __typename?: 'OrderProcedureResponse', labtracId: string, procedures: Array<(
      { __typename?: 'OrderProcedureResult' }
      & LabsGqlOrderProcedureFragment
    )> } };

export type LabsGqlListOrderReturnsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListOrderReturnsQuery = { __typename?: 'Query', listOrderReturns: Array<(
    { __typename?: 'IOrderReturn' }
    & LabsGqlOrderReturnFragment
  )> };

export type LabsGqlPendingReturnForOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type LabsGqlPendingReturnForOrderQuery = { __typename?: 'Query', pendingReturnForOrder: Maybe<(
    { __typename?: 'IOrderReturn' }
    & LabsGqlOrderReturnFragment
  )> };

export type LabsGqlOrderReturnFragment = { __typename?: 'IOrderReturn', id: string, updated_at: string, created_at: string, cancellation_date: Maybe<string>, item_ids: Array<string>, partner_id: string, manufacturer_id: string, label_url: string, status: Types.LabsGqlOrderReturnStatus, type: Types.LabsGqlOrderReturnType, created_by: (
    { __typename?: 'OrderReturnUserAction' }
    & LabsGqlOrderReturnUserActionFragment
  ), cancelled_by: Maybe<(
    { __typename?: 'OrderReturnUserAction' }
    & LabsGqlOrderReturnUserActionFragment
  )>, order: (
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlSingleLabOrderFragment
  ), shipment: (
    { __typename?: 'IShipment' }
    & LabsGqlOrderReturnShipmentFragment
  ) };

export type LabsGqlOrderReturnShipmentFragment = { __typename?: 'IShipment', id: string, status: Types.LabsGqlShipmentStatus, status_description: string, carrier: Types.LabsGqlShippingCarriersEnum, tracking_number: string };

export type LabsGqlOrderReturnUserActionFragment = { __typename?: 'OrderReturnUserAction', user_id: string, notes: string, user_first_name: string, user_last_name: string, user_role: string };

export type LabsGqlEmailReturnLabelMutationVariables = Types.Exact<{
  order_id: Types.Scalars['ID']['input'];
  email: Types.Scalars['String']['input'];
}>;


export type LabsGqlEmailReturnLabelMutation = { __typename?: 'Mutation', emailReturnLabel: boolean };

export type LabsGqlTicketActionDtoFragment = { __typename?: 'TicketActionDTO', id: string, created_at: string, created_by_user_id: string, updated_at: string, type_id: string, assigned_user_id: Maybe<string>, status: Types.LabsGqlActionStatus, closed_at: Maybe<string>, closed_by_user_id: Maybe<string>, followup_id: Maybe<string>, followup_parent_id: Maybe<string>, activate_at: Maybe<string>, due_at: Maybe<string>, opening_notes: Maybe<string>, closing_notes: Maybe<string> };

export type LabsGqlTicketDtoFragment = { __typename?: 'TicketDTO', id: string, created_at: string, updated_at: string, order_id: string, is_open: boolean, created_by_automation_event_id: Maybe<number>, actions: Array<(
    { __typename?: 'TicketActionDTO' }
    & LabsGqlTicketActionDtoFragment
  )>, active_action: Maybe<(
    { __typename?: 'TicketActionDTO' }
    & LabsGqlTicketActionDtoFragment
  )> };

export type LabsGqlGetOrderTicketsQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderTicketsQuery = { __typename?: 'Query', getOrderTickets: Array<(
    { __typename?: 'TicketDTO' }
    & LabsGqlTicketDtoFragment
  )> };

export type LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateDurationConfig_Fragment = { __typename?: 'ActionTimeConstraintCustomDateDurationConfig', type: Types.LabsGqlTimeConstraintCustomConfigType, value: number };

export type LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateNextEncounterConfig_Fragment = { __typename?: 'ActionTimeConstraintCustomDateNextEncounterConfig', type: Types.LabsGqlTimeConstraintCustomConfigType, value: number, minimum_duration: number };

export type LabsGqlActionTimeConstraintCustomDateConfigFragment = LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateDurationConfig_Fragment | LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateNextEncounterConfig_Fragment;

export type LabsGqlActionTimeConstraintConfig_ActionTimeConstraintBasicConfig_Fragment = { __typename?: 'ActionTimeConstraintBasicConfig', type: Types.LabsGqlActionTimeConstraintConfigType };

export type LabsGqlActionTimeConstraintConfig_ActionTimeConstraintCustomConfig_Fragment = { __typename?: 'ActionTimeConstraintCustomConfig', type: Types.LabsGqlActionTimeConstraintConfigType, activate_at: Maybe<(
    { __typename?: 'ActionTimeConstraintCustomDateDurationConfig' }
    & LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateDurationConfig_Fragment
  ) | (
    { __typename?: 'ActionTimeConstraintCustomDateNextEncounterConfig' }
    & LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateNextEncounterConfig_Fragment
  )>, due_at: Maybe<(
    { __typename?: 'ActionTimeConstraintCustomDateDurationConfig' }
    & LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateDurationConfig_Fragment
  ) | (
    { __typename?: 'ActionTimeConstraintCustomDateNextEncounterConfig' }
    & LabsGqlActionTimeConstraintCustomDateConfig_ActionTimeConstraintCustomDateNextEncounterConfig_Fragment
  )> };

export type LabsGqlActionTimeConstraintConfigFragment = LabsGqlActionTimeConstraintConfig_ActionTimeConstraintBasicConfig_Fragment | LabsGqlActionTimeConstraintConfig_ActionTimeConstraintCustomConfig_Fragment;

export type LabsGqlActionTypeDtoFragment = { __typename?: 'ActionTypeDTO', id: string, created_at: string, updated_at: string, category_id: string, name: string, description: Maybe<string>, capability_ids: Array<string>, is_archived: boolean, time_constraint_config: Maybe<(
    { __typename?: 'ActionTimeConstraintBasicConfig' }
    & LabsGqlActionTimeConstraintConfig_ActionTimeConstraintBasicConfig_Fragment
  ) | (
    { __typename?: 'ActionTimeConstraintCustomConfig' }
    & LabsGqlActionTimeConstraintConfig_ActionTimeConstraintCustomConfig_Fragment
  )> };

export type LabsGqlGetActionTypesQueryVariables = Types.Exact<{
  category_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetActionTypesQuery = { __typename?: 'Query', getActionTypes: Array<(
    { __typename?: 'ActionTypeDTO' }
    & LabsGqlActionTypeDtoFragment
  )> };

export type LabsGqlActionTypesWithCategoryInfoQueryVariables = Types.Exact<{
  filters: Types.LabsGqlActionTypeFilters;
}>;


export type LabsGqlActionTypesWithCategoryInfoQuery = { __typename?: 'Query', actionTypesWithCategoryInfo: Array<{ __typename?: 'ActionTypeWithCategory', id: string, created_at: string, updated_at: string, category_id: string, subcategory_id: string, category_name: string, subcategory_name: string, name: string, description: Maybe<string>, capability_ids: Array<string>, is_archived: boolean, time_constraint_config: Maybe<(
      { __typename?: 'ActionTimeConstraintBasicConfig' }
      & LabsGqlActionTimeConstraintConfig_ActionTimeConstraintBasicConfig_Fragment
    ) | (
      { __typename?: 'ActionTimeConstraintCustomConfig' }
      & LabsGqlActionTimeConstraintConfig_ActionTimeConstraintCustomConfig_Fragment
    )> }> };

export type LabsGqlActionTypeActionTimesFragment = { __typename?: 'ActionTypeActionTimes', activate_at: Maybe<string>, due_at: Maybe<string> };

export type LabsGqlResolveDefaultActionTimesQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  type_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlResolveDefaultActionTimesQuery = { __typename?: 'Query', resolveDefaultActionTimes: (
    { __typename?: 'ActionTypeActionTimes' }
    & LabsGqlActionTypeActionTimesFragment
  ) };

export type LabsGqlActionCategoryDtoFragment = { __typename?: 'ActionCategoryDTO', id: string, created_at: string, updated_at: string, parent_id: Maybe<string>, name: string, is_archived: boolean };

export type LabsGqlGetActionCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetActionCategoriesQuery = { __typename?: 'Query', getActionCategories: Array<(
    { __typename?: 'ActionCategoryDTO' }
    & LabsGqlActionCategoryDtoFragment
  )> };

export type LabsGqlActionCapabilityDtoFragment = { __typename?: 'ActionCapabilityDTO', id: string, created_at: string, updated_at: string, name: string, is_archived: boolean };

export type LabsGqlGetActionCapabilitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetActionCapabilitiesQuery = { __typename?: 'Query', getActionCapabilities: Array<(
    { __typename?: 'ActionCapabilityDTO' }
    & LabsGqlActionCapabilityDtoFragment
  )> };

export type LabsGqlTicketDataFragment = { __typename?: 'TicketWithPracticeAndOrderInfo', id: string, is_open: boolean, order_id: string, partner_id: string, updated_at: string, created_at: string, order_status: Maybe<Types.LabsGqlLabOrderStatus>, doctor_name: string, items_summary: Maybe<string>, manufacturer_id: Maybe<string>, patient_name: Maybe<string>, active_action: Maybe<(
    { __typename?: 'TicketActionDTO' }
    & LabsGqlTicketActionDtoFragment
  )>, actions: Array<(
    { __typename?: 'TicketActionDTO' }
    & LabsGqlTicketActionDtoFragment
  )> };

export type LabsGqlFilteredTicketsQueryVariables = Types.Exact<{
  input: Types.LabsGqlTicketFilterInput;
}>;


export type LabsGqlFilteredTicketsQuery = { __typename?: 'Query', filteredTickets: Array<(
    { __typename?: 'TicketWithPracticeAndOrderInfo' }
    & LabsGqlTicketDataFragment
  )> };

export type LabsGqlTicketListFilterDropdownDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlTicketListFilterDropdownDataQuery = { __typename?: 'Query', listUsers: Array<{ __typename?: 'UserDTO', id: string, email: string, first_name: string, last_name: string }>, actionTypesWithCategoryInfo: Array<{ __typename?: 'ActionTypeWithCategory', id: string, name: string, description: Maybe<string>, category_id: string, category_name: string, subcategory_id: string, subcategory_name: string }>, listOrganizations: Array<{ __typename?: 'OrganizationDTO', id: string, type: Types.LabsGqlOrganizationType, name: string }>, tags: Array<{ __typename?: 'Tag', id: string, name: string, description: Maybe<string>, color: Maybe<string>, entity_type: Types.LabsGqlTaggableEntityType }> };

export type LabsGqlGetPracticeDetailsQueryVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetPracticeDetailsQuery = { __typename?: 'Query', getPracticeDetails: (
    { __typename?: 'PracticeDetails' }
    & LabsGqlPracticeDetailsFragment
  ) };

export type LabsGqlGetPracticeInteractionsQueryVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
  customer_names: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlGetPracticeInteractionsQuery = { __typename?: 'Query', getPracticeInteractions: (
    { __typename?: 'PracticeInteractions' }
    & LabsGqlPracticeInteractionsFragment
  ) };

export type LabsGqlPracticeDetailsFragment = { __typename?: 'PracticeDetails', practice_name: string, practice_url: string, timezone: Maybe<string>, city: Maybe<string>, state: Maybe<string>, chairside_stage: Maybe<string>, salesforce_account_id: Maybe<string>, team_viewer_id: Maybe<string>, practice_email: Maybe<string>, AM: Maybe<string>, CSL: Maybe<string>, last_order_date: Maybe<string>, avg_monthly_spend: Maybe<number>, created_date: Maybe<string>, address: Maybe<string>, device_id_list: Maybe<string>, phone_number: Maybe<string> };

export type LabsGqlPracticeInteractionsFragment = { __typename?: 'PracticeInteractions', practice_name: string, practice_url: string, timezone: Maybe<string>, city: Maybe<string>, state: Maybe<string>, salesforce_account_id: Maybe<string>, team_viewer_id: Maybe<string>, sf_escalations: Array<(
    { __typename?: 'SalesforceCase' }
    & LabsGqlSalesforceCaseFragment
  )> };

export type LabsGqlSalesforceCaseFragment = { __typename?: 'SalesforceCase', Id: string, CaseNumber: string, CreatedDate: Maybe<string>, Subject: Maybe<string>, Type: Maybe<string>, Case_Type_Description__c: Maybe<string>, Resolution_Type__c: Maybe<string>, Resolution_Notes__c: Maybe<string>, Owner: Maybe<(
    { __typename?: 'SalesforceCaseOwner' }
    & LabsGqlSalesforceCaseOwnerFragment
  )> };

export type LabsGqlSalesforceCaseOwnerFragment = { __typename?: 'SalesforceCaseOwner', Name: Maybe<string> };

export type LabsGqlListPartnerBillingQueryVariables = Types.Exact<{
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset: Types.InputMaybe<Types.Scalars['Int']['input']>;
  partner_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlListPartnerBillingQuery = { __typename?: 'Query', listPartnerBillingAccounts: Array<(
    { __typename?: 'IPartnerBillingWithName' }
    & LabsGqlPartnerBillingWithNameFragment
  )> };

export type LabsGqlListOrganizationStaffBillingContactsQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlListOrganizationStaffBillingContactsQuery = { __typename?: 'Query', listOrganizationStaffBillingContacts: Array<{ __typename?: 'StaffBillingContact', id: string, deactivated_at: Maybe<string>, user_id: string, user: (
      { __typename?: 'UserDTO' }
      & LabsGqlUserDtoFragment
    ) }> };

export type LabsGqlListPracticeBillingContactUsersQueryVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlListPracticeBillingContactUsersQuery = { __typename?: 'Query', listPracticeBillingContactUsers: Array<{ __typename?: 'BillingContactUser', id: string, first_name: string, last_name: string, email: string, type: Types.LabsGqlBillingContactUserType, active: boolean }> };

export type LabsGqlMonthlyMinimumCommitmentFragment = { __typename?: 'MonthlyMinimumCommitment', effective_from_active_month_number: number, minimum_commitment_cents: number };

export type LabsGqlPartnerBillingFragment = { __typename?: 'IPartnerBilling', id: string, activation_date: Maybe<string>, activation_source: Maybe<Types.LabsGqlPartnerActivationSource>, stripe_customer_id: string, contact_emails: Array<string>, account_management_contact_emails: Array<string>, autocharge_enabled: boolean, primary_billing_contact_user_id: string, agreed_to_cc_fees: boolean, is_on_payment_plan: boolean, will_be_charged_cc_fee: boolean, usage_payment_source_config: Maybe<(
    { __typename?: 'PaymentSplitConfigDoctor' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigDoctor_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigLocation' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigLocation_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigPercent' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigPercent_Fragment
  )> };

export type LabsGqlPartnerBillingWithNameFragment = { __typename?: 'IPartnerBillingWithName', id: string, name: Maybe<string>, activation_date: Maybe<string>, activation_source: Maybe<Types.LabsGqlPartnerActivationSource>, stripe_customer_id: string, contact_emails: Array<string>, account_management_contact_emails: Array<string>, autocharge_enabled: boolean, primary_billing_contact_user_id: string, agreed_to_cc_fees: boolean, is_on_payment_plan: boolean, will_be_charged_cc_fee: boolean, usage_payment_source_config: Maybe<(
    { __typename?: 'PaymentSplitConfigDoctor' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigDoctor_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigLocation' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigLocation_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigPercent' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigPercent_Fragment
  )> };

export type LabsGqlPartnerBillingChangelogEntry_AgreeToCreditCardFeesChangelogEntry_Fragment = (
  { __typename: 'AgreeToCreditCardFeesChangelogEntry' }
  & LabsGqlAgreeToCreditCardFeesChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_AgreeToCreditCardFeesChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_BillingUsageSplitChangelogEntry_Fragment = (
  { __typename: 'BillingUsageSplitChangelogEntry' }
  & LabsGqlBillingUsageSplitChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_BillingUsageSplitChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_MonthlyMinimumScheduleChangelogEntry_Fragment = (
  { __typename: 'MonthlyMinimumScheduleChangelogEntry' }
  & LabsGqlMonthlyMinimumScheduleChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_MonthlyMinimumScheduleChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingAutochargeChangelogEntry_Fragment = (
  { __typename: 'PartnerBillingAutochargeChangelogEntry' }
  & LabsGqlPartnerBillingAutochargeChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingAutochargeChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingContactsChangelogEntry_Fragment = (
  { __typename: 'PartnerBillingContactsChangelogEntry' }
  & LabsGqlPartnerBillingContactsChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingContactsChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayAmountChangelogEntry_Fragment = (
  { __typename: 'PartnerBillingPrepayAmountChangelogEntry' }
  & LabsGqlPartnerBillingPrepayAmountChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayAmountChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayExpiresChangelogEntry_Fragment = (
  { __typename: 'PartnerBillingPrepayExpiresChangelogEntry' }
  & LabsGqlPartnerBillingPrepayExpiresChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayExpiresChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayOverrideChangelogEntry_Fragment = (
  { __typename: 'PartnerBillingPrepayOverrideChangelogEntry' }
  & LabsGqlPartnerBillingPrepayOverrideChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayOverrideChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment = (
  { __typename: 'PartnerBillingPrimaryBillingContactUserIdChangeLogEntry' }
  & LabsGqlPartnerBillingPrimaryBillingContactUserIdChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment = (
  { __typename: 'PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry' }
  & LabsGqlPartnerBillingPrimaryBillingContactUserTypeChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment = (
  { __typename: 'PartnerBillingWillBeChargedCCFeeChangelogEntry' }
  & LabsGqlPartnerBillingWillBeChargedCcFeeChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntry_PartnerStripeLinkingChangelogEntry_Fragment = (
  { __typename: 'PartnerStripeLinkingChangelogEntry' }
  & LabsGqlPartnerStripeLinkingChangelogEntryFragment
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerStripeLinkingChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingChangelogEntryFragment = LabsGqlPartnerBillingChangelogEntry_AgreeToCreditCardFeesChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_BillingUsageSplitChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_MonthlyMinimumScheduleChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingAutochargeChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingContactsChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayAmountChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayExpiresChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayOverrideChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntry_PartnerStripeLinkingChangelogEntry_Fragment;

export type LabsGqlPartnerBillingChangelogEntryBase_AgreeToCreditCardFeesChangelogEntry_Fragment = { __typename?: 'AgreeToCreditCardFeesChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_BillingUsageSplitChangelogEntry_Fragment = { __typename?: 'BillingUsageSplitChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_MonthlyMinimumScheduleChangelogEntry_Fragment = { __typename?: 'MonthlyMinimumScheduleChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingAutochargeChangelogEntry_Fragment = { __typename?: 'PartnerBillingAutochargeChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingContactsChangelogEntry_Fragment = { __typename?: 'PartnerBillingContactsChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayAmountChangelogEntry_Fragment = { __typename?: 'PartnerBillingPrepayAmountChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayExpiresChangelogEntry_Fragment = { __typename?: 'PartnerBillingPrepayExpiresChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayOverrideChangelogEntry_Fragment = { __typename?: 'PartnerBillingPrepayOverrideChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment = { __typename?: 'PartnerBillingPrimaryBillingContactUserIdChangeLogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment = { __typename?: 'PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment = { __typename?: 'PartnerBillingWillBeChargedCCFeeChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBase_PartnerStripeLinkingChangelogEntry_Fragment = { __typename?: 'PartnerStripeLinkingChangelogEntry', event_timestamp: string, event_name: string, actor_role: string, actor_id: Maybe<string>, actor_name: Maybe<string> };

export type LabsGqlPartnerBillingChangelogEntryBaseFragment = LabsGqlPartnerBillingChangelogEntryBase_AgreeToCreditCardFeesChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_BillingUsageSplitChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_MonthlyMinimumScheduleChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingAutochargeChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingContactsChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayAmountChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayExpiresChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayOverrideChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment | LabsGqlPartnerBillingChangelogEntryBase_PartnerStripeLinkingChangelogEntry_Fragment;

export type LabsGqlBillingUsageSplitChangelogEntryFragment = (
  { __typename?: 'BillingUsageSplitChangelogEntry', old_usage_split_value: Maybe<(
    { __typename?: 'PaymentSplitConfigDoctor' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigDoctor_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigLocation' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigLocation_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigPercent' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigPercent_Fragment
  )>, new_usage_split_value: Maybe<(
    { __typename?: 'PaymentSplitConfigDoctor' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigDoctor_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigLocation' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigLocation_Fragment
  ) | (
    { __typename?: 'PaymentSplitConfigPercent' }
    & LabsGqlSplitPaymentConfig_PaymentSplitConfigPercent_Fragment
  )> }
  & LabsGqlPartnerBillingChangelogEntryBase_BillingUsageSplitChangelogEntry_Fragment
);

export type LabsGqlMonthlyMinimumScheduleChangelogEntryFragment = (
  { __typename?: 'MonthlyMinimumScheduleChangelogEntry', old_monthly_minimum_schedule_value: Array<(
    { __typename?: 'MonthlyMinimumCommitment' }
    & LabsGqlMonthlyMinimumCommitmentFragment
  )>, new_monthly_minimum_schedule_value: Array<(
    { __typename?: 'MonthlyMinimumCommitment' }
    & LabsGqlMonthlyMinimumCommitmentFragment
  )> }
  & LabsGqlPartnerBillingChangelogEntryBase_MonthlyMinimumScheduleChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingAutochargeChangelogEntryFragment = (
  { __typename?: 'PartnerBillingAutochargeChangelogEntry', old_autocharge_value: boolean, new_autocharge_value: boolean }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingAutochargeChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingContactsChangelogEntryFragment = (
  { __typename?: 'PartnerBillingContactsChangelogEntry', old_contacts_value: Array<string>, new_contacts_value: Array<string> }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingContactsChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingPrepayExpiresChangelogEntryFragment = (
  { __typename?: 'PartnerBillingPrepayExpiresChangelogEntry', old_prepay_expires_value: boolean, new_prepay_expires_value: boolean }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayExpiresChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingPrepayOverrideChangelogEntryFragment = (
  { __typename?: 'PartnerBillingPrepayOverrideChangelogEntry', old_prepay_override_value: Maybe<string>, new_prepay_override_value: Maybe<string> }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayOverrideChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingPrepayAmountChangelogEntryFragment = (
  { __typename?: 'PartnerBillingPrepayAmountChangelogEntry', old_prepay_amount_value: Array<(
    { __typename?: 'MonthlyMinimumCommitment' }
    & LabsGqlMonthlyMinimumCommitmentFragment
  )>, new_prepay_amount_value: Array<(
    { __typename?: 'MonthlyMinimumCommitment' }
    & LabsGqlMonthlyMinimumCommitmentFragment
  )> }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrepayAmountChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingPrimaryBillingContactUserIdChangelogEntryFragment = (
  { __typename?: 'PartnerBillingPrimaryBillingContactUserIdChangeLogEntry', old_primary_billing_contact_user_id_value: string, new_primary_billing_contact_user_id_value: string }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment
);

export type LabsGqlPartnerBillingPrimaryBillingContactUserTypeChangelogEntryFragment = (
  { __typename?: 'PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry', old_primary_billing_contact_user_type_value: Maybe<string>, new_primary_billing_contact_user_type_value: Maybe<string> }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment
);

export type LabsGqlPartnerStripeLinkingChangelogEntryFragment = (
  { __typename?: 'PartnerStripeLinkingChangelogEntry', old_stripe_id: string, new_stripe_id: string }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerStripeLinkingChangelogEntry_Fragment
);

export type LabsGqlAgreeToCreditCardFeesChangelogEntryFragment = (
  { __typename?: 'AgreeToCreditCardFeesChangelogEntry', old_agreed_to_cc_fees: boolean, new_agreed_to_cc_fees: boolean }
  & LabsGqlPartnerBillingChangelogEntryBase_AgreeToCreditCardFeesChangelogEntry_Fragment
);

export type LabsGqlPartnerBillingWillBeChargedCcFeeChangelogEntryFragment = (
  { __typename?: 'PartnerBillingWillBeChargedCCFeeChangelogEntry', old_will_be_charged_cc_fee: boolean, new_will_be_charged_cc_fee: boolean }
  & LabsGqlPartnerBillingChangelogEntryBase_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment
);

export type LabsGqlPrepaySplitConfigFragment = { __typename: 'PaymentSplitConfigPercent', type: Types.LabsGqlPaymentSplitConfigType, splits: Array<(
    { __typename?: 'PaymentSplitConfigEntryPercent' }
    & LabsGqlPaymentSplitEntryPercentFragment
  )> };

export type LabsGqlPaymentSplitEntryPercentFragment = { __typename: 'PaymentSplitConfigEntryPercent', decimal_percentage: number, source_id: string };

export type LabsGqlSplitPaymentConfig_PaymentSplitConfigDoctor_Fragment = { __typename: 'PaymentSplitConfigDoctor', type: Types.LabsGqlPaymentSplitConfigType, splits: Array<(
    { __typename?: 'PaymentSplitConfigEntryDoctor' }
    & LabsGqlSplitConfigEntry_PaymentSplitConfigEntryDoctor_Fragment
  )> };

export type LabsGqlSplitPaymentConfig_PaymentSplitConfigLocation_Fragment = { __typename: 'PaymentSplitConfigLocation', type: Types.LabsGqlPaymentSplitConfigType, splits: Array<(
    { __typename?: 'PaymentSplitConfigEntryLocation' }
    & LabsGqlSplitConfigEntry_PaymentSplitConfigEntryLocation_Fragment
  )> };

export type LabsGqlSplitPaymentConfig_PaymentSplitConfigPercent_Fragment = { __typename: 'PaymentSplitConfigPercent', type: Types.LabsGqlPaymentSplitConfigType, splits: Array<(
    { __typename?: 'PaymentSplitConfigEntryPercent' }
    & LabsGqlSplitConfigEntry_PaymentSplitConfigEntryPercent_Fragment
  )> };

export type LabsGqlSplitPaymentConfigFragment = LabsGqlSplitPaymentConfig_PaymentSplitConfigDoctor_Fragment | LabsGqlSplitPaymentConfig_PaymentSplitConfigLocation_Fragment | LabsGqlSplitPaymentConfig_PaymentSplitConfigPercent_Fragment;

export type LabsGqlListPartnerSourcesAdminQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlListPartnerSourcesAdminQuery = { __typename?: 'Query', getLabsPaymentMethods: Array<(
    { __typename?: 'StripePaymentMethod' }
    & LabsGqlCardSourceFragment
  )> };

export type LabsGqlFetchPartnerBillingChangelogQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlFetchPartnerBillingChangelogQuery = { __typename?: 'Query', fetchPartnerBillingChangelog: Array<(
    { __typename?: 'AgreeToCreditCardFeesChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_AgreeToCreditCardFeesChangelogEntry_Fragment
  ) | (
    { __typename?: 'BillingUsageSplitChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_BillingUsageSplitChangelogEntry_Fragment
  ) | (
    { __typename?: 'MonthlyMinimumScheduleChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_MonthlyMinimumScheduleChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingAutochargeChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingAutochargeChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingContactsChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingContactsChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingPrepayAmountChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayAmountChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingPrepayExpiresChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayExpiresChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingPrepayOverrideChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrepayOverrideChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingPrimaryBillingContactUserIdChangeLogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrimaryBillingContactUserIdChangeLogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingPrimaryBillingContactUserTypeChangeLogEntry_Fragment
  ) | (
    { __typename?: 'PartnerBillingWillBeChargedCCFeeChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerBillingWillBeChargedCcFeeChangelogEntry_Fragment
  ) | (
    { __typename?: 'PartnerStripeLinkingChangelogEntry' }
    & LabsGqlPartnerBillingChangelogEntry_PartnerStripeLinkingChangelogEntry_Fragment
  )> };

export type LabsGqlCardSourceFragment = { __typename?: 'StripePaymentMethod', id: string, brand: string, last4: string, name: string, is_default: boolean, method: Types.LabsGqlStripePaymentMethodKind, funding: Maybe<string> };

export type LabsGqlSplitConfigEntry_PaymentSplitConfigEntryDoctor_Fragment = { __typename: 'PaymentSplitConfigEntryDoctor', source_id: string, doctor_preferences_id: string };

export type LabsGqlSplitConfigEntry_PaymentSplitConfigEntryLocation_Fragment = { __typename: 'PaymentSplitConfigEntryLocation', source_id: string, delivery_address_id: string };

export type LabsGqlSplitConfigEntry_PaymentSplitConfigEntryPercent_Fragment = { __typename: 'PaymentSplitConfigEntryPercent', source_id: string, decimal_percentage: number };

export type LabsGqlSplitConfigEntryFragment = LabsGqlSplitConfigEntry_PaymentSplitConfigEntryDoctor_Fragment | LabsGqlSplitConfigEntry_PaymentSplitConfigEntryLocation_Fragment | LabsGqlSplitConfigEntry_PaymentSplitConfigEntryPercent_Fragment;

export type LabsGqlLabPaymentMethodsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlLabPaymentMethodsQuery = { __typename?: 'Query', getLabsPaymentMethods: Array<(
    { __typename?: 'StripePaymentMethod' }
    & LabsGqlPaymentMethodFragment
  )> };

export type LabsGqlPaymentMethodFragment = { __typename?: 'StripePaymentMethod', brand: string, id: string, is_default: boolean, last4: string, name: string, method: Types.LabsGqlStripePaymentMethodKind, routing_number: Maybe<string>, exp_month: Maybe<number>, exp_year: Maybe<number>, funding: Maybe<string> };

export type LabsGqlBillingContactUserFragment = { __typename?: 'BillingContactUser', id: string, first_name: string, last_name: string, email: string, type: Types.LabsGqlBillingContactUserType };

export type LabsGqlCreatePaymentMethodMutationVariables = Types.Exact<{
  partnerId: Types.Scalars['String']['input'];
  cardToken: Types.Scalars['String']['input'];
  setAsDefault: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlCreatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethod: { __typename?: 'StripePaymentId', id: string } };

export type LabsGqlRemovePaymentMethodMutationVariables = Types.Exact<{
  partnerId: Types.Scalars['String']['input'];
  cardId: Types.Scalars['String']['input'];
}>;


export type LabsGqlRemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: { __typename?: 'StripePaymentId', id: string } };

export type LabsGqlSetDefaultPaymentMethodMutationVariables = Types.Exact<{
  partnerId: Types.Scalars['String']['input'];
  cardId: Types.Scalars['String']['input'];
}>;


export type LabsGqlSetDefaultPaymentMethodMutation = { __typename?: 'Mutation', setDefaultPaymentMethod: { __typename?: 'StripePaymentId', id: string } };

export type LabsGqlAgreeToCreditCardFeesMutationVariables = Types.Exact<{
  partnerId: Types.Scalars['String']['input'];
  agreedToCCFees: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlAgreeToCreditCardFeesMutation = { __typename?: 'Mutation', agreeToCreditCardFees: { __typename?: 'IPartnerBilling', id: string } };

export type LabsGqlListPartnerNotificationPrefsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListPartnerNotificationPrefsQuery = { __typename?: 'Query', listPartnerPreferences: Array<(
    { __typename?: 'PartnerNotificationPreferences' }
    & LabsGqlPartnerNotificationPreferencesFragment
  )> };

export type LabsGqlPartnerNotificationPreferencesFragment = { __typename?: 'PartnerNotificationPreferences', id: string, partner_id: string, created_at: string, emails: Array<string>, phone_number: Maybe<string>, time_zone: Maybe<string>, daily_digest_timing: Maybe<Types.LabsGqlPartnerLabsNotificationTiming>, unsubmitted_scans_daily_sms: Maybe<Types.LabsGqlPartnerLabsNotificationTiming>, unsubmitted_scan_alert_delay_mins: Maybe<number>, design_review_alerts: Maybe<boolean>, waxup_ready_for_review_email: Maybe<boolean>, estimated_delivery_alerts: Maybe<boolean>, estimated_delivery_emails: Maybe<boolean>, waxup_daily_reminder_sms_timing: Maybe<Types.LabsGqlPartnerLabsNotificationTiming> };

export type LabsGqlPartnerNotificationPrefsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlPartnerNotificationPrefsQuery = { __typename?: 'Query', getPartnerPreferences: Maybe<(
    { __typename?: 'PartnerNotificationPreferences' }
    & LabsGqlPartnerNotificationPreferencesFragment
  )> };

export type LabsGqlZendeskUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlZendeskUserQuery = { __typename?: 'Query', zendeskUser: { __typename?: 'ZendeskChatUser', token: Maybe<string>, expires_at: Maybe<string>, external_id: Maybe<string> } };

export type LabsGqlListPracticePatientsQueryVariables = Types.Exact<{
  with_replaced: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlListPracticePatientsQuery = { __typename?: 'Query', listPracticePatients: Array<(
    { __typename?: 'PatientDTO' }
    & LabsGqlPatientFragment
  )> };

export type LabsGqlPatientFragment = { __typename?: 'PatientDTO', id: string, partner_id: string, first_name: string, last_name: string, birthday: string, gender: string, replaced_by_patient_id: Maybe<string>, created_at: string, updated_at: string };

export type LabsGqlCreatePatientMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreatePatientCommand;
}>;


export type LabsGqlCreatePatientMutation = { __typename?: 'Mutation', createPatient: (
    { __typename?: 'PatientDTO' }
    & LabsGqlPatientFragment
  ) };

export type LabsGqlListPracticeSupportQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListPracticeSupportQuery = { __typename?: 'Query', listPracticeSupport: Array<(
    { __typename?: 'PracticeSupportDTO' }
    & LabsGqlPracticeSupportFragment
  )> };

export type LabsGqlGetOrCreatePracticeSupportQueryVariables = Types.Exact<{
  practice_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrCreatePracticeSupportQuery = { __typename?: 'Query', getOrCreatePracticeSupport: (
    { __typename?: 'PracticeSupportDTO' }
    & LabsGqlPracticeSupportFragment
  ) };

export type LabsGqlPracticeSupportFragment = { __typename?: 'PracticeSupportDTO', practice_id: string, agreement_version: Maybe<string>, software_type: Maybe<Types.LabsGqlPracticeSoftwareType>, id: string };

export type LabsGqlGetPracticeRequestsQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['String']['input'];
  types: Array<Types.LabsGqlPracticeRequestType>;
  sku: Types.LabsGqlOrderItemSkuType;
}>;


export type LabsGqlGetPracticeRequestsQuery = { __typename?: 'Query', getPracticeRequests: Array<(
    { __typename?: 'PracticeRequestDTO' }
    & LabsGqlPracticeRequestFragment
  )> };

export type LabsGqlSubmitPracticeFeedbackMutationVariables = Types.Exact<{
  doctor_name: Types.Scalars['String']['input'];
  feedback: Types.Scalars['String']['input'];
}>;


export type LabsGqlSubmitPracticeFeedbackMutation = { __typename?: 'Mutation', submitPracticeFeedback: boolean };

export type LabsGqlPracticeEmailHasNotStartedOrCompletedSignUpQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type LabsGqlPracticeEmailHasNotStartedOrCompletedSignUpQuery = { __typename?: 'Query', practiceEmailHasNotStartedOrCompletedSignUp: boolean };

export type LabsGqlPracticeHasBeenSentSignUpEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type LabsGqlPracticeHasBeenSentSignUpEmailQuery = { __typename?: 'Query', practiceHasBeenSentSignUpEmail: boolean };

export type LabsGqlUpdatePracticeSignUpStatusMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdatePracticeSignUpStatusCommand;
}>;


export type LabsGqlUpdatePracticeSignUpStatusMutation = { __typename?: 'Mutation', updatePracticeSignUpStatus: (
    { __typename?: 'PracticeSignUpStatusDTO' }
    & LabsGqlPracticeSignUpStatusFragment
  ) };

export type LabsGqlPracticeSignUpStatusFragment = { __typename?: 'PracticeSignUpStatusDTO', id: string, email: string, status: Types.LabsGqlPracticeSignUpStatus };

export type LabsGqlLabMetalCostFragment = { __typename?: 'LabMetalCostQueryPerAggDTO', id: string, price_cents: Maybe<number> };

export type LabsGqlGetLabMetalCostQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLabMetalCostQuery = { __typename?: 'Query', getLabMetalCost: Array<{ __typename?: 'LabMetalCostQueryDTO', metal_id: string, metal_name: string, current: Maybe<(
      { __typename?: 'LabMetalCostQueryPerAggDTO' }
      & LabsGqlLabMetalCostFragment
    )>, upcoming: (
      { __typename?: 'LabMetalCostQueryPerAggDTO' }
      & LabsGqlLabMetalCostFragment
    ) }> };

export type LabsGqlGetMetalMaterialQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetMetalMaterialQuery = { __typename?: 'Query', getMetalMaterial: Array<(
    { __typename?: 'MetalMaterialDTO' }
    & LabsGqlMetalMaterialFragment
  )> };

export type LabsGqlMigratedStaffResultFragment = { __typename?: 'MigratedStaffResult', user_id: string, organization_id: string, staff_member_id: string, roles: Array<Types.LabsGqlStaffRolePractice>, preferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlStaffMemberForPreferencesQueryVariables = Types.Exact<{
  preferences_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlStaffMemberForPreferencesQuery = { __typename?: 'Query', staffMemberForPreferences: Maybe<(
    { __typename?: 'MigratedStaffResult' }
    & LabsGqlMigratedStaffResultFragment
  )> };

export type LabsGqlCurrentDoctorPreferencesQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  include_deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlCurrentDoctorPreferencesQuery = { __typename?: 'Query', preferences: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  )> };

export type LabsGqlGetDoctorPreferencesByIdQueryVariables = Types.Exact<{
  doctor_id: Types.Scalars['String']['input'];
  include_deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlGetDoctorPreferencesByIdQuery = { __typename?: 'Query', preferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlGetLinkedDoctorPreferencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetLinkedDoctorPreferencesQuery = { __typename?: 'Query', preferences: (
    { __typename?: 'DoctorAndLastName' }
    & LabsGqlDoctorAndLastNameFragment
  ) };

export type LabsGqlGetPreferencesByIdsQueryVariables = Types.Exact<{
  pref_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetPreferencesByIdsQuery = { __typename?: 'Query', preferences: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  )> };

export type LabsGqlGetDoctorPreferencesByTokenQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDoctorPreferencesByTokenQuery = { __typename?: 'Query', preferences: (
    { __typename?: 'DoctorAndLastName' }
    & LabsGqlDoctorAndLastNameFragment
  ) };

export type LabsGqlGetPracticeStaffPreferencesByIdQueryVariables = Types.Exact<{
  practice_staff_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetPracticeStaffPreferencesByIdQuery = { __typename?: 'Query', preferences: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlAllDoctorPreferencesQueryVariables = Types.Exact<{
  include_deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlAllDoctorPreferencesQuery = { __typename?: 'Query', preferences: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  )> };

export type LabsGqlBasicDoctorPreferencesQueryVariables = Types.Exact<{
  include_deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlBasicDoctorPreferencesQuery = { __typename?: 'Query', preferences: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlBasicDoctorPreferencesFragment
  )> };

export type LabsGqlGetPreferencesByStaffMemberIdsQueryVariables = Types.Exact<{
  staff_member_ids: Array<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetPreferencesByStaffMemberIdsQuery = { __typename?: 'Query', preferences: Array<(
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  )> };

export type LabsGqlGetManufacturerProfileQueryVariables = Types.Exact<{
  manufacturer_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetManufacturerProfileQuery = { __typename?: 'Query', profile: (
    { __typename?: 'ManufacturerProfile' }
    & LabsGqlManufacturerProfileFragment
  ) };

export type LabsGqlCurrentManufacturerProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlCurrentManufacturerProfileQuery = { __typename?: 'Query', profile: (
    { __typename?: 'ManufacturerProfile' }
    & LabsGqlManufacturerProfileFragment
  ) };

export type LabsGqlAllManufacturerProfilesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlAllManufacturerProfilesQuery = { __typename?: 'Query', profiles: Array<(
    { __typename?: 'ManufacturerProfile' }
    & LabsGqlManufacturerProfileFragment
  )> };

export type LabsGqlUserExistsWithMobilePhoneNumberQueryVariables = Types.Exact<{
  mobile_phone_number: Types.Scalars['String']['input'];
  staff_member_id: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlUserExistsWithMobilePhoneNumberQuery = { __typename?: 'Query', userExistsWithMobileNumber: boolean };

export type LabsGqlCheckPracticeAdminsQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  staff_member_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlCheckPracticeAdminsQuery = { __typename?: 'Query', checkPracticeAdmins: boolean };

export type LabsGqlManufacturerProfileFragment = { __typename: 'ManufacturerProfile', id: string, created_at: string, updated_at: string, design_capability: Types.LabsGqlInternalDesignAbility, default_portalship_destination: Maybe<Types.LabsGqlPortalShipDestinationType>, default_portalship_speed: Maybe<Types.LabsGqlPortalShipShippingSpeed>, deactivated_at: Maybe<string>, exclude_from_gold_pricing: boolean, is_internal: boolean, custom_field_preferences: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlCustomFieldPrefsFragment
  )>, shipping_address: Maybe<(
    { __typename?: 'DeliveryAddress' }
    & LabsGqlDeliveryAddressFragment
  )>, return_shipping_address: Maybe<(
    { __typename?: 'DeliveryAddress' }
    & LabsGqlDeliveryAddressFragment
  )>, feature_states: { __typename?: 'ManufacturerFeatureStates', portalShip: Maybe<boolean> }, integration_configuration: Maybe<{ __typename?: 'ManufacturerIntegration', order_io_capability: Types.LabsGqlIntegrationOrderIoCapability, can_generate_order_entry_qr_code: boolean, can_complete_tasks: Array<Types.LabsGqlTaskType> }> };

export type LabsGqlDoctorGroupedNotificationsFragment = { __typename?: 'NotificationGroupDTO', communication_email: Maybe<boolean>, communication_sms: Maybe<boolean>, marketing_email: Maybe<boolean>, marketing_sms: Maybe<boolean>, order_tracking_email: Maybe<boolean>, order_tracking_sms: Maybe<boolean>, review_required_email: Maybe<boolean>, review_required_sms: Maybe<boolean>, status_change_email: Maybe<boolean>, status_change_sms: Maybe<boolean> };

export type LabsGqlGroupForwardingFragment = { __typename?: 'NotificationGroupForwardingDTO', status_change_senders: Maybe<Array<string>>, status_change_receivers: Maybe<Array<string>>, review_required_senders: Maybe<Array<string>>, review_required_receivers: Maybe<Array<string>>, order_tracking_senders: Maybe<Array<string>>, order_tracking_receivers: Maybe<Array<string>>, communication_senders: Maybe<Array<string>>, communication_receivers: Maybe<Array<string>> };

export type LabsGqlDoctorProfilePhotoFragment = { __typename?: 'DoctorProfilePhotoDTO', type: Types.LabsGqlDoctorProfilePhotoType, source: Maybe<string>, color: Types.LabsGqlDoctorProfilePhotoColor };

export type LabsGqlGettingStartedStepFragment = { __typename?: 'GettingStartedStepDTO', key: Types.LabsGqlGettingStartedStepKey, page_title: string, page_url: string, length: string, completed_at: Maybe<string> };

export type LabsGqlBasicDoctorPreferencesFragment = { __typename?: 'DoctorPreferences', formatted_name: string, id: string, name: string, partner_id: string, practice_name: Maybe<string>, contact_phone: Maybe<string>, contact_email: Maybe<string> };

export type LabsGqlDoctorPreferencesFragment = { __typename: 'DoctorPreferences', id: string, partner_id: string, name: string, mailing_address_nickname: Maybe<string>, created_at: string, updated_at: string, contact_tightness: Types.LabsGqlContactTightnessEnum, test_order_default: Maybe<boolean>, mailing_address_id: Maybe<string>, timezone: Maybe<string>, who_receives_dr_notifications: Maybe<Types.LabsGqlWhoReceivesDoctorNotifications>, contact_phone: Maybe<string>, contact_phone_call_number: Maybe<string>, best_call_hour: Maybe<number>, contact_email: Maybe<string>, practice_name: Maybe<string>, staff_member_id: Maybe<string>, invite_sent: Maybe<boolean>, roles: Maybe<Array<Types.LabsGqlStaffRolePractice>>, formatted_name: string, custom_field_preferences: Maybe<Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlCustomFieldPrefsFragment
  )>>, preferred_manufacturers: Array<(
    { __typename?: 'PreferredManufacturer' }
    & LabsGqlPreferredManufacturersFragment
  )>, lab_slip_alerts: Array<(
    { __typename?: 'DoctorLabSlipAlert' }
    & LabsGqlDoctorLabSlipAlertFragment
  )>, grouped_notification_preferences: (
    { __typename?: 'NotificationGroupDTO' }
    & LabsGqlDoctorGroupedNotificationsFragment
  ), grouped_notification_forwarding_preferences: (
    { __typename?: 'NotificationGroupForwardingDTO' }
    & LabsGqlGroupForwardingFragment
  ), profile_photo: (
    { __typename?: 'DoctorProfilePhotoDTO' }
    & LabsGqlDoctorProfilePhotoFragment
  ) };

export type LabsGqlDoctorAndLastNameFragment = { __typename?: 'DoctorAndLastName', doctor_last_name: string, doctor: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlSaveDoctorLabSlipAlertsMutationVariables = Types.Exact<{
  doctor_id: Types.Scalars['String']['input'];
  alerts: Array<Types.LabsGqlDoctorLabSlipAlertInput>;
}>;


export type LabsGqlSaveDoctorLabSlipAlertsMutation = { __typename?: 'Mutation', saveDoctorLabSlipAlerts: (
    { __typename?: 'DoctorPreferences' }
    & LabsGqlDoctorPreferencesFragment
  ) };

export type LabsGqlSendDoctorPrefsUpdatedNotificationMutationVariables = Types.Exact<{
  data: Types.LabsGqlSendDoctorPrefsUpdatedNotificationInput;
  schedule: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlSendDoctorPrefsUpdatedNotificationMutation = { __typename?: 'Mutation', sendDoctorPrefsUpdatedNotification: boolean };

export type LabsGqlDoctorLabSlipAlertFragment = { __typename?: 'DoctorLabSlipAlert', id: string, text: string, type: Types.LabsGqlLabSlipAlertType, visibility: Maybe<Array<Types.LabsGqlDoctorAlertLocation>>, filter: Maybe<(
    { __typename?: 'FilterSubmission' }
    & LabsGqlOrderFilterFragment
  )> };

export type LabsGqlCustomFieldPrefsFragment = { __typename: 'ICustomFieldSubmission', field_id: string, display_name: string, value: string | boolean | number, price_cents: Maybe<number> };

export type LabsGqlPreferredManufacturersFragment = { __typename?: 'PreferredManufacturer', id: string, manufacturer_id: string, item_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )> };

export type LabsGqlGetAllPracticeContactsIncludingExternalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetAllPracticeContactsIncludingExternalQuery = { __typename?: 'Query', getAllPracticeContactsIncludingExternal: Array<(
    { __typename?: 'PracticeContact' }
    & LabsGqlPracticeContactFragment
  )> };

export type LabsGqlPracticeContactFragment = { __typename?: 'PracticeContact', source: string, practice_name: string, contact_name: string, email: string, phone: Maybe<string>, role: Maybe<string>, practice_status: Maybe<string> };

export type LabsGqlQcIssuesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlQcIssuesQuery = { __typename?: 'Query', listQcIssues: Array<(
    { __typename?: 'QcIssue' }
    & LabsGqlQcIssueFragment
  )> };

export type LabsGqlCreateQcIssueMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateQcIssueCommand;
}>;


export type LabsGqlCreateQcIssueMutation = { __typename?: 'Mutation', createQcIssue: (
    { __typename?: 'QcIssue' }
    & LabsGqlQcIssueFragment
  ) };

export type LabsGqlUpdateQcIssueMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateQcIssueCommand;
}>;


export type LabsGqlUpdateQcIssueMutation = { __typename?: 'Mutation', updateQcIssue: (
    { __typename?: 'QcIssue' }
    & LabsGqlQcIssueFragment
  ) };

export type LabsGqlQcSubIssueFragment = { __typename?: 'QcSubIssue', name: string, is_fail_reason: boolean };

export type LabsGqlQcIssueFragment = { __typename?: 'QcIssue', id: string, updated_at: string, created_at: string, name: string, prompt: string, options: Array<string>, archived: boolean, sub_issues: Array<(
    { __typename?: 'QcSubIssue' }
    & LabsGqlQcSubIssueFragment
  )>, filters: Array<(
    { __typename?: 'FilterSubmission' }
    & LabsGqlOrderFilterFragment
  )> };

export type LabsGqlQcItemConfigsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlQcItemConfigsQuery = { __typename?: 'Query', listQCItemConfigs: Array<(
    { __typename?: 'QCItemConfigDTO' }
    & LabsGqlQcItemConfigFragment
  )> };

export type LabsGqlCreateQcItemConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateQcItemConfigCommand;
}>;


export type LabsGqlCreateQcItemConfigMutation = { __typename?: 'Mutation', createQcItemConfig: (
    { __typename?: 'QCItemConfigDTO' }
    & LabsGqlQcItemConfigFragment
  ) };

export type LabsGqlEditQcItemConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditQcItemConfigCommand;
}>;


export type LabsGqlEditQcItemConfigMutation = { __typename?: 'Mutation', editQcItemConfig: (
    { __typename?: 'QCItemConfigDTO' }
    & LabsGqlQcItemConfigFragment
  ) };

export type LabsGqlArchiveQcItemConfigMutationVariables = Types.Exact<{
  data: Types.LabsGqlArchiveQcItemConfigCommand;
}>;


export type LabsGqlArchiveQcItemConfigMutation = { __typename?: 'Mutation', archiveQcItemConfig: (
    { __typename?: 'QCItemConfigDTO' }
    & LabsGqlQcItemConfigFragment
  ) };

export type LabsGqlQcItemConfigFragment = { __typename?: 'QCItemConfigDTO', id: string, created_at: string, updated_at: string, archived_at: Maybe<string>, title: string, description: string, attachments: Maybe<Array<string>>, filters: Array<(
    { __typename?: 'FilterSubmission' }
    & LabsGqlOrderFilterFragment
  )> };

export type LabsGqlGetOrderByQcSearchQueryVariables = Types.Exact<{
  search_term: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderByQcSearchQuery = { __typename?: 'Query', getOrderByQcSearch: Maybe<(
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  )> };

export type LabsGqlReasonCodesQueryVariables = Types.Exact<{
  params: Types.InputMaybe<Types.LabsGqlListReasonCodeParams>;
}>;


export type LabsGqlReasonCodesQuery = { __typename?: 'Query', listReasonCodes: Array<(
    { __typename?: 'ReasonCodeDTO' }
    & LabsGqlReasonCodeFragment
  )> };

export type LabsGqlCreateReasonCodeMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateReasonCodeCommand;
}>;


export type LabsGqlCreateReasonCodeMutation = { __typename?: 'Mutation', createReasonCode: (
    { __typename?: 'ReasonCodeDTO' }
    & LabsGqlReasonCodeFragment
  ) };

export type LabsGqlUpdateReasonCodeMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateReasonCodeCommand;
}>;


export type LabsGqlUpdateReasonCodeMutation = { __typename?: 'Mutation', updateReasonCode: (
    { __typename?: 'ReasonCodeDTO' }
    & LabsGqlReasonCodeFragment
  ) };

export type LabsGqlAddReasonCodeRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddReasonCodeRuleCommand;
}>;


export type LabsGqlAddReasonCodeRuleMutation = { __typename?: 'Mutation', addReasonCodeRule: (
    { __typename?: 'ReasonCodeDTO' }
    & LabsGqlReasonCodeFragment
  ) };

export type LabsGqlDeleteReasonCodeRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteReasonCodeRuleCommand;
}>;


export type LabsGqlDeleteReasonCodeRuleMutation = { __typename?: 'Mutation', deleteReasonCodeRule: (
    { __typename?: 'ReasonCodeDTO' }
    & LabsGqlReasonCodeFragment
  ) };

export type LabsGqlReasonCodeFragment = { __typename?: 'ReasonCodeDTO', id: string, updated_at: string, created_at: string, archived: boolean, title: string, group: Maybe<Types.LabsGqlReasonCodeGroup>, category: Maybe<string>, internal_only: boolean, default_fault: Maybe<Types.LabsGqlReasonCodeFault>, form_display: Maybe<Types.LabsGqlFormDisplay>, additional_info_request: Array<string>, display_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )>, return_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )> };

export type LabsGqlReasonCodeCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlReasonCodeCategoriesQuery = { __typename?: 'Query', getReasonCodeCategoriesAndCounts: Array<(
    { __typename?: 'ReasonCodeCategoryCount' }
    & LabsGqlReasonCodeCategoryCountFragment
  )> };

export type LabsGqlReasonCodeCategoryCountFragment = { __typename?: 'ReasonCodeCategoryCount', category: string, count: number };

export type LabsGqlReasonCodeAdditionalInfoRequestsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlReasonCodeAdditionalInfoRequestsQuery = { __typename?: 'Query', getReasonCodeAdditionalInfoRequestsAndCounts: Array<(
    { __typename?: 'ReasonCodeAdditionalInfoRequestCount' }
    & LabsGqlReasonCodeAdditionalInfoCountFragment
  )> };

export type LabsGqlReasonCodeAdditionalInfoCountFragment = { __typename?: 'ReasonCodeAdditionalInfoRequestCount', additional_info_request: string, count: number };

export type LabsGqlRefabReasonsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlRefabReasonsQuery = { __typename?: 'Query', listRefabReasons: Array<(
    { __typename?: 'RefabReasonDTO' }
    & LabsGqlRefabReasonFragment
  )> };

export type LabsGqlCreateRefabReasonMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateRefabReasonCommand;
}>;


export type LabsGqlCreateRefabReasonMutation = { __typename?: 'Mutation', createRefabReason: (
    { __typename?: 'RefabReasonDTO' }
    & LabsGqlRefabReasonFragment
  ) };

export type LabsGqlUpdateRefabReasonMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateRefabReasonCommand;
}>;


export type LabsGqlUpdateRefabReasonMutation = { __typename?: 'Mutation', updateRefabReason: (
    { __typename?: 'RefabReasonDTO' }
    & LabsGqlRefabReasonFragment
  ) };

export type LabsGqlAddRefabReasonRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddRefabReasonRuleCommand;
}>;


export type LabsGqlAddRefabReasonRuleMutation = { __typename?: 'Mutation', addRefabReasonRule: (
    { __typename?: 'RefabReasonDTO' }
    & LabsGqlRefabReasonFragment
  ) };

export type LabsGqlDeleteRefabReasonRuleMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteRefabReasonRuleCommand;
}>;


export type LabsGqlDeleteRefabReasonRuleMutation = { __typename?: 'Mutation', deleteRefabReasonRule: (
    { __typename?: 'RefabReasonDTO' }
    & LabsGqlRefabReasonFragment
  ) };

export type LabsGqlRefabReasonFragment = { __typename?: 'RefabReasonDTO', id: string, updated_at: string, created_at: string, archived: boolean, name: string, category: Maybe<string>, internal_only: boolean, default_fault: Maybe<Types.LabsGqlRefabFault>, display_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )>, return_rules: Array<(
    { __typename?: 'CustomFieldDisplayRule' }
    & LabsGqlDisplayRuleFragment
  )> };

export type LabsGqlRefabReasonCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlRefabReasonCategoriesQuery = { __typename?: 'Query', getRefabCategoriesAndCounts: Array<(
    { __typename?: 'RefabReasonCategoryCount' }
    & LabsGqlRefabReasonCategoryCountFragment
  )> };

export type LabsGqlRefabReasonCategoryCountFragment = { __typename?: 'RefabReasonCategoryCount', category: string, count: number };

export type LabsGqlPasswordLoginQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type LabsGqlPasswordLoginQuery = { __typename?: 'Query', passwordLogin: Array<(
    { __typename?: 'UserLoginOption' }
    & LabsGqlUserLoginOptionFragment
  )> };

export type LabsGqlPhoneNumberPasswordLoginQueryVariables = Types.Exact<{
  mobile_phone_number: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type LabsGqlPhoneNumberPasswordLoginQuery = { __typename?: 'Query', phoneNumberPasswordLogin: Array<(
    { __typename?: 'UserLoginOption' }
    & LabsGqlUserLoginOptionFragment
  )> };

export type LabsGqlOneTimeCodeLoginV2MutationVariables = Types.Exact<{
  mobile_phone_number: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type LabsGqlOneTimeCodeLoginV2Mutation = { __typename?: 'Mutation', oneTimeCodeLoginV2: { __typename?: 'OneTimeCodeLoginResult', approved: boolean, error_message: Maybe<string>, options: Array<(
      { __typename?: 'UserLoginOption' }
      & LabsGqlUserLoginOptionFragment
    )> } };

export type LabsGqlGetMembershipLoginQueryVariables = Types.Exact<{
  mobile_phone_number: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetMembershipLoginQuery = { __typename?: 'Query', getMembershipLogin: Maybe<(
    { __typename?: 'UserLoginOption' }
    & LabsGqlUserLoginOptionFragment
  )> };

export type LabsGqlOneTimeCodeVerificationMutationVariables = Types.Exact<{
  mobile_phone_number: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;


export type LabsGqlOneTimeCodeVerificationMutation = { __typename?: 'Mutation', verified: boolean };

export type LabsGqlUserLoginOptionFragment = { __typename?: 'UserLoginOption', id: string, access_token: string, organization_name: string, organization_type: Types.LabsGqlOrganizationType };

export type LabsGqlLegacyTokenResultFragment = { __typename?: 'LegacyTokenResult', id: string, accessToken: string };

export type LabsGqlRefreshTokenQueryVariables = Types.Exact<{
  accessToken: Types.Scalars['String']['input'];
}>;


export type LabsGqlRefreshTokenQuery = { __typename?: 'Query', accessToken: string };

export type LabsGqlExchangeLegacyTokenQueryVariables = Types.Exact<{
  nativeIdToken: Types.Scalars['String']['input'];
}>;


export type LabsGqlExchangeLegacyTokenQuery = { __typename?: 'Query', accessToken: string };

export type LabsGqlExchangeMultiAuthLegacyTokenQueryVariables = Types.Exact<{
  nativeIdToken: Types.Scalars['String']['input'];
}>;


export type LabsGqlExchangeMultiAuthLegacyTokenQuery = { __typename?: 'Query', exchangeMultiAuthLegacyToken: (
    { __typename?: 'LegacyTokenResult' }
    & LabsGqlLegacyTokenResultFragment
  ) };

export type LabsGqlAddInternalStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddInternalStaffMemberCommand;
}>;


export type LabsGqlAddInternalStaffMemberMutation = { __typename?: 'Mutation', addInternalStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlRemoveStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlRemoveOrganizationStaffMemberCommand;
}>;


export type LabsGqlRemoveStaffMemberMutation = { __typename?: 'Mutation', removeOrganizationStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlReactivateStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlReactivateOrganizationStaffMemberCommand;
}>;


export type LabsGqlReactivateStaffMemberMutation = { __typename?: 'Mutation', reactivateOrganizationStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlAddLabStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddLabStaffMemberCommand;
}>;


export type LabsGqlAddLabStaffMemberMutation = { __typename?: 'Mutation', addLabStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlAddPracticeStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddPracticeStaffMemberCommand;
}>;


export type LabsGqlAddPracticeStaffMemberMutation = { __typename?: 'Mutation', addPracticeStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlAddParentStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddParentStaffMemberCommand;
}>;


export type LabsGqlAddParentStaffMemberMutation = { __typename?: 'Mutation', addParentStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlAddExternalStaffMemberMutationVariables = Types.Exact<{
  data: Types.LabsGqlAddExternalStaffMemberCommand;
}>;


export type LabsGqlAddExternalStaffMemberMutation = { __typename?: 'Mutation', addExternalStaffMember: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateInternalStaffMemberRolesMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateInternalStaffMemberRolesCommand;
}>;


export type LabsGqlUpdateInternalStaffMemberRolesMutation = { __typename?: 'Mutation', updateInternalStaffMemberRoles: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateLabStaffMemberRolesMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateLabStaffMemberRolesCommand;
}>;


export type LabsGqlUpdateLabStaffMemberRolesMutation = { __typename?: 'Mutation', updateLabStaffMemberRoles: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdatePracticeStaffMemberRolesMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdatePracticeStaffMemberRolesCommand;
}>;


export type LabsGqlUpdatePracticeStaffMemberRolesMutation = { __typename?: 'Mutation', updatePracticeStaffMemberRoles: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateParentStaffMemberRolesMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateParentStaffMemberRolesCommand;
}>;


export type LabsGqlUpdateParentStaffMemberRolesMutation = { __typename?: 'Mutation', updateParentStaffMemberRoles: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateExternalStaffMemberRolesMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateExternalStaffMemberRolesCommand;
}>;


export type LabsGqlUpdateExternalStaffMemberRolesMutation = { __typename?: 'Mutation', updateExternalStaffMemberRoles: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlCreateUserMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateUserCommand;
}>;


export type LabsGqlCreateUserMutation = { __typename?: 'Mutation', createUser: (
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  ) };

export type LabsGqlUpdateUserMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateUserCommand;
}>;


export type LabsGqlUpdateUserMutation = { __typename?: 'Mutation', updateUser: (
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  ) };

export type LabsGqlUpdateUserPasswordMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateUserPasswordCommand;
}>;


export type LabsGqlUpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: (
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  ) };

export type LabsGqlGetUserQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetUserQuery = { __typename?: 'Query', getUser: Maybe<(
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  )> };

export type LabsGqlGetDoesRetainerUserPreferPasswordLoginQueryVariables = Types.Exact<{
  mobile_phone_number: Types.Scalars['String']['input'];
  staff_member_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetDoesRetainerUserPreferPasswordLoginQuery = { __typename?: 'Query', getDoesUserPreferPasswordLogin: boolean };

export type LabsGqlGetOrgQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrgQuery = { __typename?: 'Query', getOrganization: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlGetOrgPrimaryAdminQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrgPrimaryAdminQuery = { __typename?: 'Query', getOrgPrimaryAdmin: (
    { __typename?: 'StaffMemberWithRelations' }
    & LabsGqlStaffMemberWithRelationsFragment
  ) };

export type LabsGqlGetOrgAdminsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrgAdminsQuery = { __typename?: 'Query', getOrgAdmins: Array<(
    { __typename?: 'StaffMemberWithRelations' }
    & LabsGqlStaffMemberWithRelationsFragment
  )> };

export type LabsGqlGetOrganizationWithDescendantsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrganizationWithDescendantsQuery = { __typename?: 'Query', getOrganizationWithDescendants: (
    { __typename?: 'OrganizationWithDescendants' }
    & LabsGqlOrganizationWithDescendantsFragment
  ) };

export type LabsGqlGetOrganizationWithAncestorsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrganizationWithAncestorsQuery = { __typename?: 'Query', getOrganizationWithAncestors: (
    { __typename?: 'OrganizationWithAncestors' }
    & LabsGqlOrganizationWithAncestorsFragment
  ) };

export type LabsGqlListRetainerUsersQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListUsersFilter>;
}>;


export type LabsGqlListRetainerUsersQuery = { __typename?: 'Query', listUsers: Array<(
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  )> };

export type LabsGqlGetFirebaseTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetFirebaseTokenQuery = { __typename?: 'Query', getFirebaseToken: string };

export type LabsGqlGetImpersonationTokenQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['String']['input'];
  user_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  expires_in_seconds: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type LabsGqlGetImpersonationTokenQuery = { __typename?: 'Query', getImpersonationToken: { __typename?: 'ImpersonationTokenDTO', token: string, practiceUrl: string, labPortalUrl: Maybe<string> } };

export type LabsGqlGetOwnImpersonationTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetOwnImpersonationTokenQuery = { __typename?: 'Query', getOwnImpersonationToken: { __typename?: 'ImpersonationTokenDTO', token: string, practiceUrl: string, labPortalUrl: Maybe<string> } };

export type LabsGqlListUserPositionsQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
  active: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlListUserPositionsQuery = { __typename?: 'Query', listUserPositions: Array<(
    { __typename?: 'StaffMemberDTO' }
    & LabsGqlStaffMemberDtoFragment
  )> };

export type LabsGqlListUserOrganizationsQueryVariables = Types.Exact<{
  user_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlListUserOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'OrganizationDTO', id: string, type: Types.LabsGqlOrganizationType, name: string }> };

export type LabsGqlListOrgsQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrgsQuery = { __typename?: 'Query', listOrganizations: Array<(
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  )> };

export type LabsGqlListOrgSummariesQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrgSummariesQuery = { __typename?: 'Query', listOrganizationSummaries: Array<(
    { __typename?: 'OrganizationSummary' }
    & LabsGqlOrganizationSummaryFragment
  )> };

export type LabsGqlListOrganizationsWithDescendantsQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrganizationsWithDescendantsQuery = { __typename?: 'Query', listOrganizationsWithDescendants: Array<(
    { __typename?: 'OrganizationWithDescendants' }
    & LabsGqlOrganizationWithDescendantsFragment
  )> };

export type LabsGqlListOrganizationsWithDescendantsSummaryQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrganizationsWithDescendantsSummaryQuery = { __typename?: 'Query', listOrganizationsWithDescendantsSummary: Array<(
    { __typename?: 'OrganizationWithDescendantsSummary' }
    & LabsGqlOrganizationWithDescendantsSummaryFragment
  )> };

export type LabsGqlListOrganizationsWithAncestorsQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrganizationsWithAncestorsQuery = { __typename?: 'Query', listOrganizationsWithAncestors: Array<(
    { __typename?: 'OrganizationWithAncestors' }
    & LabsGqlOrganizationWithAncestorsFragment
  )> };

export type LabsGqlListOrganizationsWithAncestorsSummaryQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrganizationsWithAncestorsSummaryQuery = { __typename?: 'Query', listOrganizationsWithAncestorsSummary: Array<(
    { __typename?: 'OrganizationWithAncestorsSummary' }
    & LabsGqlOrganizationWithAncestorsSummaryFragment
  )> };

export type LabsGqlListOrganizationsWithHierarchySummaryQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrganizationsWithHierarchySummaryQuery = { __typename?: 'Query', listOrganizationsWithHierarchySummary: Array<(
    { __typename?: 'OrganizationWithHierarchySummary' }
    & LabsGqlOrganizationWithHierarchySummaryFragment
  )> };

export type LabsGqlListOrgsWithoutRelationsQueryVariables = Types.Exact<{
  filter: Types.InputMaybe<Types.LabsGqlListOrgsFilter>;
}>;


export type LabsGqlListOrgsWithoutRelationsQuery = { __typename?: 'Query', listOrganizations: Array<(
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationWithoutRelationsFragment
  )> };

export type LabsGqlListPracticeNamesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListPracticeNamesQuery = { __typename?: 'Query', listPracticeNames: Array<{ __typename?: 'PracticeNameAndPrimaryContactInfo', id: string, name: string, created_at: string, primary_contact_email: Maybe<string>, primary_contact_phone_number: Maybe<string> }> };

export type LabsGqlOrganizationWithoutRelationsFragment = { __typename?: 'OrganizationDTO', id: string, name: string, legal_name: string, type: Types.LabsGqlOrganizationType };

export type LabsGqlLinkOrganizationExternalAccountMutationVariables = Types.Exact<{
  data: Types.LabsGqlLinkOrganizationExternalAccountCommand;
}>;


export type LabsGqlLinkOrganizationExternalAccountMutation = { __typename?: 'Mutation', linkOrganizationExternalAccount: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUnlinkOrganizationExternalAccountMutationVariables = Types.Exact<{
  data: Types.LabsGqlUnlinkOrganizationExternalAccountCommand;
}>;


export type LabsGqlUnlinkOrganizationExternalAccountMutation = { __typename?: 'Mutation', unlinkOrganizationExternalAccount: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateOrgNameMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrganizationNameCommand;
}>;


export type LabsGqlUpdateOrgNameMutation = { __typename?: 'Mutation', updateOrganizationName: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlUpdateOrgPhoneNumberMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateOrganizationPhoneNumberCommand;
}>;


export type LabsGqlUpdateOrgPhoneNumberMutation = { __typename?: 'Mutation', updateOrganizationPhoneNumber: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlCreateTrainingMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateTrainingCommand;
}>;


export type LabsGqlCreateTrainingMutation = { __typename?: 'Mutation', createTraining: { __typename?: 'Training', id: string } };

export type LabsGqlCreateExternalOrganizationMutationVariables = Types.Exact<{
  fields: Types.LabsGqlCreateExternalOrgCommand;
}>;


export type LabsGqlCreateExternalOrganizationMutation = { __typename?: 'Mutation', createExternalOrg: { __typename?: 'ExternalOrgCreatedRes', id: string } };

export type LabsGqlUpdatePracticeSettingsMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdatePracticeSettingsCommand;
}>;


export type LabsGqlUpdatePracticeSettingsMutation = { __typename?: 'Mutation', updatePracticeSettings: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ) };

export type LabsGqlOrganizationDtoFragment = { __typename?: 'OrganizationDTO', id: string, name: string, legal_name: string, phone_number: Maybe<string>, type: Types.LabsGqlOrganizationType, created_at: string, parent_id: Maybe<string>, staff: Array<(
    { __typename?: 'StaffMemberDTO' }
    & LabsGqlStaffMemberDtoFragment
  )>, external_accounts: Array<(
    { __typename?: 'ExternalAccountRelationshipDTO' }
    & LabsGqlExternalAccountRelationshipDtoFragment
  )>, primary_contact: Maybe<(
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  )>, lab_notification_preferences: Maybe<(
    { __typename?: 'ManufacturerNotificationPreferences' }
    & LabsGqlManufacturerNotificationPreferencesFragment
  )>, lab_profile: Maybe<(
    { __typename?: 'ManufacturerProfile' }
    & LabsGqlManufacturerProfileFragment
  )> };

export type LabsGqlOrganizationWithDescendantsFragment = { __typename?: 'OrganizationWithDescendants', id: string, name: string, legal_name: string, type: Types.LabsGqlOrganizationType, created_at: string, descendants: Array<(
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationWithoutRelationsFragment
  )> };

export type LabsGqlOrganizationWithAncestorsFragment = { __typename?: 'OrganizationWithAncestors', id: string, name: string, legal_name: string, type: Types.LabsGqlOrganizationType, created_at: string, ancestors: Array<(
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationWithoutRelationsFragment
  )> };

export type LabsGqlOrganizationSummaryFragment = { __typename?: 'OrganizationSummary', id: string, name: string, type: Types.LabsGqlOrganizationType, created_at: string };

export type LabsGqlOrganizationWithDescendantsSummaryFragment = { __typename?: 'OrganizationWithDescendantsSummary', id: string, name: string, type: Types.LabsGqlOrganizationType, created_at: string, practices_count: number };

export type LabsGqlOrganizationWithAncestorsSummaryFragment = { __typename?: 'OrganizationWithAncestorsSummary', id: string, name: string, type: Types.LabsGqlOrganizationType, created_at: string, ancestors: Array<(
    { __typename?: 'OrganizationSummary' }
    & LabsGqlOrganizationSummaryFragment
  )> };

export type LabsGqlOrganizationWithHierarchySummaryFragment = { __typename?: 'OrganizationWithHierarchySummary', id: string, name: string, type: Types.LabsGqlOrganizationType, created_at: string, practices_count: number, ancestors: Array<(
    { __typename?: 'OrganizationSummary' }
    & LabsGqlOrganizationSummaryFragment
  )> };

export type LabsGqlExternalAccountRelationshipDtoFragment = { __typename?: 'ExternalAccountRelationshipDTO', id: string, type: Types.LabsGqlExternalAccountRelationshipType };

export type LabsGqlStaffMemberDtoFragment = { __typename?: 'StaffMemberDTO', id: string, organization_id: string, organization_type: Types.LabsGqlOrganizationType, roles: Array<Types.LabsGqlStaffRole>, activated_at: Maybe<string>, deactivated_at: Maybe<string>, user_id: string };

export type LabsGqlUserDtoFragment = { __typename?: 'UserDTO', id: string, first_name: string, last_name: string, email: string, phone_number: Maybe<string>, mobile_phone_number: Maybe<string>, salesforce_contact_id: Maybe<string> };

export type LabsGqlStaffMemberOrganizationFragment = { __typename?: 'StaffMemberOrganization', id: string, legal_name: string, name: string, type: Types.LabsGqlOrganizationType, updated_at: string };

export type LabsGqlStaffMemberWithRelationsFragment = { __typename?: 'StaffMemberWithRelations', id: string, organization_id: string, organization_type: Types.LabsGqlOrganizationType, roles: Array<Types.LabsGqlStaffRole>, deactivated_at: Maybe<string>, user_id: string, user: (
    { __typename?: 'UserDTO' }
    & LabsGqlUserDtoFragment
  ), organization: (
    { __typename?: 'StaffMemberOrganization' }
    & LabsGqlStaffMemberOrganizationFragment
  ) };

export type LabsGqlGetReviewQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetReviewQuery = { __typename?: 'Query', getReview: Maybe<(
    { __typename?: 'IReviewSubmission' }
    & LabsGqlReviewSubmissionFragment
  )> };

export type LabsGqlGetReviewsQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetReviewsQuery = { __typename?: 'Query', getReviews: Array<(
    { __typename?: 'IReviewSubmission' }
    & LabsGqlReviewSubmissionFragment
  )> };

export type LabsGqlGetRecentReviewsQueryVariables = Types.Exact<{
  partner_id: Types.Scalars['String']['input'];
  doctor_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlGetRecentReviewsQuery = { __typename?: 'Query', getRecentReviews: Array<(
    { __typename?: 'IReviewSubmission' }
    & LabsGqlReviewSubmissionFragment
  )> };

export type LabsGqlPendingReviewOrderIdsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlPendingReviewOrderIdsQuery = { __typename?: 'Query', listPendingReviewLabOrderIds: Array<string> };

export type LabsGqlSubmitFeedbackV3MutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateReviewSubmissionV3Command;
}>;


export type LabsGqlSubmitFeedbackV3Mutation = { __typename?: 'Mutation', createReviewSubmissionV3: (
    { __typename?: 'IReviewSubmission' }
    & LabsGqlReviewSubmissionFragment
  ) };

export type LabsGqlUpdateReviewSubmissionItemTagsMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateReviewSubmissionItemTagsCommand;
}>;


export type LabsGqlUpdateReviewSubmissionItemTagsMutation = { __typename?: 'Mutation', updateReviewSubmissionItemTags: (
    { __typename?: 'IReviewSubmission' }
    & LabsGqlReviewSubmissionFragment
  ) };

export type LabsGqlCreateChairsideReviewSubmissionMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateChairsideReviewSubmissionCommand;
}>;


export type LabsGqlCreateChairsideReviewSubmissionMutation = { __typename?: 'Mutation', createChairsideReviewSubmission: (
    { __typename?: 'IReviewSubmission' }
    & LabsGqlReviewSubmissionFragment
  ) };

export type LabsGqlReviewSubmissionFragment = { __typename?: 'IReviewSubmission', id: string, created_at: string, updated_at: string, doctor_id: string, manufacturer_id: Maybe<string>, partner_id: string, submitting_user_id: string, lab_order_id: Maybe<string>, rating: Types.LabsGqlReviewRating, doctor_is_happy: Maybe<boolean>, notes: Maybe<string>, tags: Array<(
    { __typename?: 'ReviewTagSubmission' }
    & LabsGqlReviewTagSubmissionFragment
  )>, items: Array<(
    { __typename?: 'ReviewSubmissionSectionItem' }
    & LabsGqlItemReviewSubmissionFragment
  )>, annotations: Array<(
    { __typename?: 'ReviewSubmissionAnnotationDTO' }
    & LabsGqlReviewSubmissionAnnotationFragment
  )>, attachments: Array<(
    { __typename?: 'RefabOrderAttachmentsDTO' }
    & LabsGqlRefabOrderAttachmentsFragment
  )> };

export type LabsGqlItemReviewSubmissionFragment = { __typename?: 'ReviewSubmissionSectionItem', item_id: string, star_rating: Maybe<number>, rating: Types.LabsGqlReviewRating, notes: Maybe<string>, chairside_adjustment_minutes: Maybe<number>, is_refab: Maybe<boolean>, tags: Array<(
    { __typename?: 'ReviewTagSubmission' }
    & LabsGqlReviewTagSubmissionFragment
  )>, item_attachments: Maybe<Array<(
    { __typename?: 'ReviewItemAttachment' }
    & LabsGqlReviewItemAttachmentFragment
  )>> };

export type LabsGqlReviewTagSubmissionFragment = { __typename: 'ReviewTagSubmission', title: string, category: Maybe<string>, fault: Maybe<Types.LabsGqlReasonCodeFault>, review_tag_id: Maybe<string>, reason_code_id: Maybe<string>, other_notes: Maybe<string>, internal_only: Maybe<boolean> };

export type LabsGqlReviewSubmissionAnnotationFragment = { __typename?: 'ReviewSubmissionAnnotationDTO', comment: string, image_url: string };

export type LabsGqlRefabOrderAttachmentsFragment = { __typename?: 'RefabOrderAttachmentsDTO', url: string };

export type LabsGqlReviewItemAttachmentFragment = { __typename?: 'ReviewItemAttachment', url: string };

export type LabsGqlDeleteSavedSearchMutationVariables = Types.Exact<{
  searchId: Types.Scalars['String']['input'];
}>;


export type LabsGqlDeleteSavedSearchMutation = { __typename?: 'Mutation', deleteSavedSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlCreateSavedOrderSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateSavedOrderSearchCommand;
}>;


export type LabsGqlCreateSavedOrderSearchMutation = { __typename?: 'Mutation', createSavedOrderSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlEditSavedOrderSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditSavedOrderSearchCommand;
}>;


export type LabsGqlEditSavedOrderSearchMutation = { __typename?: 'Mutation', editSavedOrderSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlCreateSavedInboxSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateSavedInboxSearchCommand;
}>;


export type LabsGqlCreateSavedInboxSearchMutation = { __typename?: 'Mutation', createSavedInboxSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlEditSavedInboxSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditSavedInboxSearchCommand;
}>;


export type LabsGqlEditSavedInboxSearchMutation = { __typename?: 'Mutation', editSavedInboxSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlCreateSavedRoutingSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateSavedRoutingSearchCommand;
}>;


export type LabsGqlCreateSavedRoutingSearchMutation = { __typename?: 'Mutation', createSavedRoutingSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlEditSavedRoutingSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlEditSavedRoutingSearchCommand;
}>;


export type LabsGqlEditSavedRoutingSearchMutation = { __typename?: 'Mutation', editSavedRoutingSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlFavoriteSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlFavoriteSavedSearchCommand;
}>;


export type LabsGqlFavoriteSavedSearchMutation = { __typename?: 'Mutation', favoriteSavedSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlUnfavoriteSavedSearchMutationVariables = Types.Exact<{
  data: Types.LabsGqlUnfavoriteSavedSearchCommand;
}>;


export type LabsGqlUnfavoriteSavedSearchMutation = { __typename?: 'Mutation', unfavoriteSavedSearch: (
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  ) };

export type LabsGqlGetSavedSearchesQueryVariables = Types.Exact<{
  type: Types.LabsGqlCustomSearchType;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
  unique: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LabsGqlGetSavedSearchesQuery = { __typename?: 'Query', getSavedSearches: Array<(
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  )> };

export type LabsGqlGetNonFavoritedSavedSearchesQueryVariables = Types.Exact<{
  type: Types.LabsGqlCustomSearchType;
  textFilter: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetNonFavoritedSavedSearchesQuery = { __typename?: 'Query', getNonFavoritedSavedSearches: Array<(
    { __typename?: 'SavedSearch' }
    & LabsGqlSavedSearchFragment
  )> };

export type LabsGqlSavedSearchFragment = { __typename?: 'SavedSearch', id: string, name: string, visibility: Types.LabsGqlSavedSearchVisibility, created_by: string, favorited_by: Array<string>, created_by_user: { __typename?: 'UserDTO', id: string, first_name: string, last_name: string }, search: (
    { __typename: 'InboxCustomSearch' }
    & LabsGqlInboxCustomSearchFragment
  ) | (
    { __typename: 'OrderCustomSearch' }
    & LabsGqlOrderCustomSearchFragment
  ) | (
    { __typename: 'RoutingCustomSearch' }
    & LabsGqlRoutingCustomSearchFragment
  ) };

export type LabsGqlICustomSearchParams_InboxCustomSearch_Fragment = { __typename: 'InboxCustomSearch', search: Maybe<string>, type: Types.LabsGqlCustomSearchType, order_criteria: Maybe<Array<(
    { __typename?: 'FilterCriteriaSubmission' }
    & LabsGqlOrderFilterValueFragment
  )>> };

export type LabsGqlICustomSearchParams_OrderCustomSearch_Fragment = { __typename: 'OrderCustomSearch', search: Maybe<string>, type: Types.LabsGqlCustomSearchType, order_criteria: Maybe<Array<(
    { __typename?: 'FilterCriteriaSubmission' }
    & LabsGqlOrderFilterValueFragment
  )>> };

export type LabsGqlICustomSearchParams_RoutingCustomSearch_Fragment = { __typename: 'RoutingCustomSearch', search: Maybe<string>, type: Types.LabsGqlCustomSearchType, order_criteria: Maybe<Array<(
    { __typename?: 'FilterCriteriaSubmission' }
    & LabsGqlOrderFilterValueFragment
  )>> };

export type LabsGqlICustomSearchParamsFragment = LabsGqlICustomSearchParams_InboxCustomSearch_Fragment | LabsGqlICustomSearchParams_OrderCustomSearch_Fragment | LabsGqlICustomSearchParams_RoutingCustomSearch_Fragment;

export type LabsGqlOrderCustomSearchFragment = (
  { __typename: 'OrderCustomSearch', order_sort: Maybe<{ __typename?: 'SavedListOrdersSort', key: Maybe<Types.LabsGqlLabOrderSortKey>, asc: boolean }> }
  & LabsGqlICustomSearchParams_OrderCustomSearch_Fragment
);

export type LabsGqlInboxCustomSearchFragment = (
  { __typename: 'InboxCustomSearch', task_filter: Maybe<(
    { __typename?: 'SavedListWorkflowTasksFilter' }
    & LabsGqlSavedListWorkflowTasksFilterFragment
  )>, task_sort: Maybe<{ __typename?: 'SavedWorkflowTaskSortParam', isAsc: boolean, field: Types.LabsGqlWorkflowTaskSortField }> }
  & LabsGqlICustomSearchParams_InboxCustomSearch_Fragment
);

export type LabsGqlRoutingCustomSearchFragment = (
  { __typename: 'RoutingCustomSearch', range: Types.LabsGqlRoutingMetricsRange, ruleType: Types.LabsGqlRoutingCustomSearchRuleType, item_condition_json: string, order_condition_json: string }
  & LabsGqlICustomSearchParams_RoutingCustomSearch_Fragment
);

export type LabsGqlSavedListWorkflowTasksFilterFragment = { __typename?: 'SavedListWorkflowTasksFilter', assigned: Maybe<boolean>, assigned_user_ids: Maybe<Array<Maybe<string>>>, completed: Maybe<boolean>, completed_by_ids: Maybe<Array<string>>, design_review_required: Maybe<boolean>, exclude_assigned_user_ids: Maybe<Array<Maybe<string>>>, type: Maybe<Array<Types.LabsGqlWorkflowTaskType>>, completed_at: Maybe<(
    { __typename?: 'SavedTaskDateFilter' }
    & LabsGqlSavedTaskDateFilterFragment
  )>, created_at: Maybe<(
    { __typename?: 'SavedTaskDateFilter' }
    & LabsGqlSavedTaskDateFilterFragment
  )> };

export type LabsGqlSavedTaskDateFilterFragment = { __typename?: 'SavedTaskDateFilter', comparator: Maybe<Types.LabsGqlFilterComparator>, comparison_value: Maybe<string> };

export type LabsGqlSingleScanFileQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlSingleScanFileQuery = { __typename?: 'Query', scan_file: (
    { __typename?: 'scan_export', telemetry_snapshot: Maybe<{ __typename?: 'ScanExportTelemetrySnapshot', uploader_version: Maybe<string>, calibrations: Array<{ __typename?: 'ScannerCalibrationTimestamps', serial_number: string, fused_image: Maybe<number>, mirror_test: Maybe<number>, color_correction: Maybe<number> }> }> }
    & LabsGqlScanFileBaseFragment
  ) };

export type LabsGqlScanFilesQueryVariables = Types.Exact<{
  practice_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  patient_names: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlScanFilesQuery = { __typename?: 'Query', scan_files: Array<(
    { __typename?: 'scan_export' }
    & LabsGqlScanFileFragment
  )> };

export type LabsGqlScanFilesForPatientQueryVariables = Types.Exact<{
  patient_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlScanFilesForPatientQuery = { __typename?: 'Query', scan_files_for_patient: Array<(
    { __typename?: 'scan_export' }
    & LabsGqlPatientScanFileFragment
  )> };

export type LabsGqlScanFileBaseFragment = { __typename?: 'scan_export', id: string, threeshape_order_id: string, stl_url: Maybe<string>, patient_first_name: string, patient_last_name: string, patient_birthday: Maybe<string>, file_url: Maybe<string>, original_upload_url: string, created_at: string, image_urls: Maybe<Array<string>>, has_shade_match_images: boolean, sanitized_url: Maybe<string> };

export type LabsGqlScanFileFragment = (
  { __typename?: 'scan_export', restorations: Array<(
    { __typename?: 'ScanExportElement' }
    & LabsGqlScanExportItemFragment
  )>, scanner: { __typename?: 'ScannerEntity', id: string, assigned_practice_id: Maybe<string>, owner: Maybe<{ __typename?: 'OrganizationDTO', id: string, name: string, legal_name: string }> } }
  & LabsGqlScanFileBaseFragment
);

export type LabsGqlPatientScanFileFragment = { __typename?: 'scan_export', id: string, threeshape_order_id: string, stl_url: Maybe<string>, file_url: Maybe<string>, created_at: string, image_urls: Maybe<Array<string>>, has_shade_match_images: boolean, sanitized_url: Maybe<string>, scanner_id: Maybe<string>, scan_source: Types.LabsGqlScanExportSource, cart_items_v2: Array<(
    { __typename?: 'CartAlignerItem' }
    & LabsGqlCartItemV2Dto_CartAlignerItem_Fragment
  ) | (
    { __typename?: 'CartBridgeItem' }
    & LabsGqlCartItemV2Dto_CartBridgeItem_Fragment
  ) | (
    { __typename?: 'CartCrownItem' }
    & LabsGqlCartItemV2Dto_CartCrownItem_Fragment
  ) | (
    { __typename?: 'CartDentureItem' }
    & LabsGqlCartItemV2Dto_CartDentureItem_Fragment
  ) | (
    { __typename?: 'CartImplantBridgeItem' }
    & LabsGqlCartItemV2Dto_CartImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'CartImplantItem' }
    & LabsGqlCartItemV2Dto_CartImplantItem_Fragment
  ) | (
    { __typename?: 'CartInlayItem' }
    & LabsGqlCartItemV2Dto_CartInlayItem_Fragment
  ) | (
    { __typename?: 'CartModelItem' }
    & LabsGqlCartItemV2Dto_CartModelItem_Fragment
  ) | (
    { __typename?: 'CartOtherItem' }
    & LabsGqlCartItemV2Dto_CartOtherItem_Fragment
  ) | (
    { __typename?: 'CartPartialDentureItem' }
    & LabsGqlCartItemV2Dto_CartPartialDentureItem_Fragment
  ) | (
    { __typename?: 'CartRemovableItem' }
    & LabsGqlCartItemV2Dto_CartRemovableItem_Fragment
  ) | (
    { __typename?: 'CartSleepApneaItem' }
    & LabsGqlCartItemV2Dto_CartSleepApneaItem_Fragment
  ) | (
    { __typename?: 'CartSurgicalGuideItem' }
    & LabsGqlCartItemV2Dto_CartSurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'CartTMJItem' }
    & LabsGqlCartItemV2Dto_CartTmjItem_Fragment
  ) | (
    { __typename?: 'CartUnknownItem' }
    & LabsGqlCartItemV2Dto_CartUnknownItem_Fragment
  ) | (
    { __typename?: 'CartVeneerItem' }
    & LabsGqlCartItemV2Dto_CartVeneerItem_Fragment
  ) | (
    { __typename?: 'CartWaxupItem' }
    & LabsGqlCartItemV2Dto_CartWaxupItem_Fragment
  ) | (
    { __typename?: 'CartWellnessScanItem' }
    & LabsGqlCartItemV2Dto_CartWellnessScanItem_Fragment
  )> };

export type LabsGqlScanExportItemFragment = { __typename?: 'ScanExportElement', Color: Maybe<string>, Material: Maybe<string>, link_type: string, teeth: Array<{ __typename?: 'ScanExportElementTypeID', material: Maybe<string>, unit_type: string, unn: string }> };

export type LabsGqlScanFilesCheckoutQueryVariables = Types.Exact<{
  reused_scan_ids: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type LabsGqlScanFilesCheckoutQuery = { __typename?: 'Query', scan_files: Array<(
    { __typename?: 'scan_export' }
    & LabsGqlScanFileCheckoutFragment
  )> };

export type LabsGqlSingleScanFileCheckoutQueryVariables = Types.Exact<{
  scanId: Types.Scalars['String']['input'];
}>;


export type LabsGqlSingleScanFileCheckoutQuery = { __typename?: 'Query', scan_file: (
    { __typename?: 'scan_export' }
    & LabsGqlScanFileCheckoutFragment
  ) };

export type LabsGqlScanFileCheckoutFragment = { __typename?: 'scan_export', id: string, threeshape_order_id: string, patient_first_name: string, patient_last_name: string, patient_birthday: Maybe<string>, file_url: Maybe<string>, created_at: string, image_urls: Maybe<Array<string>>, has_shade_match_images: boolean, original_upload_url: string, case_comments: Maybe<string>, existingOrderMatch: Maybe<(
    { __typename?: 'ExistingPatientOrderMatch' }
    & LabsGqlExistingPatientOrderMatchFragment
  )>, restorations: Array<(
    { __typename?: 'ScanExportElement' }
    & LabsGqlScanExportItemFragment
  )>, cart_items_v2: Array<(
    { __typename?: 'CartAlignerItem' }
    & LabsGqlCartItemV2Dto_CartAlignerItem_Fragment
  ) | (
    { __typename?: 'CartBridgeItem' }
    & LabsGqlCartItemV2Dto_CartBridgeItem_Fragment
  ) | (
    { __typename?: 'CartCrownItem' }
    & LabsGqlCartItemV2Dto_CartCrownItem_Fragment
  ) | (
    { __typename?: 'CartDentureItem' }
    & LabsGqlCartItemV2Dto_CartDentureItem_Fragment
  ) | (
    { __typename?: 'CartImplantBridgeItem' }
    & LabsGqlCartItemV2Dto_CartImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'CartImplantItem' }
    & LabsGqlCartItemV2Dto_CartImplantItem_Fragment
  ) | (
    { __typename?: 'CartInlayItem' }
    & LabsGqlCartItemV2Dto_CartInlayItem_Fragment
  ) | (
    { __typename?: 'CartModelItem' }
    & LabsGqlCartItemV2Dto_CartModelItem_Fragment
  ) | (
    { __typename?: 'CartOtherItem' }
    & LabsGqlCartItemV2Dto_CartOtherItem_Fragment
  ) | (
    { __typename?: 'CartPartialDentureItem' }
    & LabsGqlCartItemV2Dto_CartPartialDentureItem_Fragment
  ) | (
    { __typename?: 'CartRemovableItem' }
    & LabsGqlCartItemV2Dto_CartRemovableItem_Fragment
  ) | (
    { __typename?: 'CartSleepApneaItem' }
    & LabsGqlCartItemV2Dto_CartSleepApneaItem_Fragment
  ) | (
    { __typename?: 'CartSurgicalGuideItem' }
    & LabsGqlCartItemV2Dto_CartSurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'CartTMJItem' }
    & LabsGqlCartItemV2Dto_CartTmjItem_Fragment
  ) | (
    { __typename?: 'CartUnknownItem' }
    & LabsGqlCartItemV2Dto_CartUnknownItem_Fragment
  ) | (
    { __typename?: 'CartVeneerItem' }
    & LabsGqlCartItemV2Dto_CartVeneerItem_Fragment
  ) | (
    { __typename?: 'CartWaxupItem' }
    & LabsGqlCartItemV2Dto_CartWaxupItem_Fragment
  ) | (
    { __typename?: 'CartWellnessScanItem' }
    & LabsGqlCartItemV2Dto_CartWellnessScanItem_Fragment
  )> };

export type LabsGqlExistingPatientOrderMatchFragment = { __typename?: 'ExistingPatientOrderMatch', type: Types.LabsGqlExistingPatientOrderType, order: (
    { __typename?: 'LabOrderWithEvents' }
    & LabsGqlLabOrderFragment
  ) };

export type LabsGqlAttachmentFragment = { __typename?: 'LabOrderAttachment', filepath: string };

export type LabsGqlLinkMetadataFragment = { __typename?: 'LabOrderItemLinkMetadata', connection: Maybe<string>, manufacturer: Maybe<string>, relationship: Maybe<Types.LabsGqlOrderItemLinkRelationship>, system: Maybe<string>, implant_scanbody_usages: Maybe<Array<(
    { __typename?: 'ImplantToothScanbodyUsage' }
    & LabsGqlScanbodyUsageFragment
  )>> };

export type LabsGqlScanbodyUsageFragment = { __typename?: 'ImplantToothScanbodyUsage', unn: number, scanbody_id: Maybe<string> };

export type LabsGqlCartItemV2Dto_CartAlignerItem_Fragment = (
  { __typename: 'CartAlignerItem' }
  & LabsGqlCartAlignerItemFragment
  & LabsGqlCartItemBase_CartAlignerItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartBridgeItem_Fragment = (
  { __typename: 'CartBridgeItem' }
  & LabsGqlCartBridgeItemFragment
  & LabsGqlCartItemBase_CartBridgeItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartCrownItem_Fragment = (
  { __typename: 'CartCrownItem' }
  & LabsGqlCartCrownItemFragment
  & LabsGqlCartItemBase_CartCrownItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartDentureItem_Fragment = (
  { __typename: 'CartDentureItem' }
  & LabsGqlCartDentureItemFragment
  & LabsGqlCartItemBase_CartDentureItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartImplantBridgeItem_Fragment = (
  { __typename: 'CartImplantBridgeItem' }
  & LabsGqlCartImplantBridgeItemFragment
  & LabsGqlCartItemBase_CartImplantBridgeItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartImplantItem_Fragment = (
  { __typename: 'CartImplantItem' }
  & LabsGqlCartImplantItemFragment
  & LabsGqlCartItemBase_CartImplantItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartInlayItem_Fragment = (
  { __typename: 'CartInlayItem' }
  & LabsGqlCartInlayItemFragment
  & LabsGqlCartItemBase_CartInlayItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartModelItem_Fragment = (
  { __typename: 'CartModelItem' }
  & LabsGqlCartModelItemFragment
  & LabsGqlCartItemBase_CartModelItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartOtherItem_Fragment = (
  { __typename: 'CartOtherItem' }
  & LabsGqlCartOtherItemFragment
  & LabsGqlCartItemBase_CartOtherItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartPartialDentureItem_Fragment = (
  { __typename: 'CartPartialDentureItem' }
  & LabsGqlCartPartialDentureItemFragment
  & LabsGqlCartItemBase_CartPartialDentureItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartRemovableItem_Fragment = (
  { __typename: 'CartRemovableItem' }
  & LabsGqlCartRemovableItemFragment
  & LabsGqlCartItemBase_CartRemovableItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartSleepApneaItem_Fragment = (
  { __typename: 'CartSleepApneaItem' }
  & LabsGqlCartSleepApneaItemFragment
  & LabsGqlCartItemBase_CartSleepApneaItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartSurgicalGuideItem_Fragment = (
  { __typename: 'CartSurgicalGuideItem' }
  & LabsGqlCartSurgicalGuideItemFragment
  & LabsGqlCartItemBase_CartSurgicalGuideItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartTmjItem_Fragment = (
  { __typename: 'CartTMJItem' }
  & LabsGqlCartTmjItemFragment
  & LabsGqlCartItemBase_CartTmjItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartUnknownItem_Fragment = (
  { __typename: 'CartUnknownItem' }
  & LabsGqlCartItemBase_CartUnknownItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartVeneerItem_Fragment = (
  { __typename: 'CartVeneerItem' }
  & LabsGqlCartVeneerItemFragment
  & LabsGqlCartItemBase_CartVeneerItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartWaxupItem_Fragment = (
  { __typename: 'CartWaxupItem' }
  & LabsGqlCartWaxupItemFragment
  & LabsGqlCartItemBase_CartWaxupItem_Fragment
);

export type LabsGqlCartItemV2Dto_CartWellnessScanItem_Fragment = (
  { __typename: 'CartWellnessScanItem' }
  & LabsGqlCartWellnessScanItemFragment
  & LabsGqlCartItemBase_CartWellnessScanItem_Fragment
);

export type LabsGqlCartItemV2DtoFragment = LabsGqlCartItemV2Dto_CartAlignerItem_Fragment | LabsGqlCartItemV2Dto_CartBridgeItem_Fragment | LabsGqlCartItemV2Dto_CartCrownItem_Fragment | LabsGqlCartItemV2Dto_CartDentureItem_Fragment | LabsGqlCartItemV2Dto_CartImplantBridgeItem_Fragment | LabsGqlCartItemV2Dto_CartImplantItem_Fragment | LabsGqlCartItemV2Dto_CartInlayItem_Fragment | LabsGqlCartItemV2Dto_CartModelItem_Fragment | LabsGqlCartItemV2Dto_CartOtherItem_Fragment | LabsGqlCartItemV2Dto_CartPartialDentureItem_Fragment | LabsGqlCartItemV2Dto_CartRemovableItem_Fragment | LabsGqlCartItemV2Dto_CartSleepApneaItem_Fragment | LabsGqlCartItemV2Dto_CartSurgicalGuideItem_Fragment | LabsGqlCartItemV2Dto_CartTmjItem_Fragment | LabsGqlCartItemV2Dto_CartUnknownItem_Fragment | LabsGqlCartItemV2Dto_CartVeneerItem_Fragment | LabsGqlCartItemV2Dto_CartWaxupItem_Fragment | LabsGqlCartItemV2Dto_CartWellnessScanItem_Fragment;

export type LabsGqlCartItemBase_CartAlignerItem_Fragment = { __typename?: 'CartAlignerItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartBridgeItem_Fragment = { __typename?: 'CartBridgeItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartCrownItem_Fragment = { __typename?: 'CartCrownItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartDentureItem_Fragment = { __typename?: 'CartDentureItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartImplantBridgeItem_Fragment = { __typename?: 'CartImplantBridgeItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartImplantItem_Fragment = { __typename?: 'CartImplantItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartInlayItem_Fragment = { __typename?: 'CartInlayItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartModelItem_Fragment = { __typename?: 'CartModelItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartOtherItem_Fragment = { __typename?: 'CartOtherItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartPartialDentureItem_Fragment = { __typename?: 'CartPartialDentureItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartRemovableItem_Fragment = { __typename?: 'CartRemovableItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartSleepApneaItem_Fragment = { __typename?: 'CartSleepApneaItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartSurgicalGuideItem_Fragment = { __typename?: 'CartSurgicalGuideItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartTmjItem_Fragment = { __typename?: 'CartTMJItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartUnknownItem_Fragment = { __typename?: 'CartUnknownItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartVeneerItem_Fragment = { __typename?: 'CartVeneerItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartWaxupItem_Fragment = { __typename?: 'CartWaxupItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBase_CartWellnessScanItem_Fragment = { __typename?: 'CartWellnessScanItem', sku: Types.LabsGqlOrderItemSkuType, item_notes: Maybe<string>, original_item_id: Maybe<string>, pricing: Maybe<{ __typename?: 'CartItemPricing', amount_due_cents: Maybe<number>, override_amount_due_cents: Maybe<number> }>, preference_fields: Array<(
    { __typename?: 'ICustomFieldSubmission' }
    & LabsGqlOrderFieldSubmissionFragment
  )>, shades: Array<(
    { __typename?: 'LabOrderItemShade' }
    & LabsGqlOrderItemShadeFragment
  )>, attachments: Array<(
    { __typename?: 'LabOrderAttachment' }
    & LabsGqlAttachmentFragment
  )> };

export type LabsGqlCartItemBaseFragment = LabsGqlCartItemBase_CartAlignerItem_Fragment | LabsGqlCartItemBase_CartBridgeItem_Fragment | LabsGqlCartItemBase_CartCrownItem_Fragment | LabsGqlCartItemBase_CartDentureItem_Fragment | LabsGqlCartItemBase_CartImplantBridgeItem_Fragment | LabsGqlCartItemBase_CartImplantItem_Fragment | LabsGqlCartItemBase_CartInlayItem_Fragment | LabsGqlCartItemBase_CartModelItem_Fragment | LabsGqlCartItemBase_CartOtherItem_Fragment | LabsGqlCartItemBase_CartPartialDentureItem_Fragment | LabsGqlCartItemBase_CartRemovableItem_Fragment | LabsGqlCartItemBase_CartSleepApneaItem_Fragment | LabsGqlCartItemBase_CartSurgicalGuideItem_Fragment | LabsGqlCartItemBase_CartTmjItem_Fragment | LabsGqlCartItemBase_CartUnknownItem_Fragment | LabsGqlCartItemBase_CartVeneerItem_Fragment | LabsGqlCartItemBase_CartWaxupItem_Fragment | LabsGqlCartItemBase_CartWellnessScanItem_Fragment;

export type LabsGqlCartCrownItemFragment = (
  { __typename?: 'CartCrownItem', unit: (
    { __typename?: 'CartItemSingleToothUnit' }
    & LabsGqlCartItemSingleToothUnitFragment
  ) }
  & LabsGqlCartItemBase_CartCrownItem_Fragment
);

export type LabsGqlCartBridgeItemFragment = (
  { __typename?: 'CartBridgeItem', units: Array<(
    { __typename?: 'CartItemSingleToothUnit' }
    & LabsGqlCartItemSingleToothUnitFragment
  )> }
  & LabsGqlCartItemBase_CartBridgeItem_Fragment
);

export type LabsGqlCartOtherItemFragment = (
  { __typename?: 'CartOtherItem', unit: (
    { __typename?: 'CartItemUnitMetadata' }
    & LabsGqlCartItemUnitMetadataFragment
  ) }
  & LabsGqlCartItemBase_CartOtherItem_Fragment
);

export type LabsGqlCartModelItemFragment = (
  { __typename?: 'CartModelItem', unit_type: string, model_type: Maybe<Types.LabsGqlOrderItemModelType>, selected_teeth: Maybe<Array<ToothNumber>> }
  & LabsGqlCartItemBase_CartModelItem_Fragment
);

export type LabsGqlCartWaxupItemFragment = (
  { __typename?: 'CartWaxupItem', unit_type: string, selected_teeth: Maybe<Array<ToothNumber>> }
  & LabsGqlCartItemBase_CartWaxupItem_Fragment
);

export type LabsGqlCartInlayItemFragment = (
  { __typename?: 'CartInlayItem', unit: (
    { __typename?: 'CartItemSingleToothUnit' }
    & LabsGqlCartItemSingleToothUnitFragment
  ) }
  & LabsGqlCartItemBase_CartInlayItem_Fragment
);

export type LabsGqlCartVeneerItemFragment = (
  { __typename?: 'CartVeneerItem', unit: (
    { __typename?: 'CartItemSingleToothUnit' }
    & LabsGqlCartItemSingleToothUnitFragment
  ) }
  & LabsGqlCartItemBase_CartVeneerItem_Fragment
);

export type LabsGqlCartRemovableItemFragment = (
  { __typename?: 'CartRemovableItem', unit: (
    { __typename?: 'CartItemArchUnit' }
    & LabsGqlCartItemArchUnitFragment
  ) }
  & LabsGqlCartItemBase_CartRemovableItem_Fragment
);

export type LabsGqlCartImplantItemFragment = (
  { __typename?: 'CartImplantItem', unit: (
    { __typename?: 'CartImplantToothGroup' }
    & LabsGqlCartImplantToothGroupFragment
  ) }
  & LabsGqlCartItemBase_CartImplantItem_Fragment
);

export type LabsGqlCartImplantBridgeItemFragment = (
  { __typename?: 'CartImplantBridgeItem', implants: Array<(
    { __typename?: 'CartImplantToothGroup' }
    & LabsGqlCartImplantToothGroupFragment
  )>, restoratives: Array<(
    { __typename?: 'CartItemSingleToothUnit' }
    & LabsGqlCartItemSingleToothUnitFragment
  )> }
  & LabsGqlCartItemBase_CartImplantBridgeItem_Fragment
);

export type LabsGqlCartItemUnitMetadataFragment = { __typename?: 'CartItemUnitMetadata', unit_type: string, material: Maybe<string> };

export type LabsGqlCartImplantToothGroupFragment = { __typename?: 'CartImplantToothGroup', unn: ToothNumber, abutment: (
    { __typename?: 'CartItemUnitMetadata' }
    & LabsGqlCartItemUnitMetadataFragment
  ), crown: (
    { __typename?: 'CartItemUnitMetadata' }
    & LabsGqlCartItemUnitMetadataFragment
  ), implant_metadata: { __typename?: 'CartItemImplantMetadata', manufacturer: Maybe<string>, system: Maybe<string>, connection_size: Maybe<string>, relationship: Maybe<Types.LabsGqlOrderItemLinkRelationship>, scanbody_id: Maybe<string>, authentic: Maybe<boolean>, generic_manufacturer: Maybe<Types.LabsGqlOrderItemLinkGenericManufacturer>, part_id: Maybe<string>, non_preferred_part_reason: Maybe<string>, abutment_part_manufacturer: Maybe<string> } };

export type LabsGqlCartDentureItemFragment = (
  { __typename?: 'CartDentureItem', denture_type: Maybe<Types.LabsGqlDentureType>, denture_production_type: Maybe<Types.LabsGqlDenturesProductionType>, denture_fabrication_method: Maybe<Types.LabsGqlDenturesFabricationMethod>, unit: (
    { __typename?: 'CartItemArchUnit' }
    & LabsGqlCartItemArchUnitFragment
  ), denture_production_metadata: Maybe<{ __typename?: 'OrderItemDentureProductionMetadata', quantity: Maybe<number>, smile_style: Maybe<Types.LabsGqlSmileStyleChoice>, festooning_level: Maybe<Types.LabsGqlDenturesFestooningLevel>, handle_diastema: Maybe<Types.LabsGqlDenturesHandleDiastemaOption>, correct_occlusal_scheme: Maybe<boolean>, add_post_dam: Maybe<boolean>, add_stippling: Maybe<boolean>, add_metal_framework: Maybe<boolean>, add_metal_mesh: Maybe<boolean>, add_softliner: Maybe<boolean>, cusil_gaskets_teeth: Maybe<Array<ToothNumber>>, try_in_design: Maybe<Types.LabsGqlDenturesTryInDesignType>, bite_adjustment: Maybe<{ __typename?: 'OrderItemDentureBiteAdjustment', adjustment_type: Types.LabsGqlDenturesBiteAdjustmentType, adjustment_distance_mm: Maybe<number> }>, midline_correction: Maybe<{ __typename?: 'OrderItemDentureMidlineCorrection', correction_type: Types.LabsGqlDenturesMidlineCorrectionType, correction_distance_mm: Maybe<number> }>, implant_support: Maybe<{ __typename?: 'OrderItemDentureImplantSupport', is_implant_supported: boolean, collar_heights_mm: Maybe<string>, is_horseshoe: Maybe<boolean> }>, copy_metadata: Maybe<{ __typename?: 'OrderItemDentureCopyMetadata', is_exact_copy: boolean, copy_change_notes: Maybe<string> }> }> }
  & LabsGqlCartItemBase_CartDentureItem_Fragment
);

export type LabsGqlCartAlignerItemFragment = (
  { __typename?: 'CartAlignerItem', unit: (
    { __typename?: 'CartItemArchUnit' }
    & LabsGqlCartItemArchUnitFragment
  ), aligner_treatment_metadata: Maybe<{ __typename?: 'OrderItemAlignerTreatmentMetadata', treatment_area: Maybe<Types.LabsGqlAlignerTreatmentArea>, aligner_plan: Maybe<Types.LabsGqlAlignerPlan>, movement_restricted_teeth: Maybe<Array<ToothNumber>>, attachment_restricted_teeth: Maybe<Array<ToothNumber>>, extraction_teeth: Maybe<Array<ToothNumber>>, proposed_step_limit: Maybe<number>, trays_count: Maybe<number>, bite_concerns: Maybe<{ __typename?: 'OrderItemAlignerBiteConcerns', improve_overjet: Maybe<Types.LabsGqlBiteConcernOptions>, improve_overbite: Maybe<Types.LabsGqlBiteConcernOptions>, improve_midline: Maybe<Types.LabsGqlBiteConcernOptions> }>, crowding_resolution: Maybe<{ __typename?: 'OrderItemAlignerCrowdingResolution', expansion: Maybe<Types.LabsGqlCrowdingResolutionOption>, proclination: Maybe<Types.LabsGqlCrowdingResolutionOption>, ipr: Maybe<Types.LabsGqlCrowdingResolutionOption> }>, interproximal_space_sizes: Maybe<Array<{ __typename?: 'InterproximalSpaceSize', size: number, space: { __typename?: 'InterproximalSpace', tooth1: number, tooth2: number } }>> }> }
  & LabsGqlCartItemBase_CartAlignerItem_Fragment
);

export type LabsGqlCartPartialDentureItemFragment = (
  { __typename?: 'CartPartialDentureItem', partial_production_type: Maybe<Types.LabsGqlOrderItemPartialDentureProductionType>, coverage_type: Maybe<Types.LabsGqlOrderItemPartialDentureCoverageType>, unit: (
    { __typename?: 'CartItemMultiToothUnit' }
    & LabsGqlCartItemMultiToothUnitFragment
  ), partial_production_metadata: Maybe<{ __typename?: 'OrderItemPartialDentureProductionMetadata', is_replacement: Maybe<boolean>, digital_extractions: Maybe<Array<ToothNumber>>, clasp_generic_type: Maybe<Types.LabsGqlOrderItemPartialDentureGenericClaspType>, clasp_color: Maybe<Types.LabsGqlOrderItemPartialDentureClaspColor>, clasp_locations: Maybe<Array<ToothNumber>>, clasp_shade: Maybe<string>, clasp_notes: Maybe<string> }>, clasps: Maybe<Array<{ __typename?: 'OrderItemPartialDentureClasp', type: Types.LabsGqlOrderItemPartialDentureClaspType, count: number }>> }
  & LabsGqlCartItemBase_CartPartialDentureItem_Fragment
);

export type LabsGqlCartItemArchUnitFragment = { __typename?: 'CartItemArchUnit', material: Maybe<string>, unit_type: string, arch: Maybe<Types.LabsGqlOrderItemArch> };

export type LabsGqlCartItemSingleToothUnitFragment = { __typename?: 'CartItemSingleToothUnit', material: Maybe<string>, unit_type: string, unn: ToothNumber, precious_metal_pennyweight: Maybe<number> };

export type LabsGqlCartItemMultiToothUnitFragment = { __typename?: 'CartItemMultiToothUnit', material: Maybe<string>, unit_type: string, unns: Array<ToothNumber> };

export type LabsGqlCartSurgicalGuideItemFragment = (
  { __typename?: 'CartSurgicalGuideItem', surgical_guide_type: Maybe<Types.LabsGqlOrderItemSurgicalGuideType>, unit: (
    { __typename?: 'CartItemSurgicalGuideUnit' }
    & LabsGqlCartItemSurgicalGuideUnitFragment
  ), treatment_plan_metadata: { __typename?: 'CartItemSurgicalGuidanceTreatmentPlanMetadata', patient_cbct_appointment_date: Maybe<string>, treatment_plan_review_type: Maybe<Types.LabsGqlOrderItemSurgicalGuideTreatmentPlanReviewType>, planned_procedures: Maybe<Array<Types.LabsGqlOrderItemSurgicalGuidePlannedProcedureType>>, final_restorative_type: Maybe<Types.LabsGqlOrderItemSurgicalGuideFinalRestorativeType> } }
  & LabsGqlCartItemBase_CartSurgicalGuideItem_Fragment
);

export type LabsGqlCartItemSurgicalGuideUnitFragment = { __typename?: 'CartItemSurgicalGuideUnit', unit_type: string, unns: Array<ToothNumber>, implant_metadata: { __typename?: 'CartItemSurgicalGuideImplantMetadata', manufacturer: Maybe<string>, system: Maybe<string>, drill_kit: Maybe<string>, desired_size: Maybe<string> } };

export type LabsGqlCartSleepApneaItemFragment = (
  { __typename?: 'CartSleepApneaItem', sleep_apnea_type: Maybe<Types.LabsGqlOrderItemSleepApneaType>, manufacturing_metadata: { __typename?: 'CartItemSleepApneaManufacturingMetadata', should_cover_last_molar_distal: Maybe<boolean>, should_include_anterior_discluding_ramp: Maybe<boolean>, should_have_posterior_support_pads: Maybe<boolean> } }
  & LabsGqlCartItemBase_CartSleepApneaItem_Fragment
);

export type LabsGqlCartTmjItemFragment = (
  { __typename?: 'CartTMJItem', tmj_type: Maybe<Types.LabsGqlOrderItemTmjType>, unit: (
    { __typename?: 'CartItemArchUnit' }
    & LabsGqlCartItemArchUnitFragment
  ), manufacturing_metadata: { __typename?: 'OrderItemTMJManufacturingMetadata', appliance_material: Maybe<Types.LabsGqlOrderItemTmjApplianceMaterial>, arch_separation_distance_mm: Maybe<number>, teeth_height_coverage: Maybe<Types.LabsGqlOrderItemTmjTeethHeightCoverage>, splint_material_thickness_mm: Maybe<number>, color: Maybe<Types.LabsGqlOrderItemTmjColor>, lingual_wire: Maybe<boolean>, teeth_coverage: Maybe<Types.LabsGqlOrderItemTmjTeethCoverage> } }
  & LabsGqlCartItemBase_CartTmjItem_Fragment
);

export type LabsGqlCartWellnessScanItemFragment = (
  { __typename?: 'CartWellnessScanItem', attaching_scans_to_order_id: Maybe<string>, prepped_teeth: Maybe<Array<ToothNumber>>, upper_arch_denture_scan_type: Maybe<Types.LabsGqlOrderItemDentureScanType>, lower_arch_denture_scan_type: Maybe<Types.LabsGqlOrderItemDentureScanType>, unit: (
    { __typename?: 'CartItemArchUnit' }
    & LabsGqlCartItemArchUnitFragment
  ) }
  & LabsGqlCartItemBase_CartWellnessScanItem_Fragment
);

export type LabsGqlScanExportAssetFragment = { __typename?: 'ScanExportAsset', kind: Types.LabsGqlScanExportAssetKind, number: Maybe<number>, ply_path: Maybe<string>, drc_path: Maybe<string>, drc_segmentation_path: Maybe<string>, stl_path: Maybe<string>, texture_path: Maybe<string> };

export type LabsGqlScanWithAssetsFragment = { __typename?: 'scan_export', assets: Maybe<Array<(
    { __typename?: 'ScanExportAsset' }
    & LabsGqlScanExportAssetFragment
  )>> };

export type LabsGqlScanWithAssetsQueryVariables = Types.Exact<{
  scanId: Types.Scalars['String']['input'];
}>;


export type LabsGqlScanWithAssetsQuery = { __typename?: 'Query', scan_file: (
    { __typename?: 'scan_export' }
    & LabsGqlScanWithAssetsFragment
  ) };

export type LabsGqlScanbodyFragment = { __typename?: 'ScanbodyDTO', created_at: string, updated_at: string, id: string, name: string, manufacturer: string, sku: string, numberOfLinkedImplants: number, is_archived: boolean };

export type LabsGqlImplantToScanbodyFragment = { __typename?: 'ImplantToScanbodyDTO', id: string, is_authentic: boolean, priority: Maybe<number>, scanbody: (
    { __typename?: 'ScanbodyDTO' }
    & LabsGqlScanbodyFragment
  ) };

export type LabsGqlImplantTypeFragment = { __typename?: 'ImplantTypeDTO', id: string, manufacturer: string, system: string, connection: string, created_at: string, updated_at: string, is_archived: boolean, scanbody_relationships: Array<(
    { __typename?: 'ImplantToScanbodyDTO' }
    & LabsGqlImplantToScanbodyFragment
  )>, implantToScanbodies: Array<(
    { __typename?: 'ImplantToScanbodyDTO' }
    & LabsGqlImplantToScanbodyFragment
  )> };

export type LabsGqlImplantTypeLiteFragment = { __typename?: 'ImplantTypeDTO', id: string, manufacturer: string, system: string, connection: string, created_at: string, updated_at: string, is_archived: boolean };

export type LabsGqlGetImplantTypesQueryVariables = Types.Exact<{
  withDeleted: Types.Scalars['Boolean']['input'];
  typeSystems?: Array<Types.LabsGqlLabsGqlQueryGetImplantTypeInput>;
}>;


export type LabsGqlGetImplantTypesQuery = { __typename?: 'Query', getImplantTypes: Array<(
    { __typename?: 'ImplantTypeDTO' }
    & LabsGqlImplantTypeFragment
  )> };

export type LabsGqlGetImplantByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetImplantByIdQuery = { __typename?: 'Query', getImplantById: Maybe<(
    { __typename?: 'ImplantTypeDTO' }
    & LabsGqlImplantTypeFragment
  )> };

export type LabsGqlGetImplantTypesLiteQueryVariables = Types.Exact<{
  withDeleted: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlGetImplantTypesLiteQuery = { __typename?: 'Query', getImplantTypesLite: Array<(
    { __typename?: 'ImplantTypeDTO' }
    & LabsGqlImplantTypeLiteFragment
  )> };

export type LabsGqlGetScanbodiesQueryVariables = Types.Exact<{
  withDeleted: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlGetScanbodiesQuery = { __typename?: 'Query', getScanbodies: Array<(
    { __typename?: 'ScanbodyDTO' }
    & LabsGqlScanbodyFragment
  )> };

export type LabsGqlCreateCaseReadinessMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateCaseReadinessCommand;
}>;


export type LabsGqlCreateCaseReadinessMutation = { __typename?: 'Mutation', createCaseReadiness: { __typename?: 'CaseReadinessDTO', id: string } };

export type LabsGqlCreateImplantTypeMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateImplantTypeCommand;
}>;


export type LabsGqlCreateImplantTypeMutation = { __typename?: 'Mutation', createImplantType: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlUpdateImplantTypeMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateImplantTypeCommand;
}>;


export type LabsGqlUpdateImplantTypeMutation = { __typename?: 'Mutation', updateImplantType: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlDeleteImplantTypeMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteImplantTypeCommand;
}>;


export type LabsGqlDeleteImplantTypeMutation = { __typename?: 'Mutation', deleteImplantType: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlRestoreImplantTypeMutationVariables = Types.Exact<{
  data: Types.LabsGqlRestoreImplantTypeCommand;
}>;


export type LabsGqlRestoreImplantTypeMutation = { __typename?: 'Mutation', restoreImplantType: { __typename?: 'ImplantTypeDTO', id: string } };

export type LabsGqlCreateScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateScanbodyCommand;
}>;


export type LabsGqlCreateScanbodyMutation = { __typename?: 'Mutation', createScanbody: { __typename?: 'ScanbodyDTO', id: string } };

export type LabsGqlUpdateScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateScanbodyCommand;
}>;


export type LabsGqlUpdateScanbodyMutation = { __typename?: 'Mutation', updateScanbody: { __typename?: 'ScanbodyDTO', id: string } };

export type LabsGqlDeleteScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlDeleteScanbodyCommand;
}>;


export type LabsGqlDeleteScanbodyMutation = { __typename?: 'Mutation', deleteScanbody: { __typename?: 'ScanbodyDTO', id: string } };

export type LabsGqlRestoreScanbodyMutationVariables = Types.Exact<{
  data: Types.LabsGqlRestoreScanbodyCommand;
}>;


export type LabsGqlRestoreScanbodyMutation = { __typename?: 'Mutation', restoreScanbody: { __typename?: 'ScanbodyDTO', id: string } };

export type LabsGqlGetScanbodyRequestsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetScanbodyRequestsQuery = { __typename?: 'Query', getScanbodyRequests: Array<(
    { __typename?: 'ScanbodyRequestDTO' }
    & LabsGqlScanbodyRequestFragment
  )> };

export type LabsGqlGetScanbodyRequestsInLastNDaysQueryVariables = Types.Exact<{
  date_range: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetScanbodyRequestsInLastNDaysQuery = { __typename?: 'Query', getScanbodyRequestsInLastNDays: Array<(
    { __typename?: 'ScanbodyRequestDTO', patient: Maybe<{ __typename?: 'PatientDTO', first_name: string, last_name: string }> }
    & LabsGqlScanbodyRequestTinyFragment
  )> };

export type LabsGqlGetScanbodyRequestsInLast30DaysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetScanbodyRequestsInLast30DaysQuery = { __typename?: 'Query', getScanbodyRequestsInLast30Days: Array<(
    { __typename?: 'ScanbodyRequestDTO', patient: Maybe<{ __typename?: 'PatientDTO', first_name: string, last_name: string }> }
    & LabsGqlScanbodyRequestTinyFragment
  )> };

export type LabsGqlGetTinyScanbodyRequestsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetTinyScanbodyRequestsQuery = { __typename?: 'Query', getScanbodyRequests: Array<(
    { __typename?: 'ScanbodyRequestDTO' }
    & LabsGqlScanbodyRequestTinyFragment
  )> };

export type LabsGqlGetFulfilledScanbodyRequestsQueryVariables = Types.Exact<{
  manufacturer: Types.InputMaybe<Types.Scalars['String']['input']>;
  system: Types.InputMaybe<Types.Scalars['String']['input']>;
  connection: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LabsGqlGetFulfilledScanbodyRequestsQuery = { __typename?: 'Query', getScanbodyRequests: Array<(
    { __typename?: 'ScanbodyRequestDTO' }
    & LabsGqlScanbodyRequestFragment
  )> };

export type LabsGqlGetScanbodyRequestShipmentQueryVariables = Types.Exact<{
  scanbody_request_id: Types.Scalars['ID']['input'];
}>;


export type LabsGqlGetScanbodyRequestShipmentQuery = { __typename?: 'Query', getScanbodyRequestById: Maybe<{ __typename?: 'ScanbodyRequestDTO', id: string, shipment: Maybe<{ __typename?: 'IShipment', id: string, tracking_number: string, carrier: Types.LabsGqlShippingCarriersEnum, status: Types.LabsGqlShipmentStatus }> }> };

export type LabsGqlGetScanbodiesByIdsQueryVariables = Types.Exact<{
  scanbody_ids: Array<Types.Scalars['ID']['input']>;
}>;


export type LabsGqlGetScanbodiesByIdsQuery = { __typename?: 'Query', getScanbodiesByIds: Array<(
    { __typename?: 'ScanbodyDTO' }
    & LabsGqlScanbodyFragment
  )> };

export type LabsGqlScanbodyRequestTinyFragment = { __typename?: 'ScanbodyRequestDTO', id: string, scanbody_id: Maybe<string>, requested_scanbody_id: Maybe<string>, created_at: string, manufacturer: string, appointment_date: string, connection: string, system: string, fulfillment_order_id: Maybe<string>, shipment_id: Maybe<string>, surgical_report_file: Maybe<string>, address: string, practice_id: string, requesting_doctor_name: Maybe<string>, abutment_type: Maybe<string>, deleted_at: Maybe<string>, implant_type: Maybe<{ __typename?: 'ImplantTypeDTO', id: string }> };

export type LabsGqlScanbodyRequestFragment = { __typename?: 'ScanbodyRequestDTO', id: string, scanbody_id: Maybe<string>, created_at: string, manufacturer: string, appointment_date: string, connection: string, system: string, fulfillment_order_id: Maybe<string>, shipment_id: Maybe<string>, surgical_report_file: Maybe<string>, address: string, requesting_doctor_name: Maybe<string>, abutment_type: Maybe<string>, requested_scanbody_id: Maybe<string>, deleted_at: Maybe<string>, scanbody: Maybe<(
    { __typename?: 'ScanbodyDTO' }
    & LabsGqlScanbodyFragment
  )>, practice: (
    { __typename?: 'OrganizationDTO' }
    & LabsGqlOrganizationDtoFragment
  ), implant_type: Maybe<{ __typename?: 'ImplantTypeDTO', manufacturer: string, scanbody_relationships: Array<{ __typename?: 'ImplantToScanbodyDTO', priority: Maybe<number>, scanbody: (
        { __typename?: 'ScanbodyDTO' }
        & LabsGqlScanbodyFragment
      ) }> }>, requested_scanbody: Maybe<(
    { __typename?: 'ScanbodyDTO' }
    & LabsGqlScanbodyFragment
  )> };

export type LabsGqlGetPracticeScanbodyInventoryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetPracticeScanbodyInventoryQuery = { __typename?: 'Query', getScanbodyRequests: Array<(
    { __typename?: 'ScanbodyRequestDTO' }
    & LabsGqlScanbodyInventoryItemFragment
  )> };

export type LabsGqlScanbodyInventoryItemFragment = { __typename?: 'ScanbodyRequestDTO', address: string, abutment_type: Maybe<string>, manufacturer: string, system: string, connection: string, fulfillment_order_id: Maybe<string>, created_at: string, patient: Maybe<{ __typename?: 'PatientDTO', first_name: string, last_name: string }>, item: Maybe<(
    { __typename?: 'CartAlignerItem' }
    & LabsGqlCartItemV2Dto_CartAlignerItem_Fragment
  ) | (
    { __typename?: 'CartBridgeItem' }
    & LabsGqlCartItemV2Dto_CartBridgeItem_Fragment
  ) | (
    { __typename?: 'CartCrownItem' }
    & LabsGqlCartItemV2Dto_CartCrownItem_Fragment
  ) | (
    { __typename?: 'CartDentureItem' }
    & LabsGqlCartItemV2Dto_CartDentureItem_Fragment
  ) | (
    { __typename?: 'CartImplantBridgeItem' }
    & LabsGqlCartItemV2Dto_CartImplantBridgeItem_Fragment
  ) | (
    { __typename?: 'CartImplantItem' }
    & LabsGqlCartItemV2Dto_CartImplantItem_Fragment
  ) | (
    { __typename?: 'CartInlayItem' }
    & LabsGqlCartItemV2Dto_CartInlayItem_Fragment
  ) | (
    { __typename?: 'CartModelItem' }
    & LabsGqlCartItemV2Dto_CartModelItem_Fragment
  ) | (
    { __typename?: 'CartOtherItem' }
    & LabsGqlCartItemV2Dto_CartOtherItem_Fragment
  ) | (
    { __typename?: 'CartPartialDentureItem' }
    & LabsGqlCartItemV2Dto_CartPartialDentureItem_Fragment
  ) | (
    { __typename?: 'CartRemovableItem' }
    & LabsGqlCartItemV2Dto_CartRemovableItem_Fragment
  ) | (
    { __typename?: 'CartSleepApneaItem' }
    & LabsGqlCartItemV2Dto_CartSleepApneaItem_Fragment
  ) | (
    { __typename?: 'CartSurgicalGuideItem' }
    & LabsGqlCartItemV2Dto_CartSurgicalGuideItem_Fragment
  ) | (
    { __typename?: 'CartTMJItem' }
    & LabsGqlCartItemV2Dto_CartTmjItem_Fragment
  ) | (
    { __typename?: 'CartUnknownItem' }
    & LabsGqlCartItemV2Dto_CartUnknownItem_Fragment
  ) | (
    { __typename?: 'CartVeneerItem' }
    & LabsGqlCartItemV2Dto_CartVeneerItem_Fragment
  ) | (
    { __typename?: 'CartWaxupItem' }
    & LabsGqlCartItemV2Dto_CartWaxupItem_Fragment
  ) | (
    { __typename?: 'CartWellnessScanItem' }
    & LabsGqlCartItemV2Dto_CartWellnessScanItem_Fragment
  )>, shipment: Maybe<{ __typename?: 'IShipment', id: string, tracking_number: string, carrier: Types.LabsGqlShippingCarriersEnum, status: Types.LabsGqlShipmentStatus }>, scanbody: Maybe<{ __typename?: 'ScanbodyDTO', name: string, manufacturer: string }> };

export type LabsGqlShipmentFragment = { __typename?: 'IShipment', id: string, updated_at: string, destination_type: Types.LabsGqlShipmentDestinationType, label_url: Maybe<string>, created_via: Maybe<Types.LabsGqlShipmentCreatedViaEnumType> };

export type LabsGqlListShipmentsQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlListShipmentsQuery = { __typename?: 'Query', listShipments: Array<(
    { __typename?: 'IShipment' }
    & LabsGqlShipmentFragment
  )> };

export type LabsGqlCreateShippingLabelMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateShippingLabelCommand;
}>;


export type LabsGqlCreateShippingLabelMutation = { __typename?: 'Mutation', createShippingLabel: string };

export type LabsGqlGetShortenedLinkQueryVariables = Types.Exact<{
  initial_url: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetShortenedLinkQuery = { __typename?: 'Query', getShortenedLink: string };

export type LabsGqlGetOwnImpersonatedShortenedLinkQueryVariables = Types.Exact<{
  initial_url: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOwnImpersonatedShortenedLinkQuery = { __typename?: 'Query', getOwnImpersonatedShortenedLink: { __typename?: 'GetOwnImpersonatedShortenedLinkResponse', fullUrl: string, shortUrl: string } };

export type LabsGqlPreviewUpdateOrderSlaQueryVariables = Types.Exact<{
  command: Types.LabsGqlModifyOrderSlaCommand;
}>;


export type LabsGqlPreviewUpdateOrderSlaQuery = { __typename?: 'Query', previewUpdateOrderSla: { __typename?: 'SLAPreviewResult', ship_by_date: string, due_date: string, internal_committed_due_date: string, manufacturer_committed_ship_by_date: string, manufacturer_committed_due_date: string, estimated_delivery_date: string, design_due_date: Maybe<string>, ready_for_fabrication_date: Maybe<string> } };

export type LabsGqlGetSlaChangesForOrderQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  showAllEvents: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlGetSlaChangesForOrderQuery = { __typename?: 'Query', getOrderSlaChanges: Array<{ __typename?: 'OrderSlaChangeEntry', event: { __typename?: 'SlaChangedEvent', id: number, name: string, created_at: string }, updates: Array<{ __typename?: 'SlaUpdateDetails', fieldType: Types.LabsGqlFieldType, field: string, previous: Maybe<string>, updated: string }>, sla: (
      { __typename?: 'OrderSLA' }
      & LabsGqlDetailedOrderSlaFragment
    ) }> };

export type LabsGqlTagsQueryVariables = Types.Exact<{
  id: Types.InputMaybe<Types.Scalars['String']['input']>;
  entity_id: Types.InputMaybe<Types.Scalars['String']['input']>;
  entity_type: Types.InputMaybe<Types.LabsGqlTaggableEntityType>;
}>;


export type LabsGqlTagsQuery = { __typename?: 'Query', tags: Array<(
    { __typename?: 'Tag' }
    & LabsGqlTagFragment
  )> };

export type LabsGqlTagFragment = { __typename?: 'Tag', id: string, entity_type: Types.LabsGqlTaggableEntityType, name: string, description: Maybe<string>, color: Maybe<string> };

export type LabsGqlGetOrderAutomateResultQueryVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetOrderAutomateResultQuery = { __typename?: 'Query', getOrderAutomateResult: Maybe<{ __typename?: 'ThreeshapeAutomateCaseResult', id: string, resultsUrl: Maybe<string>, status: { __typename?: 'ThreeshapeAutomateCaseResultStatus', accepted: boolean, downloaded: boolean, editsRequested: boolean, failed: boolean, failureCode: number, message: string, processing: boolean, rejected: boolean, reviewable: boolean, statusCode: number, successful: boolean, uploading: boolean } }> };

export type LabsGqlListThreeshapeDmesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlListThreeshapeDmesQuery = { __typename?: 'Query', listThreeshapeDmes: Array<(
    { __typename?: 'ThreeshapeDmeDTO' }
    & LabsGqlThreeshapeDmeDtoFragment
  )> };

export type LabsGqlThreeshapeDmeDtoFragment = { __typename?: 'ThreeshapeDmeDTO', id: string, updated_at: string, created_at: string, is_archived: boolean, name: string, file_path: string, current_version: number };

export type LabsGqlGetTicketSavedSearchesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlGetTicketSavedSearchesQuery = { __typename?: 'Query', getTicketSavedSearches: Array<{ __typename?: 'TicketingSavedSearch', id: string, name: string, visibility: Types.LabsGqlSavedSearchVisibility, created_at: string, updated_at: string, created_by: string, favorited_by: Array<string>, search: { __typename?: 'TicketsFilters', ticket_ids: Maybe<Array<string>>, assigned_user_ids: Maybe<Array<string>>, practice_ids: Maybe<Array<string>>, order_tag_ids: Maybe<Array<string>>, action_type_ids: Maybe<Array<string>>, manufacturer_ids: Maybe<Array<string>>, is_open: Maybe<boolean>, active_action_is_workable_now: Maybe<boolean> } }> };

export type LabsGqlGetChairsideFirebaseUploadUrlQueryVariables = Types.Exact<{
  chairsideCaseId: Types.Scalars['String']['input'];
  uploadType: Types.Scalars['String']['input'];
  fileName: Types.Scalars['String']['input'];
}>;


export type LabsGqlGetChairsideFirebaseUploadUrlQuery = { __typename?: 'Query', getChairsideFirebaseUploadUrl: { __typename?: 'ChairsideUpload', uploadUrl: string, path: string } };

export type LabsGqlSubmitWaxupReviewMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  rejection: Types.InputMaybe<Types.LabsGqlWaxupReviewRejectionInput>;
}>;


export type LabsGqlSubmitWaxupReviewMutation = { __typename?: 'Mutation', submitWaxupReview: { __typename?: 'lab_order', id: string } };

export type LabsGqlConfigureWaxupMutationVariables = Types.Exact<{
  order_id: Types.Scalars['String']['input'];
  waxup_required: Types.Scalars['Boolean']['input'];
}>;


export type LabsGqlConfigureWaxupMutation = { __typename?: 'Mutation', configureOrderWaxup: { __typename?: 'lab_order', id: string } };

export type LabsGqlWorkflowStepDefinitionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlWorkflowStepDefinitionsQuery = { __typename?: 'Query', listWorkflowStepDefinitions: Array<(
    { __typename?: 'WorkflowStepDefinition' }
    & LabsGqlWorkflowStepDefinitionFragment
  )> };

export type LabsGqlCreateWorkflowStepDefinitionMutationVariables = Types.Exact<{
  data: Types.LabsGqlCreateWorkflowStepDefinitionCommand;
}>;


export type LabsGqlCreateWorkflowStepDefinitionMutation = { __typename?: 'Mutation', createWorkflowStepDefinition: (
    { __typename?: 'WorkflowStepDefinition' }
    & LabsGqlWorkflowStepDefinitionFragment
  ) };

export type LabsGqlUpdateWorkflowStepDefinitionMutationVariables = Types.Exact<{
  data: Types.LabsGqlUpdateWorkflowStepDefinitionCommand;
}>;


export type LabsGqlUpdateWorkflowStepDefinitionMutation = { __typename?: 'Mutation', updateWorkflowStepDefinition: (
    { __typename?: 'WorkflowStepDefinition' }
    & LabsGqlWorkflowStepDefinitionFragment
  ) };

export type LabsGqlWorkflowStepDefinitionFragment = { __typename?: 'WorkflowStepDefinition', id: string, updated_at: string, created_at: string, name: string, priority: number, archived: boolean };

export type LabsGqlWorkflowTasksByListViewQueryVariables = Types.Exact<{
  order_filter: Types.InputMaybe<Array<Types.LabsGqlFilterCriteriaSubmissionInput>>;
  task_filter: Types.InputMaybe<Types.LabsGqlListWorkflowTasksFilter>;
  search: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort: Types.InputMaybe<Types.LabsGqlWorkflowTaskSortParam>;
}>;


export type LabsGqlWorkflowTasksByListViewQuery = { __typename?: 'Query', orderWorkflowTasksByListView: Array<(
    { __typename?: 'DesignReviewWorkflowTask' }
    & LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'DrReviewHoldWorkflowTask' }
    & LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ExternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'InternalDesignWorkflowTask' }
    & LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveHoldWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment
  ) | (
    { __typename?: 'ResolveScanRejectionWorkflowTask' }
    & LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
  ) | (
    { __typename?: 'ReviewOrderWorkflowTask' }
    & LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment
  ) | (
    { __typename?: 'ScanReviewWorkflowTask' }
    & LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WaxupReviewWorkflowTask' }
    & LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment
  ) | (
    { __typename?: 'WorkflowTaskGeneric' }
    & LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment
  )> };

export type LabsGqlWorkflowTasksCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LabsGqlWorkflowTasksCountQuery = { __typename?: 'Query', orderWorkflowTasksCount: (
    { __typename?: 'WorkflowTaskStatusCounts' }
    & LabsGqlWorkflowTaskStatusCountsFragment
  ) };

export type LabsGqlWorkflowTaskStatusCountsFragment = { __typename?: 'WorkflowTaskStatusCounts', AssignedToMe: number, AssignedToOthers: number, AllUnassigned: number, WaitingOnPractice: number, ResolveHold: number, ShipOrder: number, ReturnOrder: number, PullFromFloor: number, AcknowledgeReturn: number, ReviewOrder: number, ScanReview: number, InternalDesign: number, ResolveScanRejection: number, DesignReview: number, DesignReview2: number, DesignPrep: number, AutomateReview: number, ModelDesign: number, InjectionMoldDesign: number, ExternalDesignVerification: number, CreateTreatmentPlanRequest: number, SetTreatmentPlanRequestUrl: number, ConvertTreatmentPlanRequest: number, FinalizeTreatmentPlanRequest: number, ApproveAlignerFabrication: number, CreateExternalAlignerFulfillment: number };

export type LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment = (
  { __typename: 'DesignReviewWorkflowTask' }
  & LabsGqlIWorkflowTask_DesignReviewWorkflowTask_Fragment
  & LabsGqlDesignReviewWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment = (
  { __typename: 'DrReviewHoldWorkflowTask' }
  & LabsGqlIWorkflowTask_DrReviewHoldWorkflowTask_Fragment
  & LabsGqlDrReviewHoldWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment = (
  { __typename: 'ExternalDesignWorkflowTask' }
  & LabsGqlIWorkflowTask_ExternalDesignWorkflowTask_Fragment
  & LabsGqlExternalDesignWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment = (
  { __typename: 'InternalDesignWorkflowTask' }
  & LabsGqlIWorkflowTask_InternalDesignWorkflowTask_Fragment
  & LabsGqlInternalDesignWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment = (
  { __typename: 'ResolveHoldWorkflowTask' }
  & LabsGqlIWorkflowTask_ResolveHoldWorkflowTask_Fragment
  & LabsGqlResolveHoldWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment = (
  { __typename: 'ResolveScanRejectionWorkflowTask' }
  & LabsGqlIWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment
);

export type LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment = (
  { __typename: 'ReviewOrderWorkflowTask' }
  & LabsGqlIWorkflowTask_ReviewOrderWorkflowTask_Fragment
  & LabsGqlReviewOrderWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment = (
  { __typename: 'ScanReviewWorkflowTask' }
  & LabsGqlIWorkflowTask_ScanReviewWorkflowTask_Fragment
  & LabsGqlScanReviewWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment = (
  { __typename: 'WaxupReviewWorkflowTask' }
  & LabsGqlIWorkflowTask_WaxupReviewWorkflowTask_Fragment
  & LabsGqlWaxupReviewWorkflowTaskFragment
);

export type LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment = (
  { __typename: 'WorkflowTaskGeneric' }
  & LabsGqlIWorkflowTask_WorkflowTaskGeneric_Fragment
  & LabsGqlWorkflowTaskGenericFragment
);

export type LabsGqlWorkflowTaskFragment = LabsGqlWorkflowTask_DesignReviewWorkflowTask_Fragment | LabsGqlWorkflowTask_DrReviewHoldWorkflowTask_Fragment | LabsGqlWorkflowTask_ExternalDesignWorkflowTask_Fragment | LabsGqlWorkflowTask_InternalDesignWorkflowTask_Fragment | LabsGqlWorkflowTask_ResolveHoldWorkflowTask_Fragment | LabsGqlWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment | LabsGqlWorkflowTask_ReviewOrderWorkflowTask_Fragment | LabsGqlWorkflowTask_ScanReviewWorkflowTask_Fragment | LabsGqlWorkflowTask_WaxupReviewWorkflowTask_Fragment | LabsGqlWorkflowTask_WorkflowTaskGeneric_Fragment;

export type LabsGqlResolveHoldWorkflowTaskFragment = { __typename?: 'ResolveHoldWorkflowTask', configuration: { __typename?: 'WorkflowTaskReasonsConfig', doctor_request_id: Maybe<string> } };

export type LabsGqlReviewOrderWorkflowTaskFragment = { __typename?: 'ReviewOrderWorkflowTask', configuration: { __typename?: 'WorkflowTaskReviewOrderConfig', review_flag_reasons: Array<string>, review_step: { __typename?: 'WorkflowStep', id: string, name: string } } };

export type LabsGqlWaxupReviewWorkflowTaskFragment = { __typename?: 'WaxupReviewWorkflowTask', configuration: { __typename?: 'WorkflowTaskWaxupReviewConfig', previous_reject_notes: Maybe<string> } };

export type LabsGqlDrReviewHoldWorkflowTaskFragment = { __typename?: 'DrReviewHoldWorkflowTask', configuration: { __typename?: 'WorkflowTaskDrReviewHoldConfig', dr_visible_notes: string, photo_attachment_urls: Array<string>, structured_response_options: Array<string>, doctor_request_id: Maybe<string> } };

export type LabsGqlScanReviewWorkflowTaskFragment = { __typename?: 'ScanReviewWorkflowTask', configuration: { __typename?: 'WorkflowTaskReasonsConfig', scan_review_reasons: Array<string>, scan_review_request_notes: Maybe<string> } };

export type LabsGqlDesignReviewWorkflowTaskFragment = { __typename?: 'DesignReviewWorkflowTask', configuration: { __typename?: 'WorkflowTaskDesignReviewConfig', blocks_fabrication: boolean, internal_design_notes: Maybe<string> } };

export type LabsGqlDesignReviewGuidedQcResultEntryFragment = { __typename?: 'DesignReviewGuidedQcResultEntry', category: string, name: string, verdict: Types.LabsGqlGuidedQcResultEntryScoreVerdict, duration_ms: number, affected_unns: Array<number>, markup_paths: Maybe<Array<string>>, reasons: Maybe<Array<string>>, note: Maybe<string> };

export type LabsGqlInternalDesignWorkflowTaskFragment = { __typename?: 'InternalDesignWorkflowTask', task_has_qa_evaluation_results: boolean, configuration: { __typename?: 'WorkflowTaskInternalDesignConfig', rejection_notes: Maybe<string>, rejection_reasons: Maybe<Array<string>>, rejection_attachment_urls: Maybe<Array<string>>, prepped_design_file_path: Maybe<string>, resolved_scan_notes: Maybe<string>, is_revision: Maybe<boolean>, guided_qc_results: Maybe<Array<(
      { __typename?: 'DesignReviewGuidedQcResultEntry' }
      & LabsGqlDesignReviewGuidedQcResultEntryFragment
    )>>, previous_metafields: Maybe<Array<{ __typename?: 'DesignMetafieldSubmission', name: string, value: string | boolean | number }>> } };

export type LabsGqlExternalDesignWorkflowTaskFragment = { __typename?: 'ExternalDesignWorkflowTask', configuration: { __typename?: 'WorkflowTaskExternalDesignConfig', rejection_notes: Maybe<string>, rejection_reasons: Maybe<Array<string>>, rejection_attachment_urls: Maybe<Array<string>>, prepped_design_file_path: Maybe<string>, is_revision: Maybe<boolean> } };

export type LabsGqlWorkflowTaskGenericFragment = { __typename?: 'WorkflowTaskGeneric', configuration: { __typename?: 'GenericWorkflowTaskConfig', description: Maybe<string> } };

export type LabsGqlIWorkflowTask_DesignReviewWorkflowTask_Fragment = { __typename?: 'DesignReviewWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_DrReviewHoldWorkflowTask_Fragment = { __typename?: 'DrReviewHoldWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_ExternalDesignWorkflowTask_Fragment = { __typename?: 'ExternalDesignWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_InternalDesignWorkflowTask_Fragment = { __typename?: 'InternalDesignWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_ResolveHoldWorkflowTask_Fragment = { __typename?: 'ResolveHoldWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment = { __typename?: 'ResolveScanRejectionWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_ReviewOrderWorkflowTask_Fragment = { __typename?: 'ReviewOrderWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_ScanReviewWorkflowTask_Fragment = { __typename?: 'ScanReviewWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_WaxupReviewWorkflowTask_Fragment = { __typename?: 'WaxupReviewWorkflowTask', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTask_WorkflowTaskGeneric_Fragment = { __typename?: 'WorkflowTaskGeneric', id: string, lab_order_id: string, created_at: string, type: Types.LabsGqlWorkflowTaskType, started_at: Maybe<string>, due_at: Maybe<string>, assignee: Maybe<(
    { __typename?: 'WorkflowTaskAssignee' }
    & LabsGqlWorkflowTaskAssigneeFragment
  )>, closeout: Maybe<(
    { __typename?: 'WorkflowTaskCloseout' }
    & LabsGqlWorkflowTaskCloseoutFragment
  )> };

export type LabsGqlIWorkflowTaskFragment = LabsGqlIWorkflowTask_DesignReviewWorkflowTask_Fragment | LabsGqlIWorkflowTask_DrReviewHoldWorkflowTask_Fragment | LabsGqlIWorkflowTask_ExternalDesignWorkflowTask_Fragment | LabsGqlIWorkflowTask_InternalDesignWorkflowTask_Fragment | LabsGqlIWorkflowTask_ResolveHoldWorkflowTask_Fragment | LabsGqlIWorkflowTask_ResolveScanRejectionWorkflowTask_Fragment | LabsGqlIWorkflowTask_ReviewOrderWorkflowTask_Fragment | LabsGqlIWorkflowTask_ScanReviewWorkflowTask_Fragment | LabsGqlIWorkflowTask_WaxupReviewWorkflowTask_Fragment | LabsGqlIWorkflowTask_WorkflowTaskGeneric_Fragment;

export type LabsGqlWorkflowTaskAssigneeFragment = { __typename?: 'WorkflowTaskAssignee', assigned_at: string, auto_assignment_expiration: Maybe<string>, assigned_user: { __typename?: 'UserDTO', id: string, first_name: string, last_name: string } };

export type LabsGqlWorkflowTaskCloseoutFragment = { __typename?: 'WorkflowTaskCloseout', actor: string, actor_id: Maybe<string>, closed_at: string, reason: Types.LabsGqlWorkflowTaskCloseReason, actor_staff: Maybe<{ __typename?: 'StaffMemberWithRelations', user: { __typename?: 'UserDTO', id: string, first_name: string, last_name: string } }> };
